import { c as __toESM, n as fileTypeFromBlob, o as __commonJSMin, s as __export } from "./core-Cet55PGg.js";
import { t as preset_default } from "./preset-B9qMHp0b.js";
import { Combobox, Dialog as Dialog$1, Disclosure, Listbox, Menu, Popover as Popover$1, RadioGroup, Switch, Tab, Transition } from "@headlessui/react";
import * as React$1 from "react";
import React, { Children, Component, Fragment, cloneElement, createContext, createElement, forwardRef, isValidElement, memo, useCallback, useContext, useEffect, useImperativeHandle, useLayoutEffect, useMemo, useReducer, useRef, useState } from "react";
import { AlignBottom, AlignCenterHorizontal, AlignCenterHorizontalSimple, AlignCenterVertical, AlignLeft, AlignLeftSimple, AlignRight, AlignRightSimple, AlignTop, ArrowArcLeft, ArrowArcRight, ArrowClockwise, ArrowCounterClockwise, ArrowDown, ArrowElbowLeftUp, ArrowFatLineDown, ArrowFatLineUp, ArrowFatLinesRight, ArrowLeft, ArrowRight, ArrowSquareOut, ArrowUp, ArrowsDownUp, ArrowsOutCardinal, ArrowsOutLineHorizontal, ArrowsOutSimple, Basketball, Book, Bookmark, BoundingBox, BracketsCurly, Broadcast, Browser, Calendar, Camera, Cards, CaretDown, CaretLeft, CaretRight, CaretUp, Certificate, Check, CheckCircle, Circle, CircleNotch, CirclesThreePlus, Clipboard, Clock, ClockClockwise, ClockCountdown, CloudArrowDown, CloudArrowUp, Copy, CopySimple, Crosshair, Cursor, Database, Diamond, Dot, DotsSixVertical, DotsThree, DotsThreeOutlineVertical, ExcludeSquare, Export, Eye, EyeSlash, Faders, FastForward, FileArrowDown, FileHtml, FileJpg, FilePng, FileSvg, FileVideo, FilmStrip, FlowArrow, Folder, FolderMinus, FolderOpen, FolderPlus, FolderSimpleDashed, FolderSimplePlus, FrameCorners, Gear, Globe, Gradient, Hand, Hash, Image as Image$1, ImageSquare, Images, Infinity as Infinity$1, Info, LineSegment, Link, LinkBreak, LinkSimple, LinkSimpleHorizontal, LinkSimpleHorizontalBreak, List, ListMagnifyingGlass, LockKey, LockKeyOpen, MagnifyingGlass, Minus, MinusCircle, Monitor, MonitorArrowUp, MonitorPlay, Moon, NavigationArrow, NotePencil, Nut, Palette, Path, Pause, PencilRuler, PencilSimpleLine, Percent, Play, Plus, PlusCircle, Polygon, Question, Queue, Rectangle, Repeat, Rows, Shapes, Shield, ShuffleIcon, SignOut, SkipBack, SkipForward, SoccerBall, Stack, StackMinus, StackPlus, Stop, Sun, Swap, TennisBall, TextAlignCenter, TextAlignJustify, TextAlignLeft, TextAlignRight, TextColumns, TextIndent, TextOutdent, TextT, Textbox, TrashSimple, UploadSimple, User, Users, Video, VideoCamera, VideoCameraSlash, Volleyball, Wall, Warning, WarningCircle, X, XCircle } from "@phosphor-icons/react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import format from "date-fns/format";
import nl from "date-fns/locale/nl";
import parseISO from "date-fns/parseISO";
import { I18nextProvider, useTranslation } from "react-i18next";
import * as ReactDOM from "react-dom";
import { createPortal } from "react-dom";
import { Link as Link$1, NavLink, Navigate } from "react-router-dom";
import { withTheme } from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import { buttonId, getTemplate, getUiOptions } from "@rjsf/utils";
import { arrayMove } from "@dnd-kit/sortable";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Tippy from "@tippyjs/react";
var require_classnames = /* @__PURE__ */ __commonJSMin(((x, w) => {
	(function() {
		var x = {}.hasOwnProperty;
		function V() {
			for (var x = "", w = 0; w < arguments.length; w++) {
				var V = arguments[w];
				V && (x = W(x, U(V)));
			}
			return x;
		}
		function U(w) {
			if (typeof w == "string" || typeof w == "number") return w;
			if (typeof w != "object") return "";
			if (Array.isArray(w)) return V.apply(null, w);
			if (w.toString !== Object.prototype.toString && !w.toString.toString().includes("[native code]")) return w.toString();
			var U = "";
			for (var G in w) x.call(w, G) && w[G] && (U = W(U, G));
			return U;
		}
		function W(x, w) {
			return w ? x ? x + " " + w : x + w : x;
		}
		w !== void 0 && w.exports ? (V.default = V, w.exports = V) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
			return V;
		}) : window.classNames = V;
	})();
})), config_default = {
	play: Play,
	pause: Pause,
	stop: Stop,
	plus: Plus,
	minus: Minus,
	"arrow-clockwise": ArrowClockwise,
	"arrow-counter-clockwise": ArrowCounterClockwise,
	"arrow-left": ArrowLeft,
	"arrow-lines-right": ArrowFatLinesRight,
	"arrow-right": ArrowRight,
	"arrow-down": ArrowDown,
	"arrow-up": ArrowUp,
	"arrows-down-up": ArrowsDownUp,
	"clock-clockwise": ClockClockwise,
	"chevron-right": CaretRight,
	"chevron-left": CaretLeft,
	"chevron-down": CaretDown,
	"chevron-up": CaretUp,
	"circle-notch": CircleNotch,
	"exit-link": ArrowSquareOut,
	search: MagnifyingGlass,
	"navigation-arrow": NavigationArrow,
	ellipsis: DotsThreeOutlineVertical,
	"dots-three": DotsThree,
	dot: Dot,
	trash: TrashSimple,
	copy: CopySimple,
	clone: Copy,
	repeat: Repeat,
	calendar: Calendar,
	sort: DotsSixVertical,
	hamburger: List,
	clock: Clock,
	"clock-countdown": ClockCountdown,
	media: Image$1,
	pencil: PencilSimpleLine,
	"pencil-ruler": PencilRuler,
	rows: Rows,
	folder: Folder,
	cog: Gear,
	warning: Warning,
	"warning-circle": WarningCircle,
	quickbutton: CirclesThreePlus,
	clipboard: Clipboard,
	"x-circle": XCircle,
	x: X,
	"plus-circle": PlusCircle,
	"folder-minus": FolderMinus,
	"folder-open": FolderOpen,
	"folder-plus": FolderPlus,
	"folder-simple-plus": FolderSimplePlus,
	"monitor-play": MonitorPlay,
	monitor: Monitor,
	check: Check,
	"check-circle": CheckCircle,
	link: Link,
	info: Info,
	browser: Browser,
	"file-png": FilePng,
	"file-jpg": FileJpg,
	"sign-out": SignOut,
	queue: Queue,
	"fast-forward": FastForward,
	"arrow-fat-line-up": ArrowFatLineUp,
	"arrow-fat-line-down": ArrowFatLineDown,
	"note-pencil": NotePencil,
	shield: Shield,
	"tennis-ball": TennisBall,
	"soccer-ball": SoccerBall,
	"basketball-ball": Basketball,
	"arrow-elbow-left-up": ArrowElbowLeftUp,
	"video-camera-slash": VideoCameraSlash,
	"video-camera": VideoCamera,
	video: Video,
	camera: Camera,
	volleyball: Volleyball,
	users: Users,
	cards: Cards,
	certificate: Certificate,
	persistent: Infinity$1,
	diamond: Diamond,
	database: Database,
	"file-svg": FileSvg,
	stack: Stack,
	book: Book,
	bookmark: Bookmark,
	"text-t": TextT,
	"file-html": FileHtml,
	path: Path,
	"line-segment": LineSegment,
	gradient: Gradient,
	"bounding-box": BoundingBox,
	shapes: Shapes,
	"image-square": ImageSquare,
	question: Question,
	"upload-simple": UploadSimple,
	"cloud-arrow-down": CloudArrowDown,
	"cloud-arrow-up": CloudArrowUp,
	"stack-minus": StackMinus,
	"stack-plus": StackPlus,
	rectangle: Rectangle,
	circle: Circle,
	eye: Eye,
	"eye-slash": EyeSlash,
	"lock-key": LockKey,
	"lock-key-open": LockKeyOpen,
	"flow-arrow": FlowArrow,
	"exclude-square": ExcludeSquare,
	"text-align-center": TextAlignCenter,
	"text-align-left": TextAlignLeft,
	"text-align-right": TextAlignRight,
	"text-align-justify": TextAlignJustify,
	"align-bottom": AlignBottom,
	"align-center-horizontal": AlignCenterHorizontal,
	"align-center-vertical": AlignCenterVertical,
	"align-left": AlignLeft,
	"align-right": AlignRight,
	"align-top": AlignTop,
	"text-columns": TextColumns,
	"text-indent": TextIndent,
	"text-outdent": TextOutdent,
	"text-box": Textbox,
	polygon: Polygon,
	faders: Faders,
	moon: Moon,
	sun: Sun,
	crosshair: Crosshair,
	cursor: Cursor,
	hand: Hand,
	"file-video": FileVideo,
	swap: Swap,
	user: User,
	globe: Globe,
	palette: Palette,
	hash: Hash,
	percentage: Percent,
	wall: Wall,
	"arrows-out-line-horizontal": ArrowsOutLineHorizontal,
	"folder-simple-dashed": FolderSimpleDashed,
	broadcast: Broadcast,
	"arrows-out-cardinal": ArrowsOutCardinal,
	"export-icon": Export,
	"file-arrow-down": FileArrowDown,
	"link-horizontal": LinkSimpleHorizontal,
	"link-horizontal-break": LinkSimpleHorizontalBreak,
	shuffle: ShuffleIcon,
	"skip-back": SkipBack,
	"skip-forward": SkipForward,
	images: Images,
	"film-strip": FilmStrip,
	"arrow-arc-left": ArrowArcLeft,
	"arrow-arc-right": ArrowArcRight,
	"minus-circle": MinusCircle,
	"arrows-out-simple": ArrowsOutSimple,
	"align-center-horizontal-simple": AlignCenterHorizontalSimple,
	"align-left-simple": AlignLeftSimple,
	"align-right-simple": AlignRightSimple,
	"link-break": LinkBreak,
	"link-simple": LinkSimple,
	"arrow-square-out": ArrowSquareOut,
	"brackets-curly": BracketsCurly,
	"list-magnifying-glass": ListMagnifyingGlass,
	"frame-corners": FrameCorners,
	"monitor-arrow-up": MonitorArrowUp,
	nut: Nut
}, Icon_default = ({ icon: x, size: w = 16, color: V, className: U, weight: W = "fill", ...G }) => {
	let K = config_default[x];
	return /* @__PURE__ */ jsx(K, {
		size: w,
		weight: W,
		color: V,
		className: U,
		...G
	});
}, Button_module_default = {
	Button: "_Button_zx4e7_1",
	primary: "_primary_zx4e7_7",
	secondary: "_secondary_zx4e7_13",
	success: "_success_zx4e7_19",
	danger: "_danger_zx4e7_25",
	live: "_live_zx4e7_31",
	warning: "_warning_zx4e7_37",
	primaryLight: "_primaryLight_zx4e7_43",
	outlinedPrimary: "_outlinedPrimary_zx4e7_47",
	white: "_white_zx4e7_52",
	purple: "_purple_zx4e7_56",
	gray: "_gray_zx4e7_60",
	darkGray: "_darkGray_zx4e7_64",
	yellow: "_yellow_zx4e7_68",
	muted: "_muted_zx4e7_76",
	tertiary: "_tertiary_zx4e7_82",
	icon: "_icon_zx4e7_116",
	hasIconLeft: "_hasIconLeft_zx4e7_153",
	hasIconRight: "_hasIconRight_zx4e7_154",
	smallButton: "_smallButton_zx4e7_166",
	mediumButton: "_mediumButton_zx4e7_170",
	fullWidth: "_fullWidth_zx4e7_174",
	disabled: "_disabled_zx4e7_178",
	disabledIcon: "_disabledIcon_zx4e7_182"
}, import_classnames$59 = /* @__PURE__ */ __toESM(require_classnames(), 1), Button_default = React.forwardRef(({ onClick: x, children: w, disabled: V, type: U = "button", className: W, as: G = "button", to: K, iconProps: J, iconPosition: Y = "left", buttonSize: Z = w === void 0 && J ? "small" : "medium", variant: $ = "default", isFullWidth: ql = !1, color: Jl = Z === "small" ? "darkGray" : void 0, ...Yl }, Xl) => {
	let Zl = (0, import_classnames$59.default)(Button_module_default.Button, {
		[Button_module_default.primary]: Jl === "primary",
		[Button_module_default.primaryLight]: Jl === "primaryLight",
		[Button_module_default.outlinedPrimary]: Jl === "outlinedPrimary",
		[Button_module_default.white]: Jl === "white",
		[Button_module_default.purple]: Jl === "purple",
		[Button_module_default.gray]: Jl === "gray",
		[Button_module_default.darkGray]: Jl === "darkGray",
		[Button_module_default.warning]: Jl === "warning",
		[Button_module_default.yellow]: Jl === "yellow",
		[Button_module_default.danger]: Jl === "danger"
	}, {
		[Button_module_default.primary]: $ === "primary",
		[Button_module_default.outlinedPrimary]: $ === "outlinedPrimary",
		[Button_module_default.secondary]: $ === "secondary",
		[Button_module_default.tertiary]: $ === "tertiary",
		[Button_module_default.icon]: $ === "icon",
		[Button_module_default.danger]: $ === "danger",
		[Button_module_default.success]: $ === "success",
		[Button_module_default.live]: $ === "live",
		[Button_module_default.warning]: $ === "warning",
		[Button_module_default.white]: $ === "white",
		[Button_module_default.muted]: $ === "muted"
	}, {
		[Button_module_default.smallButton]: Z === "small",
		[Button_module_default.mediumButton]: Z === "medium",
		[Button_module_default.hasIconLeft]: J && w && Y === "left",
		[Button_module_default.hasIconRight]: J && w && Y === "right",
		[Button_module_default.fullWidth]: ql === !0,
		[Button_module_default.disabled]: V,
		[Button_module_default.disabledIcon]: $ === "icon" && V
	}), Ql = /* @__PURE__ */ jsxs(Fragment$1, { children: [
		Y === "left" && J && /* @__PURE__ */ jsx(Icon_default, { ...J }),
		w,
		Y === "right" && J && /* @__PURE__ */ jsx(Icon_default, { ...J })
	] });
	return G === "a" ? /* @__PURE__ */ jsx("a", {
		href: K,
		className: (0, import_classnames$59.default)(Zl, W),
		onClick: x,
		children: Ql
	}) : /* @__PURE__ */ jsx("button", {
		className: (0, import_classnames$59.default)(Zl, W),
		onClick: x,
		disabled: V,
		type: U,
		ref: Xl,
		...Yl,
		children: Ql
	});
}), Button$8 = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Disclosure.Button, {
	...w,
	children: x
}), Panel$9 = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Disclosure.Panel, {
	...w,
	children: x
}), RootDisclosure = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Disclosure, {
	...w,
	children: x
});
RootDisclosure.displayName = "Disclosure", RootDisclosure.Button = Button$8, RootDisclosure.Panel = Panel$9;
var Disclosure_default = RootDisclosure, CLASS_PART_SEPARATOR = "-", createClassGroupUtils = (x) => {
	let w = createClassMap(x), { conflictingClassGroups: V, conflictingClassGroupModifiers: U } = x;
	return {
		getClassGroupId: (x) => {
			let V = x.split(CLASS_PART_SEPARATOR);
			return V[0] === "" && V.length !== 1 && V.shift(), getGroupRecursive(V, w) || getGroupIdForArbitraryProperty(x);
		},
		getConflictingClassGroupIds: (x, w) => {
			let W = V[x] || [];
			return w && U[x] ? [...W, ...U[x]] : W;
		}
	};
}, getGroupRecursive = (x, w) => {
	if (x.length === 0) return w.classGroupId;
	let V = x[0], U = w.nextPart.get(V), W = U ? getGroupRecursive(x.slice(1), U) : void 0;
	if (W) return W;
	if (w.validators.length === 0) return;
	let G = x.join(CLASS_PART_SEPARATOR);
	return w.validators.find(({ validator: x }) => x(G))?.classGroupId;
}, arbitraryPropertyRegex = /^\[(.+)\]$/, getGroupIdForArbitraryProperty = (x) => {
	if (arbitraryPropertyRegex.test(x)) {
		let w = arbitraryPropertyRegex.exec(x)[1], V = w?.substring(0, w.indexOf(":"));
		if (V) return "arbitrary.." + V;
	}
}, createClassMap = (x) => {
	let { theme: w, prefix: V } = x, U = {
		nextPart: /* @__PURE__ */ new Map(),
		validators: []
	};
	return getPrefixedClassGroupEntries(Object.entries(x.classGroups), V).forEach(([x, V]) => {
		processClassesRecursively(V, U, x, w);
	}), U;
}, processClassesRecursively = (x, w, V, U) => {
	x.forEach((x) => {
		if (typeof x == "string") {
			let U = x === "" ? w : getPart(w, x);
			U.classGroupId = V;
			return;
		}
		if (typeof x == "function") {
			if (isThemeGetter(x)) {
				processClassesRecursively(x(U), w, V, U);
				return;
			}
			w.validators.push({
				validator: x,
				classGroupId: V
			});
			return;
		}
		Object.entries(x).forEach(([x, W]) => {
			processClassesRecursively(W, getPart(w, x), V, U);
		});
	});
}, getPart = (x, w) => {
	let V = x;
	return w.split(CLASS_PART_SEPARATOR).forEach((x) => {
		V.nextPart.has(x) || V.nextPart.set(x, {
			nextPart: /* @__PURE__ */ new Map(),
			validators: []
		}), V = V.nextPart.get(x);
	}), V;
}, isThemeGetter = (x) => x.isThemeGetter, getPrefixedClassGroupEntries = (x, w) => w ? x.map(([x, V]) => [x, V.map((x) => typeof x == "string" ? w + x : typeof x == "object" ? Object.fromEntries(Object.entries(x).map(([x, V]) => [w + x, V])) : x)]) : x, createLruCache = (x) => {
	if (x < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let w = 0, V = /* @__PURE__ */ new Map(), U = /* @__PURE__ */ new Map(), W = (W, G) => {
		V.set(W, G), w++, w > x && (w = 0, U = V, V = /* @__PURE__ */ new Map());
	};
	return {
		get(x) {
			let w = V.get(x);
			if (w !== void 0) return w;
			if ((w = U.get(x)) !== void 0) return W(x, w), w;
		},
		set(x, w) {
			V.has(x) ? V.set(x, w) : W(x, w);
		}
	};
}, IMPORTANT_MODIFIER = "!", createParseClassName = (x) => {
	let { separator: w, experimentalParseClassName: V } = x, U = w.length === 1, W = w[0], G = w.length, K = (x) => {
		let V = [], K = 0, J = 0, Y;
		for (let Z = 0; Z < x.length; Z++) {
			let $ = x[Z];
			if (K === 0) {
				if ($ === W && (U || x.slice(Z, Z + G) === w)) {
					V.push(x.slice(J, Z)), J = Z + G;
					continue;
				}
				if ($ === "/") {
					Y = Z;
					continue;
				}
			}
			$ === "[" ? K++ : $ === "]" && K--;
		}
		let Z = V.length === 0 ? x : x.substring(J), $ = Z.startsWith(IMPORTANT_MODIFIER);
		return {
			modifiers: V,
			hasImportantModifier: $,
			baseClassName: $ ? Z.substring(1) : Z,
			maybePostfixModifierPosition: Y && Y > J ? Y - J : void 0
		};
	};
	return V ? (x) => V({
		className: x,
		parseClassName: K
	}) : K;
}, sortModifiers = (x) => {
	if (x.length <= 1) return x;
	let w = [], V = [];
	return x.forEach((x) => {
		x[0] === "[" ? (w.push(...V.sort(), x), V = []) : V.push(x);
	}), w.push(...V.sort()), w;
}, createConfigUtils = (x) => ({
	cache: createLruCache(x.cacheSize),
	parseClassName: createParseClassName(x),
	...createClassGroupUtils(x)
}), SPLIT_CLASSES_REGEX = /\s+/, mergeClassList = (x, w) => {
	let { parseClassName: V, getClassGroupId: U, getConflictingClassGroupIds: W } = w, G = [], K = x.trim().split(SPLIT_CLASSES_REGEX), J = "";
	for (let x = K.length - 1; x >= 0; --x) {
		let w = K[x], { modifiers: Y, hasImportantModifier: Z, baseClassName: $, maybePostfixModifierPosition: ql } = V(w), Jl = !!ql, Yl = U(Jl ? $.substring(0, ql) : $);
		if (!Yl) {
			if (!Jl) {
				J = w + (J.length > 0 ? " " + J : J);
				continue;
			}
			if (Yl = U($), !Yl) {
				J = w + (J.length > 0 ? " " + J : J);
				continue;
			}
			Jl = !1;
		}
		let Xl = sortModifiers(Y).join(":"), Zl = Z ? Xl + IMPORTANT_MODIFIER : Xl, Ql = Zl + Yl;
		if (G.includes(Ql)) continue;
		G.push(Ql);
		let $l = W(Yl, Jl);
		for (let x = 0; x < $l.length; ++x) {
			let w = $l[x];
			G.push(Zl + w);
		}
		J = w + (J.length > 0 ? " " + J : J);
	}
	return J;
};
function twJoin() {
	let x = 0, w, V, U = "";
	for (; x < arguments.length;) (w = arguments[x++]) && (V = toValue(w)) && (U && (U += " "), U += V);
	return U;
}
var toValue = (x) => {
	if (typeof x == "string") return x;
	let w, V = "";
	for (let U = 0; U < x.length; U++) x[U] && (w = toValue(x[U])) && (V && (V += " "), V += w);
	return V;
};
function createTailwindMerge(x, ...w) {
	let V, U, W, G = K;
	function K(K) {
		return V = createConfigUtils(w.reduce((x, w) => w(x), x())), U = V.cache.get, W = V.cache.set, G = J, J(K);
	}
	function J(x) {
		let w = U(x);
		if (w) return w;
		let G = mergeClassList(x, V);
		return W(x, G), G;
	}
	return function() {
		return G(twJoin.apply(null, arguments));
	};
}
var fromTheme = (x) => {
	let w = (w) => w[x] || [];
	return w.isThemeGetter = !0, w;
}, arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i, fractionRegex = /^\d+\/\d+$/, stringLengths = /* @__PURE__ */ new Set([
	"px",
	"full",
	"screen"
]), tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, isLength = (x) => isNumber(x) || stringLengths.has(x) || fractionRegex.test(x), isArbitraryLength = (x) => getIsArbitraryValue(x, "length", isLengthOnly), isNumber = (x) => !!x && !Number.isNaN(Number(x)), isArbitraryNumber = (x) => getIsArbitraryValue(x, "number", isNumber), isInteger = (x) => !!x && Number.isInteger(Number(x)), isPercent = (x) => x.endsWith("%") && isNumber(x.slice(0, -1)), isArbitraryValue = (x) => arbitraryValueRegex.test(x), isTshirtSize = (x) => tshirtUnitRegex.test(x), sizeLabels = /* @__PURE__ */ new Set([
	"length",
	"size",
	"percentage"
]), isArbitrarySize = (x) => getIsArbitraryValue(x, sizeLabels, isNever), isArbitraryPosition = (x) => getIsArbitraryValue(x, "position", isNever), imageLabels = /* @__PURE__ */ new Set(["image", "url"]), isArbitraryImage = (x) => getIsArbitraryValue(x, imageLabels, isImage), isArbitraryShadow = (x) => getIsArbitraryValue(x, "", isShadow), isAny = () => !0, getIsArbitraryValue = (x, w, V) => {
	let U = arbitraryValueRegex.exec(x);
	return U ? U[1] ? typeof w == "string" ? U[1] === w : w.has(U[1]) : V(U[2]) : !1;
}, isLengthOnly = (x) => lengthUnitRegex.test(x) && !colorFunctionRegex.test(x), isNever = () => !1, isShadow = (x) => shadowRegex.test(x), isImage = (x) => imageRegex.test(x), twMerge = /* @__PURE__ */ createTailwindMerge(() => {
	let x = fromTheme("colors"), w = fromTheme("spacing"), V = fromTheme("blur"), U = fromTheme("brightness"), W = fromTheme("borderColor"), G = fromTheme("borderRadius"), K = fromTheme("borderSpacing"), J = fromTheme("borderWidth"), Y = fromTheme("contrast"), Z = fromTheme("grayscale"), $ = fromTheme("hueRotate"), ql = fromTheme("invert"), Jl = fromTheme("gap"), Yl = fromTheme("gradientColorStops"), Xl = fromTheme("gradientColorStopPositions"), Zl = fromTheme("inset"), Ql = fromTheme("margin"), $l = fromTheme("opacity"), eu = fromTheme("padding"), tu = fromTheme("saturate"), nu = fromTheme("scale"), ru = fromTheme("sepia"), iu = fromTheme("skew"), au = fromTheme("space"), ou = fromTheme("translate"), su = () => [
		"auto",
		"contain",
		"none"
	], cu = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], lu = () => [
		"auto",
		isArbitraryValue,
		w
	], uu = () => [isArbitraryValue, w], du = () => [
		"",
		isLength,
		isArbitraryLength
	], fu = () => [
		"auto",
		isNumber,
		isArbitraryValue
	], pu = () => [
		"bottom",
		"center",
		"left",
		"left-bottom",
		"left-top",
		"right",
		"right-bottom",
		"right-top",
		"top"
	], mu = () => [
		"solid",
		"dashed",
		"dotted",
		"double",
		"none"
	], hu = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], gu = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch"
	], _u = () => [
		"",
		"0",
		isArbitraryValue
	], vu = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], yu = () => [isNumber, isArbitraryValue];
	return {
		cacheSize: 500,
		separator: ":",
		theme: {
			colors: [isAny],
			spacing: [isLength, isArbitraryLength],
			blur: [
				"none",
				"",
				isTshirtSize,
				isArbitraryValue
			],
			brightness: yu(),
			borderColor: [x],
			borderRadius: [
				"none",
				"",
				"full",
				isTshirtSize,
				isArbitraryValue
			],
			borderSpacing: uu(),
			borderWidth: du(),
			contrast: yu(),
			grayscale: _u(),
			hueRotate: yu(),
			invert: _u(),
			gap: uu(),
			gradientColorStops: [x],
			gradientColorStopPositions: [isPercent, isArbitraryLength],
			inset: lu(),
			margin: lu(),
			opacity: yu(),
			padding: uu(),
			saturate: yu(),
			scale: yu(),
			sepia: _u(),
			skew: yu(),
			space: uu(),
			translate: uu()
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				"video",
				isArbitraryValue
			] }],
			container: ["container"],
			columns: [{ columns: [isTshirtSize] }],
			"break-after": [{ "break-after": vu() }],
			"break-before": [{ "break-before": vu() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: [...pu(), isArbitraryValue] }],
			overflow: [{ overflow: cu() }],
			"overflow-x": [{ "overflow-x": cu() }],
			"overflow-y": [{ "overflow-y": cu() }],
			overscroll: [{ overscroll: su() }],
			"overscroll-x": [{ "overscroll-x": su() }],
			"overscroll-y": [{ "overscroll-y": su() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: [Zl] }],
			"inset-x": [{ "inset-x": [Zl] }],
			"inset-y": [{ "inset-y": [Zl] }],
			start: [{ start: [Zl] }],
			end: [{ end: [Zl] }],
			top: [{ top: [Zl] }],
			right: [{ right: [Zl] }],
			bottom: [{ bottom: [Zl] }],
			left: [{ left: [Zl] }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				"auto",
				isInteger,
				isArbitraryValue
			] }],
			basis: [{ basis: lu() }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"wrap",
				"wrap-reverse",
				"nowrap"
			] }],
			flex: [{ flex: [
				"1",
				"auto",
				"initial",
				"none",
				isArbitraryValue
			] }],
			grow: [{ grow: _u() }],
			shrink: [{ shrink: _u() }],
			order: [{ order: [
				"first",
				"last",
				"none",
				isInteger,
				isArbitraryValue
			] }],
			"grid-cols": [{ "grid-cols": [isAny] }],
			"col-start-end": [{ col: [
				"auto",
				{ span: [
					"full",
					isInteger,
					isArbitraryValue
				] },
				isArbitraryValue
			] }],
			"col-start": [{ "col-start": fu() }],
			"col-end": [{ "col-end": fu() }],
			"grid-rows": [{ "grid-rows": [isAny] }],
			"row-start-end": [{ row: [
				"auto",
				{ span: [isInteger, isArbitraryValue] },
				isArbitraryValue
			] }],
			"row-start": [{ "row-start": fu() }],
			"row-end": [{ "row-end": fu() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": [
				"auto",
				"min",
				"max",
				"fr",
				isArbitraryValue
			] }],
			"auto-rows": [{ "auto-rows": [
				"auto",
				"min",
				"max",
				"fr",
				isArbitraryValue
			] }],
			gap: [{ gap: [Jl] }],
			"gap-x": [{ "gap-x": [Jl] }],
			"gap-y": [{ "gap-y": [Jl] }],
			"justify-content": [{ justify: ["normal", ...gu()] }],
			"justify-items": [{ "justify-items": [
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"justify-self": [{ "justify-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"align-content": [{ content: [
				"normal",
				...gu(),
				"baseline"
			] }],
			"align-items": [{ items: [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"align-self": [{ self: [
				"auto",
				"start",
				"end",
				"center",
				"stretch",
				"baseline"
			] }],
			"place-content": [{ "place-content": [...gu(), "baseline"] }],
			"place-items": [{ "place-items": [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"place-self": [{ "place-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			p: [{ p: [eu] }],
			px: [{ px: [eu] }],
			py: [{ py: [eu] }],
			ps: [{ ps: [eu] }],
			pe: [{ pe: [eu] }],
			pt: [{ pt: [eu] }],
			pr: [{ pr: [eu] }],
			pb: [{ pb: [eu] }],
			pl: [{ pl: [eu] }],
			m: [{ m: [Ql] }],
			mx: [{ mx: [Ql] }],
			my: [{ my: [Ql] }],
			ms: [{ ms: [Ql] }],
			me: [{ me: [Ql] }],
			mt: [{ mt: [Ql] }],
			mr: [{ mr: [Ql] }],
			mb: [{ mb: [Ql] }],
			ml: [{ ml: [Ql] }],
			"space-x": [{ "space-x": [au] }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": [au] }],
			"space-y-reverse": ["space-y-reverse"],
			w: [{ w: [
				"auto",
				"min",
				"max",
				"fit",
				"svw",
				"lvw",
				"dvw",
				isArbitraryValue,
				w
			] }],
			"min-w": [{ "min-w": [
				isArbitraryValue,
				w,
				"min",
				"max",
				"fit"
			] }],
			"max-w": [{ "max-w": [
				isArbitraryValue,
				w,
				"none",
				"full",
				"min",
				"max",
				"fit",
				"prose",
				{ screen: [isTshirtSize] },
				isTshirtSize
			] }],
			h: [{ h: [
				isArbitraryValue,
				w,
				"auto",
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"min-h": [{ "min-h": [
				isArbitraryValue,
				w,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"max-h": [{ "max-h": [
				isArbitraryValue,
				w,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			size: [{ size: [
				isArbitraryValue,
				w,
				"auto",
				"min",
				"max",
				"fit"
			] }],
			"font-size": [{ text: [
				"base",
				isTshirtSize,
				isArbitraryLength
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black",
				isArbitraryNumber
			] }],
			"font-family": [{ font: [isAny] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest",
				isArbitraryValue
			] }],
			"line-clamp": [{ "line-clamp": [
				"none",
				isNumber,
				isArbitraryNumber
			] }],
			leading: [{ leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose",
				isLength,
				isArbitraryValue
			] }],
			"list-image": [{ "list-image": ["none", isArbitraryValue] }],
			"list-style-type": [{ list: [
				"none",
				"disc",
				"decimal",
				isArbitraryValue
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"placeholder-color": [{ placeholder: [x] }],
			"placeholder-opacity": [{ "placeholder-opacity": [$l] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"text-color": [{ text: [x] }],
			"text-opacity": [{ "text-opacity": [$l] }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...mu(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				"auto",
				"from-font",
				isLength,
				isArbitraryLength
			] }],
			"underline-offset": [{ "underline-offset": [
				"auto",
				isLength,
				isArbitraryValue
			] }],
			"text-decoration-color": [{ decoration: [x] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: uu() }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				isArbitraryValue
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: ["none", isArbitraryValue] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-opacity": [{ "bg-opacity": [$l] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: [...pu(), isArbitraryPosition] }],
			"bg-repeat": [{ bg: ["no-repeat", { repeat: [
				"",
				"x",
				"y",
				"round",
				"space"
			] }] }],
			"bg-size": [{ bg: [
				"auto",
				"cover",
				"contain",
				isArbitrarySize
			] }],
			"bg-image": [{ bg: [
				"none",
				{ "gradient-to": [
					"t",
					"tr",
					"r",
					"br",
					"b",
					"bl",
					"l",
					"tl"
				] },
				isArbitraryImage
			] }],
			"bg-color": [{ bg: [x] }],
			"gradient-from-pos": [{ from: [Xl] }],
			"gradient-via-pos": [{ via: [Xl] }],
			"gradient-to-pos": [{ to: [Xl] }],
			"gradient-from": [{ from: [Yl] }],
			"gradient-via": [{ via: [Yl] }],
			"gradient-to": [{ to: [Yl] }],
			rounded: [{ rounded: [G] }],
			"rounded-s": [{ "rounded-s": [G] }],
			"rounded-e": [{ "rounded-e": [G] }],
			"rounded-t": [{ "rounded-t": [G] }],
			"rounded-r": [{ "rounded-r": [G] }],
			"rounded-b": [{ "rounded-b": [G] }],
			"rounded-l": [{ "rounded-l": [G] }],
			"rounded-ss": [{ "rounded-ss": [G] }],
			"rounded-se": [{ "rounded-se": [G] }],
			"rounded-ee": [{ "rounded-ee": [G] }],
			"rounded-es": [{ "rounded-es": [G] }],
			"rounded-tl": [{ "rounded-tl": [G] }],
			"rounded-tr": [{ "rounded-tr": [G] }],
			"rounded-br": [{ "rounded-br": [G] }],
			"rounded-bl": [{ "rounded-bl": [G] }],
			"border-w": [{ border: [J] }],
			"border-w-x": [{ "border-x": [J] }],
			"border-w-y": [{ "border-y": [J] }],
			"border-w-s": [{ "border-s": [J] }],
			"border-w-e": [{ "border-e": [J] }],
			"border-w-t": [{ "border-t": [J] }],
			"border-w-r": [{ "border-r": [J] }],
			"border-w-b": [{ "border-b": [J] }],
			"border-w-l": [{ "border-l": [J] }],
			"border-opacity": [{ "border-opacity": [$l] }],
			"border-style": [{ border: [...mu(), "hidden"] }],
			"divide-x": [{ "divide-x": [J] }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": [J] }],
			"divide-y-reverse": ["divide-y-reverse"],
			"divide-opacity": [{ "divide-opacity": [$l] }],
			"divide-style": [{ divide: mu() }],
			"border-color": [{ border: [W] }],
			"border-color-x": [{ "border-x": [W] }],
			"border-color-y": [{ "border-y": [W] }],
			"border-color-s": [{ "border-s": [W] }],
			"border-color-e": [{ "border-e": [W] }],
			"border-color-t": [{ "border-t": [W] }],
			"border-color-r": [{ "border-r": [W] }],
			"border-color-b": [{ "border-b": [W] }],
			"border-color-l": [{ "border-l": [W] }],
			"divide-color": [{ divide: [W] }],
			"outline-style": [{ outline: ["", ...mu()] }],
			"outline-offset": [{ "outline-offset": [isLength, isArbitraryValue] }],
			"outline-w": [{ outline: [isLength, isArbitraryLength] }],
			"outline-color": [{ outline: [x] }],
			"ring-w": [{ ring: du() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: [x] }],
			"ring-opacity": [{ "ring-opacity": [$l] }],
			"ring-offset-w": [{ "ring-offset": [isLength, isArbitraryLength] }],
			"ring-offset-color": [{ "ring-offset": [x] }],
			shadow: [{ shadow: [
				"",
				"inner",
				"none",
				isTshirtSize,
				isArbitraryShadow
			] }],
			"shadow-color": [{ shadow: [isAny] }],
			opacity: [{ opacity: [$l] }],
			"mix-blend": [{ "mix-blend": [
				...hu(),
				"plus-lighter",
				"plus-darker"
			] }],
			"bg-blend": [{ "bg-blend": hu() }],
			filter: [{ filter: ["", "none"] }],
			blur: [{ blur: [V] }],
			brightness: [{ brightness: [U] }],
			contrast: [{ contrast: [Y] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				isTshirtSize,
				isArbitraryValue
			] }],
			grayscale: [{ grayscale: [Z] }],
			"hue-rotate": [{ "hue-rotate": [$] }],
			invert: [{ invert: [ql] }],
			saturate: [{ saturate: [tu] }],
			sepia: [{ sepia: [ru] }],
			"backdrop-filter": [{ "backdrop-filter": ["", "none"] }],
			"backdrop-blur": [{ "backdrop-blur": [V] }],
			"backdrop-brightness": [{ "backdrop-brightness": [U] }],
			"backdrop-contrast": [{ "backdrop-contrast": [Y] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [Z] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [$] }],
			"backdrop-invert": [{ "backdrop-invert": [ql] }],
			"backdrop-opacity": [{ "backdrop-opacity": [$l] }],
			"backdrop-saturate": [{ "backdrop-saturate": [tu] }],
			"backdrop-sepia": [{ "backdrop-sepia": [ru] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": [K] }],
			"border-spacing-x": [{ "border-spacing-x": [K] }],
			"border-spacing-y": [{ "border-spacing-y": [K] }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"none",
				"all",
				"",
				"colors",
				"opacity",
				"shadow",
				"transform",
				isArbitraryValue
			] }],
			duration: [{ duration: yu() }],
			ease: [{ ease: [
				"linear",
				"in",
				"out",
				"in-out",
				isArbitraryValue
			] }],
			delay: [{ delay: yu() }],
			animate: [{ animate: [
				"none",
				"spin",
				"ping",
				"pulse",
				"bounce",
				isArbitraryValue
			] }],
			transform: [{ transform: [
				"",
				"gpu",
				"none"
			] }],
			scale: [{ scale: [nu] }],
			"scale-x": [{ "scale-x": [nu] }],
			"scale-y": [{ "scale-y": [nu] }],
			rotate: [{ rotate: [isInteger, isArbitraryValue] }],
			"translate-x": [{ "translate-x": [ou] }],
			"translate-y": [{ "translate-y": [ou] }],
			"skew-x": [{ "skew-x": [iu] }],
			"skew-y": [{ "skew-y": [iu] }],
			"transform-origin": [{ origin: [
				"center",
				"top",
				"top-right",
				"right",
				"bottom-right",
				"bottom",
				"bottom-left",
				"left",
				"top-left",
				isArbitraryValue
			] }],
			accent: [{ accent: ["auto", x] }],
			appearance: [{ appearance: ["none", "auto"] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				isArbitraryValue
			] }],
			"caret-color": [{ caret: [x] }],
			"pointer-events": [{ "pointer-events": ["none", "auto"] }],
			resize: [{ resize: [
				"none",
				"y",
				"x",
				""
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scroll-m": [{ "scroll-m": uu() }],
			"scroll-mx": [{ "scroll-mx": uu() }],
			"scroll-my": [{ "scroll-my": uu() }],
			"scroll-ms": [{ "scroll-ms": uu() }],
			"scroll-me": [{ "scroll-me": uu() }],
			"scroll-mt": [{ "scroll-mt": uu() }],
			"scroll-mr": [{ "scroll-mr": uu() }],
			"scroll-mb": [{ "scroll-mb": uu() }],
			"scroll-ml": [{ "scroll-ml": uu() }],
			"scroll-p": [{ "scroll-p": uu() }],
			"scroll-px": [{ "scroll-px": uu() }],
			"scroll-py": [{ "scroll-py": uu() }],
			"scroll-ps": [{ "scroll-ps": uu() }],
			"scroll-pe": [{ "scroll-pe": uu() }],
			"scroll-pt": [{ "scroll-pt": uu() }],
			"scroll-pr": [{ "scroll-pr": uu() }],
			"scroll-pb": [{ "scroll-pb": uu() }],
			"scroll-pl": [{ "scroll-pl": uu() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				isArbitraryValue
			] }],
			fill: [{ fill: [x, "none"] }],
			"stroke-w": [{ stroke: [
				isLength,
				isArbitraryLength,
				isArbitraryNumber
			] }],
			stroke: [{ stroke: [x, "none"] }],
			sr: ["sr-only", "not-sr-only"],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-s",
				"border-w-e",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-s",
				"border-color-e",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] }
	};
}), Text_module_default = {
	Text: "_Text_8xl3r_1",
	success: "_success_8xl3r_5",
	danger: "_danger_8xl3r_9",
	warning: "_warning_8xl3r_13",
	primary: "_primary_8xl3r_17",
	surface: "_surface_8xl3r_21",
	elevated: "_elevated_8xl3r_25",
	light: "_light_8xl3r_29",
	dark: "_dark_8xl3r_33",
	h1: "_h1_8xl3r_37",
	h2: "_h2_8xl3r_41",
	h3: "_h3_8xl3r_45",
	h4: "_h4_8xl3r_49",
	p: "_p_8xl3r_17",
	span: "_span_8xl3r_53",
	dt: "_dt_8xl3r_53",
	dd: "_dd_8xl3r_53",
	legend: "_legend_8xl3r_53",
	strong: "_strong_8xl3r_57",
	"clamp-none": "_clamp-none_8xl3r_61",
	"clamp-1": "_clamp-1_8xl3r_65",
	"clamp-2": "_clamp-2_8xl3r_69",
	"clamp-3": "_clamp-3_8xl3r_73"
}, import_classnames$58 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function Text({ children: x, as: w = "p", className: V, color: U = "light", lineClamp: W = "clamp-none", ...G }) {
	return /* @__PURE__ */ jsx(w, {
		className: twMerge((0, import_classnames$58.default)({
			[Text_module_default[U]]: U,
			[Text_module_default[w]]: w,
			[Text_module_default[W]]: W
		}), V),
		...G,
		children: x
	});
}
var AccordionForm_module_default = {
	Title: "_Title_whpgv_1",
	Container: "_Container_whpgv_8",
	SideMenu: "_SideMenu_whpgv_13",
	SectionsWrapper: "_SectionsWrapper_whpgv_17",
	SectionContainer: "_SectionContainer_whpgv_22",
	SectionForm: "_SectionForm_whpgv_28",
	SectionInfo: "_SectionInfo_whpgv_32",
	SectionHeader: "_SectionHeader_whpgv_36",
	SectionFormContent: "_SectionFormContent_whpgv_41",
	DisclosureButton: "_DisclosureButton_whpgv_45",
	SectionActions: "_SectionActions_whpgv_51",
	Accordion: "_Accordion_whpgv_55",
	Enter: "_Enter_whpgv_59",
	EnterFrom: "_EnterFrom_whpgv_63",
	EnterTo: "_EnterTo_whpgv_67",
	Leave: "_Leave_whpgv_71",
	LeaveFrom: "_LeaveFrom_whpgv_75",
	LeaveTo: "_LeaveTo_whpgv_79"
}, AccordionForm_default = ({ title: x, openId: w, handleChangeSection: V, sections: U, handleClickNext: G }) => /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("header", {
	className: AccordionForm_module_default.Title,
	children: /* @__PURE__ */ jsx(Text, {
		as: "h1",
		children: x
	})
}), /* @__PURE__ */ jsxs("div", {
	className: AccordionForm_module_default.Container,
	children: [/* @__PURE__ */ jsx("aside", { className: AccordionForm_module_default.SideMenu }), /* @__PURE__ */ jsx("div", {
		className: AccordionForm_module_default.SectionsWrapper,
		children: U.map((x, K) => /* @__PURE__ */ jsxs(Disclosure_default, {
			as: "div",
			className: AccordionForm_module_default.SectionContainer,
			children: [/* @__PURE__ */ jsxs("div", {
				className: AccordionForm_module_default.SectionForm,
				children: [x.type === "visible" ? null : /* @__PURE__ */ jsxs(Disclosure_default.Button, {
					className: AccordionForm_module_default.SectionHeader,
					onClick: () => V(x.id),
					children: [x.title, x.completed ? /* @__PURE__ */ jsx(Icon_default, {
						icon: "check-circle",
						color: preset_default.theme.extend.colors.primary,
						size: 20
					}) : /* @__PURE__ */ jsx(Icon_default, {
						icon: "warning-circle",
						color: preset_default.theme.extend.colors["gray-400"],
						size: 20
					})]
				}), /* @__PURE__ */ jsx(Transition, {
					className: AccordionForm_module_default.Accordion,
					show: x.type === "visible" || w === x.id,
					enter: AccordionForm_module_default.Enter,
					enterFrom: AccordionForm_module_default.EnterFrom,
					enterTo: AccordionForm_module_default.EnterTo,
					leave: AccordionForm_module_default.Leave,
					leaveFrom: AccordionForm_module_default.LeaveFrom,
					leaveTo: AccordionForm_module_default.LeaveTo,
					children: /* @__PURE__ */ jsxs(Disclosure_default.Panel, {
						className: AccordionForm_module_default.SectionFormContent,
						as: "div",
						static: !0,
						children: [x.form, x.type === "disclosure" && K !== U.length - 1 ? /* @__PURE__ */ jsx("div", {
							className: AccordionForm_module_default.SectionActions,
							children: /* @__PURE__ */ jsx(Button_default, {
								variant: "primary",
								buttonSize: "medium",
								disabled: U[K + 1]?.locked,
								onClick: G,
								children: "Next"
							})
						}) : null]
					})
				}, `transition-${x.id}`)]
			}), /* @__PURE__ */ jsx("aside", {
				className: AccordionForm_module_default.SectionInfo,
				children: /* @__PURE__ */ jsx(Transition, {
					className: AccordionForm_module_default.Accordion,
					show: w === x.id,
					enter: AccordionForm_module_default.Enter,
					enterFrom: AccordionForm_module_default.EnterFrom,
					enterTo: AccordionForm_module_default.EnterTo,
					leave: AccordionForm_module_default.Leave,
					leaveFrom: AccordionForm_module_default.LeaveFrom,
					leaveTo: AccordionForm_module_default.LeaveTo,
					children: /* @__PURE__ */ jsx(Disclosure_default.Panel, {
						as: "div",
						static: !0,
						children: x.info
					})
				}, `transition-${x.id}`)
			})]
		}, x.id))
	})]
})] }), AccountMenu_module_default = {
	AccountMenu: "_AccountMenu_hcdyd_1",
	AccountMenuDropdown: "_AccountMenuDropdown_hcdyd_5",
	AccountMenuItem: "_AccountMenuItem_hcdyd_12",
	AccountMenuItemButton: "_AccountMenuItemButton_hcdyd_18",
	WorkspaceOptionsWrapper: "_WorkspaceOptionsWrapper_hcdyd_29",
	WorkspaceOption: "_WorkspaceOption_hcdyd_29",
	WorkspaceSelect: "_WorkspaceSelect_hcdyd_41",
	Example: "_Example_hcdyd_49",
	Divider: "_Divider_hcdyd_54"
};
function AccountMenuButton({ children: x, icon: w, onClick: V }) {
	return /* @__PURE__ */ jsx(Menu_default.Item, {
		className: AccountMenu_module_default.AccountMenuItem,
		children: /* @__PURE__ */ jsx(Button_default, {
			className: AccountMenu_module_default.AccountMenuItemButton,
			buttonSize: "small",
			iconProps: {
				icon: w,
				size: 16,
				color: preset_default.theme.extend.colors.gray[300],
				weight: "bold"
			},
			isFullWidth: !0,
			onClick: V,
			variant: "secondary",
			children: x
		})
	});
}
function AccountMenu({ avatarInput: x, currentWorkspaceId: w, handleDashboard: V, handleLogout: U, handleAccountSettings: W, isLoading: G, setCurrentWorkspace: K, showDashboard: J, userLabel: Y, workspaces: Z }) {
	let $ = useMemo(() => Z.map((x) => ({
		label: x.name,
		value: x.id
	})), [Z]), ql = useMemo(() => $.find(({ value: x }) => x === w), [w, $]);
	return /* @__PURE__ */ jsxs(Menu_default, {
		as: "div",
		className: AccountMenu_module_default.AccountMenu,
		children: [/* @__PURE__ */ jsx(Menu_default.Button, {
			title: Y,
			disabled: G,
			children: /* @__PURE__ */ jsx(Avatar, {
				input: x,
				isLoading: G
			})
		}), /* @__PURE__ */ jsxs(Menu_default.Items, {
			className: AccountMenu_module_default.AccountMenuDropdown,
			children: [
				/* @__PURE__ */ jsx(AccountMenuButton, {
					icon: "user",
					onClick: W,
					children: "Account settings"
				}),
				J && /* @__PURE__ */ jsx(AccountMenuButton, {
					icon: "faders",
					onClick: V,
					children: "Admin dashboard"
				}),
				Z.length > 1 && /* @__PURE__ */ jsx(Menu_default.Item, {
					className: AccountMenu_module_default.AccountMenuItem,
					children: /* @__PURE__ */ jsx(Input, {
						className: AccountMenu_module_default.WorkspaceSelect,
						onChange: (x) => {
							Array.isArray(x) || K(x.value);
						},
						optionClassname: AccountMenu_module_default.WorkspaceOption,
						optionsWrapperClassname: AccountMenu_module_default.WorkspaceOptionsWrapper,
						options: $,
						panelWidth: "fit",
						placeholder: ql?.label || "Toggle workspace",
						type: "select",
						value: ql,
						variant: "transparent"
					})
				}),
				/* @__PURE__ */ jsx("hr", { className: AccountMenu_module_default.Divider }),
				/* @__PURE__ */ jsx(AccountMenuButton, {
					icon: "sign-out",
					onClick: U,
					children: "Sign out"
				})
			]
		})]
	});
}
var require__freeGlobal = /* @__PURE__ */ __commonJSMin(((x, w) => {
	w.exports = typeof global == "object" && global && global.Object === Object && global;
})), require__root = /* @__PURE__ */ __commonJSMin(((x, w) => {
	var V = require__freeGlobal(), U = typeof self == "object" && self && self.Object === Object && self;
	w.exports = V || U || Function("return this")();
})), require__Symbol = /* @__PURE__ */ __commonJSMin(((x, w) => {
	w.exports = require__root().Symbol;
})), require__arrayMap = /* @__PURE__ */ __commonJSMin(((x, w) => {
	function V(x, w) {
		for (var V = -1, U = x == null ? 0 : x.length, W = Array(U); ++V < U;) W[V] = w(x[V], V, x);
		return W;
	}
	w.exports = V;
})), require_isArray = /* @__PURE__ */ __commonJSMin(((x, w) => {
	w.exports = Array.isArray;
})), require__getRawTag = /* @__PURE__ */ __commonJSMin(((x, w) => {
	var V = require__Symbol(), U = Object.prototype, W = U.hasOwnProperty, G = U.toString, K = V ? V.toStringTag : void 0;
	function J(x) {
		var w = W.call(x, K), V = x[K];
		try {
			x[K] = void 0;
			var U = !0;
		} catch {}
		var J = G.call(x);
		return U && (w ? x[K] = V : delete x[K]), J;
	}
	w.exports = J;
})), require__objectToString = /* @__PURE__ */ __commonJSMin(((x, w) => {
	var V = Object.prototype.toString;
	function U(x) {
		return V.call(x);
	}
	w.exports = U;
})), require__baseGetTag = /* @__PURE__ */ __commonJSMin(((x, w) => {
	var V = require__Symbol(), U = require__getRawTag(), W = require__objectToString(), G = "[object Null]", K = "[object Undefined]", J = V ? V.toStringTag : void 0;
	function Y(x) {
		return x == null ? x === void 0 ? K : G : J && J in Object(x) ? U(x) : W(x);
	}
	w.exports = Y;
})), require_isObjectLike = /* @__PURE__ */ __commonJSMin(((x, w) => {
	function V(x) {
		return typeof x == "object" && !!x;
	}
	w.exports = V;
})), require_isSymbol = /* @__PURE__ */ __commonJSMin(((x, w) => {
	var V = require__baseGetTag(), U = require_isObjectLike(), W = "[object Symbol]";
	function G(x) {
		return typeof x == "symbol" || U(x) && V(x) == W;
	}
	w.exports = G;
})), require__baseToString = /* @__PURE__ */ __commonJSMin(((x, w) => {
	var V = require__Symbol(), U = require__arrayMap(), W = require_isArray(), G = require_isSymbol(), K = Infinity, J = V ? V.prototype : void 0, Y = J ? J.toString : void 0;
	function Z(x) {
		if (typeof x == "string") return x;
		if (W(x)) return U(x, Z) + "";
		if (G(x)) return Y ? Y.call(x) : "";
		var w = x + "";
		return w == "0" && 1 / x == -K ? "-0" : w;
	}
	w.exports = Z;
})), require_toString = /* @__PURE__ */ __commonJSMin(((x, w) => {
	var V = require__baseToString();
	function U(x) {
		return x == null ? "" : V(x);
	}
	w.exports = U;
})), require_uniqueId = /* @__PURE__ */ __commonJSMin(((x, w) => {
	var V = require_toString(), U = 0;
	function W(x) {
		var w = ++U;
		return V(x) + w;
	}
	w.exports = W;
})), ActionButtons_module_default = {
	Container: "_Container_1jx22_1",
	Extra: "_Extra_1jx22_7",
	Text: "_Text_1jx22_10",
	Button: "_Button_1jx22_15",
	OptionsContainer: "_OptionsContainer_1jx22_18",
	Options: "_Options_1jx22_18",
	MenuOpen: "_MenuOpen_1jx22_32"
}, import_classnames$57 = /* @__PURE__ */ __toESM(require_classnames(), 1), import_uniqueId$3 = /* @__PURE__ */ __toESM(require_uniqueId(), 1), ActionButtons_default = forwardRef(function({ text: x, children: w, isActive: V, autoEnabled: U = !1, showAuto: W = !1, onClickAutoPlay: G }, K) {
	let [J, Y] = useState(!1), Z = useRef(null), $ = useMemo(() => (0, import_uniqueId$3.default)("buttons-"), []), ql = () => {
		Y(!0), Z.current?.focus();
	}, Jl = () => {
		Y(!1);
	}, Yl = (x) => {
		if (x.relatedTarget === null) {
			Y(!1);
			return;
		}
		Z.current?.contains(x.relatedTarget) || Y(!1);
	};
	return useImperativeHandle(K, () => ({
		close: Jl,
		open: ql,
		toggle: () => Y((x) => !x)
	}), []), /* @__PURE__ */ jsxs("div", {
		className: (0, import_classnames$57.default)(ActionButtons_module_default.Container, { [ActionButtons_module_default.Active]: V }),
		onClick: (x) => x.stopPropagation(),
		children: [/* @__PURE__ */ jsxs("div", {
			className: ActionButtons_module_default.Extra,
			children: [
				!J && x?.length ? /* @__PURE__ */ jsx(Text, {
					className: ActionButtons_module_default.Text,
					as: "p",
					children: x
				}) : null,
				W ? /* @__PURE__ */ jsx(Button_default, {
					iconProps: { icon: "arrow-clockwise" },
					variant: U ? "danger" : "secondary",
					onClick: G
				}) : null,
				/* @__PURE__ */ jsx(Button_default, {
					iconProps: {
						icon: "dots-three",
						weight: "bold",
						size: 20
					},
					buttonSize: "medium",
					variant: "icon",
					onClick: ql,
					className: ActionButtons_module_default.Button
				})
			]
		}), /* @__PURE__ */ jsx("div", {
			id: $,
			tabIndex: 0,
			ref: Z,
			onBlur: Yl,
			className: ActionButtons_module_default.OptionsContainer,
			children: /* @__PURE__ */ jsx("div", {
				className: (0, import_classnames$57.default)(ActionButtons_module_default.Options, { [ActionButtons_module_default.MenuOpen]: J }),
				children: w
			})
		})]
	});
}), Button_default$1 = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Popover$1.Button, {
	...w,
	children: x
}), Group_default = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Popover$1.Group, {
	...w,
	children: x
}), Overlay_default = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Popover$1.Overlay, {
	...w,
	children: x
}), Popover_module_default = {
	Popover: "_Popover_4zey8_1",
	Right: "_Right_4zey8_4",
	Center: "_Center_4zey8_7",
	Button: "_Button_4zey8_10",
	Panel: "_Panel_4zey8_13"
}, Panel_default$1 = ({ children: x, className: w, ...V }) => /* @__PURE__ */ jsx(Popover$1.Panel, {
	className: twMerge(Popover_module_default.Panel, w),
	...V,
	children: x
}), Popover = ({ children: x, className: w, position: V = "left", ...U }) => {
	let W = V === "left" ? Popover_module_default.Left : V === "right" ? Popover_module_default.Right : Popover_module_default.Center;
	return /* @__PURE__ */ jsx(Popover$1, {
		className: twMerge(Popover_module_default.Popover, W, w),
		...U,
		children: x
	});
};
Popover.Button = Button_default$1, Popover.Group = Group_default, Popover.Overlay = Overlay_default, Popover.Panel = Panel_default$1;
var ActionsPopover_module_default = {
	ActionsPopover: "_ActionsPopover_1b4hu_1",
	Panel: "_Panel_1b4hu_4",
	Popover: "_Popover_1b4hu_7",
	PopoverLink: "_PopoverLink_1b4hu_10",
	PopoverButton: "_PopoverButton_1b4hu_14"
};
function ActionsPopover({ className: x, iconColor: w, actionItems: V, position: U = "left", buttonDirection: W = "vertical" }) {
	return /* @__PURE__ */ jsx("div", {
		className: twMerge(ActionsPopover_module_default.ActionsPopover, x),
		onClick: (x) => x.stopPropagation(),
		children: /* @__PURE__ */ jsx(Popover, {
			position: U,
			children: ({ close: x }) => /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Popover.Button, {
				className: ActionsPopover_module_default.PopoverButton,
				children: /* @__PURE__ */ jsx(Icon_default, {
					icon: W === "vertical" ? "ellipsis" : "dots-three",
					color: w,
					size: 18,
					weight: "regular"
				})
			}), /* @__PURE__ */ jsx(Popover.Panel, {
				className: ActionsPopover_module_default.Panel,
				children: /* @__PURE__ */ jsx("div", {
					className: ActionsPopover_module_default.Popover,
					children: V?.map((w, V) => /* @__PURE__ */ jsx(w.as || "a", {
						className: ActionsPopover_module_default.PopoverLink,
						href: w.to,
						to: w.to,
						onClick: (V) => {
							w.onClick?.(V), x();
						},
						children: w.value
					}, V))
				})
			})] })
		})
	});
}
var Loader_module_default = {
	Loader: "_Loader_s0yea_1",
	spin: "_spin_s0yea_1",
	CenteredFullscreen: "_CenteredFullscreen_s0yea_11",
	CenteredInContainer: "_CenteredInContainer_s0yea_15"
}, import_classnames$56 = /* @__PURE__ */ __toESM(require_classnames(), 1), Loader_default = ({ centeredFullscreen: x, centeredInContainer: w, className: V, delay: U, error: W }) => {
	let [G, K] = useState(!1);
	return useEffect(() => {
		let x = setTimeout(() => K(!0), U);
		return () => {
			clearTimeout(x);
		};
	}, [U]), W ? /* @__PURE__ */ jsx("div", { children: "The requested resource could not be loaded" }) : G ? /* @__PURE__ */ jsx("div", {
		className: (0, import_classnames$56.default)(Loader_module_default.Loader, { [Loader_module_default.CenteredFullscreen]: x }, { [Loader_module_default.CenteredInContainer]: w }, V),
		children: /* @__PURE__ */ jsx("svg", {
			xmlns: "http://www.w3.org/2000/svg",
			width: "60",
			height: "60",
			viewBox: "-1.5 1.5 60 60",
			children: /* @__PURE__ */ jsx("path", {
				d: "M1181-5791.3h0a23.85,23.85,0,0,1-9.341-1.886,23.969,23.969,0,0,1-7.629-5.143,23.96,23.96,0,0,1-5.143-7.629A23.85,23.85,0,0,1,1157-5815.3a23.851,23.851,0,0,1,1.886-9.342,23.967,23.967,0,0,1,5.143-7.629,23.975,23.975,0,0,1,7.629-5.143A23.836,23.836,0,0,1,1181-5839.3a23.851,23.851,0,0,1,9.343,1.885,23.941,23.941,0,0,1,7.628,5.143l-2.827,2.829a19.889,19.889,0,0,0-6.358-4.284A19.845,19.845,0,0,0,1181-5835.3a19.854,19.854,0,0,0-7.785,1.572,19.926,19.926,0,0,0-6.356,4.284,19.92,19.92,0,0,0-4.286,6.359A19.875,19.875,0,0,0,1161-5815.3a19.872,19.872,0,0,0,1.573,7.784,19.92,19.92,0,0,0,4.286,6.359,19.918,19.918,0,0,0,6.356,4.285A19.889,19.889,0,0,0,1181-5795.3v4Z",
				transform: "translate(-4920.833 -3242.211) rotate(112)",
				fill: "#4360ff"
			})
		})
	}) : null;
};
function classNames$10(...x) {
	return x.filter(Boolean).join(" ");
}
function r$2(x) {
	var w, V, U = "";
	if (typeof x == "string" || typeof x == "number") U += x;
	else if (typeof x == "object") if (Array.isArray(x)) {
		var W = x.length;
		for (w = 0; w < W; w++) x[w] && (V = r$2(x[w])) && (U && (U += " "), U += V);
	} else for (V in x) x[V] && (U && (U += " "), U += V);
	return U;
}
function clsx$1() {
	for (var x, w, V = 0, U = "", W = arguments.length; V < W; V++) (x = arguments[V]) && (w = r$2(x)) && (U && (U += " "), U += w);
	return U;
}
var clsx_default = clsx$1;
const cn$12 = (...x) => twMerge(clsx_default(...x));
function validateEmailAddress(x = "") {
	return x && /^[a-zA-Z0-9!#$%&'*+-/=?^_`{|}~]{1,64}@(?:[a-zA-Z0-9-]{1,63}[.]{1}){1,125}[a-zA-Z0-9]{2,63}$/.test(x);
}
var utility_exports = /* @__PURE__ */ __export({
	classNames: () => classNames$10,
	cn: () => cn$12,
	validateEmailAddress: () => validateEmailAddress
}, 1);
function getInitials(x) {
	if (validateEmailAddress(x)) {
		let w = x.split("@");
		return `${w[0][0]}${w[1][0]}`.toUpperCase();
	}
	let w = x.match(/\p{Lu}/gu), V;
	return V = w && w.length >= 2 ? w : x.toUpperCase().match(/\p{Lu}/gu), !V || V.length < 2 ? x.length >= 2 ? x.slice(0, 2).toUpperCase() : x.toUpperCase() : `${V[0]}${V[1]}`;
}
var Avatar_module_default = {
	Avatar: "_Avatar_azf3s_1",
	NoImage: "_NoImage_azf3s_7",
	Loader: "_Loader_azf3s_16",
	pulse: "_pulse_azf3s_1",
	Rounded: "_Rounded_azf3s_22",
	Examples: "_Examples_azf3s_26",
	Example: "_Example_azf3s_26",
	ExampleOriginal: "_ExampleOriginal_azf3s_34",
	ExampleAvatar: "_ExampleAvatar_azf3s_38"
}, import_classnames$55 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function Avatar({ input: x = "Anonymous", isLoading: w = !1, rounded: V = !0, className: U }) {
	let W = useMemo(() => w ? "" : getInitials(x), [x, w]);
	return /* @__PURE__ */ jsx("div", {
		className: (0, import_classnames$55.default)(Avatar_module_default.Avatar, {
			[Avatar_module_default.NoImage]: !0,
			[Avatar_module_default.Rounded]: V
		}, U),
		children: w ? /* @__PURE__ */ jsx(Loader_default, { className: Avatar_module_default.Loader }) : /* @__PURE__ */ jsx("span", { children: W })
	});
}
var Card_module_default = {
	Card: "_Card_p7867_1",
	Header: "_Header_p7867_11",
	Title: "_Title_p7867_14",
	Actions: "_Actions_p7867_17",
	CardActivated: "_CardActivated_p7867_27"
}, import_classnames$54 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function Card({ activated: x, children: w, className: V, actionItems: U, popoverPosition: W = "right", popoverButtonDirection: G, headerContent: K }) {
	return /* @__PURE__ */ jsxs("div", {
		className: (0, import_classnames$54.default)(Card_module_default.Card, x ? Card_module_default.CardActivated : null, V),
		children: [/* @__PURE__ */ jsxs("div", {
			className: Card_module_default.Header,
			children: [typeof K == "string" ? /* @__PURE__ */ jsx(Text, {
				as: "h3",
				className: Card_module_default.Title,
				title: K,
				children: K
			}) : /* @__PURE__ */ jsx("div", { children: K }), U ? /* @__PURE__ */ jsx("div", {
				className: Card_module_default.Actions,
				children: /* @__PURE__ */ jsx(ActionsPopover, {
					iconColor: "#F5F6FF",
					actionItems: U,
					position: W,
					buttonDirection: G
				})
			}) : null]
		}), w ? /* @__PURE__ */ jsx("div", {
			className: Card_module_default.Children,
			children: w
		}) : null]
	});
}
var Button$4 = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Combobox.Button, {
	...w,
	children: x
}), Input$3 = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Combobox.Input, {
	...w,
	children: x
}), Label$5 = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Combobox.Label, {
	...w,
	children: x
}), Option$5 = ({ children: x, as: w = "li", ...V }) => /* @__PURE__ */ jsx(Combobox.Option, {
	as: w,
	...V,
	children: x
}), Options$2 = ({ children: x, as: w = "ul", ...V }) => /* @__PURE__ */ jsx(Combobox.Options, {
	as: w,
	...V,
	children: x
}), RootCombobox = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Combobox, {
	...w,
	children: x
});
RootCombobox.displayName = "Combobox", RootCombobox.Button = Button$4, RootCombobox.Input = Input$3, RootCombobox.Label = Label$5, RootCombobox.Option = Option$5, RootCombobox.Options = Options$2;
var Combobox_default = RootCombobox, DarkModeSwitch_module_default = {
	DarkModeSwitch: "_DarkModeSwitch_if2gw_1",
	label: "_label_if2gw_5",
	light: "_light_if2gw_9",
	dark: "_dark_if2gw_12",
	switch: "_switch_if2gw_16",
	switchInner: "_switchInner_if2gw_21",
	icon: "_icon_if2gw_25",
	darkMode: "_darkMode_if2gw_28",
	lightMode: "_lightMode_if2gw_31",
	slider: "_slider_if2gw_35"
}, import_classnames$53 = /* @__PURE__ */ __toESM(require_classnames(), 1), DarkModeSwitch_default = ({ defaultDarkMode: x = !0, onToggle: w, className: V = "" }) => {
	let [U, W] = useState(x);
	return /* @__PURE__ */ jsxs("div", {
		className: (0, import_classnames$53.default)(DarkModeSwitch_module_default.DarkModeSwitch, V),
		onClick: () => {
			let x = !U;
			W(x), w?.(x);
		},
		children: [
			/* @__PURE__ */ jsx("span", {
				className: (0, import_classnames$53.default)(DarkModeSwitch_module_default.label, {
					[DarkModeSwitch_module_default.light]: !U,
					[DarkModeSwitch_module_default.dark]: U
				}),
				children: "Light"
			}),
			/* @__PURE__ */ jsx(Switch, {
				checked: U,
				className: DarkModeSwitch_module_default.switch,
				children: /* @__PURE__ */ jsxs("div", {
					className: DarkModeSwitch_module_default.switchInner,
					children: [/* @__PURE__ */ jsx("span", {
						className: (0, import_classnames$53.default)(DarkModeSwitch_module_default.icon, {
							[DarkModeSwitch_module_default.darkMode]: U,
							[DarkModeSwitch_module_default.lightMode]: !U
						}),
						children: /* @__PURE__ */ jsx(Icon_default, {
							icon: U ? "moon" : "sun",
							size: 12,
							color: "white"
						})
					}), /* @__PURE__ */ jsx("span", { className: (0, import_classnames$53.default)(DarkModeSwitch_module_default.slider, {
						[DarkModeSwitch_module_default.darkMode]: U,
						[DarkModeSwitch_module_default.lightMode]: !U
					}) })]
				})
			}),
			/* @__PURE__ */ jsx("span", {
				className: (0, import_classnames$53.default)(DarkModeSwitch_module_default.label, {
					[DarkModeSwitch_module_default.light]: U,
					[DarkModeSwitch_module_default.dark]: !U
				}),
				children: "Dark"
			})
		]
	});
};
function Date$1({ dateString: x, className: w }) {
	return /* @__PURE__ */ jsx("time", {
		className: w,
		dateTime: x,
		children: format(parseISO(x), "d MMM yyyy", { locale: nl })
	});
}
var Description_module_default = {}, import_classnames$52 = /* @__PURE__ */ __toESM(require_classnames(), 1), Description_default = ({ children: x, className: w }) => /* @__PURE__ */ jsx(Dialog$1.Description, {
	className: twMerge((0, import_classnames$52.default)(Description_module_default.Description, w)),
	children: x
}), Dialog_module_default = {
	Dialog: "_Dialog_lmzhs_1",
	Backdrop: "_Backdrop_lmzhs_6",
	OuterWrapper: "_OuterWrapper_lmzhs_10",
	InnerWrapper: "_InnerWrapper_lmzhs_14"
}, Footer_module_default = { Footer: "_Footer_gj0p8_1" }, import_classnames$51 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function Footer({ children: x, className: w }) {
	return /* @__PURE__ */ jsx("div", {
		className: twMerge((0, import_classnames$51.default)(Footer_module_default.Footer, w)),
		children: x
	});
}
var Panel_module_default$1 = { Panel: "_Panel_1j3t3_1" }, import_classnames$50 = /* @__PURE__ */ __toESM(require_classnames(), 1), Panel_default = ({ children: x, refName: w, className: V, ...U }) => /* @__PURE__ */ jsx(Dialog$1.Panel, {
	className: twMerge((0, import_classnames$50.default)(Panel_module_default$1.Panel, V)),
	...U,
	children: x
}), Title_module_default = { Title: "_Title_1xldg_1" }, import_classnames$49 = /* @__PURE__ */ __toESM(require_classnames(), 1), Title_default = ({ children: x, className: w, ...V }) => /* @__PURE__ */ jsx(Dialog$1.Title, {
	className: twMerge((0, import_classnames$49.default)(Title_module_default.Title, w)),
	...V,
	children: x
}), import_classnames$48 = /* @__PURE__ */ __toESM(require_classnames(), 1), Dialog = ({ children: x, backdrop: w, className: V, ...U }) => /* @__PURE__ */ jsxs(Dialog$1, {
	className: twMerge((0, import_classnames$48.default)(Dialog_module_default.Dialog, V)),
	...U,
	children: [w ? /* @__PURE__ */ jsx("div", {
		className: Dialog_module_default.Backdrop,
		"aria-hidden": "true"
	}) : null, /* @__PURE__ */ jsx("div", {
		className: Dialog_module_default.OuterWrapper,
		children: /* @__PURE__ */ jsx("div", {
			className: Dialog_module_default.InnerWrapper,
			children: x
		})
	})]
});
Dialog.Panel = Panel_default, Dialog.Title = Title_default, Dialog.Description = Description_default, Dialog.Footer = Footer;
var Directory_module_default$1 = {
	FolderName: "_FolderName_15yms_1",
	FolderIcon: "_FolderIcon_15yms_8",
	DirectoryItem: "_DirectoryItem_15yms_12",
	DirectoryItemActive: "_DirectoryItemActive_15yms_19",
	DirectoryList: "_DirectoryList_15yms_23",
	CreateDirectoryButton: "_CreateDirectoryButton_15yms_28",
	BrowserDirectoryWrapper: "_BrowserDirectoryWrapper_15yms_32",
	ActiveDirectoryItem: "_ActiveDirectoryItem_15yms_36",
	ActiveSubDirectoryItem: "_ActiveSubDirectoryItem_15yms_40",
	CreateFolderButton: "_CreateFolderButton_15yms_44",
	CreatingFolderSpinnerWrapper: "_CreatingFolderSpinnerWrapper_15yms_51",
	CreatingFolderSpinner: "_CreatingFolderSpinner_15yms_51",
	NewFolderNameInput: "_NewFolderNameInput_15yms_65",
	ShowCreateFolderInputButton: "_ShowCreateFolderInputButton_15yms_72",
	DeleteButton: "_DeleteButton_15yms_84",
	DialogFooter: "_DialogFooter_15yms_99",
	TitleWrapper: "_TitleWrapper_15yms_103",
	Truncated: "_Truncated_15yms_111",
	UpdateFolderButton: "_UpdateFolderButton_15yms_115"
}, Input_module_default = {
	InputField: "_InputField_i2vf1_1",
	HasSuffix: "_HasSuffix_i2vf1_1",
	InputFlex: "_InputFlex_i2vf1_4",
	LabelWrapper: "_LabelWrapper_i2vf1_7",
	ToggleWrapper: "_ToggleWrapper_i2vf1_14",
	Description: "_Description_i2vf1_23",
	Suffix: "_Suffix_i2vf1_28",
	TextSelectCursor: "_TextSelectCursor_i2vf1_41",
	SuffixValue: "_SuffixValue_i2vf1_49",
	Error: "_Error_i2vf1_68",
	Success: "_Success_i2vf1_72",
	Dark: "_Dark_i2vf1_134"
}, Checkbox_module_default = { CheckboxWrapper: "_CheckboxWrapper_1akoo_1" }, import_classnames$47 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function CheckboxImpl({ checked: x, ...w }, V) {
	return /* @__PURE__ */ jsx("div", {
		className: (0, import_classnames$47.default)(Checkbox_module_default.CheckboxWrapper, { [Checkbox_module_default.Checked]: x }),
		children: /* @__PURE__ */ jsx("input", {
			ref: V,
			checked: x,
			type: "checkbox",
			...w
		})
	});
}
var Checkbox_default = React.forwardRef(CheckboxImpl), ColorPicker_module_default = {
	wrapper: "_wrapper_1kf77_1",
	textInput: "_textInput_1kf77_10",
	trigger: "_trigger_1kf77_27",
	swatch: "_swatch_1kf77_35",
	hiddenInput: "_hiddenInput_1kf77_39"
}, import_classnames$46 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function ColorPickerImpl({ value: x, onChange: w, disabled: V, readOnly: U, className: W, placeholder: G = "#000000" }, K) {
	let J = useRef(null), Y = x == null ? "" : String(x);
	return /* @__PURE__ */ jsxs("div", {
		className: (0, import_classnames$46.default)(ColorPicker_module_default.wrapper, W),
		children: [/* @__PURE__ */ jsx("input", {
			ref: K,
			type: "text",
			className: ColorPicker_module_default.textInput,
			value: Y,
			placeholder: G,
			onChange: w,
			disabled: V
		}), /* @__PURE__ */ jsxs("button", {
			type: "button",
			className: ColorPicker_module_default.trigger,
			onClick: () => {
				V || U || J.current?.click();
			},
			disabled: V || U,
			tabIndex: -1,
			children: [/* @__PURE__ */ jsx("span", {
				className: ColorPicker_module_default.swatch,
				style: { backgroundColor: Y || "transparent" }
			}), /* @__PURE__ */ jsx("input", {
				ref: J,
				type: "color",
				value: Y || "#000000",
				onChange: w,
				className: ColorPicker_module_default.hiddenInput,
				disabled: V || U,
				tabIndex: -1
			})]
		})]
	});
}
var ColorPicker_default = React.forwardRef(ColorPickerImpl), BYTE_UNITS = [
	"B",
	"kB",
	"MB",
	"GB",
	"TB",
	"PB",
	"EB",
	"ZB",
	"YB"
], BIBYTE_UNITS = [
	"B",
	"KiB",
	"MiB",
	"GiB",
	"TiB",
	"PiB",
	"EiB",
	"ZiB",
	"YiB"
], BIT_UNITS = [
	"b",
	"kbit",
	"Mbit",
	"Gbit",
	"Tbit",
	"Pbit",
	"Ebit",
	"Zbit",
	"Ybit"
], BIBIT_UNITS = [
	"b",
	"kibit",
	"Mibit",
	"Gibit",
	"Tibit",
	"Pibit",
	"Eibit",
	"Zibit",
	"Yibit"
], toLocaleString = (x, w, V) => {
	let U = x;
	return typeof w == "string" || Array.isArray(w) ? U = x.toLocaleString(w, V) : (w === !0 || V !== void 0) && (U = x.toLocaleString(void 0, V)), U;
};
function prettyBytes(x, w) {
	if (!Number.isFinite(x)) throw TypeError(`Expected a finite number, got ${typeof x}: ${x}`);
	w = {
		bits: !1,
		binary: !1,
		space: !0,
		...w
	};
	let V = w.bits ? w.binary ? BIBIT_UNITS : BIT_UNITS : w.binary ? BIBYTE_UNITS : BYTE_UNITS, U = w.space ? " " : "";
	if (w.signed && x === 0) return ` 0${U}${V[0]}`;
	let W = x < 0, G = W ? "-" : w.signed ? "+" : "";
	W && (x = -x);
	let K;
	if (w.minimumFractionDigits !== void 0 && (K = { minimumFractionDigits: w.minimumFractionDigits }), w.maximumFractionDigits !== void 0 && (K = {
		maximumFractionDigits: w.maximumFractionDigits,
		...K
	}), x < 1) return G + toLocaleString(x, w.locale, K) + U + V[0];
	let J = Math.min(Math.floor(w.binary ? Math.log(x) / Math.log(1024) : Math.log10(x) / 3), V.length - 1);
	x /= (w.binary ? 1024 : 1e3) ** J, K || (x = x.toPrecision(3));
	let Y = toLocaleString(Number(x), w.locale, K), Z = V[J];
	return G + Y + U + Z;
}
var File_module_default$1 = {
	FileInputWrapper: "_FileInputWrapper_t1y90_1",
	FakeFileInput: "_FakeFileInput_t1y90_6",
	Hover: "_Hover_t1y90_12",
	SubTitle: "_SubTitle_t1y90_15",
	IsUploading: "_IsUploading_t1y90_23",
	FileInput: "_FileInput_t1y90_1",
	Icon: "_Icon_t1y90_32",
	Title: "_Title_t1y90_36",
	FileInputUploaded: "_FileInputUploaded_t1y90_44",
	UploadedFileDescription: "_UploadedFileDescription_t1y90_50",
	FileName: "_FileName_t1y90_54",
	FileSize: "_FileSize_t1y90_58",
	ImagePreview: "_ImagePreview_t1y90_62",
	Image: "_Image_t1y90_62"
}, import_classnames$45 = /* @__PURE__ */ __toESM(require_classnames(), 1);
const STATUS_INITIAL = "initial", STATUS_PROCESSING = "processing", STATUS_COMPLETED = "completed";
var Droppable$1 = ({ children: x, className: w, fileDropped: V }) => {
	let [U, W] = useState(!1), G = useRef(null), K = (x) => {
		x.preventDefault(), x.stopPropagation();
	}, J = (x) => {
		V(x.dataTransfer.files[0]);
	};
	return useEffect(() => (G.current.addEventListener("dragover", (x) => {
		K(x), W(!0);
	}, !1), G.current.addEventListener("dragenter", (x) => {
		K(x), W(!0);
	}, !1), G.current.addEventListener("dragleave", (x) => {
		K(x), W(!1);
	}, !1), G.current.addEventListener("drop", (x) => {
		K(x), J(x), W(!1);
	}, !1), () => {}), []), /* @__PURE__ */ jsx("div", {
		className: (0, import_classnames$45.default)(w, { [File_module_default$1.Hover]: U }),
		ref: G,
		children: x
	});
}, File_default = ({ accept: x = "image/*", fileAdded: w = () => {}, fileRemoved: V = () => {}, customFileSizeInstructionMessage: U, multiple: W, className: G }) => {
	let K = {
		status: STATUS_INITIAL,
		file: {},
		imagePreview: ""
	}, [J, Y] = useState(K), { t: Z } = useTranslation(), $ = useRef(null), ql = () => $.current.click(), Jl = (x) => {
		let V = new FileReader();
		Y((w) => ({
			...w,
			file: x,
			status: STATUS_PROCESSING
		})), V.onload = () => {
			Y((w) => ({
				...w,
				...x.type.startsWith("image/") ? { imagePreview: V.result } : {},
				status: STATUS_COMPLETED
			}));
		}, V.readAsDataURL(x), w(x);
	}, Yl = (x) => {
		let w = x.target.files[0];
		Jl(w);
	};
	return J.status === "completed" ? /* @__PURE__ */ jsxs("div", {
		className: (0, import_classnames$45.default)(File_module_default$1.FileInputUploaded, G),
		children: [J.imagePreview && /* @__PURE__ */ jsx("div", {
			className: File_module_default$1.ImagePreview,
			children: /* @__PURE__ */ jsx("img", {
				className: File_module_default$1.Image,
				src: J.imagePreview,
				alt: J.file.name
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: (0, import_classnames$45.default)(File_module_default$1.UploadedFileDescription),
			children: [/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("span", {
				className: File_module_default$1.FileName,
				children: J.file?.name
			}), /* @__PURE__ */ jsx("span", {
				className: File_module_default$1.FileSize,
				children: prettyBytes(J.file?.size)
			})] }), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Button_default, {
				variant: "tertiary",
				iconProps: { icon: "x-circle" },
				onClick: () => {
					V(J.file), Y(K);
				}
			}) })]
		})]
	}) : /* @__PURE__ */ jsxs(Droppable$1, {
		className: File_module_default$1.FileInputWrapper,
		fileDropped: (x) => Jl(x),
		children: [/* @__PURE__ */ jsxs("div", {
			className: (0, import_classnames$45.default)(File_module_default$1.FakeFileInput, { [File_module_default$1.IsUploading]: J.status === STATUS_PROCESSING }),
			onClick: ql,
			children: [
				/* @__PURE__ */ jsx("div", { className: File_module_default$1.Icon }),
				/* @__PURE__ */ jsx("span", {
					className: File_module_default$1.Title,
					children: Z("Input:fileUploadInstruction")
				}),
				/* @__PURE__ */ jsx("span", {
					className: File_module_default$1.SubTitle,
					children: U || Z("Input:fileSizeInstruction")
				})
			]
		}), /* @__PURE__ */ jsx("input", {
			type: "file",
			accept: x,
			multiple: W,
			className: File_module_default$1.FileInput,
			ref: $,
			onChange: Yl
		})]
	});
}, Radio_module_default = {
	RadioWrapper: "_RadioWrapper_dhizx_1",
	Radio: "_Radio_dhizx_1"
}, import_uniqueId$2 = /* @__PURE__ */ __toESM(require_uniqueId(), 1);
function RadioImpl({ id: x, className: w, onChange: V = () => {}, radioOptions: U = [], required: W = !1, value: G }, K) {
	return /* @__PURE__ */ jsx("div", {
		className: Radio_module_default.RadioWrapper,
		children: U.map((U, J) => {
			let Y = (0, import_uniqueId$2.default)(`${x}-`);
			return /* @__PURE__ */ jsxs("div", {
				className: Radio_module_default.Radio,
				children: [/* @__PURE__ */ jsx("input", {
					checked: U.value === G,
					className: w,
					id: Y,
					name: x,
					onChange: () => V(U.value),
					required: W,
					type: "radio",
					value: U.value,
					ref: K
				}, `input-${J}`), /* @__PURE__ */ jsxs("label", {
					htmlFor: Y,
					children: [typeof U.label == "string" && U.label, typeof U.label == "function" && U.label()]
				}, `label-${J}`)]
			}, `wrap-${J}`);
		})
	});
}
var Radio_default = React.forwardRef(RadioImpl);
function isSelectOption(x) {
	return !Array.isArray(x) && typeof x != "string" && typeof x != "number" && x.value && x.label;
}
function isSelectOptionArray(x) {
	return Array.isArray(x) && x.every(isSelectOption);
}
var Select_module_default$1 = {
	ListLabel: "_ListLabel_142zp_1",
	BoxWrapper: "_BoxWrapper_142zp_5",
	Disabled: "_Disabled_142zp_9",
	DisplayValue: "_DisplayValue_142zp_17",
	ListButton: "_ListButton_142zp_21",
	OptionsWrapper: "_OptionsWrapper_142zp_31",
	full: "_full_142zp_36",
	fit: "_fit_142zp_39",
	Option: "_Option_142zp_31",
	Selected: "_Selected_142zp_50",
	OptionLabel: "_OptionLabel_142zp_54",
	Placeholder: "_Placeholder_142zp_58",
	TransitionLeave: "_TransitionLeave_142zp_62",
	TransitionLeaveFrom: "_TransitionLeaveFrom_142zp_66",
	TransitionLeaveTo: "_TransitionLeaveTo_142zp_70",
	SearchInputWrapper: "_SearchInputWrapper_142zp_74",
	SearchIcon: "_SearchIcon_142zp_82",
	SearchInput: "_SearchInput_142zp_74"
}, import_classnames$44 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function OptionSearch({ options: x, setFilteredOptions: w }) {
	let [V, U] = useState(""), W = useRef(null), G = useCallback((x) => {
		let w = x?.label?.toLocaleLowerCase(), U = V.toLocaleLowerCase();
		return w.includes(U);
	}, [V]);
	return useEffect(() => {
		w(x.filter(G));
	}, [
		x,
		V,
		w
	]), /* @__PURE__ */ jsxs("div", {
		className: Select_module_default$1.SearchInputWrapper,
		children: [/* @__PURE__ */ jsx(Icon_default, {
			className: Select_module_default$1.SearchIcon,
			icon: "search",
			size: 18,
			weight: "regular",
			onClick: () => W?.current?.focus()
		}), /* @__PURE__ */ jsx("input", {
			className: Select_module_default$1.SearchInput,
			type: "text",
			value: V,
			onChange: (x) => U(x.target.value),
			onKeyDown: (x) => {
				x.code === "Space" && x.stopPropagation();
			},
			placeholder: "Search...",
			ref: W
		})]
	});
}
function SelectImpl({ className: x, disabled: w, error: V, label: U, onChange: G, options: K = [], optionClassname: J, optionsWrapperClassname: Z, caret: $ = !1, placeholder: ql, value: Jl, multiple: Yl, panelWidth: Zl, searchable: Ql = !1, selectedClassname: $l }, eu) {
	let nu = useMemo(() => Jl === void 0 ? Yl ? [] : "" : Jl, [Jl, Yl]), ru = useMemo(() => !!(isSelectOptionArray(nu) && nu.length > 0 || isSelectOption(nu) && nu.label || !isSelectOptionArray(nu) && nu), [nu]), iu = useMemo(() => isSelectOptionArray(nu) ? K.filter((x) => nu.map(({ value: x }) => x).includes(x.value)).map((x) => x.label).join(", ") : isSelectOption(nu) ? nu.label : nu, [nu]), [au, ou] = useState(K), su = useCallback((x) => {
		let w;
		if (isSelectOptionArray(nu) && isSelectOptionArray(x)) {
			let V = x.map(({ value: x }) => x), U = V.filter((x, w) => V.indexOf(x) !== w);
			w = x.filter(({ value: x }) => !U.includes(x));
		} else w = isSelectOption(x) ? isSelectOption(nu) && nu.value !== x.value || !nu ? x : "" : isSelectOption(nu) && nu.value !== x || !nu ? K.find((w) => w.value === x) : "";
		G(w);
	}, [nu, K]), lu = useCallback((x, w) => x ? !0 : isSelectOption(nu) ? w.value === nu.value : isSelectOptionArray(nu) ? nu.map(({ value: x }) => x).includes(w.value) : !1, [nu]);
	return /* @__PURE__ */ jsx(Listbox, {
		ref: eu,
		disabled: w,
		multiple: Yl,
		onChange: su,
		value: nu,
		children: ({ open: G }) => /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Listbox.Label, {
			className: (0, import_classnames$44.default)(Select_module_default$1.ListLabel),
			children: U
		}), /* @__PURE__ */ jsxs("div", {
			className: (0, import_classnames$44.default)(Select_module_default$1.BoxWrapper),
			children: [/* @__PURE__ */ jsxs(Listbox.Button, {
				as: Button_default,
				variant: "tertiary",
				className: (0, import_classnames$44.default)(Select_module_default$1.ListButton, {
					[Select_module_default$1.Disabled]: w,
					[Select_module_default$1.Error]: V
				}, x),
				children: [ru ? /* @__PURE__ */ jsx("span", {
					className: Select_module_default$1.DisplayValue,
					children: iu
				}) : /* @__PURE__ */ jsx("span", {
					className: Select_module_default$1.Placeholder,
					children: ql
				}), $ && /* @__PURE__ */ jsx(Icon_default, {
					icon: "chevron-down",
					size: 16,
					color: preset_default.theme.extend.colors.white
				})]
			}), /* @__PURE__ */ jsx(Transition, {
				show: G,
				as: Fragment,
				leave: Select_module_default$1.TransitionLeave,
				leaveFrom: Select_module_default$1.TransitionLeaveFrom,
				leaveTo: Select_module_default$1.TransitionLeaveTo,
				children: /* @__PURE__ */ jsxs(Listbox.Options, {
					className: (0, import_classnames$44.default)(Select_module_default$1.OptionsWrapper, Select_module_default$1[Zl], Z),
					children: [Ql && /* @__PURE__ */ jsx(OptionSearch, {
						options: K,
						setFilteredOptions: ou
					}), au.map((x) => /* @__PURE__ */ jsx(Listbox.Option, {
						value: x,
						children: ({ selected: w }) => /* @__PURE__ */ jsxs("div", {
							className: (0, import_classnames$44.default)(Select_module_default$1.Option, {
								[Select_module_default$1.Selected]: lu(w, x),
								[J]: J && !lu(w, x),
								[$l]: $l && lu(w, x)
							}),
							children: [/* @__PURE__ */ jsx("span", {
								className: Select_module_default$1.OptionLabel,
								children: x.label
							}), lu(w, x) && /* @__PURE__ */ jsx(Icon_default, {
								icon: "quickbutton",
								size: 16,
								color: "#fff"
							})]
						})
					}, x.value))]
				})
			})]
		})] })
	});
}
var Select_default$1 = React.forwardRef(SelectImpl), SelectableInput_module_default = {
	SelectableInputWrapper: "_SelectableInputWrapper_12uqi_1",
	SelectableInputParagraph: "_SelectableInputParagraph_12uqi_5"
}, SelectableInput_default = React.forwardRef(({ onClick: x, placeholder: w = "Select an option", value: V = "", buttonIcon: U }, W) => {
	let G = V === "", K = G ? "secondary" : "primary";
	return /* @__PURE__ */ jsxs("div", {
		className: SelectableInput_module_default.SelectableInputWrapper,
		children: [/* @__PURE__ */ jsx("p", {
			className: SelectableInput_module_default.SelectableInputParagraph,
			children: G ? w : V
		}), U ? /* @__PURE__ */ jsx(Button_default, {
			iconProps: { icon: U },
			variant: K,
			onClick: x,
			"aria-label": "Select option"
		}) : /* @__PURE__ */ jsx(Button_default, {
			variant: K,
			hasBorderRadius: !0,
			onClick: x,
			"aria-label": "Select option",
			ref: W,
			children: "Select"
		})]
	});
}), Textarea_module_default = { Textarea: "_Textarea_169sd_1" }, import_classnames$43 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function TextareaImpl({ className: x, rows: w = null, ...V }, U) {
	return /* @__PURE__ */ jsx("textarea", {
		ref: U,
		className: (0, import_classnames$43.default)(Textarea_module_default.Textarea, x),
		rows: w,
		...V
	});
}
var Textarea_default = React.forwardRef(TextareaImpl), Toggle_module_default = {
	Toggle: "_Toggle_1x6o7_1",
	Disabled: "_Disabled_1x6o7_4",
	Switch: "_Switch_1x6o7_4",
	SwitchSpan: "_SwitchSpan_1x6o7_7",
	Enabled: "_Enabled_1x6o7_10",
	lg: "_lg_1x6o7_10",
	sm: "_sm_1x6o7_13",
	Dark: "_Dark_1x6o7_39"
}, import_classnames$42 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function ToggleImpl({ disabled: x, checked: w, className: V, onChange: U, dark: W, size: G }, K) {
	return /* @__PURE__ */ jsx(Switch.Group, {
		as: "div",
		className: (0, import_classnames$42.default)(Toggle_module_default.Toggle, Toggle_module_default[G], V, {
			[Toggle_module_default.Disabled]: x,
			[Toggle_module_default.Enabled]: !!w
		}),
		children: /* @__PURE__ */ jsx(Switch, {
			checked: !!w,
			onChange: U,
			className: (0, import_classnames$42.default)(Toggle_module_default.Switch, { [Toggle_module_default.Dark]: W }),
			disabled: !!x,
			ref: K,
			children: /* @__PURE__ */ jsx("span", {
				"aria-hidden": "true",
				className: Toggle_module_default.SwitchSpan
			})
		})
	});
}
var Toggle_default = React.forwardRef(ToggleImpl), import_classnames$41 = /* @__PURE__ */ __toESM(require_classnames(), 1), import_uniqueId$1 = /* @__PURE__ */ __toESM(require_uniqueId(), 1);
function hasPointerCursor(x) {
	return x === "checkbox" || x === "file" || x === "radio" || x === "select" || x === "toggle" || x === "selectableInput";
}
var InputElement = React.forwardRef((x, w) => {
	let { type: V, ...U } = x, W = V === void 0 || !hasPointerCursor(V), G = {
		default: (0, import_classnames$41.default)(Input_module_default.Dark, W && Input_module_default.TextSelectCursor, x.className),
		checkbox: (0, import_classnames$41.default)(Input_module_default.Checkbox, x.className)
	};
	switch (V) {
		case "checkbox": return /* @__PURE__ */ jsx(Checkbox_default, {
			...U,
			ref: w,
			className: G.checkbox
		});
		case "file": return /* @__PURE__ */ jsx(File_default, {
			...U,
			className: G.default
		});
		case "radio": return /* @__PURE__ */ jsx(Radio_default, {
			...U,
			ref: w,
			className: G.default
		});
		case "select": return /* @__PURE__ */ jsx(Select_default$1, {
			...U,
			ref: w
		});
		case "textarea": return /* @__PURE__ */ jsx(Textarea_default, {
			...U,
			ref: w,
			className: G.default
		});
		case "colorPicker": return /* @__PURE__ */ jsx(ColorPicker_default, {
			...U,
			ref: w,
			className: G.default
		});
		case "toggle": return /* @__PURE__ */ jsx(Toggle_default, {
			...U,
			ref: w,
			className: G.default
		});
		case "selectableInput": return /* @__PURE__ */ jsx(SelectableInput_default, {
			...U,
			ref: w
		});
		default: return /* @__PURE__ */ jsx("input", {
			...U,
			ref: w,
			className: G.default,
			type: typeof V == "string" && V
		});
	}
}), InputWrapper = ({ children: x, className: w, description: V = null, hasSuffix: U = !1, id: W, label: G, required: K, type: J }) => /* @__PURE__ */ jsxs("div", {
	className: (0, import_classnames$41.default)(Input_module_default.InputField, w, {
		[Input_module_default.HasSuffix]: U,
		[Input_module_default.InputFlex]: J === "checkbox",
		[Input_module_default.ToggleWrapper]: J === "toggle"
	}),
	children: [
		["checkbox"].includes(J) && x,
		G && /* @__PURE__ */ jsxs("div", {
			className: Input_module_default.LabelWrapper,
			children: [/* @__PURE__ */ jsxs("label", {
				htmlFor: W,
				children: [
					G,
					" ",
					K && /* @__PURE__ */ jsx("sup", {
						className: "required",
						children: "*"
					})
				]
			}), (V && J === "checkbox" || J === "toggle") && /* @__PURE__ */ jsx("p", {
				className: Input_module_default.Description,
				children: V
			})]
		}),
		!["checkbox"].includes(J) && x
	]
}), Input = ({ className: x, classNameInput: w, classNameWrapper: V, hasError: U = !1, hasSuccess: W = !1, inputRef: G, label: K, required: J = !1, suffix: Y, description: Z = null, type: $ = "text", style: ql, ...Jl }) => {
	let Yl = {
		autoComplete: "off",
		caret: "HiChevronDown",
		disabled: !1,
		onChange: () => {},
		onClick: () => {},
		onKeyPress: () => {},
		onKeyDown: () => {},
		onFocus: () => {},
		placeholder: null,
		readOnly: !1,
		value: "",
		...Jl
	}, Xl = useMemo(() => (0, import_uniqueId$1.default)("input-"), []), Zl = (0, import_classnames$41.default)({
		[Input_module_default.Error]: U,
		[Input_module_default.Success]: W
	}, x), Ql = G ?? useRef(null);
	return /* @__PURE__ */ jsxs(InputWrapper, {
		className: (0, import_classnames$41.default)(Zl, V),
		description: Z,
		hasSuffix: !!Y,
		id: Xl,
		label: K,
		required: J,
		type: $,
		children: [Y && /* @__PURE__ */ jsxs("span", {
			className: Input_module_default.Suffix,
			onClick: () => Ql.current.focus(),
			children: [/* @__PURE__ */ jsx("span", {
				className: Input_module_default.SuffixValue,
				children: Yl.value
			}), Y]
		}), /* @__PURE__ */ jsx(InputElement, {
			className: (0, import_classnames$41.default)(Zl, w),
			id: Xl,
			ref: Ql,
			type: $,
			style: ql,
			...Yl
		})]
	});
};
const CreateDirectory = (x) => {
	let { createDirectory: w, setShowCreateDirectoryInput: V, currentDirectory: U, showCreateDirectoryInput: G } = x, [K, J] = useState(!1), [Y, Z] = useState("");
	useEffect(() => {
		let x = (x) => {
			x.key === "Escape" && (Z(""), J(!1), V(""));
		};
		return document.addEventListener("keydown", x, !0), function() {
			document.removeEventListener("keydown", x, !0);
		};
	}, []);
	async function $() {
		Y && (V(""), J(!0), await w(`${U}/${Y}`), Z(""), J(!1));
	}
	return /* @__PURE__ */ jsx(Fragment$1, { children: G ? /* @__PURE__ */ jsx(Input, {
		classNameInput: Directory_module_default$1.NewFolderNameInput,
		value: Y,
		onChange: (x) => {
			Z(x.currentTarget.value.replace(/\//g, ""));
		},
		onKeyDown: (x) => {
			x.key === "Enter" && $();
		},
		placeholder: "New folder name",
		suffix: /* @__PURE__ */ jsx(Button_default, {
			className: Directory_module_default$1.CreateFolderButton,
			disabled: !Y,
			iconProps: {
				color: preset_default.theme.extend.colors.primary,
				icon: "check",
				weight: "regular"
			},
			onClick: $,
			variant: "tertiary"
		})
	}) : K ? /* @__PURE__ */ jsxs("div", {
		className: Directory_module_default$1.CreatingFolderSpinnerWrapper,
		children: [/* @__PURE__ */ jsx(Loader_default, { className: Directory_module_default$1.CreatingFolderSpinner }), " One moment..."]
	}) : /* @__PURE__ */ jsxs(Button_default, {
		className: Directory_module_default$1.ShowCreateFolderInputButton,
		onClick: () => V(U),
		variant: "secondary",
		children: [/* @__PURE__ */ jsx(Icon_default, {
			icon: "folder-simple-plus",
			size: 18
		}), " Create folder"]
	}) });
};
var import_classnames$40 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function getClassnames(x, w) {
	let V = x.lastIndexOf(w);
	return V === -1 ? "" : V === x.length - 1 ? Directory_module_default$1.ActiveDirectoryItem : Directory_module_default$1.ActiveSubDirectoryItem;
}
var DirectoryItem_default = ({ activeIds: x, item: w, onClick: V, onDeleteConfirm: U, preventDeletion: W = !1 }) => {
	let [G, K] = useState(!1), J = w?.name?.length > 12;
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
		className: (0, import_classnames$40.default)(Directory_module_default$1.DirectoryItem, getClassnames(x, w.id)),
		children: [/* @__PURE__ */ jsxs("div", {
			className: Directory_module_default$1.TitleWrapper,
			onClick: V,
			children: [/* @__PURE__ */ jsx(Icon_default, {
				className: Directory_module_default$1.FolderIcon,
				icon: x.lastIndexOf(w.id) > -1 ? "folder-open" : "folder",
				color: "currentColor",
				size: 18
			}), /* @__PURE__ */ jsx(Text, {
				className: Directory_module_default$1.FolderName,
				as: "h3",
				title: J ? w?.name : "",
				children: /* @__PURE__ */ jsxs("div", {
					className: Directory_module_default$1.Truncated,
					children: [" ", w?.name ? w?.name : "N/A"]
				})
			})]
		}), !W && /* @__PURE__ */ jsx(Button_default, {
			className: (0, import_classnames$40.default)(Directory_module_default$1.UpdateFolderButton, Directory_module_default$1.DeleteButton),
			iconProps: {
				icon: "trash",
				size: 14
			},
			onClick: () => K(!0),
			variant: "tertiary"
		})]
	}), /* @__PURE__ */ jsx(Dialog, {
		backdrop: !0,
		open: G,
		onClose: () => K(!1),
		children: /* @__PURE__ */ jsxs(Dialog.Panel, { children: [
			/* @__PURE__ */ jsx(Dialog.Title, { children: "Attention: You're about to delete a folder" }),
			/* @__PURE__ */ jsxs(Text, {
				as: "span",
				children: [
					"Are you sure you want to delete ",
					/* @__PURE__ */ jsx("strong", { children: w?.name || "N/A" }),
					"?"
				]
			}),
			/* @__PURE__ */ jsx(Text, { children: "Keep in mind that all of your images will be removed. This action can not be undone." }),
			/* @__PURE__ */ jsxs("div", {
				className: Directory_module_default$1.DialogFooter,
				children: [/* @__PURE__ */ jsx(Button_default, {
					onClick: () => K(!1),
					variant: "secondary",
					children: "Cancel"
				}), /* @__PURE__ */ jsx(Button_default, {
					onClick: () => {
						U(w.id), K(!1);
					},
					variant: "danger",
					children: "Delete"
				})]
			})
		] })
	})] });
}, DirectoryList_default = ({ activeIds: x, createDirectory: w, currentDirectory: V, openDirectory: U, onClick: W, showCreateDirectoryForm: G, showCreateDirectoryInput: K, setShowCreateDirectoryInput: J, onDeleteConfirm: Y }) => /* @__PURE__ */ jsxs("div", {
	className: Directory_module_default$1.DirectoryList,
	children: [U?.map((w) => /* @__PURE__ */ jsx(DirectoryItem_default, {
		onClick: () => W(w),
		item: w,
		activeIds: x,
		onDeleteConfirm: Y,
		preventDeletion: w.preventDeletion
	}, w.id)), G && /* @__PURE__ */ jsx(CreateDirectory, {
		createDirectory: w,
		currentDirectory: V,
		showCreateDirectoryInput: K,
		setShowCreateDirectoryInput: J
	})]
}), DirectoryBrowser_default = ({ activeIds: x, createDirectory: w, data: V = [], getData: U, setActiveIds: W, onDeleteConfirm: G }) => {
	let [K, J] = useState([]), [Y, Z] = useState(), [$, ql] = useState(""), Jl = (w, V) => {
		w?.id !== Y?.id && (W([
			x[0],
			...x.slice(1, V),
			w?.id
		]), U(w), Z(w), ql(""));
	}, Yl = (w) => K.slice(0, w).map((w) => w.find((w) => x.includes(w.id))).reduce((x, w) => [...x, ...w?.id ? [w.id] : []], []).join("/"), Xl = (w) => {
		let V = [], U = (w) => w.forEach((w) => {
			let { directories: W = [], ...G } = w;
			V.some((x) => x.some(({ id: x }) => G.id === x)) || V.push([G]), x.includes(G.id) && (V.push(W), U(W));
		});
		return U(w), JSON.parse(JSON.stringify(V)).map((x) => x.map((x) => ({
			id: x.id,
			name: x.name,
			preventDeletion: x.preventDeletion,
			createdAt: x.createdAt,
			updatedAt: x.updatedAt
		})));
	};
	return useEffect(() => {
		J(Xl(V));
	}, [x, V]), /* @__PURE__ */ jsx("div", {
		className: Directory_module_default$1.BrowserDirectoryWrapper,
		children: K?.map((V, U) => {
			let W = Yl(U);
			return /* @__PURE__ */ jsx(DirectoryList_default, {
				activeIds: x,
				createDirectory: w,
				currentDirectory: Yl(U),
				openDirectory: V,
				onClick: (x) => Jl(x, U),
				showCreateDirectoryForm: U === K.length - 1,
				showCreateDirectoryInput: W === $,
				setShowCreateDirectoryInput: ql,
				onDeleteConfirm: G
			}, U);
		})
	});
}, Drawer_module_default = {
	Drawer: "_Drawer_iqh1c_1",
	Backdrop: "_Backdrop_iqh1c_5",
	DrawerPanel: "_DrawerPanel_iqh1c_9",
	DrawerPanelContent: "_DrawerPanelContent_iqh1c_13",
	PanelContent: "_PanelContent_iqh1c_17",
	PanelHeader: "_PanelHeader_iqh1c_21",
	fadeTransition: "_fadeTransition_iqh1c_25",
	fadeEnterFrom: "_fadeEnterFrom_iqh1c_29",
	fadeEnterTo: "_fadeEnterTo_iqh1c_33",
	fadeLeaveFrom: "_fadeLeaveFrom_iqh1c_37",
	fadeLeaveTo: "_fadeLeaveTo_iqh1c_41",
	slideTransition: "_slideTransition_iqh1c_45",
	slideEnterFrom: "_slideEnterFrom_iqh1c_49",
	slideEnterTo: "_slideEnterTo_iqh1c_53",
	slideLeaveFrom: "_slideLeaveFrom_iqh1c_57",
	slideLeaveTo: "_slideLeaveTo_iqh1c_61"
};
function Drawer({ children: x, className: w, onClose: V, header: U, isVisible: W, drawerPanelContentClassName: G }) {
	return /* @__PURE__ */ jsx(Transition.Root, {
		show: !!W,
		as: Fragment,
		children: /* @__PURE__ */ jsxs(Dialog$1, {
			as: "div",
			className: Drawer_module_default.Drawer,
			onClose: V,
			children: [/* @__PURE__ */ jsx(Transition.Child, {
				as: Fragment,
				enter: Drawer_module_default.fadeTransition,
				enterFrom: Drawer_module_default.fadeEnterFrom,
				enterTo: Drawer_module_default.fadeEnterTo,
				leave: Drawer_module_default.fadeTransition,
				leaveFrom: Drawer_module_default.fadeLeaveFrom,
				leaveTo: Drawer_module_default.fadeLeaveTo,
				children: /* @__PURE__ */ jsx("div", { className: Drawer_module_default.Backdrop })
			}), /* @__PURE__ */ jsx("div", {
				className: Drawer_module_default.DrawerPanel,
				children: /* @__PURE__ */ jsx(Transition.Child, {
					as: Fragment,
					enter: Drawer_module_default.slideTransition,
					enterFrom: Drawer_module_default.slideEnterFrom,
					enterTo: Drawer_module_default.slideEnterTo,
					leave: Drawer_module_default.slideTransition,
					leaveFrom: Drawer_module_default.slideLeaveFrom,
					leaveTo: Drawer_module_default.slideLeaveTo,
					children: /* @__PURE__ */ jsx(Dialog$1.Panel, {
						className: Drawer_module_default.DrawerPanelContent,
						children: /* @__PURE__ */ jsxs("div", {
							className: twMerge(Drawer_module_default.PanelContent, G),
							children: [/* @__PURE__ */ jsx("div", {
								className: Drawer_module_default.PanelHeader,
								children: /* @__PURE__ */ jsx(Text, {
									as: "h3",
									children: U
								})
							}), /* @__PURE__ */ jsx("div", {
								className: w,
								children: x
							})]
						})
					})
				})
			})]
		})
	});
}
var Drawer_default = Drawer, fromEntries = function(x) {
	return x.reduce(function(x, w) {
		var V = w[0];
		return x[V] = w[1], x;
	}, {});
}, useIsomorphicLayoutEffect$1 = typeof window < "u" && window.document && window.document.createElement ? React$1.useLayoutEffect : React$1.useEffect, bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [
	"top",
	bottom,
	right,
	left
], start = "start", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(x, w) {
	return x.concat([w + "-" + start, w + "-end"]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(x, w) {
	return x.concat([
		w,
		w + "-" + start,
		w + "-end"
	]);
}, []), modifierPhases = [
	"beforeRead",
	"read",
	"afterRead",
	"beforeMain",
	"main",
	"afterMain",
	"beforeWrite",
	"write",
	"afterWrite"
];
function getNodeName(x) {
	return x ? (x.nodeName || "").toLowerCase() : null;
}
function getWindow(x) {
	if (x == null) return window;
	if (x.toString() !== "[object Window]") {
		var w = x.ownerDocument;
		return w && w.defaultView || window;
	}
	return x;
}
function isElement(x) {
	return x instanceof getWindow(x).Element || x instanceof Element;
}
function isHTMLElement(x) {
	return x instanceof getWindow(x).HTMLElement || x instanceof HTMLElement;
}
function isShadowRoot(x) {
	return typeof ShadowRoot > "u" ? !1 : x instanceof getWindow(x).ShadowRoot || x instanceof ShadowRoot;
}
function applyStyles(x) {
	var w = x.state;
	Object.keys(w.elements).forEach(function(x) {
		var V = w.styles[x] || {}, U = w.attributes[x] || {}, W = w.elements[x];
		!isHTMLElement(W) || !getNodeName(W) || (Object.assign(W.style, V), Object.keys(U).forEach(function(x) {
			var w = U[x];
			w === !1 ? W.removeAttribute(x) : W.setAttribute(x, w === !0 ? "" : w);
		}));
	});
}
function effect$2(x) {
	var w = x.state, V = {
		popper: {
			position: w.options.strategy,
			left: "0",
			top: "0",
			margin: "0"
		},
		arrow: { position: "absolute" },
		reference: {}
	};
	return Object.assign(w.elements.popper.style, V.popper), w.styles = V, w.elements.arrow && Object.assign(w.elements.arrow.style, V.arrow), function() {
		Object.keys(w.elements).forEach(function(x) {
			var U = w.elements[x], W = w.attributes[x] || {}, G = Object.keys(w.styles.hasOwnProperty(x) ? w.styles[x] : V[x]).reduce(function(x, w) {
				return x[w] = "", x;
			}, {});
			!isHTMLElement(U) || !getNodeName(U) || (Object.assign(U.style, G), Object.keys(W).forEach(function(x) {
				U.removeAttribute(x);
			}));
		});
	};
}
var applyStyles_default = {
	name: "applyStyles",
	enabled: !0,
	phase: "write",
	fn: applyStyles,
	effect: effect$2,
	requires: ["computeStyles"]
};
function getBasePlacement(x) {
	return x.split("-")[0];
}
var max = Math.max, min = Math.min, round$1 = Math.round;
function getUAString() {
	var x = navigator.userAgentData;
	return x != null && x.brands && Array.isArray(x.brands) ? x.brands.map(function(x) {
		return x.brand + "/" + x.version;
	}).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
	return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(x, w, V) {
	w === void 0 && (w = !1), V === void 0 && (V = !1);
	var U = x.getBoundingClientRect(), W = 1, G = 1;
	w && isHTMLElement(x) && (W = x.offsetWidth > 0 && round$1(U.width) / x.offsetWidth || 1, G = x.offsetHeight > 0 && round$1(U.height) / x.offsetHeight || 1);
	var K = (isElement(x) ? getWindow(x) : window).visualViewport, J = !isLayoutViewport() && V, Y = (U.left + (J && K ? K.offsetLeft : 0)) / W, Z = (U.top + (J && K ? K.offsetTop : 0)) / G, $ = U.width / W, ql = U.height / G;
	return {
		width: $,
		height: ql,
		top: Z,
		right: Y + $,
		bottom: Z + ql,
		left: Y,
		x: Y,
		y: Z
	};
}
function getLayoutRect(x) {
	var w = getBoundingClientRect(x), V = x.offsetWidth, U = x.offsetHeight;
	return Math.abs(w.width - V) <= 1 && (V = w.width), Math.abs(w.height - U) <= 1 && (U = w.height), {
		x: x.offsetLeft,
		y: x.offsetTop,
		width: V,
		height: U
	};
}
function contains(x, w) {
	var V = w.getRootNode && w.getRootNode();
	if (x.contains(w)) return !0;
	if (V && isShadowRoot(V)) {
		var U = w;
		do {
			if (U && x.isSameNode(U)) return !0;
			U = U.parentNode || U.host;
		} while (U);
	}
	return !1;
}
function getComputedStyle$1(x) {
	return getWindow(x).getComputedStyle(x);
}
function isTableElement(x) {
	return [
		"table",
		"td",
		"th"
	].indexOf(getNodeName(x)) >= 0;
}
function getDocumentElement(x) {
	return ((isElement(x) ? x.ownerDocument : x.document) || window.document).documentElement;
}
function getParentNode(x) {
	return getNodeName(x) === "html" ? x : x.assignedSlot || x.parentNode || (isShadowRoot(x) ? x.host : null) || getDocumentElement(x);
}
function getTrueOffsetParent(x) {
	return !isHTMLElement(x) || getComputedStyle$1(x).position === "fixed" ? null : x.offsetParent;
}
function getContainingBlock(x) {
	var w = /firefox/i.test(getUAString());
	if (/Trident/i.test(getUAString()) && isHTMLElement(x) && getComputedStyle$1(x).position === "fixed") return null;
	var V = getParentNode(x);
	for (isShadowRoot(V) && (V = V.host); isHTMLElement(V) && ["html", "body"].indexOf(getNodeName(V)) < 0;) {
		var U = getComputedStyle$1(V);
		if (U.transform !== "none" || U.perspective !== "none" || U.contain === "paint" || ["transform", "perspective"].indexOf(U.willChange) !== -1 || w && U.willChange === "filter" || w && U.filter && U.filter !== "none") return V;
		V = V.parentNode;
	}
	return null;
}
function getOffsetParent(x) {
	for (var w = getWindow(x), V = getTrueOffsetParent(x); V && isTableElement(V) && getComputedStyle$1(V).position === "static";) V = getTrueOffsetParent(V);
	return V && (getNodeName(V) === "html" || getNodeName(V) === "body" && getComputedStyle$1(V).position === "static") ? w : V || getContainingBlock(x) || w;
}
function getMainAxisFromPlacement(x) {
	return ["top", "bottom"].indexOf(x) >= 0 ? "x" : "y";
}
function within(x, w, V) {
	return max(x, min(w, V));
}
function withinMaxClamp(x, w, V) {
	var U = within(x, w, V);
	return U > V ? V : U;
}
function getFreshSideObject() {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0
	};
}
function mergePaddingObject(x) {
	return Object.assign({}, getFreshSideObject(), x);
}
function expandToHashMap(x, w) {
	return w.reduce(function(w, V) {
		return w[V] = x, w;
	}, {});
}
var toPaddingObject = function(x, w) {
	return x = typeof x == "function" ? x(Object.assign({}, w.rects, { placement: w.placement })) : x, mergePaddingObject(typeof x == "number" ? expandToHashMap(x, basePlacements) : x);
};
function arrow(x) {
	var w, V = x.state, U = x.name, W = x.options, G = V.elements.arrow, K = V.modifiersData.popperOffsets, J = getBasePlacement(V.placement), Y = getMainAxisFromPlacement(J), Z = ["left", "right"].indexOf(J) >= 0 ? "height" : "width";
	if (!(!G || !K)) {
		var $ = toPaddingObject(W.padding, V), ql = getLayoutRect(G), Jl = Y === "y" ? "top" : left, Yl = Y === "y" ? bottom : right, Xl = V.rects.reference[Z] + V.rects.reference[Y] - K[Y] - V.rects.popper[Z], Zl = K[Y] - V.rects.reference[Y], Ql = getOffsetParent(G), $l = Ql ? Y === "y" ? Ql.clientHeight || 0 : Ql.clientWidth || 0 : 0, eu = Xl / 2 - Zl / 2, tu = $[Jl], nu = $l - ql[Z] - $[Yl], ru = $l / 2 - ql[Z] / 2 + eu, iu = within(tu, ru, nu), au = Y;
		V.modifiersData[U] = (w = {}, w[au] = iu, w.centerOffset = iu - ru, w);
	}
}
function effect$1(x) {
	var w = x.state, V = x.options.element, U = V === void 0 ? "[data-popper-arrow]" : V;
	U != null && (typeof U == "string" && (U = w.elements.popper.querySelector(U), !U) || contains(w.elements.popper, U) && (w.elements.arrow = U));
}
var arrow_default = {
	name: "arrow",
	enabled: !0,
	phase: "main",
	fn: arrow,
	effect: effect$1,
	requires: ["popperOffsets"],
	requiresIfExists: ["preventOverflow"]
};
function getVariation(x) {
	return x.split("-")[1];
}
var unsetSides = {
	top: "auto",
	right: "auto",
	bottom: "auto",
	left: "auto"
};
function roundOffsetsByDPR(x, w) {
	var V = x.x, U = x.y, W = w.devicePixelRatio || 1;
	return {
		x: round$1(V * W) / W || 0,
		y: round$1(U * W) / W || 0
	};
}
function mapToStyles(x) {
	var w, V = x.popper, U = x.popperRect, W = x.placement, G = x.variation, K = x.offsets, J = x.position, Y = x.gpuAcceleration, Z = x.adaptive, $ = x.roundOffsets, ql = x.isFixed, Jl = K.x, Yl = Jl === void 0 ? 0 : Jl, Xl = K.y, Zl = Xl === void 0 ? 0 : Xl, Ql = typeof $ == "function" ? $({
		x: Yl,
		y: Zl
	}) : {
		x: Yl,
		y: Zl
	};
	Yl = Ql.x, Zl = Ql.y;
	var $l = K.hasOwnProperty("x"), eu = K.hasOwnProperty("y"), tu = left, nu = "top", ru = window;
	if (Z) {
		var iu = getOffsetParent(V), au = "clientHeight", ou = "clientWidth";
		if (iu === getWindow(V) && (iu = getDocumentElement(V), getComputedStyle$1(iu).position !== "static" && J === "absolute" && (au = "scrollHeight", ou = "scrollWidth")), iu = iu, W === "top" || (W === "left" || W === "right") && G === "end") {
			nu = bottom;
			var su = ql && iu === ru && ru.visualViewport ? ru.visualViewport.height : iu[au];
			Zl -= su - U.height, Zl *= Y ? 1 : -1;
		}
		if (W === "left" || (W === "top" || W === "bottom") && G === "end") {
			tu = right;
			var cu = ql && iu === ru && ru.visualViewport ? ru.visualViewport.width : iu[ou];
			Yl -= cu - U.width, Yl *= Y ? 1 : -1;
		}
	}
	var lu = Object.assign({ position: J }, Z && unsetSides), uu = $ === !0 ? roundOffsetsByDPR({
		x: Yl,
		y: Zl
	}, getWindow(V)) : {
		x: Yl,
		y: Zl
	};
	if (Yl = uu.x, Zl = uu.y, Y) {
		var du;
		return Object.assign({}, lu, (du = {}, du[nu] = eu ? "0" : "", du[tu] = $l ? "0" : "", du.transform = (ru.devicePixelRatio || 1) <= 1 ? "translate(" + Yl + "px, " + Zl + "px)" : "translate3d(" + Yl + "px, " + Zl + "px, 0)", du));
	}
	return Object.assign({}, lu, (w = {}, w[nu] = eu ? Zl + "px" : "", w[tu] = $l ? Yl + "px" : "", w.transform = "", w));
}
function computeStyles(x) {
	var w = x.state, V = x.options, U = V.gpuAcceleration, W = U === void 0 ? !0 : U, G = V.adaptive, K = G === void 0 ? !0 : G, J = V.roundOffsets, Y = J === void 0 ? !0 : J, Z = {
		placement: getBasePlacement(w.placement),
		variation: getVariation(w.placement),
		popper: w.elements.popper,
		popperRect: w.rects.popper,
		gpuAcceleration: W,
		isFixed: w.options.strategy === "fixed"
	};
	w.modifiersData.popperOffsets != null && (w.styles.popper = Object.assign({}, w.styles.popper, mapToStyles(Object.assign({}, Z, {
		offsets: w.modifiersData.popperOffsets,
		position: w.options.strategy,
		adaptive: K,
		roundOffsets: Y
	})))), w.modifiersData.arrow != null && (w.styles.arrow = Object.assign({}, w.styles.arrow, mapToStyles(Object.assign({}, Z, {
		offsets: w.modifiersData.arrow,
		position: "absolute",
		adaptive: !1,
		roundOffsets: Y
	})))), w.attributes.popper = Object.assign({}, w.attributes.popper, { "data-popper-placement": w.placement });
}
var computeStyles_default = {
	name: "computeStyles",
	enabled: !0,
	phase: "beforeWrite",
	fn: computeStyles,
	data: {}
}, passive = { passive: !0 };
function effect(x) {
	var w = x.state, V = x.instance, U = x.options, W = U.scroll, G = W === void 0 ? !0 : W, K = U.resize, J = K === void 0 ? !0 : K, Y = getWindow(w.elements.popper), Z = [].concat(w.scrollParents.reference, w.scrollParents.popper);
	return G && Z.forEach(function(x) {
		x.addEventListener("scroll", V.update, passive);
	}), J && Y.addEventListener("resize", V.update, passive), function() {
		G && Z.forEach(function(x) {
			x.removeEventListener("scroll", V.update, passive);
		}), J && Y.removeEventListener("resize", V.update, passive);
	};
}
var eventListeners_default = {
	name: "eventListeners",
	enabled: !0,
	phase: "write",
	fn: function() {},
	effect,
	data: {}
}, hash$1 = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
};
function getOppositePlacement(x) {
	return x.replace(/left|right|bottom|top/g, function(x) {
		return hash$1[x];
	});
}
var hash = {
	start: "end",
	end: "start"
};
function getOppositeVariationPlacement(x) {
	return x.replace(/start|end/g, function(x) {
		return hash[x];
	});
}
function getWindowScroll(x) {
	var w = getWindow(x);
	return {
		scrollLeft: w.pageXOffset,
		scrollTop: w.pageYOffset
	};
}
function getWindowScrollBarX(x) {
	return getBoundingClientRect(getDocumentElement(x)).left + getWindowScroll(x).scrollLeft;
}
function getViewportRect(x, w) {
	var V = getWindow(x), U = getDocumentElement(x), W = V.visualViewport, G = U.clientWidth, K = U.clientHeight, J = 0, Y = 0;
	if (W) {
		G = W.width, K = W.height;
		var Z = isLayoutViewport();
		(Z || !Z && w === "fixed") && (J = W.offsetLeft, Y = W.offsetTop);
	}
	return {
		width: G,
		height: K,
		x: J + getWindowScrollBarX(x),
		y: Y
	};
}
function getDocumentRect(x) {
	var w = getDocumentElement(x), V = getWindowScroll(x), U = x.ownerDocument?.body, W = max(w.scrollWidth, w.clientWidth, U ? U.scrollWidth : 0, U ? U.clientWidth : 0), G = max(w.scrollHeight, w.clientHeight, U ? U.scrollHeight : 0, U ? U.clientHeight : 0), K = -V.scrollLeft + getWindowScrollBarX(x), J = -V.scrollTop;
	return getComputedStyle$1(U || w).direction === "rtl" && (K += max(w.clientWidth, U ? U.clientWidth : 0) - W), {
		width: W,
		height: G,
		x: K,
		y: J
	};
}
function isScrollParent(x) {
	var w = getComputedStyle$1(x), V = w.overflow, U = w.overflowX, W = w.overflowY;
	return /auto|scroll|overlay|hidden/.test(V + W + U);
}
function getScrollParent(x) {
	return [
		"html",
		"body",
		"#document"
	].indexOf(getNodeName(x)) >= 0 ? x.ownerDocument.body : isHTMLElement(x) && isScrollParent(x) ? x : getScrollParent(getParentNode(x));
}
function listScrollParents(x, w) {
	w === void 0 && (w = []);
	var V = getScrollParent(x), U = V === x.ownerDocument?.body, W = getWindow(V), G = U ? [W].concat(W.visualViewport || [], isScrollParent(V) ? V : []) : V, K = w.concat(G);
	return U ? K : K.concat(listScrollParents(getParentNode(G)));
}
function rectToClientRect(x) {
	return Object.assign({}, x, {
		left: x.x,
		top: x.y,
		right: x.x + x.width,
		bottom: x.y + x.height
	});
}
function getInnerBoundingClientRect(x, w) {
	var V = getBoundingClientRect(x, !1, w === "fixed");
	return V.top += x.clientTop, V.left += x.clientLeft, V.bottom = V.top + x.clientHeight, V.right = V.left + x.clientWidth, V.width = x.clientWidth, V.height = x.clientHeight, V.x = V.left, V.y = V.top, V;
}
function getClientRectFromMixedType(x, w, V) {
	return w === "viewport" ? rectToClientRect(getViewportRect(x, V)) : isElement(w) ? getInnerBoundingClientRect(w, V) : rectToClientRect(getDocumentRect(getDocumentElement(x)));
}
function getClippingParents(x) {
	var w = listScrollParents(getParentNode(x)), V = ["absolute", "fixed"].indexOf(getComputedStyle$1(x).position) >= 0 && isHTMLElement(x) ? getOffsetParent(x) : x;
	return isElement(V) ? w.filter(function(x) {
		return isElement(x) && contains(x, V) && getNodeName(x) !== "body";
	}) : [];
}
function getClippingRect(x, w, V, U) {
	var W = w === "clippingParents" ? getClippingParents(x) : [].concat(w), G = [].concat(W, [V]), K = G[0], J = G.reduce(function(w, V) {
		var W = getClientRectFromMixedType(x, V, U);
		return w.top = max(W.top, w.top), w.right = min(W.right, w.right), w.bottom = min(W.bottom, w.bottom), w.left = max(W.left, w.left), w;
	}, getClientRectFromMixedType(x, K, U));
	return J.width = J.right - J.left, J.height = J.bottom - J.top, J.x = J.left, J.y = J.top, J;
}
function computeOffsets(x) {
	var w = x.reference, V = x.element, U = x.placement, W = U ? getBasePlacement(U) : null, G = U ? getVariation(U) : null, K = w.x + w.width / 2 - V.width / 2, J = w.y + w.height / 2 - V.height / 2, Y;
	switch (W) {
		case "top":
			Y = {
				x: K,
				y: w.y - V.height
			};
			break;
		case bottom:
			Y = {
				x: K,
				y: w.y + w.height
			};
			break;
		case right:
			Y = {
				x: w.x + w.width,
				y: J
			};
			break;
		case left:
			Y = {
				x: w.x - V.width,
				y: J
			};
			break;
		default: Y = {
			x: w.x,
			y: w.y
		};
	}
	var Z = W ? getMainAxisFromPlacement(W) : null;
	if (Z != null) {
		var $ = Z === "y" ? "height" : "width";
		switch (G) {
			case start:
				Y[Z] = Y[Z] - (w[$] / 2 - V[$] / 2);
				break;
			case "end":
				Y[Z] = Y[Z] + (w[$] / 2 - V[$] / 2);
				break;
			default:
		}
	}
	return Y;
}
function detectOverflow(x, w) {
	w === void 0 && (w = {});
	var V = w, U = V.placement, W = U === void 0 ? x.placement : U, G = V.strategy, K = G === void 0 ? x.strategy : G, J = V.boundary, Y = J === void 0 ? clippingParents : J, Z = V.rootBoundary, $ = Z === void 0 ? viewport : Z, ql = V.elementContext, Jl = ql === void 0 ? popper : ql, Yl = V.altBoundary, Xl = Yl === void 0 ? !1 : Yl, Zl = V.padding, Ql = Zl === void 0 ? 0 : Zl, $l = mergePaddingObject(typeof Ql == "number" ? expandToHashMap(Ql, basePlacements) : Ql), eu = Jl === "popper" ? reference : popper, tu = x.rects.popper, nu = x.elements[Xl ? eu : Jl], ru = getClippingRect(isElement(nu) ? nu : nu.contextElement || getDocumentElement(x.elements.popper), Y, $, K), iu = getBoundingClientRect(x.elements.reference), au = computeOffsets({
		reference: iu,
		element: tu,
		strategy: "absolute",
		placement: W
	}), ou = rectToClientRect(Object.assign({}, tu, au)), su = Jl === "popper" ? ou : iu, cu = {
		top: ru.top - su.top + $l.top,
		bottom: su.bottom - ru.bottom + $l.bottom,
		left: ru.left - su.left + $l.left,
		right: su.right - ru.right + $l.right
	}, lu = x.modifiersData.offset;
	if (Jl === "popper" && lu) {
		var uu = lu[W];
		Object.keys(cu).forEach(function(x) {
			var w = ["right", "bottom"].indexOf(x) >= 0 ? 1 : -1, V = ["top", "bottom"].indexOf(x) >= 0 ? "y" : "x";
			cu[x] += uu[V] * w;
		});
	}
	return cu;
}
function computeAutoPlacement(x, w) {
	w === void 0 && (w = {});
	var V = w, U = V.placement, W = V.boundary, G = V.rootBoundary, K = V.padding, J = V.flipVariations, Y = V.allowedAutoPlacements, Z = Y === void 0 ? placements : Y, $ = getVariation(U), ql = $ ? J ? variationPlacements : variationPlacements.filter(function(x) {
		return getVariation(x) === $;
	}) : basePlacements, Jl = ql.filter(function(x) {
		return Z.indexOf(x) >= 0;
	});
	Jl.length === 0 && (Jl = ql);
	var Yl = Jl.reduce(function(w, V) {
		return w[V] = detectOverflow(x, {
			placement: V,
			boundary: W,
			rootBoundary: G,
			padding: K
		})[getBasePlacement(V)], w;
	}, {});
	return Object.keys(Yl).sort(function(x, w) {
		return Yl[x] - Yl[w];
	});
}
function getExpandedFallbackPlacements(x) {
	if (getBasePlacement(x) === "auto") return [];
	var w = getOppositePlacement(x);
	return [
		getOppositeVariationPlacement(x),
		w,
		getOppositeVariationPlacement(w)
	];
}
function flip(x) {
	var w = x.state, V = x.options, U = x.name;
	if (!w.modifiersData[U]._skip) {
		for (var W = V.mainAxis, G = W === void 0 ? !0 : W, K = V.altAxis, J = K === void 0 ? !0 : K, Y = V.fallbackPlacements, Z = V.padding, $ = V.boundary, ql = V.rootBoundary, Jl = V.altBoundary, Yl = V.flipVariations, Xl = Yl === void 0 ? !0 : Yl, Zl = V.allowedAutoPlacements, Ql = w.options.placement, $l = getBasePlacement(Ql) === Ql, eu = Y || ($l || !Xl ? [getOppositePlacement(Ql)] : getExpandedFallbackPlacements(Ql)), tu = [Ql].concat(eu).reduce(function(x, V) {
			return x.concat(getBasePlacement(V) === "auto" ? computeAutoPlacement(w, {
				placement: V,
				boundary: $,
				rootBoundary: ql,
				padding: Z,
				flipVariations: Xl,
				allowedAutoPlacements: Zl
			}) : V);
		}, []), nu = w.rects.reference, ru = w.rects.popper, iu = /* @__PURE__ */ new Map(), au = !0, ou = tu[0], su = 0; su < tu.length; su++) {
			var cu = tu[su], lu = getBasePlacement(cu), uu = getVariation(cu) === start, du = ["top", bottom].indexOf(lu) >= 0, fu = du ? "width" : "height", pu = detectOverflow(w, {
				placement: cu,
				boundary: $,
				rootBoundary: ql,
				altBoundary: Jl,
				padding: Z
			}), mu = du ? uu ? right : left : uu ? bottom : "top";
			nu[fu] > ru[fu] && (mu = getOppositePlacement(mu));
			var hu = getOppositePlacement(mu), gu = [];
			if (G && gu.push(pu[lu] <= 0), J && gu.push(pu[mu] <= 0, pu[hu] <= 0), gu.every(function(x) {
				return x;
			})) {
				ou = cu, au = !1;
				break;
			}
			iu.set(cu, gu);
		}
		if (au) for (var _u = Xl ? 3 : 1, vu = function(x) {
			var w = tu.find(function(w) {
				var V = iu.get(w);
				if (V) return V.slice(0, x).every(function(x) {
					return x;
				});
			});
			if (w) return ou = w, "break";
		}, yu = _u; yu > 0 && vu(yu) !== "break"; yu--);
		w.placement !== ou && (w.modifiersData[U]._skip = !0, w.placement = ou, w.reset = !0);
	}
}
var flip_default = {
	name: "flip",
	enabled: !0,
	phase: "main",
	fn: flip,
	requiresIfExists: ["offset"],
	data: { _skip: !1 }
};
function getSideOffsets(x, w, V) {
	return V === void 0 && (V = {
		x: 0,
		y: 0
	}), {
		top: x.top - w.height - V.y,
		right: x.right - w.width + V.x,
		bottom: x.bottom - w.height + V.y,
		left: x.left - w.width - V.x
	};
}
function isAnySideFullyClipped(x) {
	return [
		"top",
		right,
		bottom,
		left
	].some(function(w) {
		return x[w] >= 0;
	});
}
function hide(x) {
	var w = x.state, V = x.name, U = w.rects.reference, W = w.rects.popper, G = w.modifiersData.preventOverflow, K = detectOverflow(w, { elementContext: "reference" }), J = detectOverflow(w, { altBoundary: !0 }), Y = getSideOffsets(K, U), Z = getSideOffsets(J, W, G), $ = isAnySideFullyClipped(Y), ql = isAnySideFullyClipped(Z);
	w.modifiersData[V] = {
		referenceClippingOffsets: Y,
		popperEscapeOffsets: Z,
		isReferenceHidden: $,
		hasPopperEscaped: ql
	}, w.attributes.popper = Object.assign({}, w.attributes.popper, {
		"data-popper-reference-hidden": $,
		"data-popper-escaped": ql
	});
}
var hide_default = {
	name: "hide",
	enabled: !0,
	phase: "main",
	requiresIfExists: ["preventOverflow"],
	fn: hide
};
function distanceAndSkiddingToXY(x, w, V) {
	var U = getBasePlacement(x), W = ["left", "top"].indexOf(U) >= 0 ? -1 : 1, G = typeof V == "function" ? V(Object.assign({}, w, { placement: x })) : V, K = G[0], J = G[1];
	return K ||= 0, J = (J || 0) * W, ["left", "right"].indexOf(U) >= 0 ? {
		x: J,
		y: K
	} : {
		x: K,
		y: J
	};
}
function offset(x) {
	var w = x.state, V = x.options, U = x.name, W = V.offset, G = W === void 0 ? [0, 0] : W, K = placements.reduce(function(x, V) {
		return x[V] = distanceAndSkiddingToXY(V, w.rects, G), x;
	}, {}), J = K[w.placement], Y = J.x, Z = J.y;
	w.modifiersData.popperOffsets != null && (w.modifiersData.popperOffsets.x += Y, w.modifiersData.popperOffsets.y += Z), w.modifiersData[U] = K;
}
var offset_default = {
	name: "offset",
	enabled: !0,
	phase: "main",
	requires: ["popperOffsets"],
	fn: offset
};
function popperOffsets(x) {
	var w = x.state, V = x.name;
	w.modifiersData[V] = computeOffsets({
		reference: w.rects.reference,
		element: w.rects.popper,
		strategy: "absolute",
		placement: w.placement
	});
}
var popperOffsets_default = {
	name: "popperOffsets",
	enabled: !0,
	phase: "read",
	fn: popperOffsets,
	data: {}
};
function getAltAxis(x) {
	return x === "x" ? "y" : "x";
}
function preventOverflow(x) {
	var w = x.state, V = x.options, U = x.name, W = V.mainAxis, G = W === void 0 ? !0 : W, K = V.altAxis, J = K === void 0 ? !1 : K, Y = V.boundary, Z = V.rootBoundary, $ = V.altBoundary, ql = V.padding, Jl = V.tether, Yl = Jl === void 0 ? !0 : Jl, Xl = V.tetherOffset, Zl = Xl === void 0 ? 0 : Xl, Ql = detectOverflow(w, {
		boundary: Y,
		rootBoundary: Z,
		padding: ql,
		altBoundary: $
	}), $l = getBasePlacement(w.placement), eu = getVariation(w.placement), tu = !eu, nu = getMainAxisFromPlacement($l), ru = getAltAxis(nu), iu = w.modifiersData.popperOffsets, au = w.rects.reference, ou = w.rects.popper, su = typeof Zl == "function" ? Zl(Object.assign({}, w.rects, { placement: w.placement })) : Zl, cu = typeof su == "number" ? {
		mainAxis: su,
		altAxis: su
	} : Object.assign({
		mainAxis: 0,
		altAxis: 0
	}, su), lu = w.modifiersData.offset ? w.modifiersData.offset[w.placement] : null, uu = {
		x: 0,
		y: 0
	};
	if (iu) {
		if (G) {
			var du = nu === "y" ? "top" : left, fu = nu === "y" ? bottom : right, pu = nu === "y" ? "height" : "width", mu = iu[nu], hu = mu + Ql[du], gu = mu - Ql[fu], _u = Yl ? -ou[pu] / 2 : 0, vu = eu === "start" ? au[pu] : ou[pu], yu = eu === "start" ? -ou[pu] : -au[pu], bu = w.elements.arrow, xu = Yl && bu ? getLayoutRect(bu) : {
				width: 0,
				height: 0
			}, Su = w.modifiersData["arrow#persistent"] ? w.modifiersData["arrow#persistent"].padding : getFreshSideObject(), Cu = Su[du], wu = Su[fu], Tu = within(0, au[pu], xu[pu]), Eu = tu ? au[pu] / 2 - _u - Tu - Cu - cu.mainAxis : vu - Tu - Cu - cu.mainAxis, Du = tu ? -au[pu] / 2 + _u + Tu + wu + cu.mainAxis : yu + Tu + wu + cu.mainAxis, Ou = w.elements.arrow && getOffsetParent(w.elements.arrow), ku = Ou ? nu === "y" ? Ou.clientTop || 0 : Ou.clientLeft || 0 : 0, Au = lu?.[nu] ?? 0, ju = mu + Eu - Au - ku, Mu = mu + Du - Au, Nu = within(Yl ? min(hu, ju) : hu, mu, Yl ? max(gu, Mu) : gu);
			iu[nu] = Nu, uu[nu] = Nu - mu;
		}
		if (J) {
			var Pu = nu === "x" ? "top" : left, Fu = nu === "x" ? bottom : right, Iu = iu[ru], Lu = ru === "y" ? "height" : "width", Ru = Iu + Ql[Pu], zu = Iu - Ql[Fu], Bu = ["top", left].indexOf($l) !== -1, Vu = lu?.[ru] ?? 0, Hu = Bu ? Ru : Iu - au[Lu] - ou[Lu] - Vu + cu.altAxis, Uu = Bu ? Iu + au[Lu] + ou[Lu] - Vu - cu.altAxis : zu, Wu = Yl && Bu ? withinMaxClamp(Hu, Iu, Uu) : within(Yl ? Hu : Ru, Iu, Yl ? Uu : zu);
			iu[ru] = Wu, uu[ru] = Wu - Iu;
		}
		w.modifiersData[U] = uu;
	}
}
var preventOverflow_default = {
	name: "preventOverflow",
	enabled: !0,
	phase: "main",
	fn: preventOverflow,
	requiresIfExists: ["offset"]
};
function getHTMLElementScroll(x) {
	return {
		scrollLeft: x.scrollLeft,
		scrollTop: x.scrollTop
	};
}
function getNodeScroll(x) {
	return x === getWindow(x) || !isHTMLElement(x) ? getWindowScroll(x) : getHTMLElementScroll(x);
}
function isElementScaled(x) {
	var w = x.getBoundingClientRect(), V = round$1(w.width) / x.offsetWidth || 1, U = round$1(w.height) / x.offsetHeight || 1;
	return V !== 1 || U !== 1;
}
function getCompositeRect(x, w, V) {
	V === void 0 && (V = !1);
	var U = isHTMLElement(w), W = isHTMLElement(w) && isElementScaled(w), G = getDocumentElement(w), K = getBoundingClientRect(x, W, V), J = {
		scrollLeft: 0,
		scrollTop: 0
	}, Y = {
		x: 0,
		y: 0
	};
	return (U || !U && !V) && ((getNodeName(w) !== "body" || isScrollParent(G)) && (J = getNodeScroll(w)), isHTMLElement(w) ? (Y = getBoundingClientRect(w, !0), Y.x += w.clientLeft, Y.y += w.clientTop) : G && (Y.x = getWindowScrollBarX(G))), {
		x: K.left + J.scrollLeft - Y.x,
		y: K.top + J.scrollTop - Y.y,
		width: K.width,
		height: K.height
	};
}
function order(x) {
	var w = /* @__PURE__ */ new Map(), V = /* @__PURE__ */ new Set(), U = [];
	x.forEach(function(x) {
		w.set(x.name, x);
	});
	function W(x) {
		V.add(x.name), [].concat(x.requires || [], x.requiresIfExists || []).forEach(function(x) {
			if (!V.has(x)) {
				var U = w.get(x);
				U && W(U);
			}
		}), U.push(x);
	}
	return x.forEach(function(x) {
		V.has(x.name) || W(x);
	}), U;
}
function orderModifiers(x) {
	var w = order(x);
	return modifierPhases.reduce(function(x, V) {
		return x.concat(w.filter(function(x) {
			return x.phase === V;
		}));
	}, []);
}
function debounce$2(x) {
	var w;
	return function() {
		return w ||= new Promise(function(V) {
			Promise.resolve().then(function() {
				w = void 0, V(x());
			});
		}), w;
	};
}
function mergeByName(x) {
	var w = x.reduce(function(x, w) {
		var V = x[w.name];
		return x[w.name] = V ? Object.assign({}, V, w, {
			options: Object.assign({}, V.options, w.options),
			data: Object.assign({}, V.data, w.data)
		}) : w, x;
	}, {});
	return Object.keys(w).map(function(x) {
		return w[x];
	});
}
var DEFAULT_OPTIONS = {
	placement: "bottom",
	modifiers: [],
	strategy: "absolute"
};
function areValidElements() {
	return ![...arguments].some(function(x) {
		return !(x && typeof x.getBoundingClientRect == "function");
	});
}
function popperGenerator(x) {
	x === void 0 && (x = {});
	var w = x, V = w.defaultModifiers, U = V === void 0 ? [] : V, W = w.defaultOptions, G = W === void 0 ? DEFAULT_OPTIONS : W;
	return function(x, w, V) {
		V === void 0 && (V = G);
		var W = {
			placement: "bottom",
			orderedModifiers: [],
			options: Object.assign({}, DEFAULT_OPTIONS, G),
			modifiersData: {},
			elements: {
				reference: x,
				popper: w
			},
			attributes: {},
			styles: {}
		}, K = [], J = !1, Y = {
			state: W,
			setOptions: function(V) {
				var K = typeof V == "function" ? V(W.options) : V;
				$(), W.options = Object.assign({}, G, W.options, K), W.scrollParents = {
					reference: isElement(x) ? listScrollParents(x) : x.contextElement ? listScrollParents(x.contextElement) : [],
					popper: listScrollParents(w)
				};
				var J = orderModifiers(mergeByName([].concat(U, W.options.modifiers)));
				return W.orderedModifiers = J.filter(function(x) {
					return x.enabled;
				}), Z(), Y.update();
			},
			forceUpdate: function() {
				if (!J) {
					var x = W.elements, w = x.reference, V = x.popper;
					if (areValidElements(w, V)) {
						W.rects = {
							reference: getCompositeRect(w, getOffsetParent(V), W.options.strategy === "fixed"),
							popper: getLayoutRect(V)
						}, W.reset = !1, W.placement = W.options.placement, W.orderedModifiers.forEach(function(x) {
							return W.modifiersData[x.name] = Object.assign({}, x.data);
						});
						for (var U = 0; U < W.orderedModifiers.length; U++) {
							if (W.reset === !0) {
								W.reset = !1, U = -1;
								continue;
							}
							var G = W.orderedModifiers[U], K = G.fn, Z = G.options, $ = Z === void 0 ? {} : Z, ql = G.name;
							typeof K == "function" && (W = K({
								state: W,
								options: $,
								name: ql,
								instance: Y
							}) || W);
						}
					}
				}
			},
			update: debounce$2(function() {
				return new Promise(function(x) {
					Y.forceUpdate(), x(W);
				});
			}),
			destroy: function() {
				$(), J = !0;
			}
		};
		if (!areValidElements(x, w)) return Y;
		Y.setOptions(V).then(function(x) {
			!J && V.onFirstUpdate && V.onFirstUpdate(x);
		});
		function Z() {
			W.orderedModifiers.forEach(function(x) {
				var w = x.name, V = x.options, U = V === void 0 ? {} : V, G = x.effect;
				if (typeof G == "function") {
					var J = G({
						state: W,
						name: w,
						instance: Y,
						options: U
					});
					K.push(J || function() {});
				}
			});
		}
		function $() {
			K.forEach(function(x) {
				return x();
			}), K = [];
		}
		return Y;
	};
}
var createPopper = /* @__PURE__ */ popperGenerator({ defaultModifiers: [
	eventListeners_default,
	popperOffsets_default,
	computeStyles_default,
	applyStyles_default,
	offset_default,
	flip_default,
	preventOverflow_default,
	arrow_default,
	hide_default
] }), import_react_fast_compare = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((x, w) => {
	var V = typeof Element < "u", U = typeof Map == "function", W = typeof Set == "function", G = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
	function K(x, w) {
		if (x === w) return !0;
		if (x && w && typeof x == "object" && typeof w == "object") {
			if (x.constructor !== w.constructor) return !1;
			var J, Y, Z;
			if (Array.isArray(x)) {
				if (J = x.length, J != w.length) return !1;
				for (Y = J; Y-- !== 0;) if (!K(x[Y], w[Y])) return !1;
				return !0;
			}
			var $;
			if (U && x instanceof Map && w instanceof Map) {
				if (x.size !== w.size) return !1;
				for ($ = x.entries(); !(Y = $.next()).done;) if (!w.has(Y.value[0])) return !1;
				for ($ = x.entries(); !(Y = $.next()).done;) if (!K(Y.value[1], w.get(Y.value[0]))) return !1;
				return !0;
			}
			if (W && x instanceof Set && w instanceof Set) {
				if (x.size !== w.size) return !1;
				for ($ = x.entries(); !(Y = $.next()).done;) if (!w.has(Y.value[0])) return !1;
				return !0;
			}
			if (G && ArrayBuffer.isView(x) && ArrayBuffer.isView(w)) {
				if (J = x.length, J != w.length) return !1;
				for (Y = J; Y-- !== 0;) if (x[Y] !== w[Y]) return !1;
				return !0;
			}
			if (x.constructor === RegExp) return x.source === w.source && x.flags === w.flags;
			if (x.valueOf !== Object.prototype.valueOf && typeof x.valueOf == "function" && typeof w.valueOf == "function") return x.valueOf() === w.valueOf();
			if (x.toString !== Object.prototype.toString && typeof x.toString == "function" && typeof w.toString == "function") return x.toString() === w.toString();
			if (Z = Object.keys(x), J = Z.length, J !== Object.keys(w).length) return !1;
			for (Y = J; Y-- !== 0;) if (!Object.prototype.hasOwnProperty.call(w, Z[Y])) return !1;
			if (V && x instanceof Element) return !1;
			for (Y = J; Y-- !== 0;) if (!((Z[Y] === "_owner" || Z[Y] === "__v" || Z[Y] === "__o") && x.$$typeof) && !K(x[Z[Y]], w[Z[Y]])) return !1;
			return !0;
		}
		return x !== x && w !== w;
	}
	w.exports = function(x, w) {
		try {
			return K(x, w);
		} catch (x) {
			if ((x.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
			throw x;
		}
	};
})))()), EMPTY_MODIFIERS = [], usePopper = function(x, w, V) {
	V === void 0 && (V = {});
	var U = React$1.useRef(null), W = {
		onFirstUpdate: V.onFirstUpdate,
		placement: V.placement || "bottom",
		strategy: V.strategy || "absolute",
		modifiers: V.modifiers || EMPTY_MODIFIERS
	}, G = React$1.useState({
		styles: {
			popper: {
				position: W.strategy,
				left: "0",
				top: "0"
			},
			arrow: { position: "absolute" }
		},
		attributes: {}
	}), K = G[0], J = G[1], Y = React$1.useMemo(function() {
		return {
			name: "updateState",
			enabled: !0,
			phase: "write",
			fn: function(x) {
				var w = x.state, V = Object.keys(w.elements);
				ReactDOM.flushSync(function() {
					J({
						styles: fromEntries(V.map(function(x) {
							return [x, w.styles[x] || {}];
						})),
						attributes: fromEntries(V.map(function(x) {
							return [x, w.attributes[x]];
						}))
					});
				});
			},
			requires: ["computeStyles"]
		};
	}, []), Z = React$1.useMemo(function() {
		var x = {
			onFirstUpdate: W.onFirstUpdate,
			placement: W.placement,
			strategy: W.strategy,
			modifiers: [].concat(W.modifiers, [Y, {
				name: "applyStyles",
				enabled: !1
			}])
		};
		return (0, import_react_fast_compare.default)(U.current, x) ? U.current || x : (U.current = x, x);
	}, [
		W.onFirstUpdate,
		W.placement,
		W.strategy,
		W.modifiers,
		Y
	]), $ = React$1.useRef();
	return useIsomorphicLayoutEffect$1(function() {
		$.current && $.current.setOptions(Z);
	}, [Z]), useIsomorphicLayoutEffect$1(function() {
		if (!(x == null || w == null)) {
			var U = (V.createPopper || createPopper)(x, w, Z);
			return $.current = U, function() {
				U.destroy(), $.current = null;
			};
		}
	}, [
		x,
		w,
		V.createPopper
	]), {
		state: $.current ? $.current.state : null,
		styles: K.styles,
		attributes: K.attributes,
		update: $.current ? $.current.update : null,
		forceUpdate: $.current ? $.current.forceUpdate : null
	};
}, DropdownMenu_module_default = {
	DropdownMenu: "_DropdownMenu_1ius3_1",
	Panel: "_Panel_1ius3_5",
	EmptyState: "_EmptyState_1ius3_12",
	SearchWrapper: "_SearchWrapper_1ius3_16",
	SearchIcon: "_SearchIcon_1ius3_19",
	SearchInput: "_SearchInput_1ius3_22",
	OptionList: "_OptionList_1ius3_26",
	Option: "_Option_1ius3_26",
	Disabled: "_Disabled_1ius3_35",
	OptionIcon: "_OptionIcon_1ius3_38",
	OptionLabel: "_OptionLabel_1ius3_41"
}, import_classnames$39 = /* @__PURE__ */ __toESM(require_classnames(), 1), DropdownMenu_default = ({ options: x, trigger: w, withSearch: V = !1, onSelect: U, className: W, searchPlaceholder: G = "Search.." }) => {
	let [K, J] = useState(""), [Y, Z] = useState(null), [ql, Jl] = useState(null), { styles: Yl, attributes: Xl } = usePopper(Y, ql, {
		placement: "bottom-end",
		modifiers: [{
			name: "offset",
			options: { offset: [0, 4] }
		}]
	}), Zl = V || x.length > 7, Ql = Zl ? x.filter((x) => (x.searchLabel ?? (typeof x.label == "string" ? x.label : x.value)).toLowerCase().includes(K.toLowerCase())) : x, $l = Ql.length === 0;
	return /* @__PURE__ */ jsxs(Popover$1, {
		as: Fragment,
		children: [/* @__PURE__ */ jsx(Popover$1.Button, {
			as: "div",
			ref: Z,
			className: (0, import_classnames$39.default)(DropdownMenu_module_default.DropdownMenu, W),
			children: w
		}), createPortal(/* @__PURE__ */ jsx(Popover$1.Panel, {
			ref: Jl,
			className: DropdownMenu_module_default.Panel,
			style: Yl.popper,
			...Xl.popper,
			children: ({ close: x }) => /* @__PURE__ */ jsxs(Fragment$1, { children: [Zl && /* @__PURE__ */ jsxs("div", {
				className: DropdownMenu_module_default.SearchWrapper,
				children: [/* @__PURE__ */ jsx(MagnifyingGlass, {
					size: 14,
					weight: "bold",
					className: DropdownMenu_module_default.SearchIcon
				}), /* @__PURE__ */ jsx("input", {
					className: DropdownMenu_module_default.SearchInput,
					placeholder: G,
					value: K,
					onChange: (x) => J(x.target.value),
					autoFocus: !0
				})]
			}), $l ? /* @__PURE__ */ jsx("p", {
				className: DropdownMenu_module_default.EmptyState,
				children: Zl && K ? "No matches" : "No options"
			}) : /* @__PURE__ */ jsx("ul", {
				className: DropdownMenu_module_default.OptionList,
				children: Ql.map((w) => /* @__PURE__ */ jsxs("li", {
					className: (0, import_classnames$39.default)(DropdownMenu_module_default.Option, { [DropdownMenu_module_default.Disabled]: w.disabled }),
					onClick: () => {
						w.disabled || (w.onClick?.(), U?.(w.value), J(""), x());
					},
					children: [w.icon && /* @__PURE__ */ jsx("span", {
						className: DropdownMenu_module_default.OptionIcon,
						children: w.icon
					}), /* @__PURE__ */ jsx("span", {
						className: DropdownMenu_module_default.OptionLabel,
						children: w.label
					})]
				}, w.value))
			})] })
		}), document.body)]
	});
};
function Form({ action: x, children: w, method: V = "post", name: U, preventDefault: W = !0, onSubmit: G, className: K }) {
	return /* @__PURE__ */ jsx("form", {
		action: x,
		method: V,
		name: U,
		onSubmit: useCallback((x) => {
			W && (x.preventDefault(), G(x));
		}, [G, W]),
		className: K || "",
		children: w
	});
}
var Label_module_default = {
	Label: "_Label_1dnv5_1",
	error: "_error_1dnv5_4"
}, import_classnames$38 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function getId(x) {
	return x ? `${x}Label` : void 0;
}
function Label({ children: x, id: w, className: V, hasErrors: U, ...W }) {
	let G = (0, import_classnames$38.default)(Label_module_default.Label, V, { [Label_module_default.error]: U });
	return /* @__PURE__ */ jsx("label", {
		id: getId(w),
		htmlFor: w,
		className: G,
		...W,
		children: x
	});
}
var FormGroup_module_default = {
	FormGroup: "_FormGroup_11rjy_1",
	elevated: "_elevated_11rjy_1",
	modal: "_modal_11rjy_4"
}, import_classnames$37 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function FormGroup({ children: x, label: w, htmlFor: V, className: U, hasErrors: W, variant: G = "elevated", inputClassName: K, ...J }) {
	return /* @__PURE__ */ jsxs("div", {
		className: twMerge((0, import_classnames$37.default)(FormGroup_module_default.FormGroup, {
			[FormGroup_module_default.elevated]: G === "elevated",
			[FormGroup_module_default.modal]: G === "modal"
		}), U),
		...J,
		children: [/* @__PURE__ */ jsx(Label, {
			id: V,
			hasErrors: W,
			children: w
		}), /* @__PURE__ */ jsx("div", {
			className: K,
			children: x
		})]
	});
}
var Heartbeat_module_default = {
	Heartbeat: "_Heartbeat_b6g2t_1",
	pulse: "_pulse_b6g2t_1",
	bounce: "_bounce_b6g2t_1"
}, Heartbeat_default = () => {
	let { t: x } = useTranslation();
	return /* @__PURE__ */ jsx("div", {
		className: Heartbeat_module_default.Heartbeat,
		children: /* @__PURE__ */ jsx("h1", { children: /* @__PURE__ */ jsx("span", { children: x("Heartbeat:pulse") }) })
	});
}, InlineEdit_module_default = {
	InlineEditContainer: "_InlineEditContainer_11jjy_1",
	EditingWrapper: "_EditingWrapper_11jjy_5",
	Input: "_Input_11jjy_9",
	ButtonGroup: "_ButtonGroup_11jjy_13",
	ConfirmButton: "_ConfirmButton_11jjy_19",
	CancelButton: "_CancelButton_11jjy_20",
	DisplayWrapper: "_DisplayWrapper_11jjy_36",
	PencilIcon: "_PencilIcon_11jjy_42",
	DisplayText: "_DisplayText_11jjy_54"
};
function InlineEdit({ value: x, onChange: w, placeholder: V = "Click to edit", id: U, name: W, sizingClassName: G, type: K = "text", characterLimit: J, hidePencil: Y = !1 }) {
	let [Z, $] = useState(!1), [ql, Jl] = useState(x), Yl = useRef(null), Xl = useCallback(() => {
		Jl(x), $(!1);
	}, [x]);
	useEffect(() => {
		let x = (x) => {
			Yl.current && !Yl.current.contains(x.target) && Xl();
		};
		return Z && document.addEventListener("mousedown", x), function() {
			document.removeEventListener("mousedown", x);
		};
	}, [Z, Xl]), useEffect(() => {
		Jl(x);
	}, [x]);
	let Zl = () => {
		Jl(x), $(!0);
	}, Ql = (x) => {
		J && x.target.value.length > J || Jl(x.target.value);
	}, $l = () => {
		ql.trim() !== "" && ql !== x && w(ql), $(!1);
	};
	return /* @__PURE__ */ jsx("div", {
		className: InlineEdit_module_default.InlineEditContainer,
		ref: Yl,
		children: Z ? /* @__PURE__ */ jsxs("div", {
			className: InlineEdit_module_default.EditingWrapper,
			children: [/* @__PURE__ */ jsx(Input, {
				type: K,
				value: ql,
				onChange: Ql,
				onKeyDown: (x) => {
					switch (x.key) {
						case "Enter":
							$l();
							break;
						case "Escape":
							Xl();
							break;
						default: break;
					}
				},
				id: U,
				name: W,
				placeholder: V,
				classNameInput: InlineEdit_module_default.Input,
				autoFocus: !0
			}), /* @__PURE__ */ jsxs("div", {
				className: InlineEdit_module_default.ButtonGroup,
				children: [/* @__PURE__ */ jsx("button", {
					className: InlineEdit_module_default.ConfirmButton,
					onClick: $l,
					type: "button",
					"aria-label": "Confirm",
					children: /* @__PURE__ */ jsx(Icon_default, {
						icon: "check",
						size: 12,
						weight: "bold"
					})
				}), /* @__PURE__ */ jsx("button", {
					className: InlineEdit_module_default.CancelButton,
					onClick: Xl,
					type: "button",
					"aria-label": "Cancel",
					children: /* @__PURE__ */ jsx(Icon_default, {
						icon: "x",
						size: 12,
						weight: "bold"
					})
				})]
			})]
		}) : /* @__PURE__ */ jsxs("div", {
			className: InlineEdit_module_default.DisplayWrapper,
			children: [!Y && /* @__PURE__ */ jsx("button", {
				className: InlineEdit_module_default.PencilIcon,
				onClick: Zl,
				type: "button",
				"aria-label": "Edit",
				children: /* @__PURE__ */ jsx(Icon_default, {
					icon: "pencil",
					size: 14
				})
			}), /* @__PURE__ */ jsx("button", {
				className: classNames$10(InlineEdit_module_default.DisplayText, G),
				onClick: Zl,
				type: "button",
				"aria-label": "Edit text",
				children: x || V
			})]
		})
	});
}
var require_tinycolor = /* @__PURE__ */ __commonJSMin(((x, w) => {
	(function(x) {
		var V = /^\s+/, U = /\s+$/, W = 0, G = x.round, K = x.min, J = x.max, Y = x.random;
		function Z(x, w) {
			if (x ||= "", w ||= {}, x instanceof Z) return x;
			if (!(this instanceof Z)) return new Z(x, w);
			var V = $(x);
			this._originalInput = x, this._r = V.r, this._g = V.g, this._b = V.b, this._a = V.a, this._roundA = G(100 * this._a) / 100, this._format = w.format || V.format, this._gradientType = w.gradientType, this._r < 1 && (this._r = G(this._r)), this._g < 1 && (this._g = G(this._g)), this._b < 1 && (this._b = G(this._b)), this._ok = V.ok, this._tc_id = W++;
		}
		Z.prototype = {
			isDark: function() {
				return this.getBrightness() < 128;
			},
			isLight: function() {
				return !this.isDark();
			},
			isValid: function() {
				return this._ok;
			},
			getOriginalInput: function() {
				return this._originalInput;
			},
			getFormat: function() {
				return this._format;
			},
			getAlpha: function() {
				return this._a;
			},
			getBrightness: function() {
				var x = this.toRgb();
				return (x.r * 299 + x.g * 587 + x.b * 114) / 1e3;
			},
			getLuminance: function() {
				var w = this.toRgb(), V = w.r / 255, U = w.g / 255, W = w.b / 255, G = V <= .03928 ? V / 12.92 : x.pow((V + .055) / 1.055, 2.4), K = U <= .03928 ? U / 12.92 : x.pow((U + .055) / 1.055, 2.4), J = W <= .03928 ? W / 12.92 : x.pow((W + .055) / 1.055, 2.4);
				return .2126 * G + .7152 * K + .0722 * J;
			},
			setAlpha: function(x) {
				return this._a = _u(x), this._roundA = G(100 * this._a) / 100, this;
			},
			toHsv: function() {
				var x = Xl(this._r, this._g, this._b);
				return {
					h: x.h * 360,
					s: x.s,
					v: x.v,
					a: this._a
				};
			},
			toHsvString: function() {
				var x = Xl(this._r, this._g, this._b), w = G(x.h * 360), V = G(x.s * 100), U = G(x.v * 100);
				return this._a == 1 ? "hsv(" + w + ", " + V + "%, " + U + "%)" : "hsva(" + w + ", " + V + "%, " + U + "%, " + this._roundA + ")";
			},
			toHsl: function() {
				var x = Jl(this._r, this._g, this._b);
				return {
					h: x.h * 360,
					s: x.s,
					l: x.l,
					a: this._a
				};
			},
			toHslString: function() {
				var x = Jl(this._r, this._g, this._b), w = G(x.h * 360), V = G(x.s * 100), U = G(x.l * 100);
				return this._a == 1 ? "hsl(" + w + ", " + V + "%, " + U + "%)" : "hsla(" + w + ", " + V + "%, " + U + "%, " + this._roundA + ")";
			},
			toHex: function(x) {
				return Ql(this._r, this._g, this._b, x);
			},
			toHexString: function(x) {
				return "#" + this.toHex(x);
			},
			toHex8: function(x) {
				return $l(this._r, this._g, this._b, this._a, x);
			},
			toHex8String: function(x) {
				return "#" + this.toHex8(x);
			},
			toRgb: function() {
				return {
					r: G(this._r),
					g: G(this._g),
					b: G(this._b),
					a: this._a
				};
			},
			toRgbString: function() {
				return this._a == 1 ? "rgb(" + G(this._r) + ", " + G(this._g) + ", " + G(this._b) + ")" : "rgba(" + G(this._r) + ", " + G(this._g) + ", " + G(this._b) + ", " + this._roundA + ")";
			},
			toPercentageRgb: function() {
				return {
					r: G(vu(this._r, 255) * 100) + "%",
					g: G(vu(this._g, 255) * 100) + "%",
					b: G(vu(this._b, 255) * 100) + "%",
					a: this._a
				};
			},
			toPercentageRgbString: function() {
				return this._a == 1 ? "rgb(" + G(vu(this._r, 255) * 100) + "%, " + G(vu(this._g, 255) * 100) + "%, " + G(vu(this._b, 255) * 100) + "%)" : "rgba(" + G(vu(this._r, 255) * 100) + "%, " + G(vu(this._g, 255) * 100) + "%, " + G(vu(this._b, 255) * 100) + "%, " + this._roundA + ")";
			},
			toName: function() {
				return this._a === 0 ? "transparent" : this._a < 1 ? !1 : hu[Ql(this._r, this._g, this._b, !0)] || !1;
			},
			toFilter: function(x) {
				var w = "#" + eu(this._r, this._g, this._b, this._a), V = w, U = this._gradientType ? "GradientType = 1, " : "";
				if (x) {
					var W = Z(x);
					V = "#" + eu(W._r, W._g, W._b, W._a);
				}
				return "progid:DXImageTransform.Microsoft.gradient(" + U + "startColorstr=" + w + ",endColorstr=" + V + ")";
			},
			toString: function(x) {
				var w = !!x;
				x ||= this._format;
				var V = !1, U = this._a < 1 && this._a >= 0;
				return !w && U && (x === "hex" || x === "hex6" || x === "hex3" || x === "hex4" || x === "hex8" || x === "name") ? x === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (x === "rgb" && (V = this.toRgbString()), x === "prgb" && (V = this.toPercentageRgbString()), (x === "hex" || x === "hex6") && (V = this.toHexString()), x === "hex3" && (V = this.toHexString(!0)), x === "hex4" && (V = this.toHex8String(!0)), x === "hex8" && (V = this.toHex8String()), x === "name" && (V = this.toName()), x === "hsl" && (V = this.toHslString()), x === "hsv" && (V = this.toHsvString()), V || this.toHexString());
			},
			clone: function() {
				return Z(this.toString());
			},
			_applyModification: function(x, w) {
				var V = x.apply(null, [this].concat([].slice.call(w)));
				return this._r = V._r, this._g = V._g, this._b = V._b, this.setAlpha(V._a), this;
			},
			lighten: function() {
				return this._applyModification(iu, arguments);
			},
			brighten: function() {
				return this._applyModification(au, arguments);
			},
			darken: function() {
				return this._applyModification(ou, arguments);
			},
			desaturate: function() {
				return this._applyModification(tu, arguments);
			},
			saturate: function() {
				return this._applyModification(nu, arguments);
			},
			greyscale: function() {
				return this._applyModification(ru, arguments);
			},
			spin: function() {
				return this._applyModification(su, arguments);
			},
			_applyCombination: function(x, w) {
				return x.apply(null, [this].concat([].slice.call(w)));
			},
			analogous: function() {
				return this._applyCombination(fu, arguments);
			},
			complement: function() {
				return this._applyCombination(cu, arguments);
			},
			monochromatic: function() {
				return this._applyCombination(pu, arguments);
			},
			splitcomplement: function() {
				return this._applyCombination(du, arguments);
			},
			triad: function() {
				return this._applyCombination(lu, arguments);
			},
			tetrad: function() {
				return this._applyCombination(uu, arguments);
			}
		}, Z.fromRatio = function(x, w) {
			if (typeof x == "object") {
				var V = {};
				for (var U in x) x.hasOwnProperty(U) && (U === "a" ? V[U] = x[U] : V[U] = wu(x[U]));
				x = V;
			}
			return Z(x, w);
		};
		function $(x) {
			var w = {
				r: 0,
				g: 0,
				b: 0
			}, V = 1, U = null, W = null, G = null, Y = !1, Z = !1;
			return typeof x == "string" && (x = ku(x)), typeof x == "object" && (Ou(x.r) && Ou(x.g) && Ou(x.b) ? (w = ql(x.r, x.g, x.b), Y = !0, Z = String(x.r).substr(-1) === "%" ? "prgb" : "rgb") : Ou(x.h) && Ou(x.s) && Ou(x.v) ? (U = wu(x.s), W = wu(x.v), w = Zl(x.h, U, W), Y = !0, Z = "hsv") : Ou(x.h) && Ou(x.s) && Ou(x.l) && (U = wu(x.s), G = wu(x.l), w = Yl(x.h, U, G), Y = !0, Z = "hsl"), x.hasOwnProperty("a") && (V = x.a)), V = _u(V), {
				ok: Y,
				format: x.format || Z,
				r: K(255, J(w.r, 0)),
				g: K(255, J(w.g, 0)),
				b: K(255, J(w.b, 0)),
				a: V
			};
		}
		function ql(x, w, V) {
			return {
				r: vu(x, 255) * 255,
				g: vu(w, 255) * 255,
				b: vu(V, 255) * 255
			};
		}
		function Jl(x, w, V) {
			x = vu(x, 255), w = vu(w, 255), V = vu(V, 255);
			var U = J(x, w, V), W = K(x, w, V), G, Y, Z = (U + W) / 2;
			if (U == W) G = Y = 0;
			else {
				var $ = U - W;
				switch (Y = Z > .5 ? $ / (2 - U - W) : $ / (U + W), U) {
					case x:
						G = (w - V) / $ + (w < V ? 6 : 0);
						break;
					case w:
						G = (V - x) / $ + 2;
						break;
					case V:
						G = (x - w) / $ + 4;
						break;
				}
				G /= 6;
			}
			return {
				h: G,
				s: Y,
				l: Z
			};
		}
		function Yl(x, w, V) {
			var U, W, G;
			x = vu(x, 360), w = vu(w, 100), V = vu(V, 100);
			function K(x, w, V) {
				return V < 0 && (V += 1), V > 1 && --V, V < 1 / 6 ? x + (w - x) * 6 * V : V < 1 / 2 ? w : V < 2 / 3 ? x + (w - x) * (2 / 3 - V) * 6 : x;
			}
			if (w === 0) U = W = G = V;
			else {
				var J = V < .5 ? V * (1 + w) : V + w - V * w, Y = 2 * V - J;
				U = K(Y, J, x + 1 / 3), W = K(Y, J, x), G = K(Y, J, x - 1 / 3);
			}
			return {
				r: U * 255,
				g: W * 255,
				b: G * 255
			};
		}
		function Xl(x, w, V) {
			x = vu(x, 255), w = vu(w, 255), V = vu(V, 255);
			var U = J(x, w, V), W = K(x, w, V), G, Y, Z = U, $ = U - W;
			if (Y = U === 0 ? 0 : $ / U, U == W) G = 0;
			else {
				switch (U) {
					case x:
						G = (w - V) / $ + (w < V ? 6 : 0);
						break;
					case w:
						G = (V - x) / $ + 2;
						break;
					case V:
						G = (x - w) / $ + 4;
						break;
				}
				G /= 6;
			}
			return {
				h: G,
				s: Y,
				v: Z
			};
		}
		function Zl(w, V, U) {
			w = vu(w, 360) * 6, V = vu(V, 100), U = vu(U, 100);
			var W = x.floor(w), G = w - W, K = U * (1 - V), J = U * (1 - G * V), Y = U * (1 - (1 - G) * V), Z = W % 6, $ = [
				U,
				J,
				K,
				K,
				Y,
				U
			][Z], ql = [
				Y,
				U,
				U,
				J,
				K,
				K
			][Z], Jl = [
				K,
				K,
				Y,
				U,
				U,
				J
			][Z];
			return {
				r: $ * 255,
				g: ql * 255,
				b: Jl * 255
			};
		}
		function Ql(x, w, V, U) {
			var W = [
				Cu(G(x).toString(16)),
				Cu(G(w).toString(16)),
				Cu(G(V).toString(16))
			];
			return U && W[0].charAt(0) == W[0].charAt(1) && W[1].charAt(0) == W[1].charAt(1) && W[2].charAt(0) == W[2].charAt(1) ? W[0].charAt(0) + W[1].charAt(0) + W[2].charAt(0) : W.join("");
		}
		function $l(x, w, V, U, W) {
			var K = [
				Cu(G(x).toString(16)),
				Cu(G(w).toString(16)),
				Cu(G(V).toString(16)),
				Cu(Tu(U))
			];
			return W && K[0].charAt(0) == K[0].charAt(1) && K[1].charAt(0) == K[1].charAt(1) && K[2].charAt(0) == K[2].charAt(1) && K[3].charAt(0) == K[3].charAt(1) ? K[0].charAt(0) + K[1].charAt(0) + K[2].charAt(0) + K[3].charAt(0) : K.join("");
		}
		function eu(x, w, V, U) {
			return [
				Cu(Tu(U)),
				Cu(G(x).toString(16)),
				Cu(G(w).toString(16)),
				Cu(G(V).toString(16))
			].join("");
		}
		Z.equals = function(x, w) {
			return !x || !w ? !1 : Z(x).toRgbString() == Z(w).toRgbString();
		}, Z.random = function() {
			return Z.fromRatio({
				r: Y(),
				g: Y(),
				b: Y()
			});
		};
		function tu(x, w) {
			w = w === 0 ? 0 : w || 10;
			var V = Z(x).toHsl();
			return V.s -= w / 100, V.s = yu(V.s), Z(V);
		}
		function nu(x, w) {
			w = w === 0 ? 0 : w || 10;
			var V = Z(x).toHsl();
			return V.s += w / 100, V.s = yu(V.s), Z(V);
		}
		function ru(x) {
			return Z(x).desaturate(100);
		}
		function iu(x, w) {
			w = w === 0 ? 0 : w || 10;
			var V = Z(x).toHsl();
			return V.l += w / 100, V.l = yu(V.l), Z(V);
		}
		function au(x, w) {
			w = w === 0 ? 0 : w || 10;
			var V = Z(x).toRgb();
			return V.r = J(0, K(255, V.r - G(255 * -(w / 100)))), V.g = J(0, K(255, V.g - G(255 * -(w / 100)))), V.b = J(0, K(255, V.b - G(255 * -(w / 100)))), Z(V);
		}
		function ou(x, w) {
			w = w === 0 ? 0 : w || 10;
			var V = Z(x).toHsl();
			return V.l -= w / 100, V.l = yu(V.l), Z(V);
		}
		function su(x, w) {
			var V = Z(x).toHsl(), U = (V.h + w) % 360;
			return V.h = U < 0 ? 360 + U : U, Z(V);
		}
		function cu(x) {
			var w = Z(x).toHsl();
			return w.h = (w.h + 180) % 360, Z(w);
		}
		function lu(x) {
			var w = Z(x).toHsl(), V = w.h;
			return [
				Z(x),
				Z({
					h: (V + 120) % 360,
					s: w.s,
					l: w.l
				}),
				Z({
					h: (V + 240) % 360,
					s: w.s,
					l: w.l
				})
			];
		}
		function uu(x) {
			var w = Z(x).toHsl(), V = w.h;
			return [
				Z(x),
				Z({
					h: (V + 90) % 360,
					s: w.s,
					l: w.l
				}),
				Z({
					h: (V + 180) % 360,
					s: w.s,
					l: w.l
				}),
				Z({
					h: (V + 270) % 360,
					s: w.s,
					l: w.l
				})
			];
		}
		function du(x) {
			var w = Z(x).toHsl(), V = w.h;
			return [
				Z(x),
				Z({
					h: (V + 72) % 360,
					s: w.s,
					l: w.l
				}),
				Z({
					h: (V + 216) % 360,
					s: w.s,
					l: w.l
				})
			];
		}
		function fu(x, w, V) {
			w ||= 6, V ||= 30;
			var U = Z(x).toHsl(), W = 360 / V, G = [Z(x)];
			for (U.h = (U.h - (W * w >> 1) + 720) % 360; --w;) U.h = (U.h + W) % 360, G.push(Z(U));
			return G;
		}
		function pu(x, w) {
			w ||= 6;
			for (var V = Z(x).toHsv(), U = V.h, W = V.s, G = V.v, K = [], J = 1 / w; w--;) K.push(Z({
				h: U,
				s: W,
				v: G
			})), G = (G + J) % 1;
			return K;
		}
		Z.mix = function(x, w, V) {
			V = V === 0 ? 0 : V || 50;
			var U = Z(x).toRgb(), W = Z(w).toRgb(), G = V / 100;
			return Z({
				r: (W.r - U.r) * G + U.r,
				g: (W.g - U.g) * G + U.g,
				b: (W.b - U.b) * G + U.b,
				a: (W.a - U.a) * G + U.a
			});
		}, Z.readability = function(w, V) {
			var U = Z(w), W = Z(V);
			return (x.max(U.getLuminance(), W.getLuminance()) + .05) / (x.min(U.getLuminance(), W.getLuminance()) + .05);
		}, Z.isReadable = function(x, w, V) {
			var U = Z.readability(x, w), W, G = !1;
			switch (W = Au(V), W.level + W.size) {
				case "AAsmall":
				case "AAAlarge":
					G = U >= 4.5;
					break;
				case "AAlarge":
					G = U >= 3;
					break;
				case "AAAsmall":
					G = U >= 7;
					break;
			}
			return G;
		}, Z.mostReadable = function(x, w, V) {
			var U = null, W = 0, G, K, J, Y;
			V ||= {}, K = V.includeFallbackColors, J = V.level, Y = V.size;
			for (var $ = 0; $ < w.length; $++) G = Z.readability(x, w[$]), G > W && (W = G, U = Z(w[$]));
			return Z.isReadable(x, U, {
				level: J,
				size: Y
			}) || !K ? U : (V.includeFallbackColors = !1, Z.mostReadable(x, ["#fff", "#000"], V));
		};
		var mu = Z.names = {
			aliceblue: "f0f8ff",
			antiquewhite: "faebd7",
			aqua: "0ff",
			aquamarine: "7fffd4",
			azure: "f0ffff",
			beige: "f5f5dc",
			bisque: "ffe4c4",
			black: "000",
			blanchedalmond: "ffebcd",
			blue: "00f",
			blueviolet: "8a2be2",
			brown: "a52a2a",
			burlywood: "deb887",
			burntsienna: "ea7e5d",
			cadetblue: "5f9ea0",
			chartreuse: "7fff00",
			chocolate: "d2691e",
			coral: "ff7f50",
			cornflowerblue: "6495ed",
			cornsilk: "fff8dc",
			crimson: "dc143c",
			cyan: "0ff",
			darkblue: "00008b",
			darkcyan: "008b8b",
			darkgoldenrod: "b8860b",
			darkgray: "a9a9a9",
			darkgreen: "006400",
			darkgrey: "a9a9a9",
			darkkhaki: "bdb76b",
			darkmagenta: "8b008b",
			darkolivegreen: "556b2f",
			darkorange: "ff8c00",
			darkorchid: "9932cc",
			darkred: "8b0000",
			darksalmon: "e9967a",
			darkseagreen: "8fbc8f",
			darkslateblue: "483d8b",
			darkslategray: "2f4f4f",
			darkslategrey: "2f4f4f",
			darkturquoise: "00ced1",
			darkviolet: "9400d3",
			deeppink: "ff1493",
			deepskyblue: "00bfff",
			dimgray: "696969",
			dimgrey: "696969",
			dodgerblue: "1e90ff",
			firebrick: "b22222",
			floralwhite: "fffaf0",
			forestgreen: "228b22",
			fuchsia: "f0f",
			gainsboro: "dcdcdc",
			ghostwhite: "f8f8ff",
			gold: "ffd700",
			goldenrod: "daa520",
			gray: "808080",
			green: "008000",
			greenyellow: "adff2f",
			grey: "808080",
			honeydew: "f0fff0",
			hotpink: "ff69b4",
			indianred: "cd5c5c",
			indigo: "4b0082",
			ivory: "fffff0",
			khaki: "f0e68c",
			lavender: "e6e6fa",
			lavenderblush: "fff0f5",
			lawngreen: "7cfc00",
			lemonchiffon: "fffacd",
			lightblue: "add8e6",
			lightcoral: "f08080",
			lightcyan: "e0ffff",
			lightgoldenrodyellow: "fafad2",
			lightgray: "d3d3d3",
			lightgreen: "90ee90",
			lightgrey: "d3d3d3",
			lightpink: "ffb6c1",
			lightsalmon: "ffa07a",
			lightseagreen: "20b2aa",
			lightskyblue: "87cefa",
			lightslategray: "789",
			lightslategrey: "789",
			lightsteelblue: "b0c4de",
			lightyellow: "ffffe0",
			lime: "0f0",
			limegreen: "32cd32",
			linen: "faf0e6",
			magenta: "f0f",
			maroon: "800000",
			mediumaquamarine: "66cdaa",
			mediumblue: "0000cd",
			mediumorchid: "ba55d3",
			mediumpurple: "9370db",
			mediumseagreen: "3cb371",
			mediumslateblue: "7b68ee",
			mediumspringgreen: "00fa9a",
			mediumturquoise: "48d1cc",
			mediumvioletred: "c71585",
			midnightblue: "191970",
			mintcream: "f5fffa",
			mistyrose: "ffe4e1",
			moccasin: "ffe4b5",
			navajowhite: "ffdead",
			navy: "000080",
			oldlace: "fdf5e6",
			olive: "808000",
			olivedrab: "6b8e23",
			orange: "ffa500",
			orangered: "ff4500",
			orchid: "da70d6",
			palegoldenrod: "eee8aa",
			palegreen: "98fb98",
			paleturquoise: "afeeee",
			palevioletred: "db7093",
			papayawhip: "ffefd5",
			peachpuff: "ffdab9",
			peru: "cd853f",
			pink: "ffc0cb",
			plum: "dda0dd",
			powderblue: "b0e0e6",
			purple: "800080",
			rebeccapurple: "663399",
			red: "f00",
			rosybrown: "bc8f8f",
			royalblue: "4169e1",
			saddlebrown: "8b4513",
			salmon: "fa8072",
			sandybrown: "f4a460",
			seagreen: "2e8b57",
			seashell: "fff5ee",
			sienna: "a0522d",
			silver: "c0c0c0",
			skyblue: "87ceeb",
			slateblue: "6a5acd",
			slategray: "708090",
			slategrey: "708090",
			snow: "fffafa",
			springgreen: "00ff7f",
			steelblue: "4682b4",
			tan: "d2b48c",
			teal: "008080",
			thistle: "d8bfd8",
			tomato: "ff6347",
			turquoise: "40e0d0",
			violet: "ee82ee",
			wheat: "f5deb3",
			white: "fff",
			whitesmoke: "f5f5f5",
			yellow: "ff0",
			yellowgreen: "9acd32"
		}, hu = Z.hexNames = gu(mu);
		function gu(x) {
			var w = {};
			for (var V in x) x.hasOwnProperty(V) && (w[x[V]] = V);
			return w;
		}
		function _u(x) {
			return x = parseFloat(x), (isNaN(x) || x < 0 || x > 1) && (x = 1), x;
		}
		function vu(w, V) {
			xu(w) && (w = "100%");
			var U = Su(w);
			return w = K(V, J(0, parseFloat(w))), U && (w = parseInt(w * V, 10) / 100), x.abs(w - V) < 1e-6 ? 1 : w % V / parseFloat(V);
		}
		function yu(x) {
			return K(1, J(0, x));
		}
		function bu(x) {
			return parseInt(x, 16);
		}
		function xu(x) {
			return typeof x == "string" && x.indexOf(".") != -1 && parseFloat(x) === 1;
		}
		function Su(x) {
			return typeof x == "string" && x.indexOf("%") != -1;
		}
		function Cu(x) {
			return x.length == 1 ? "0" + x : "" + x;
		}
		function wu(x) {
			return x <= 1 && (x = x * 100 + "%"), x;
		}
		function Tu(w) {
			return x.round(parseFloat(w) * 255).toString(16);
		}
		function Eu(x) {
			return bu(x) / 255;
		}
		var Du = (function() {
			var x = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)", w = "[\\s|\\(]+(" + x + ")[,|\\s]+(" + x + ")[,|\\s]+(" + x + ")\\s*\\)?", V = "[\\s|\\(]+(" + x + ")[,|\\s]+(" + x + ")[,|\\s]+(" + x + ")[,|\\s]+(" + x + ")\\s*\\)?";
			return {
				CSS_UNIT: new RegExp(x),
				rgb: /* @__PURE__ */ RegExp("rgb" + w),
				rgba: /* @__PURE__ */ RegExp("rgba" + V),
				hsl: /* @__PURE__ */ RegExp("hsl" + w),
				hsla: /* @__PURE__ */ RegExp("hsla" + V),
				hsv: /* @__PURE__ */ RegExp("hsv" + w),
				hsva: /* @__PURE__ */ RegExp("hsva" + V),
				hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
				hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
				hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
				hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
			};
		})();
		function Ou(x) {
			return !!Du.CSS_UNIT.exec(x);
		}
		function ku(x) {
			x = x.replace(V, "").replace(U, "").toLowerCase();
			var w = !1;
			if (mu[x]) x = mu[x], w = !0;
			else if (x == "transparent") return {
				r: 0,
				g: 0,
				b: 0,
				a: 0,
				format: "name"
			};
			var W;
			return (W = Du.rgb.exec(x)) ? {
				r: W[1],
				g: W[2],
				b: W[3]
			} : (W = Du.rgba.exec(x)) ? {
				r: W[1],
				g: W[2],
				b: W[3],
				a: W[4]
			} : (W = Du.hsl.exec(x)) ? {
				h: W[1],
				s: W[2],
				l: W[3]
			} : (W = Du.hsla.exec(x)) ? {
				h: W[1],
				s: W[2],
				l: W[3],
				a: W[4]
			} : (W = Du.hsv.exec(x)) ? {
				h: W[1],
				s: W[2],
				v: W[3]
			} : (W = Du.hsva.exec(x)) ? {
				h: W[1],
				s: W[2],
				v: W[3],
				a: W[4]
			} : (W = Du.hex8.exec(x)) ? {
				r: bu(W[1]),
				g: bu(W[2]),
				b: bu(W[3]),
				a: Eu(W[4]),
				format: w ? "name" : "hex8"
			} : (W = Du.hex6.exec(x)) ? {
				r: bu(W[1]),
				g: bu(W[2]),
				b: bu(W[3]),
				format: w ? "name" : "hex"
			} : (W = Du.hex4.exec(x)) ? {
				r: bu(W[1] + "" + W[1]),
				g: bu(W[2] + "" + W[2]),
				b: bu(W[3] + "" + W[3]),
				a: Eu(W[4] + "" + W[4]),
				format: w ? "name" : "hex8"
			} : (W = Du.hex3.exec(x)) ? {
				r: bu(W[1] + "" + W[1]),
				g: bu(W[2] + "" + W[2]),
				b: bu(W[3] + "" + W[3]),
				format: w ? "name" : "hex"
			} : !1;
		}
		function Au(x) {
			var w, V;
			return x ||= {
				level: "AA",
				size: "small"
			}, w = (x.level || "AA").toUpperCase(), V = (x.size || "small").toLowerCase(), w !== "AA" && w !== "AAA" && (w = "AA"), V !== "small" && V !== "large" && (V = "small"), {
				level: w,
				size: V
			};
		}
		w !== void 0 && w.exports ? w.exports = Z : typeof define == "function" && define.amd ? define(function() {
			return Z;
		}) : window.tinycolor = Z;
	})(Math);
})), import_tinycolor$7 = /* @__PURE__ */ __toESM(require_tinycolor(), 1), __assign$16 = function() {
	return __assign$16 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$16.apply(this, arguments);
}, __spreadArray$2 = function(x, w, V) {
	if (V || arguments.length === 2) for (var U = 0, W = w.length, G; U < W; U++) (G || !(U in w)) && (G ||= Array.prototype.slice.call(w, 0, U), G[U] = w[U]);
	return x.concat(G || Array.prototype.slice.call(w));
}, gradientParser = function(x) {
	x === void 0 && (x = "");
	var w = {
		linearGradient: /^(-(webkit|o|ms|moz)-)?(linear-gradient)/i,
		repeatingLinearGradient: /^(-(webkit|o|ms|moz)-)?(repeating-linear-gradient)/i,
		radialGradient: /^(-(webkit|o|ms|moz)-)?(radial-gradient)/i,
		repeatingRadialGradient: /^(-(webkit|o|ms|moz)-)?(repeating-radial-gradient)/i,
		sideOrCorner: /^to (left (top|bottom)|right (top|bottom)|top (left|right)|bottom (left|right)|left|right|top|bottom)/i,
		extentKeywords: /^(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)/,
		positionKeywords: /^(left|center|right|top|bottom)/i,
		pixelValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))px/,
		percentageValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))%/,
		emValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))em/,
		angleValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))deg/,
		startCall: /^\(/,
		endCall: /^\)/,
		comma: /^,/,
		hexColor: /^#([0-9a-fA-F]+)/,
		literalColor: /^([a-zA-Z]+)/,
		rgbColor: /^rgb/i,
		spacedRgbColor: /^(\d{1,3})\s+(\d{1,3})\s+(\d{1,3})\s+\/\s+([0-1](\.\d+)?)/,
		rgbaColor: /^rgba/i,
		hslColor: /^hsl/i,
		hsvColor: /^hsv/i,
		number: /^(([0-9]*\.[0-9]+)|([0-9]+\.?))/
	};
	function V(w) {
		throw /* @__PURE__ */ Error(x + ": " + w);
	}
	function U(w) {
		x = x.substr(w);
	}
	function W(w) {
		var V = /^[\n\r\t\s]+/.exec(x);
		V && U(V[0].length);
		var W = w.exec(x);
		return W && U(W[0].length), W;
	}
	function G(x) {
		var U = x(), G = [];
		if (U) for (G.push(U); W(w.comma);) U = x(), U ? G.push(U) : V("One extra comma");
		return G;
	}
	function K(x, w, V) {
		var U = W(w);
		if (U) return {
			type: x,
			value: U[V]
		};
	}
	function J() {
		var x = K("hex", w.hexColor, 1);
		if (x?.value) {
			var V = (0, import_tinycolor$7.default)(x?.value).toRgb();
			return { value: `rgba(${V.r}, ${V.g}, ${V.b}, ${V.a})` };
		}
	}
	var Y = function(x) {
		return { value: `${isUpperCase(x?.[0]) ? "RGBA" : "rgba"}(${G(hu)})` };
	};
	function Z(x, U) {
		var G = W(x);
		if (G) {
			W(w.startCall) || V("Missing (");
			var K = U(G);
			return W(w.endCall) || V("Missing )"), K;
		}
	}
	function $() {
		return Z(w.hslColor, gu);
	}
	function ql() {
		return Z(w.rgbaColor, Y);
	}
	function Jl() {
		return Z(w.rgbColor, vu);
	}
	function Yl() {
		var x = K("literal", w.literalColor, 0);
		if (x?.value) {
			var V = (0, import_tinycolor$7.default)(x?.value).toRgb();
			return { value: `rgba(${V.r}, ${V.g}, ${V.b}, ${V.a})` };
		}
	}
	function Xl() {
		return Z(w.hsvColor, _u);
	}
	function Zl() {
		return J() || $() || ql() || Jl() || Yl() || Xl();
	}
	function Ql() {
		var x = Zl();
		return x || V("Expected color definition"), x.left = parseInt(yu()?.value), x;
	}
	function $l(x, U, K) {
		return Z(U, function() {
			var U = K();
			return U && (W(w.comma) || V("Missing comma before color stops")), {
				type: x,
				orientation: U,
				colorStops: G(Ql)
			};
		});
	}
	function eu() {
		return iu() || au();
	}
	function tu() {
		return $l("linear-gradient", w.linearGradient, eu) || $l("repeating-linear-gradient", w.repeatingLinearGradient, eu) || $l("radial-gradient", w.radialGradient, ou) || $l("repeating-radial-gradient", w.repeatingRadialGradient, ou);
	}
	function nu() {
		return G(tu);
	}
	function ru() {
		var w = nu();
		x.length > 0 && V("Invalid input not EOF");
		var U = w[0], W = (U?.colorStops)?.filter(function(x) {
			return isUpperCase(x.value);
		}).length;
		return function() {
			if (W > 0) return U;
			var x = function(x, w) {
				return w === 0 ? high(x) : low(x);
			};
			return __assign$16(__assign$16({}, U), { colorStops: U.colorStops.map(function(w, V) {
				return __assign$16(__assign$16({}, w), { value: x(w, V) });
			}) });
		}();
	}
	function iu() {
		return K("directional", w.sideOrCorner, 1);
	}
	function au() {
		return K("angular", w.angleValue, 1);
	}
	function ou() {
		var V, U = su(), G;
		return U && (V = [], V.push(U), G = x, W(w.comma) && (U = su(), U ? V.push(U) : x = G)), V;
	}
	function su() {
		var x = lu() || uu();
		if (x) x.at = fu();
		else {
			var w = du();
			if (w) {
				x = w;
				var V = fu();
				V && (x.at = V);
			} else {
				var U = pu();
				U && (x = {
					type: "default-radial",
					at: U
				});
			}
		}
		return x;
	}
	function cu() {
		return K("px", w.pixelValue, 1) || K("em", w.emValue, 1);
	}
	function lu() {
		var x = K("shape", /^(circle)/i, 0);
		return x && (x.style = cu() || du()), x;
	}
	function uu() {
		var x = K("shape", /^(ellipse)/i, 0);
		return x && (x.style = yu() || du()), x;
	}
	function du() {
		return K("extent-keyword", w.extentKeywords, 1);
	}
	function fu() {
		if (K("position", /^at/, 0)) {
			var x = pu();
			return x || V("Missing positioning value"), x;
		}
	}
	function pu() {
		var x = mu();
		if (x.x || x.y) return {
			type: "position",
			value: x
		};
	}
	function mu() {
		return {
			x: yu(),
			y: yu()
		};
	}
	function hu() {
		return W(w.number)[1];
	}
	var gu = function(x) {
		var w = isUpperCase(x?.[0]), V = G(hu), U = (0, import_tinycolor$7.default)({
			h: V[0],
			s: V[1],
			l: V[2],
			a: V[3] || 1
		}).toRgb(), W = U.r, K = U.g, J = U.b, Y = U.a;
		return { value: `${w ? "RGBA" : "rgba"}(${W}, ${K}, ${J}, ${Y})` };
	}, _u = function(x) {
		var w = isUpperCase(x?.[0]), V = G(hu), U = (0, import_tinycolor$7.default)({
			h: V[0],
			s: V[1],
			v: V[2],
			a: V[3] || 1
		}).toRgb(), W = U.r, K = U.g, J = U.b, Y = U.a;
		return { value: `${w ? "RGBA" : "rgba"}(${W}, ${K}, ${J}, ${Y})` };
	}, vu = function(x) {
		var V = isUpperCase(x?.[0]), U = W(w.spacedRgbColor) || __spreadArray$2([null], G(hu), !0), K = U[1], J = U[2], Y = U[3], Z = U[4];
		return { value: `${V ? "RGBA" : "rgba"}(${K}, ${J}, ${Y}, ${Z === void 0 ? 1 : Z})` };
	};
	function yu() {
		return K("%", w.percentageValue, 1) || bu() || cu();
	}
	function bu() {
		return K("position-keyword", w.positionKeywords, 1);
	}
	return ru();
}, low = function(x) {
	return x.value.toLowerCase();
}, high = function(x) {
	return x.value.toUpperCase();
}, getColors = function(x, w, V) {
	if (x?.includes("gradient")) {
		var U = x?.includes("conic"), W = U ? V : x;
		return U && console.log("Sorry we cant handle conic gradients yet"), gradientParser(W)?.colorStops;
	} else {
		var W = x || w;
		return [{ value: W }];
	}
}, formatInputValues = function(x, w, V) {
	return isNaN(x) || x < w ? w : x > V ? V : x;
}, round = function(x) {
	return Math.round(x);
}, __assign$15 = function() {
	return __assign$15 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$15.apply(this, arguments);
}, safeBounds = function(x) {
	var w = x.target.parentNode.getBoundingClientRect(), V = x.target.className === "c-resize ps-rl" ? 15 : 0;
	return {
		offsetLeft: w?.x + V,
		offsetTop: w?.y,
		clientWidth: w?.width,
		clientHeight: w?.height
	};
};
function getHandleValue(x, w) {
	var V = safeBounds(x), U = V.offsetLeft, W = V.clientWidth, G = x.clientX - U - w / 2, K = W - 18, J = formatInputValues(G, 0, K);
	return Math.round(J / (K / 100));
}
function computeSquareXY(x, w, V, U, W) {
	return [x * V - W / 2, (100 - w) / 100 * U - W / 2];
}
var getClientXY = function(x) {
	if (x.clientX) return {
		clientX: x.clientX,
		clientY: x.clientY
	};
	var w = x.touches[0] || {};
	return {
		clientX: w.clientX,
		clientY: w.clientY
	};
};
function computePickerPosition(x, w) {
	var V = safeBounds(x), U = V.offsetLeft, W = V.offsetTop, G = V.clientWidth, K = V.clientHeight, J = getClientXY(x), Y = J.clientX, Z = J.clientY;
	return [function() {
		return formatInputValues(Y - U - w / 2, -9, G - 10);
	}(), function() {
		return formatInputValues(Z - W - w / 2, -9, K - 10);
	}()];
}
var isUpperCase = function(x) {
	return x?.[0] === (x?.[0])?.toUpperCase();
}, convertShortHandDeg = function(x) {
	if (x === "to top") return 0;
	if (x === "to bottom") return 180;
	if (x === "to left") return 270;
	if (x === "to right") return 90;
	if (x === "to top right") return 45;
	if (x === "to bottom right") return 135;
	if (x === "to bottom left") return 225;
	if (x === "to top left") return 315;
	var w = x || 0;
	return parseInt(w);
}, objectToString = function(x) {
	if (typeof x == "string") return x;
	if ((x?.type)?.includes("gradient")) {
		var w = (((x?.colorStops)?.sort(function(x, w) {
			return x?.left - w?.left;
		}))?.map(function(x) {
			return `${x?.value} ${x?.left}%`;
		}))?.join(", "), V = x?.type, U = convertShortHandDeg(x?.orientation?.value);
		return `${V}(${V === "linear-gradient" ? `${U}deg` : "circle"}, ${w})`;
	} else return x?.colorStops[0]?.value || "rgba(175, 51, 242, 1)";
}, getColorObj = function(x, w) {
	var V = x?.map(function(x, w) {
		return __assign$15(__assign$15({}, x), { index: w });
	}), U = V?.find(function(x) {
		return isUpperCase(x.value);
	}) || V[0];
	return {
		currentColor: U?.value || w,
		selectedColor: U?.index || 0,
		currentLeft: U?.left || 0
	};
}, getDegrees = function(x) {
	var w = x?.split(",")[0];
	return convertShortHandDeg((w?.split("(")[1])?.replace("deg", ""));
}, getDetails = function(x) {
	var w = x?.includes("gradient"), V = x?.split("(")[0], U = getDegrees(x);
	return {
		degrees: U,
		degreeStr: V === "linear-gradient" ? `${U}deg` : "circle",
		isGradient: w,
		gradientType: V
	};
}, import_tinycolor$6 = /* @__PURE__ */ __toESM(require_tinycolor(), 1), __assign$14 = function() {
	return __assign$14 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$14.apply(this, arguments);
}, __spreadArray$1 = function(x, w, V) {
	if (V || arguments.length === 2) for (var U = 0, W = w.length, G; U < W; U++) (G || !(U in w)) && (G ||= Array.prototype.slice.call(w, 0, U), G[U] = w[U]);
	return x.concat(G || Array.prototype.slice.call(w));
}, PickerContext = createContext(null);
function PickerContextWrapper(x) {
	var w = x.value, V = x.children, U = x.onChange, W = x.isDarkMode, G = x.squareWidth, K = x.hideOpacity, J = x.showHexAlpha, Y = x.squareHeight, Z = x.passedConfig, $ = x.defaultStyles, ql = x.pickerIdSuffix, Jl = {
		barSize: Z.barSize ?? defaultConfig.barSize,
		crossSize: Z.crossSize ?? defaultConfig.crossSize,
		defaultColor: Z.defaultColor ?? defaultConfig.defaultColor,
		defaultGradient: Z.defaultGradient ?? defaultConfig.defaultGradient
	}, Yl = getColors(w, Jl.defaultColor, Jl.defaultGradient), Xl = getDetails(w), Zl = Xl.degrees, $l = Xl.degreeStr, eu = Xl.isGradient, tu = Xl.gradientType, nu = getColorObj(Yl, Jl.defaultGradient), ru = nu.currentColor, iu = nu.selectedColor, au = nu.currentLeft, ou = useState("rgb"), su = ou[0], cu = ou[1], lu = useState({}), du = lu[0], fu = lu[1], pu = (0, import_tinycolor$6.default)(ru), mu = pu.toRgb(), hu = pu.toHsv(), _u = useState(__assign$14(__assign$14({}, mu), hu)), vu = _u[0], yu = _u[1];
	useEffect(function() {
		hu?.s === 0 ? yu(__assign$14(__assign$14(__assign$14({}, mu), hu), { h: vu?.h })) : yu(__assign$14(__assign$14({}, mu), hu));
	}, [ru]);
	var bu = function(x) {
		var w = `${tu}(${$l}, ${(x.sort(function(x, w) {
			return x.left - w.left;
		})?.map(function(x) {
			return `${x?.value} ${x.left}%`;
		})).join(", ")})`;
		fu(__assign$14(__assign$14({}, du), { gradient: w })), U(w);
	}, xu = function(x, w) {
		var V = Yl?.filter(function(x) {
			return !isUpperCase(x.value);
		});
		bu(__spreadArray$1([{
			value: x.toUpperCase(),
			left: w ?? au
		}], V, !0));
	}, Su = {
		hc: vu,
		setHc: yu,
		value: w,
		colors: Yl,
		config: Jl,
		degrees: Zl,
		onChange: U,
		previous: du,
		inputType: su,
		tinyColor: pu,
		isDarkMode: W,
		isGradient: eu,
		squareWidth: G,
		hideOpacity: K,
		currentLeft: au,
		deletePoint: function() {
			if (Yl?.length > 2) {
				var x = Yl?.map(function(x, w) {
					return __assign$14(__assign$14({}, x), { value: w === iu - 1 ? high(x) : low(x) });
				});
				bu(x?.filter(function(x, w) {
					return w !== iu;
				}));
			}
		},
		showHexAlpha: J,
		squareHeight: Y,
		setInputType: cu,
		gradientType: tu,
		handleChange: function(x) {
			eu ? xu(x) : (fu(__assign$14(__assign$14({}, du), { color: x })), U(x));
		},
		currentColor: ru,
		selectedColor: iu,
		defaultStyles: $,
		handleGradient: xu,
		pickerIdSuffix: ql,
		createGradientStr: bu
	};
	return React.createElement(PickerContext.Provider, { value: Su }, V);
}
function usePicker() {
	var x = useContext(PickerContext);
	if (!x) throw Error("usePicker has to be used within <PickerContext.Provider>");
	return x;
}
var defaultConfig = {
	barSize: 18,
	crossSize: 18,
	inputSize: 40,
	delay: 150,
	defaultColor: "rgba(175, 51, 242, 1)",
	defaultGradient: "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)"
}, import_tinycolor$5 = /* @__PURE__ */ __toESM(require_tinycolor(), 1), usePaintHue_default = function(x, w) {
	useEffect(function() {
		var V = (x?.current)?.getContext("2d", { willReadFrequently: !0 });
		if (V) {
			V.rect(0, 0, w, 14);
			for (var U = V.createLinearGradient(0, 0, w, 0), W = 0; W <= 360; W += 30) U.addColorStop(W / 360, `hsl(${W}, 100%, 50%)`);
			V.fillStyle = U, V.fill();
		}
	}, [x, w]);
}, usePaintSat = function(x, w, V, U) {
	useEffect(function() {
		var W = (x?.current)?.getContext("2d", { willReadFrequently: !0 });
		if (W) {
			W.rect(0, 0, U, 14);
			for (var G = W.createLinearGradient(0, 0, U, 0), K = 0; K <= 100; K += 10) G.addColorStop(K / 100, `hsl(${w}, ${K}%, ${V}%)`);
			W.fillStyle = G, W.fill();
		}
	}, [
		x,
		w,
		V,
		U
	]);
}, usePaintLight = function(x, w, V, U) {
	useEffect(function() {
		var W = (x?.current)?.getContext("2d", { willReadFrequently: !0 });
		if (W) {
			W.rect(0, 0, U, 14);
			for (var G = W.createLinearGradient(0, 0, U, 0), K = 0; K <= 100; K += 10) G.addColorStop(K / 100, `hsl(${w}, ${V}%, ${K}%)`);
			W.fillStyle = G, W.fill();
		}
	}, [
		x,
		w,
		V,
		U
	]);
}, usePaintBright = function(x, w, V, U) {
	useEffect(function() {
		var W = (x?.current)?.getContext("2d", { willReadFrequently: !0 });
		if (W) {
			W.rect(0, 0, U, 14);
			for (var G = W.createLinearGradient(0, 0, U, 0), K = 0; K <= 100; K += 10) {
				var J = (0, import_tinycolor$5.default)({
					h: w,
					s: V,
					v: K
				});
				G.addColorStop(K / 100, J.toHslString());
			}
			W.fillStyle = G, W.fill();
		}
	}, [
		x,
		w,
		V,
		U
	]);
}, import_tinycolor$4 = /* @__PURE__ */ __toESM(require_tinycolor(), 1), __assign$13 = function() {
	return __assign$13 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$13.apply(this, arguments);
}, Hue_default = function() {
	var x = useRef(null), w = usePicker(), V = w.config, U = w.handleChange, W = w.squareWidth, G = w.hc, K = w.setHc, J = w.pickerIdSuffix, Y = useState(!1), Z = Y[0], $ = Y[1], ql = V.barSize;
	usePaintHue_default(x, W);
	var Jl = function() {
		$(!1);
	}, Yl = function() {
		$(!0);
	}, Xl = function(x) {
		var w = getHandleValue(x, ql) * 3.6, V = (0, import_tinycolor$4.default)({
			h: w,
			s: G?.s,
			v: G?.v
		}).toRgb(), W = V.r, J = V.g, Y = V.b;
		U(`rgba(${W}, ${J}, ${Y}, ${G.a})`), K(__assign$13(__assign$13({}, G), { h: w }));
	}, Zl = function(x) {
		Z && Xl(x);
	}, $l = function(x) {
		Z || Xl(x);
	};
	return useEffect(function() {
		var x = function() {
			Jl();
		};
		return window.addEventListener("mouseup", x), function() {
			window.removeEventListener("mouseup", x);
		};
	}, []), React.createElement("div", {
		style: {
			height: 14,
			marginTop: 17,
			marginBottom: 4,
			cursor: "ew-resize",
			position: "relative"
		},
		onMouseMove: function(x) {
			return Zl(x);
		},
		id: `rbgcp-hue-wrap${J}`
	}, React.createElement("div", {
		tabIndex: 0,
		role: "button",
		style: {
			border: "2px solid white",
			borderRadius: "50%",
			boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.5)",
			width: "18px",
			height: "18px",
			zIndex: 1e3,
			transition: "all 10ms linear",
			position: "absolute",
			left: G?.h * ((W - 18) / 360),
			top: -2,
			cursor: "ew-resize",
			boxSizing: "border-box"
		},
		onMouseDown: Yl,
		id: `rbgcp-hue-handle${J}`
	}), React.createElement("canvas", {
		ref: x,
		height: "14px",
		width: `${W}px`,
		onClick: function(x) {
			return $l(x);
		},
		id: `rbgcp-hue-bar${J}`,
		style: {
			borderRadius: 14,
			position: "relative",
			verticalAlign: "top"
		}
	}));
};
function rgb2cmyk(x, w, V) {
	var U = 0, W = 0, G = 0, K = 0;
	if (x === null || w === null || V === null || isNaN(x) || isNaN(w) || isNaN(V)) return console.log("Please enter numeric RGB values!"), {
		c: 0,
		m: 0,
		k: 0,
		y: 1
	};
	if (x < 0 || w < 0 || V < 0 || x > 255 || w > 255 || V > 255) return console.log("RGB values must be in the range 0 to 255."), {
		c: 0,
		m: 0,
		k: 0,
		y: 1
	};
	if (x === 0 && w === 0 && V === 0) return K = 1, {
		c: 0,
		m: 0,
		k: 0,
		y: 1
	};
	U = 1 - x / 255, W = 1 - w / 255, G = 1 - V / 255;
	var J = Math.min(U, Math.min(W, G));
	return U = (U - J) / (1 - J), W = (W - J) / (1 - J), G = (G - J) / (1 - J), K = J, {
		c: U,
		m: W,
		y: G,
		k: K
	};
}
var cmykToRgb = function(x) {
	var w = x.c, V = x.m, U = x.y, W = x.k;
	return {
		r: 255 * (1 - w) * (1 - W),
		g: 255 * (1 - V) * (1 - W),
		b: 255 * (1 - U) * (1 - W)
	};
}, getHexAlpha = function(x) {
	return typeof x == "number" ? x < 0 ? "00" : x > 1 ? "FF" : Math.round(x * 255).toString(16).padStart(2, "0").toUpperCase() : "FF";
}, import_tinycolor$3 = /* @__PURE__ */ __toESM(require_tinycolor(), 1), __assign$12 = function() {
	return __assign$12 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$12.apply(this, arguments);
}, Input$1 = function(x) {
	var w = x.label, V = x.value, U = x.callback, W = x.max, G = W === void 0 ? 100 : W, K = x.hideOpacity, J = x.defaultStyles, Y = x.pickerIdSuffix, Z = useState(V), $ = Z[0], ql = Z[1], Jl = K ? "25%" : "20%";
	useEffect(function() {
		ql(V);
	}, [V]);
	var Yl = function(x) {
		var w = formatInputValues(parseFloat(x.target.value), 0, G);
		ql(w), U(w);
	};
	return React.createElement("div", {
		style: {
			width: Jl,
			flexShrink: 1
		},
		id: `rbgcp-${w}-input-wrapper${Y}`
	}, React.createElement("input", {
		value: $,
		onChange: function(x) {
			return Yl(x);
		},
		style: __assign$12({}, J.rbgcpInput),
		id: `rbgcp-${w}-input${Y}`
	}), React.createElement("div", { style: __assign$12({}, J.rbgcpInputLabel) }, w));
}, HexInput = function(x) {
	var w = x.opacity, V = x.tinyColor, U = x.showHexAlpha, W = x.handleChange, G = x.defaultStyles, K = x.pickerIdSuffix, J = useState(""), Y = J[0], Z = J[1], $ = V.toHex(), ql = useState($), Jl = ql[0], Yl = ql[1];
	useEffect(function() {
		Y !== "hex" && Yl($);
	}, [
		V,
		Y,
		$
	]);
	var Xl = function() {
		Z("hex");
	}, Zl = function() {
		Z("");
	}, $l = function(x) {
		var V = (0, import_tinycolor$3.default)(x.target.value);
		if (Yl(x.target.value), V.isValid()) {
			var U = V.toRgb(), G = U.r, K = U.g, J = U.b;
			W(`rgba(${G}, ${K}, ${J}, ${w})`);
		}
	}, eu = U ? `${Jl}${getHexAlpha(w)}` : Jl, tu = U ? "HEXA" : "HEX", nu = U ? 88 : 76;
	return React.createElement("div", {
		style: {
			width: nu,
			flexShrink: 0
		},
		id: `rbgcp-hex-input-wrapper${K}`
	}, React.createElement("input", {
		onBlur: Zl,
		onFocus: Xl,
		onChange: function(x) {
			return $l(x);
		},
		value: eu?.toUpperCase(),
		id: `rbgcp-hex-input${K}`,
		style: __assign$12(__assign$12({}, G.rbgcpInput), G.rbgcpHexInput)
	}), React.createElement("div", { style: __assign$12({}, G.rbgcpInputLabel) }, tu));
}, RGBInputs = function(x) {
	var w = x.hc, V = x.hideOpacity, U = x.handleChange, W = x.defaultStyles, G = x.pickerIdSuffix, K = function(x) {
		var V = x.r, W = x.g, G = x.b;
		U(`rgba(${V}, ${W}, ${G}, ${w?.a})`);
	};
	return React.createElement(React.Fragment, null, React.createElement(Input$1, {
		label: "R",
		max: 255,
		value: w?.r,
		hideOpacity: V,
		defaultStyles: W,
		pickerIdSuffix: G,
		callback: function(x) {
			return K({
				r: x,
				g: w?.g,
				b: w?.b
			});
		}
	}), React.createElement(Input$1, {
		label: "G",
		max: 255,
		value: w?.g,
		hideOpacity: V,
		defaultStyles: W,
		pickerIdSuffix: G,
		callback: function(x) {
			return K({
				r: w?.r,
				g: x,
				b: w?.b
			});
		}
	}), React.createElement(Input$1, {
		label: "B",
		max: 255,
		value: w?.b,
		hideOpacity: V,
		defaultStyles: W,
		pickerIdSuffix: G,
		callback: function(x) {
			return K({
				r: w?.r,
				g: w?.g,
				b: x
			});
		}
	}));
}, HSLInputs = function(x) {
	var w = x.hc, V = x.setHc, U = x.tinyColor, W = x.hideOpacity, G = x.handleChange, K = x.defaultStyles, J = x.pickerIdSuffix, Y = U.toHsl(), Z = Y.s, $ = Y.l, ql = function(x, U, W) {
		var K = (0, import_tinycolor$3.default)({
			h: x,
			s: U,
			l: W
		}).toRgb(), J = K.r, Y = K.g, Z = K.b;
		G(`rgba(${J}, ${Y}, ${Z}, ${w?.a})`), V(__assign$12(__assign$12({}, w), { h: x }));
	}, Jl = function(x) {
		var V = (0, import_tinycolor$3.default)(x).toRgb(), U = V.r, W = V.g, K = V.b;
		G(`rgba(${U}, ${W}, ${K}, ${w?.a})`);
	};
	return React.createElement(React.Fragment, null, React.createElement(Input$1, {
		label: "H",
		max: 360,
		value: round(w?.h),
		hideOpacity: W,
		defaultStyles: K,
		pickerIdSuffix: J,
		callback: function(x) {
			return ql(x, Z, $);
		}
	}), React.createElement(Input$1, {
		label: "S",
		value: round(Z * 100),
		hideOpacity: W,
		defaultStyles: K,
		pickerIdSuffix: J,
		callback: function(x) {
			return Jl({
				h: w?.h,
				s: x,
				l: $
			});
		}
	}), React.createElement(Input$1, {
		label: "L",
		value: round($ * 100),
		hideOpacity: W,
		defaultStyles: K,
		pickerIdSuffix: J,
		callback: function(x) {
			return Jl({
				h: w?.h,
				s: Z,
				l: x
			});
		}
	}));
}, HSVInputs = function(x) {
	var w = x.hc, V = x.setHc, U = x.hideOpacity, W = x.handleChange, G = x.defaultStyles, K = x.pickerIdSuffix, J = function(x, U, G) {
		var K = (0, import_tinycolor$3.default)({
			h: x,
			s: U,
			v: G
		}).toRgb(), J = K.r, Y = K.g, Z = K.b;
		W(`rgba(${J}, ${Y}, ${Z}, ${w?.a})`), V(__assign$12(__assign$12({}, w), { h: x }));
	}, Y = function(x) {
		var V = (0, import_tinycolor$3.default)(x).toRgb(), U = V.r, G = V.g, K = V.b;
		W(`rgba(${U}, ${G}, ${K}, ${w?.a})`);
	};
	return React.createElement(React.Fragment, null, React.createElement(Input$1, {
		label: "H",
		max: 360,
		value: round(w?.h),
		hideOpacity: U,
		defaultStyles: G,
		pickerIdSuffix: K,
		callback: function(x) {
			return J(x, w?.s, w?.v);
		}
	}), React.createElement(Input$1, {
		label: "S",
		hideOpacity: U,
		value: round(w?.s * 100),
		defaultStyles: G,
		pickerIdSuffix: K,
		callback: function(x) {
			return Y({
				h: w?.h,
				s: x,
				v: w?.v
			});
		}
	}), React.createElement(Input$1, {
		label: "V",
		hideOpacity: U,
		value: round(w?.v * 100),
		defaultStyles: G,
		pickerIdSuffix: K,
		callback: function(x) {
			return Y({
				h: w?.h,
				s: w?.s,
				v: x
			});
		}
	}));
}, CMKYInputs = function(x) {
	var w = x.hc, V = x.hideOpacity, U = x.handleChange, W = x.defaultStyles, G = x.pickerIdSuffix, K = rgb2cmyk(w?.r, w?.g, w?.b), J = K.c, Y = K.m, Z = K.y, $ = K.k, ql = function(x) {
		var V = cmykToRgb(x), W = V.r, G = V.g, K = V.b;
		U(`rgba(${W}, ${G}, ${K}, ${w?.a})`);
	};
	return React.createElement(React.Fragment, null, React.createElement(Input$1, {
		label: "C",
		value: round(J * 100),
		hideOpacity: V,
		defaultStyles: W,
		pickerIdSuffix: G,
		callback: function(x) {
			return ql({
				c: x / 100,
				m: Y,
				y: Z,
				k: $
			});
		}
	}), React.createElement(Input$1, {
		label: "M",
		value: round(Y * 100),
		hideOpacity: V,
		defaultStyles: W,
		pickerIdSuffix: G,
		callback: function(x) {
			return ql({
				c: J,
				m: x / 100,
				y: Z,
				k: $
			});
		}
	}), React.createElement(Input$1, {
		label: "Y",
		value: round(Z * 100),
		hideOpacity: V,
		defaultStyles: W,
		pickerIdSuffix: G,
		callback: function(x) {
			return ql({
				c: J,
				m: Y,
				y: x / 100,
				k: $
			});
		}
	}), React.createElement(Input$1, {
		label: "K",
		value: round($ * 100),
		hideOpacity: V,
		defaultStyles: W,
		pickerIdSuffix: G,
		callback: function(x) {
			return ql({
				c: J,
				m: Y,
				y: Z,
				k: x / 100
			});
		}
	}));
}, Inputs_default = function() {
	var x = usePicker(), w = x.hc, V = x.setHc, U = x.inputType, W = x.tinyColor, G = x.hideOpacity, K = x.showHexAlpha, J = x.handleChange, Y = x.defaultStyles, Z = x.pickerIdSuffix;
	return React.createElement("div", {
		style: __assign$12({
			columnGap: 6,
			paddingTop: 14,
			display: "flex",
			justifyContent: "space-between"
		}, Y.rbgcpInputsWrap),
		id: `rbgcp-inputs-wrap${Z}`
	}, U !== "cmyk" && React.createElement(HexInput, {
		opacity: w?.a,
		tinyColor: W,
		showHexAlpha: K,
		handleChange: J,
		defaultStyles: Y,
		pickerIdSuffix: Z
	}), U === "hsl" && React.createElement(HSLInputs, {
		hc: w,
		setHc: V,
		tinyColor: W,
		hideOpacity: G,
		handleChange: J,
		defaultStyles: Y,
		pickerIdSuffix: Z
	}), U === "rgb" && React.createElement(RGBInputs, {
		hc: w,
		hideOpacity: G,
		handleChange: J,
		defaultStyles: Y,
		pickerIdSuffix: Z
	}), U === "hsv" && React.createElement(HSVInputs, {
		hc: w,
		setHc: V,
		hideOpacity: G,
		handleChange: J,
		defaultStyles: Y,
		pickerIdSuffix: Z
	}), U === "cmyk" && React.createElement(CMKYInputs, {
		hc: w,
		hideOpacity: G,
		handleChange: J,
		defaultStyles: Y,
		pickerIdSuffix: Z
	}), !G && React.createElement(Input$1, {
		label: "A",
		hideOpacity: G,
		defaultStyles: Y,
		value: Math.round(w?.a * 100),
		pickerIdSuffix: Z,
		callback: function(x) {
			return J(`rgba(${w?.r}, ${w?.g}, ${w?.b}, ${x / 100})`);
		}
	}));
}, usePaintSquare_default = function(x, w, V, U) {
	useEffect(function() {
		if (x.current) {
			var W = x.current.getContext("2d", { willReadFrequently: !0 });
			if (W) {
				W.fillStyle = `hsl(${w}, 100%, 50%)`, W.fillRect(0, 0, V, U);
				var G = W.createLinearGradient(0, 0, V, 0);
				G.addColorStop(0, "rgba(255, 255, 255, 1)"), G.addColorStop(1, "rgba(255, 255, 255, 0)"), W.fillStyle = G, W.fillRect(0, 0, V, U);
				var K = W.createLinearGradient(0, 0, 0, U);
				K.addColorStop(0, "rgba(0, 0, 0, 0)"), K.addColorStop(1, "rgba(0, 0, 0, 1)"), W.fillStyle = K, W.fillRect(0, 0, V, U);
			}
		}
	}, [
		x,
		w,
		V,
		U
	]);
}, import_lodash = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((x, w) => {
	var V = "Expected a function", U = NaN, W = "[object Symbol]", G = /^\s+|\s+$/g, K = /^[-+]0x[0-9a-f]+$/i, J = /^0b[01]+$/i, Y = /^0o[0-7]+$/i, Z = parseInt, $ = typeof global == "object" && global && global.Object === Object && global, ql = typeof self == "object" && self && self.Object === Object && self, Jl = $ || ql || Function("return this")(), Yl = Object.prototype.toString, Xl = Math.max, Zl = Math.min, Ql = function() {
		return Jl.Date.now();
	};
	function $l(x, w, U) {
		var W, G, K, J, Y, Z, $ = 0, ql = !1, Jl = !1, Yl = !0;
		if (typeof x != "function") throw TypeError(V);
		w = iu(w) || 0, tu(U) && (ql = !!U.leading, Jl = "maxWait" in U, K = Jl ? Xl(iu(U.maxWait) || 0, w) : K, Yl = "trailing" in U ? !!U.trailing : Yl);
		function $l(w) {
			var V = W, U = G;
			return W = G = void 0, $ = w, J = x.apply(U, V), J;
		}
		function eu(x) {
			return $ = x, Y = setTimeout(au, w), ql ? $l(x) : J;
		}
		function nu(x) {
			var V = x - Z, U = x - $, W = w - V;
			return Jl ? Zl(W, K - U) : W;
		}
		function ru(x) {
			var V = x - Z, U = x - $;
			return Z === void 0 || V >= w || V < 0 || Jl && U >= K;
		}
		function au() {
			var x = Ql();
			if (ru(x)) return ou(x);
			Y = setTimeout(au, nu(x));
		}
		function ou(x) {
			return Y = void 0, Yl && W ? $l(x) : (W = G = void 0, J);
		}
		function su() {
			Y !== void 0 && clearTimeout(Y), $ = 0, W = Z = G = Y = void 0;
		}
		function cu() {
			return Y === void 0 ? J : ou(Ql());
		}
		function lu() {
			var x = Ql(), V = ru(x);
			if (W = arguments, G = this, Z = x, V) {
				if (Y === void 0) return eu(Z);
				if (Jl) return Y = setTimeout(au, w), $l(Z);
			}
			return Y === void 0 && (Y = setTimeout(au, w)), J;
		}
		return lu.cancel = su, lu.flush = cu, lu;
	}
	function eu(x, w, U) {
		var W = !0, G = !0;
		if (typeof x != "function") throw TypeError(V);
		return tu(U) && (W = "leading" in U ? !!U.leading : W, G = "trailing" in U ? !!U.trailing : G), $l(x, w, {
			leading: W,
			maxWait: w,
			trailing: G
		});
	}
	function tu(x) {
		var w = typeof x;
		return !!x && (w == "object" || w == "function");
	}
	function nu(x) {
		return !!x && typeof x == "object";
	}
	function ru(x) {
		return typeof x == "symbol" || nu(x) && Yl.call(x) == W;
	}
	function iu(x) {
		if (typeof x == "number") return x;
		if (ru(x)) return U;
		if (tu(x)) {
			var w = typeof x.valueOf == "function" ? x.valueOf() : x;
			x = tu(w) ? w + "" : w;
		}
		if (typeof x != "string") return x === 0 ? x : +x;
		x = x.replace(G, "");
		var V = J.test(x);
		return V || Y.test(x) ? Z(x.slice(2), V ? 2 : 8) : K.test(x) ? U : +x;
	}
	w.exports = eu;
})))(), 1), import_tinycolor$2 = /* @__PURE__ */ __toESM(require_tinycolor(), 1), __assign$11 = function() {
	return __assign$11 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$11.apply(this, arguments);
}, Square_default = function() {
	var x = usePicker(), w = x.hc, V = x.config, U = x.squareWidth, W = x.squareHeight, G = x.handleChange, K = x.defaultStyles, J = x.pickerIdSuffix, Y = V.crossSize, Z = useState(!1), $ = Z[0], ql = Z[1], Jl = useRef(null), Yl = computeSquareXY(w?.s, w?.v * 100, U, W, Y), Xl = Yl[0], Zl = Yl[1], $l = useState({
		x: Xl,
		y: Zl
	}), eu = $l[0], tu = $l[1];
	usePaintSquare_default(Jl, w?.h, U, W), useEffect(function() {
		$ || tu({
			x: w?.v === 0 ? eu.x : Xl,
			y: Zl
		});
	}, [Xl, Zl]);
	var nu = function(x) {
		(0, import_lodash.default)(function() {
			var V = computePickerPosition(x, Y), K = V[0], J = V[1];
			if (K && J) {
				var Z = Math.min(K + Y / 2, U - 1), $ = Math.min(J + Y / 2, W - 1), ql = Z / U * 100, Jl = 100 - $ / W * 100;
				tu({
					x: Jl === 0 ? eu?.x : K,
					y: J
				}), G((0, import_tinycolor$2.default)(`hsva(${w?.h}, ${ql}%, ${Jl}%, ${w?.a})`).toRgbString());
			}
		}, 250)();
	}, ru = function() {
		ql(!1);
	}, iu = function(x) {
		$ && nu(x);
	}, au = function(x) {
		$ || nu(x);
	}, ou = function() {
		ql(!0);
	}, su = function(x) {
		ql(!0), nu(x);
	};
	return useEffect(function() {
		var x = function() {
			ru();
		};
		return window.addEventListener("mouseup", x), function() {
			window.removeEventListener("mouseup", x);
		};
	}, []), React.createElement("div", {
		style: {
			position: "relative",
			marginBottom: 12
		},
		id: `rbgcp-square-wrapper${J}`
	}, React.createElement("div", {
		onMouseUp: ru,
		onTouchEnd: ru,
		onMouseDown: su,
		onTouchStart: su,
		onMouseMove: function(x) {
			return iu(x);
		},
		id: `rbgcp-square${J}`,
		style: {
			position: "relative",
			cursor: "ew-cross"
		}
	}, React.createElement("div", {
		style: __assign$11(__assign$11(__assign$11({}, K.rbgcpHandle), { transform: `translate(${eu?.x ?? 0}px, ${eu?.y ?? 0}px)` }), $ ? { transition: "" } : {}),
		onMouseDown: ou,
		id: `rbgcp-square-handle${J}`
	}), React.createElement("div", {
		style: __assign$11(__assign$11({}, K.rbgcpCanvasWrapper), { height: W }),
		id: `rbgcp-square-canvas-wrapper${J}`,
		onClick: function(x) {
			return au(x);
		}
	}, React.createElement("canvas", {
		ref: Jl,
		width: `${U}px`,
		height: `${W}px`,
		id: `rbgcp-square-canvas${J}`
	}))));
}, __assign$10 = function() {
	return __assign$10 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$10.apply(this, arguments);
}, Opacity_default = function() {
	var x = usePicker(), w = x.config, V = x.hc, U = V === void 0 ? {} : V, W = x.squareWidth, G = x.handleChange, K = x.defaultStyles, J = x.pickerIdSuffix, Y = useState(!1), Z = Y[0], $ = Y[1], ql = U.r, Jl = U.g, Yl = U.b, Xl = `linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(${ql},${Jl},${Yl},.5) 100%)`, Zl = w.barSize, $l = function() {
		$(!1);
	}, eu = function() {
		$(!0);
	}, tu = function(x) {
		G(`rgba(${ql}, ${Jl}, ${Yl}, ${getHandleValue(x, Zl) / 100})`);
	}, nu = function(x) {
		Z && tu(x);
	}, ru = function(x) {
		Z || tu(x);
	}, iu = W - 18;
	return useEffect(function() {
		var x = function() {
			$l();
		};
		return window.addEventListener("mouseup", x), function() {
			window.removeEventListener("mouseup", x);
		};
	}, []), React.createElement("div", {
		onMouseDown: eu,
		onMouseMove: function(x) {
			return nu(x);
		},
		style: {
			height: 14,
			marginTop: 17,
			marginBottom: 4,
			cursor: "ew-resize",
			position: "relative"
		},
		id: `rbgcp-opacity-wrapper${J}`
	}, React.createElement("div", {
		id: `rbgcp-opacity-checkered-bg${J}`,
		style: __assign$10(__assign$10({}, K.rbgcpCheckered), {
			width: "100%",
			height: 14
		})
	}), React.createElement("div", {
		id: `rbgcp-opacity-handle${J}`,
		style: __assign$10(__assign$10({}, K.rbgcpHandle), {
			left: iu * U?.a,
			top: -2
		})
	}), React.createElement("div", {
		style: __assign$10(__assign$10({}, K.rbgcpOpacityOverlay), { background: Xl }),
		id: `rbgcp-opacity-overlay${J}`,
		onClick: function(x) {
			return ru(x);
		}
	}));
}, defaultLocales = { CONTROLS: {
	SOLID: "Solid",
	GRADIENT: "Gradient"
} }, fakePresets = [
	"rgba(0,0,0,1)",
	"rgba(128,128,128, 1)",
	"rgba(192,192,192, 1)",
	"rgba(255,255,255, 1)",
	"rgba(0,0,128,1)",
	"rgba(0,0,255,1)",
	"rgba(0,255,255, 1)",
	"rgba(0,128,0,1)",
	"rgba(128,128,0, 1)",
	"rgba(0,128,128,1)",
	"rgba(0,255,0, 1)",
	"rgba(128,0,0, 1)",
	"rgba(128,0,128, 1)",
	"rgba(175, 51, 242, 1)",
	"rgba(255,0,255, 1)",
	"rgba(255,0,0, 1)",
	"rgba(240, 103, 46, 1)",
	"rgba(255,255,0, 1)"
], Presets_default = function(x) {
	var w = x.presets, V = w === void 0 ? [] : w, U = usePicker(), W = U.value, G = U.onChange, K = U.isDarkMode, J = U.squareWidth, Y = U.handleChange, Z = U.pickerIdSuffix, $ = function() {
		return V?.length > 0 ? V?.slice(0, 18) : fakePresets;
	}, ql = function(x) {
		x?.includes("gradient") ? G(x) : Y(x);
	}, Jl = function(x) {
		return !x || K ? "" : x?.replace(" ", "") === "rgba(255,255,255,1)" ? "1px solid #96959c" : "";
	};
	return React.createElement("div", {
		style: {
			marginTop: 14,
			display: "flex",
			justifyContent: "space-between"
		},
		id: `rbgcp-footer-wrapper${Z}`
	}, React.createElement("div", {
		style: {
			width: 50,
			height: 50,
			flexShrink: 0,
			borderRadius: 6,
			background: W,
			border: Jl(W)
		},
		id: `rbgcp-preview${Z}`
	}), React.createElement("div", {
		style: {
			rowGap: 3,
			display: "flex",
			flexWrap: "wrap",
			width: J - 57,
			justifyContent: "space-between"
		},
		id: `rbgcp-presets-wrapper${Z}`
	}, $().map(function(x, w) {
		return React.createElement("div", {
			key: `${x}-${w}`,
			id: `rbgcp-preset-${w}-wrapper${Z}`,
			style: {
				width: "calc(100% / 9)",
				paddingLeft: 3
			}
		}, React.createElement("div", {
			style: {
				height: 23.5,
				width: "100%",
				background: x,
				borderRadius: 4,
				border: Jl(x)
			},
			onClick: function() {
				return ql(x);
			},
			id: `rbgcp-preset-${w}${Z}`
		}));
	})));
}, __assign$9 = function() {
	return __assign$9 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$9.apply(this, arguments);
}, icon_default = function() {
	var x = usePicker().defaultStyles;
	return React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		style: { width: 15 }
	}, React.createElement("polyline", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$9(__assign$9({}, {
			fill: "none",
			strokeWidth: "1.8px"
		}), x.rbgcpControlIcon),
		points: "17.96 4.31 2.04 4.3 3.75 4.3 4.81 17.29 5.16 17.96 5.74 18.47 6.59 18.62 13.64 18.62 14.52 18.32 15.07 17.68 15.29 17.12 16.28 4.3 12.87 4.3 12.87 2.38 12.48 1.75 11.83 1.46 8.4 1.46 7.64 1.68 7.26 2.21 7.16 2.52 7.17 4.23"
	}));
}, LinearIcon = function(x) {
	var w = x.color, V = usePicker().defaultStyles, U = w ?? "";
	return React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		style: { width: 14 }
	}, React.createElement("polyline", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$9(__assign$9(__assign$9({}, {
			fill: "none",
			strokeWidth: "1.8px"
		}), V.rbgcpControlIcon), U && { stroke: U }),
		points: "0.9 12.73 0.9 19.1 7.27 19.1 0.9 19.1 19.1 0.9 12.73 0.9 19.1 0.9 19.1 7.27"
	}));
}, RadialIcon = function(x) {
	var w = x.color, V = usePicker().defaultStyles, U = w ?? "", W = {
		fill: "none",
		strokeMiterlimit: 10,
		strokeWidth: "1.8px"
	};
	return React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		style: { width: 15 }
	}, React.createElement("circle", {
		style: __assign$9(__assign$9(__assign$9({}, W), V.rbgcpControlIcon), U && { stroke: U }),
		cx: "10",
		cy: "10",
		r: "9"
	}), React.createElement("circle", {
		style: __assign$9(__assign$9(__assign$9({}, W), V.rbgcpControlIcon), U && { stroke: U }),
		cx: "10",
		cy: "10",
		r: "5"
	}));
}, SlidersIcon = function(x) {
	var w = x.color, V = usePicker().defaultStyles, U = w ?? "", W = {
		fill: "none",
		strokeWidth: "1.8px"
	}, G = { strokeWidth: "1.8px" };
	return React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		style: { width: 17 }
	}, React.createElement("polyline", {
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$9(__assign$9(__assign$9({}, W), V.rbgcpControlIcon), U && { stroke: U }),
		points: "3.74 2.75 3.74 12.69 0.9 12.71 6.59 12.71"
	}), React.createElement("line", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$9(__assign$9(__assign$9({}, G), V.rbgcpControlIcon), U && {
			stroke: U,
			fill: U
		}),
		x1: "3.74",
		y1: "17.26",
		x2: "3.74",
		y2: "15.21"
	}), React.createElement("polyline", {
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$9(__assign$9(__assign$9({}, W), V.rbgcpControlIcon), U && { stroke: U }),
		points: "10.1 17.25 10.1 7.31 12.95 7.29 7.26 7.29"
	}), React.createElement("line", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$9(__assign$9(__assign$9({}, G), V.rbgcpControlIcon), U && {
			stroke: U,
			fill: U
		}),
		x1: "10.1",
		y1: "2.74",
		x2: "10.1",
		y2: "4.79"
	}), React.createElement("polyline", {
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$9(__assign$9(__assign$9({}, W), V.rbgcpControlIcon), U && { stroke: U }),
		points: "16.26 2.75 16.26 12.69 13.41 12.71 19.1 12.71"
	}), React.createElement("line", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$9(__assign$9(__assign$9({}, G), V.rbgcpControlIcon), U && {
			stroke: U,
			fill: U
		}),
		x1: "16.26",
		y1: "17.26",
		x2: "16.26",
		y2: "15.21"
	}));
}, InputsIcon = function(x) {
	var w = x.color, V = usePicker().defaultStyles, U = w ?? "", W = {
		fill: "none",
		strokeWidth: "1.8px"
	};
	return React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		style: { width: 17 }
	}, React.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$9(__assign$9(__assign$9({}, W), V.rbgcpControlIcon), U && { stroke: U }),
		d: "M6.35,2.72a4.85,4.85,0,0,1,1.86.16,7.94,7.94,0,0,1,.88.43,3.66,3.66,0,0,0,.85.49c.25,0,.58-.27.81-.39A8.25,8.25,0,0,1,11.7,3a4,4,0,0,1,1.79-.23,3.21,3.21,0,0,0-1.34.09,6.39,6.39,0,0,0-1.47.63c-.45.25-.7.3-.7.86s0,1.18,0,1.78c0,1.3,0,2.61,0,3.92h0v5.63a2.46,2.46,0,0,1,0,.47c-.07.28-.43.42-.7.57a5.29,5.29,0,0,1-2.94.61A9.3,9.3,0,0,0,8,17.15l1.09-.37.89-.52c.06,0,.48.21.56.25.32.14.64.27,1,.38a8.54,8.54,0,0,0,2.12.4"
	}), React.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$9(__assign$9(__assign$9({}, W), V.rbgcpControlIcon), U && { stroke: U }),
		d: "M7.57,5.73C6,5.7,4.5,5.65,3,5.77a2.28,2.28,0,0,0-1.76.74A2.3,2.3,0,0,0,.94,7.83l0,3.82A4.73,4.73,0,0,0,1,12.9a1.64,1.64,0,0,0,.68,1,2.44,2.44,0,0,0,1,.27,25,25,0,0,0,4.74.09"
	}), React.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$9(__assign$9(__assign$9({}, W), V.rbgcpControlIcon), U && { stroke: U }),
		d: "M12.43,14.32a44.12,44.12,0,0,0,4.6,0,2.24,2.24,0,0,0,1.76-.74,2.29,2.29,0,0,0,.27-1.32l0-3.81A4.81,4.81,0,0,0,19,7.15a1.62,1.62,0,0,0-.68-1,2.31,2.31,0,0,0-1-.28,26.8,26.8,0,0,0-4.74-.09"
	}));
}, PaletteIcon = function(x) {
	var w = x.color, V = usePicker().defaultStyles, U = w ?? "";
	return React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		style: { width: 17 }
	}, React.createElement("circle", {
		style: __assign$9(__assign$9({}, V.rbgcpControlIcon2), U && { fill: U }),
		cx: "9.36",
		cy: "5.07",
		r: "1.71"
	}), React.createElement("circle", {
		style: __assign$9(__assign$9({}, V.rbgcpControlIcon2), U && { fill: U }),
		cx: "13.93",
		cy: "6.91",
		r: "1.71"
	}), React.createElement("circle", {
		style: __assign$9(__assign$9({}, V.rbgcpControlIcon2), U && { fill: U }),
		cx: "5.8",
		cy: "7.55",
		r: "1.71"
	}), React.createElement("circle", {
		style: __assign$9(__assign$9({}, V.rbgcpControlIcon2), U && { fill: U }),
		cx: "5.45",
		cy: "12.04",
		r: "1.71"
	}), React.createElement("path", {
		style: __assign$9(__assign$9(__assign$9(__assign$9({}, {
			strokeMiterlimit: 10,
			strokeWidth: "0.5px"
		}), V.rbgcpControlIcon), V.rbgcpControlIcon2), U && {
			fill: U,
			stroke: U
		}),
		d: "M19.1,10c0,3.58-2.12,2.94-4.06,2.35-1.15-.34-2.24-.67-2.77-.08-.68.78-.54,2.07-.39,3.33.2,1.79.39,3.5-1.88,3.5A9.1,9.1,0,1,1,19.1,10ZM10,18c.7,0,.74-.19.75-.2a2.67,2.67,0,0,0,.07-1.27c0-.19,0-.42-.06-.67-.06-.53-.13-1.15-.14-1.67a3.82,3.82,0,0,1,.8-2.63,2.14,2.14,0,0,1,1.45-.7,4.36,4.36,0,0,1,1.32.12c.39.08.8.21,1.16.32h0c.39.12.74.23,1.08.3.74.17,1,.1,1.13,0S18,11.32,18,10a8,8,0,1,0-8,8Z"
	}));
}, DegreesIcon = function(x) {
	var w = x.color, V = usePicker().defaultStyles, U = w ?? "", W = {
		fill: "none",
		strokeMiterlimit: 10,
		strokeWidth: "1.8px"
	};
	return React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		style: { width: 15 }
	}, React.createElement("polyline", {
		strokeLinecap: "round",
		style: __assign$9(__assign$9(__assign$9({}, W), V.rbgcpControlIcon), U && { stroke: U }),
		points: "13.86 2.01 1.7 16.99 18.77 16.99"
	}), React.createElement("polyline", {
		strokeLinecap: "round",
		style: __assign$9(__assign$9(__assign$9({}, W), V.rbgcpControlIcon), U && { stroke: U }),
		points: "10.96 16.38 10.96 16.38 10.74 15.7 10.44 14.97 10.06 14.21 9.72 13.63 9.21 12.89 8.85 12.44 8.41 11.95 7.91 11.45 7.51 11.1"
	}));
}, StopIcon = function() {
	var x = usePicker().defaultStyles;
	return React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		style: {
			width: 20,
			marginRight: 1
		}
	}, React.createElement("path", {
		style: __assign$9({}, x.rbgcpControlIcon2),
		d: "M2.39,8c-.63,0-1,.21-1,.63A.49.49,0,0,0,1.67,9a6.48,6.48,0,0,0,1.11.43A3,3,0,0,1,4,10.09a1.47,1.47,0,0,1,.35,1.09,1.75,1.75,0,0,1-.57,1.42,2.21,2.21,0,0,1-1.48.48,8.32,8.32,0,0,1-1.68-.21l-.31-.06.12-.94a13.7,13.7,0,0,0,1.8.16c.61,0,.92-.26.92-.77a.52.52,0,0,0-.21-.44,3.13,3.13,0,0,0-.85-.34A3.32,3.32,0,0,1,.66,9.79a1.43,1.43,0,0,1-.42-1.1A1.6,1.6,0,0,1,.78,7.36a2.32,2.32,0,0,1,1.49-.44,10.46,10.46,0,0,1,1.64.17l.32.07-.1.95C3.31,8,2.73,8,2.39,8Z"
	}), React.createElement("path", {
		style: __assign$9({}, x.rbgcpControlIcon2),
		d: "M4.79,8.09V7H9.16V8.09H7.59V13H6.38V8.09Z"
	}), React.createElement("path", {
		style: __assign$9({}, x.rbgcpControlIcon2),
		d: "M14,12.34a2.25,2.25,0,0,1-1.91.74,2.24,2.24,0,0,1-1.91-.74A3.85,3.85,0,0,1,9.61,10a4,4,0,0,1,.56-2.34,2.2,2.2,0,0,1,1.91-.77A2.21,2.21,0,0,1,14,7.69,4,4,0,0,1,14.55,10,3.85,3.85,0,0,1,14,12.34Zm-2.88-.77a1,1,0,0,0,1,.46,1,1,0,0,0,1-.46A3.25,3.25,0,0,0,13.3,10,3.45,3.45,0,0,0,13,8.46a1,1,0,0,0-1-.49,1,1,0,0,0-1,.49A3.43,3.43,0,0,0,10.85,10,3.38,3.38,0,0,0,11.11,11.57Z"
	}), React.createElement("path", {
		style: __assign$9({}, x.rbgcpControlIcon2),
		d: "M17.77,11.24h-1V13H15.58V7h2.19a1.85,1.85,0,0,1,2.11,2.07,2.21,2.21,0,0,1-.54,1.6A2.07,2.07,0,0,1,17.77,11.24Zm-1-1h1c.6,0,.9-.37.9-1.12a1.18,1.18,0,0,0-.22-.79.88.88,0,0,0-.68-.24h-1Z"
	}));
}, Portal_default = memo(function(x) {
	var w = x.children, V = "id" + Math.random().toString(16).slice(2), U = useRef(document.getElementById(V) ?? document.createElement("div")), W = useState(!U.current.parentElement)[0];
	return useEffect(function() {
		var x = U.current;
		return W && (U.current.id = V, document.body.appendChild(U.current)), function() {
			W && x.parentElement && x.parentElement.removeChild(x);
		};
	}, [V]), createPortal(w, U.current);
}), require_html2canvas = /* @__PURE__ */ __commonJSMin(((x, w) => {
	(function(V, U) {
		typeof x == "object" && w !== void 0 ? w.exports = U() : typeof define == "function" && define.amd ? define(U) : (V = typeof globalThis < "u" ? globalThis : V || self, V.html2canvas = U());
	})(x, (function() {
		var x = function(w, V) {
			return x = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(x, w) {
				x.__proto__ = w;
			} || function(x, w) {
				for (var V in w) Object.prototype.hasOwnProperty.call(w, V) && (x[V] = w[V]);
			}, x(w, V);
		};
		function w(w, V) {
			if (typeof V != "function" && V !== null) throw TypeError("Class extends value " + String(V) + " is not a constructor or null");
			x(w, V);
			function U() {
				this.constructor = w;
			}
			w.prototype = V === null ? Object.create(V) : (U.prototype = V.prototype, new U());
		}
		var V = function() {
			return V = Object.assign || function(x) {
				for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
				return x;
			}, V.apply(this, arguments);
		};
		function U(x, w, V, U) {
			function W(x) {
				return x instanceof V ? x : new V(function(w) {
					w(x);
				});
			}
			return new (V ||= Promise)(function(V, G) {
				function K(x) {
					try {
						Y(U.next(x));
					} catch (x) {
						G(x);
					}
				}
				function J(x) {
					try {
						Y(U.throw(x));
					} catch (x) {
						G(x);
					}
				}
				function Y(x) {
					x.done ? V(x.value) : W(x.value).then(K, J);
				}
				Y((U = U.apply(x, w || [])).next());
			});
		}
		function W(x, w) {
			var V = {
				label: 0,
				sent: function() {
					if (G[0] & 1) throw G[1];
					return G[1];
				},
				trys: [],
				ops: []
			}, U, W, G, K;
			return K = {
				next: J(0),
				throw: J(1),
				return: J(2)
			}, typeof Symbol == "function" && (K[Symbol.iterator] = function() {
				return this;
			}), K;
			function J(x) {
				return function(w) {
					return Y([x, w]);
				};
			}
			function Y(K) {
				if (U) throw TypeError("Generator is already executing.");
				for (; V;) try {
					if (U = 1, W && (G = K[0] & 2 ? W.return : K[0] ? W.throw || ((G = W.return) && G.call(W), 0) : W.next) && !(G = G.call(W, K[1])).done) return G;
					switch (W = 0, G && (K = [K[0] & 2, G.value]), K[0]) {
						case 0:
						case 1:
							G = K;
							break;
						case 4: return V.label++, {
							value: K[1],
							done: !1
						};
						case 5:
							V.label++, W = K[1], K = [0];
							continue;
						case 7:
							K = V.ops.pop(), V.trys.pop();
							continue;
						default:
							if ((G = V.trys, !(G = G.length > 0 && G[G.length - 1])) && (K[0] === 6 || K[0] === 2)) {
								V = 0;
								continue;
							}
							if (K[0] === 3 && (!G || K[1] > G[0] && K[1] < G[3])) {
								V.label = K[1];
								break;
							}
							if (K[0] === 6 && V.label < G[1]) {
								V.label = G[1], G = K;
								break;
							}
							if (G && V.label < G[2]) {
								V.label = G[2], V.ops.push(K);
								break;
							}
							G[2] && V.ops.pop(), V.trys.pop();
							continue;
					}
					K = w.call(x, V);
				} catch (x) {
					K = [6, x], W = 0;
				} finally {
					U = G = 0;
				}
				if (K[0] & 5) throw K[1];
				return {
					value: K[0] ? K[1] : void 0,
					done: !0
				};
			}
		}
		function G(x, w, V) {
			if (V || arguments.length === 2) for (var U = 0, W = w.length, G; U < W; U++) (G || !(U in w)) && (G ||= Array.prototype.slice.call(w, 0, U), G[U] = w[U]);
			return x.concat(G || w);
		}
		for (var K = function() {
			function x(x, w, V, U) {
				this.left = x, this.top = w, this.width = V, this.height = U;
			}
			return x.prototype.add = function(w, V, U, W) {
				return new x(this.left + w, this.top + V, this.width + U, this.height + W);
			}, x.fromClientRect = function(w, V) {
				return new x(V.left + w.windowBounds.left, V.top + w.windowBounds.top, V.width, V.height);
			}, x.fromDOMRectList = function(w, V) {
				var U = Array.from(V).find(function(x) {
					return x.width !== 0;
				});
				return U ? new x(U.left + w.windowBounds.left, U.top + w.windowBounds.top, U.width, U.height) : x.EMPTY;
			}, x.EMPTY = new x(0, 0, 0, 0), x;
		}(), J = function(x, w) {
			return K.fromClientRect(x, w.getBoundingClientRect());
		}, Y = function(x) {
			var w = x.body, V = x.documentElement;
			if (!w || !V) throw Error("Unable to get document size");
			return new K(0, 0, Math.max(Math.max(w.scrollWidth, V.scrollWidth), Math.max(w.offsetWidth, V.offsetWidth), Math.max(w.clientWidth, V.clientWidth)), Math.max(Math.max(w.scrollHeight, V.scrollHeight), Math.max(w.offsetHeight, V.offsetHeight), Math.max(w.clientHeight, V.clientHeight)));
		}, Z = function(x) {
			for (var w = [], V = 0, U = x.length; V < U;) {
				var W = x.charCodeAt(V++);
				if (W >= 55296 && W <= 56319 && V < U) {
					var G = x.charCodeAt(V++);
					(G & 64512) == 56320 ? w.push(((W & 1023) << 10) + (G & 1023) + 65536) : (w.push(W), V--);
				} else w.push(W);
			}
			return w;
		}, $ = function() {
			var x = [...arguments];
			if (String.fromCodePoint) return String.fromCodePoint.apply(String, x);
			var w = x.length;
			if (!w) return "";
			for (var V = [], U = -1, W = ""; ++U < w;) {
				var G = x[U];
				G <= 65535 ? V.push(G) : (G -= 65536, V.push((G >> 10) + 55296, G % 1024 + 56320)), (U + 1 === w || V.length > 16384) && (W += String.fromCharCode.apply(String, V), V.length = 0);
			}
			return W;
		}, ql = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Jl = typeof Uint8Array > "u" ? [] : new Uint8Array(256), Yl = 0; Yl < ql.length; Yl++) Jl[ql.charCodeAt(Yl)] = Yl;
		for (var Xl = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Zl = typeof Uint8Array > "u" ? [] : new Uint8Array(256), Ql = 0; Ql < Xl.length; Ql++) Zl[Xl.charCodeAt(Ql)] = Ql;
		for (var $l = function(x) {
			var w = x.length * .75, V = x.length, U, W = 0, G, K, J, Y;
			x[x.length - 1] === "=" && (w--, x[x.length - 2] === "=" && w--);
			var Z = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && Uint8Array.prototype.slice !== void 0 ? new ArrayBuffer(w) : Array(w), $ = Array.isArray(Z) ? Z : new Uint8Array(Z);
			for (U = 0; U < V; U += 4) G = Zl[x.charCodeAt(U)], K = Zl[x.charCodeAt(U + 1)], J = Zl[x.charCodeAt(U + 2)], Y = Zl[x.charCodeAt(U + 3)], $[W++] = G << 2 | K >> 4, $[W++] = (K & 15) << 4 | J >> 2, $[W++] = (J & 3) << 6 | Y & 63;
			return Z;
		}, eu = function(x) {
			for (var w = x.length, V = [], U = 0; U < w; U += 2) V.push(x[U + 1] << 8 | x[U]);
			return V;
		}, tu = function(x) {
			for (var w = x.length, V = [], U = 0; U < w; U += 4) V.push(x[U + 3] << 24 | x[U + 2] << 16 | x[U + 1] << 8 | x[U]);
			return V;
		}, nu = 5, ru = 11, iu = 2, au = ru - nu, ou = 65536 >> nu, su = (1 << nu) - 1, cu = ou + (1024 >> nu) + 32, lu = 65536 >> ru, uu = (1 << au) - 1, du = function(x, w, V) {
			return x.slice ? x.slice(w, V) : new Uint16Array(Array.prototype.slice.call(x, w, V));
		}, fu = function(x, w, V) {
			return x.slice ? x.slice(w, V) : new Uint32Array(Array.prototype.slice.call(x, w, V));
		}, pu = function(x, w) {
			var V = $l(x), U = Array.isArray(V) ? tu(V) : new Uint32Array(V), W = Array.isArray(V) ? eu(V) : new Uint16Array(V), G = 24, K = du(W, G / 2, U[4] / 2), J = U[5] === 2 ? du(W, (G + U[4]) / 2) : fu(U, Math.ceil((G + U[4]) / 4));
			return new mu(U[0], U[1], U[2], U[3], K, J);
		}, mu = function() {
			function x(x, w, V, U, W, G) {
				this.initialValue = x, this.errorValue = w, this.highStart = V, this.highValueIndex = U, this.index = W, this.data = G;
			}
			return x.prototype.get = function(x) {
				var w;
				if (x >= 0) {
					if (x < 55296 || x > 56319 && x <= 65535) return w = this.index[x >> nu], w = (w << iu) + (x & su), this.data[w];
					if (x <= 65535) return w = this.index[ou + (x - 55296 >> nu)], w = (w << iu) + (x & su), this.data[w];
					if (x < this.highStart) return w = cu - lu + (x >> ru), w = this.index[w], w += x >> nu & uu, w = this.index[w], w = (w << iu) + (x & su), this.data[w];
					if (x <= 1114111) return this.data[this.highValueIndex];
				}
				return this.errorValue;
			}, x;
		}(), hu = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", gu = typeof Uint8Array > "u" ? [] : new Uint8Array(256), _u = 0; _u < hu.length; _u++) gu[hu.charCodeAt(_u)] = _u;
		var vu = "KwAAAAAAAAAACA4AUD0AADAgAAACAAAAAAAIABAAGABAAEgAUABYAGAAaABgAGgAYgBqAF8AZwBgAGgAcQB5AHUAfQCFAI0AlQCdAKIAqgCyALoAYABoAGAAaABgAGgAwgDKAGAAaADGAM4A0wDbAOEA6QDxAPkAAQEJAQ8BFwF1AH0AHAEkASwBNAE6AUIBQQFJAVEBWQFhAWgBcAF4ATAAgAGGAY4BlQGXAZ8BpwGvAbUBvQHFAc0B0wHbAeMB6wHxAfkBAQIJAvEBEQIZAiECKQIxAjgCQAJGAk4CVgJeAmQCbAJ0AnwCgQKJApECmQKgAqgCsAK4ArwCxAIwAMwC0wLbAjAA4wLrAvMC+AIAAwcDDwMwABcDHQMlAy0DNQN1AD0DQQNJA0kDSQNRA1EDVwNZA1kDdQB1AGEDdQBpA20DdQN1AHsDdQCBA4kDkQN1AHUAmQOhA3UAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AKYDrgN1AHUAtgO+A8YDzgPWAxcD3gPjA+sD8wN1AHUA+wMDBAkEdQANBBUEHQQlBCoEFwMyBDgEYABABBcDSARQBFgEYARoBDAAcAQzAXgEgASIBJAEdQCXBHUAnwSnBK4EtgS6BMIEyAR1AHUAdQB1AHUAdQCVANAEYABgAGAAYABgAGAAYABgANgEYADcBOQEYADsBPQE/AQEBQwFFAUcBSQFLAU0BWQEPAVEBUsFUwVbBWAAYgVgAGoFcgV6BYIFigWRBWAAmQWfBaYFYABgAGAAYABgAKoFYACxBbAFuQW6BcEFwQXHBcEFwQXPBdMF2wXjBeoF8gX6BQIGCgYSBhoGIgYqBjIGOgZgAD4GRgZMBmAAUwZaBmAAYABgAGAAYABgAGAAYABgAGAAYABgAGIGYABpBnAGYABgAGAAYABgAGAAYABgAGAAYAB4Bn8GhQZgAGAAYAB1AHcDFQSLBmAAYABgAJMGdQA9A3UAmwajBqsGqwaVALMGuwbDBjAAywbSBtIG1QbSBtIG0gbSBtIG0gbdBuMG6wbzBvsGAwcLBxMHAwcbByMHJwcsBywHMQcsB9IGOAdAB0gHTgfSBkgHVgfSBtIG0gbSBtIG0gbSBtIG0gbSBiwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdgAGAALAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdbB2MHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB2kH0gZwB64EdQB1AHUAdQB1AHUAdQB1AHUHfQdgAIUHjQd1AHUAlQedB2AAYAClB6sHYACzB7YHvgfGB3UAzgfWBzMB3gfmB1EB7gf1B/0HlQENAQUIDQh1ABUIHQglCBcDLQg1CD0IRQhNCEEDUwh1AHUAdQBbCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIcAh3CHoIMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIgggwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAALAcsBywHLAcsBywHLAcsBywHLAcsB4oILAcsB44I0gaWCJ4Ipgh1AHUAqgiyCHUAdQB1AHUAdQB1AHUAdQB1AHUAtwh8AXUAvwh1AMUIyQjRCNkI4AjoCHUAdQB1AO4I9gj+CAYJDgkTCS0HGwkjCYIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiAAIAAAAFAAYABgAGIAXwBgAHEAdQBFAJUAogCyAKAAYABgAEIA4ABGANMA4QDxAMEBDwE1AFwBLAE6AQEBUQF4QkhCmEKoQrhCgAHIQsAB0MLAAcABwAHAAeDC6ABoAHDCwMMAAcABwAHAAdDDGMMAAcAB6MM4wwjDWMNow3jDaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAEjDqABWw6bDqABpg6gAaABoAHcDvwOPA+gAaABfA/8DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DpcPAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcAB9cPKwkyCToJMAB1AHUAdQBCCUoJTQl1AFUJXAljCWcJawkwADAAMAAwAHMJdQB2CX4JdQCECYoJjgmWCXUAngkwAGAAYABxAHUApgn3A64JtAl1ALkJdQDACTAAMAAwADAAdQB1AHUAdQB1AHUAdQB1AHUAowYNBMUIMAAwADAAMADICcsJ0wnZCRUE4QkwAOkJ8An4CTAAMAB1AAAKvwh1AAgKDwoXCh8KdQAwACcKLgp1ADYKqAmICT4KRgowADAAdQB1AE4KMAB1AFYKdQBeCnUAZQowADAAMAAwADAAMAAwADAAMAAVBHUAbQowADAAdQC5CXUKMAAwAHwBxAijBogEMgF9CoQKiASMCpQKmgqIBKIKqgquCogEDQG2Cr4KxgrLCjAAMADTCtsKCgHjCusK8Qr5CgELMAAwADAAMAB1AIsECQsRC3UANAEZCzAAMAAwADAAMAB1ACELKQswAHUANAExCzkLdQBBC0kLMABRC1kLMAAwADAAMAAwADAAdQBhCzAAMAAwAGAAYABpC3ELdwt/CzAAMACHC4sLkwubC58Lpwt1AK4Ltgt1APsDMAAwADAAMAAwADAAMAAwAL4LwwvLC9IL1wvdCzAAMADlC+kL8Qv5C/8LSQswADAAMAAwADAAMAAwADAAMAAHDDAAMAAwADAAMAAODBYMHgx1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1ACYMMAAwADAAdQB1AHUALgx1AHUAdQB1AHUAdQA2DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AD4MdQBGDHUAdQB1AHUAdQB1AEkMdQB1AHUAdQB1AFAMMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQBYDHUAdQB1AF8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUA+wMVBGcMMAAwAHwBbwx1AHcMfwyHDI8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAYABgAJcMMAAwADAAdQB1AJ8MlQClDDAAMACtDCwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB7UMLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AA0EMAC9DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAsBywHLAcsBywHLAcsBywHLQcwAMEMyAwsBywHLAcsBywHLAcsBywHLAcsBywHzAwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1ANQM2QzhDDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMABgAGAAYABgAGAAYABgAOkMYADxDGAA+AwADQYNYABhCWAAYAAODTAAMAAwADAAFg1gAGAAHg37AzAAMAAwADAAYABgACYNYAAsDTQNPA1gAEMNPg1LDWAAYABgAGAAYABgAGAAYABgAGAAUg1aDYsGVglhDV0NcQBnDW0NdQ15DWAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAlQCBDZUAiA2PDZcNMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAnw2nDTAAMAAwADAAMAAwAHUArw23DTAAMAAwADAAMAAwADAAMAAwADAAMAB1AL8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQDHDTAAYABgAM8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA1w11ANwNMAAwAD0B5A0wADAAMAAwADAAMADsDfQN/A0EDgwOFA4wABsOMAAwADAAMAAwADAAMAAwANIG0gbSBtIG0gbSBtIG0gYjDigOwQUuDsEFMw7SBjoO0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGQg5KDlIOVg7SBtIGXg5lDm0OdQ7SBtIGfQ6EDooOjQ6UDtIGmg6hDtIG0gaoDqwO0ga0DrwO0gZgAGAAYADEDmAAYAAkBtIGzA5gANIOYADaDokO0gbSBt8O5w7SBu8O0gb1DvwO0gZgAGAAxA7SBtIG0gbSBtIGYABgAGAAYAAED2AAsAUMD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHJA8sBywHLAcsBywHLAccDywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywPLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAc0D9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHPA/SBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gYUD0QPlQCVAJUAMAAwADAAMACVAJUAlQCVAJUAlQCVAEwPMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA//8EAAQABAAEAAQABAAEAAQABAANAAMAAQABAAIABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQACgATABcAHgAbABoAHgAXABYAEgAeABsAGAAPABgAHABLAEsASwBLAEsASwBLAEsASwBLABgAGAAeAB4AHgATAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYAGwASAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWAA0AEQAeAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAFAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJABYAGgAbABsAGwAeAB0AHQAeAE8AFwAeAA0AHgAeABoAGwBPAE8ADgBQAB0AHQAdAE8ATwAXAE8ATwBPABYAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAFAATwBAAE8ATwBPAEAATwBQAFAATwBQAB4AHgAeAB4AHgAeAB0AHQAdAB0AHgAdAB4ADgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgBQAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkACQAJAAkACQAJAAkABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAFAAHgAeAB4AKwArAFAAUABQAFAAGABQACsAKwArACsAHgAeAFAAHgBQAFAAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUAAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAYAA0AKwArAB4AHgAbACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAB4ABAAEAB4ABAAEABMABAArACsAKwArACsAKwArACsAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAKwArACsAKwBWAFYAVgBWAB4AHgArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AGgAaABoAGAAYAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQAEwAEACsAEwATAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABLAEsASwBLAEsASwBLAEsASwBLABoAGQAZAB4AUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABMAUAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABABQAFAABAAEAB4ABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUAAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAFAABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQAUABQAB4AHgAYABMAUAArACsABAAbABsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAFAABAAEAAQABAAEAFAABAAEAAQAUAAEAAQABAAEAAQAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArACsAHgArAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAUAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEAA0ADQBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUAArACsAKwBQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABABQACsAKwArACsAKwArACsAKwAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUAAaABoAUABQAFAAUABQAEwAHgAbAFAAHgAEACsAKwAEAAQABAArAFAAUABQAFAAUABQACsAKwArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQACsAUABQACsAKwAEACsABAAEAAQABAAEACsAKwArACsABAAEACsAKwAEAAQABAArACsAKwAEACsAKwArACsAKwArACsAUABQAFAAUAArAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLAAQABABQAFAAUAAEAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAArACsAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AGwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAKwArACsAKwArAAQABAAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAAQAUAArAFAAUABQAFAAUABQACsAKwArAFAAUABQACsAUABQAFAAUAArACsAKwBQAFAAKwBQACsAUABQACsAKwArAFAAUAArACsAKwBQAFAAUAArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAAQABAAEAAQABAArACsAKwAEAAQABAArAAQABAAEAAQAKwArAFAAKwArACsAKwArACsABAArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAHgAeAB4AHgAeAB4AGwAeACsAKwArACsAKwAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAUABQAFAAKwArACsAKwArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwAOAFAAUABQAFAAUABQAFAAHgBQAAQABAAEAA4AUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAKwArAAQAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAKwArACsAKwArACsAUAArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABABQAB4AKwArACsAKwBQAFAAUAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQABoAUABQAFAAUABQAFAAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQACsAUAArACsAUABQAFAAUABQAFAAUAArACsAKwAEACsAKwArACsABAAEAAQABAAEAAQAKwAEACsABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgAqACsAKwArACsAGwBcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAeAEsASwBLAEsASwBLAEsASwBLAEsADQANACsAKwArACsAKwBcAFwAKwBcACsAXABcAFwAXABcACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAXAArAFwAXABcAFwAXABcAFwAXABcAFwAKgBcAFwAKgAqACoAKgAqACoAKgAqACoAXAArACsAXABcAFwAXABcACsAXAArACoAKgAqACoAKgAqACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwBcAFwAXABcAFAADgAOAA4ADgAeAA4ADgAJAA4ADgANAAkAEwATABMAEwATAAkAHgATAB4AHgAeAAQABAAeAB4AHgAeAB4AHgBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQAFAADQAEAB4ABAAeAAQAFgARABYAEQAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAAQABAAEAAQADQAEAAQAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAA0ADQAeAB4AHgAeAB4AHgAEAB4AHgAeAB4AHgAeACsAHgAeAA4ADgANAA4AHgAeAB4AHgAeAAkACQArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgBcAEsASwBLAEsASwBLAEsASwBLAEsADQANAB4AHgAeAB4AXABcAFwAXABcAFwAKgAqACoAKgBcAFwAXABcACoAKgAqAFwAKgAqACoAXABcACoAKgAqACoAKgAqACoAXABcAFwAKgAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqAFwAKgBLAEsASwBLAEsASwBLAEsASwBLACoAKgAqACoAKgAqAFAAUABQAFAAUABQACsAUAArACsAKwArACsAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAKwBQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsABAAEAAQAHgANAB4AHgAeAB4AHgAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUAArACsADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWABEAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQANAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAANAA0AKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUAArAAQABAArACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqAA0ADQAVAFwADQAeAA0AGwBcACoAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwAeAB4AEwATAA0ADQAOAB4AEwATAB4ABAAEAAQACQArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAHgArACsAKwATABMASwBLAEsASwBLAEsASwBLAEsASwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAXABcAFwAXABcACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAXAArACsAKwAqACoAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsAHgAeAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKwAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKwArAAQASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACoAKgAqACoAKgAqACoAXAAqACoAKgAqACoAKgArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABABQAFAAUABQAFAAUABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwANAA0AHgANAA0ADQANAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwAeAB4AHgAeAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArAA0ADQANAA0ADQBLAEsASwBLAEsASwBLAEsASwBLACsAKwArAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUAAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAAQAUABQAFAAUABQAFAABABQAFAABAAEAAQAUAArACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQACsAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQACsAKwAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQACsAHgAeAB4AHgAeAB4AHgAOAB4AKwANAA0ADQANAA0ADQANAAkADQANAA0ACAAEAAsABAAEAA0ACQANAA0ADAAdAB0AHgAXABcAFgAXABcAFwAWABcAHQAdAB4AHgAUABQAFAANAAEAAQAEAAQABAAEAAQACQAaABoAGgAaABoAGgAaABoAHgAXABcAHQAVABUAHgAeAB4AHgAeAB4AGAAWABEAFQAVABUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ADQAeAA0ADQANAA0AHgANAA0ADQAHAB4AHgAeAB4AKwAEAAQABAAEAAQABAAEAAQABAAEAFAAUAArACsATwBQAFAAUABQAFAAHgAeAB4AFgARAE8AUABPAE8ATwBPAFAAUABQAFAAUAAeAB4AHgAWABEAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArABsAGwAbABsAGwAbABsAGgAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGgAbABsAGwAbABoAGwAbABoAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAHgAeAFAAGgAeAB0AHgBQAB4AGgAeAB4AHgAeAB4AHgAeAB4AHgBPAB4AUAAbAB4AHgBQAFAAUABQAFAAHgAeAB4AHQAdAB4AUAAeAFAAHgBQAB4AUABPAFAAUAAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgBQAFAAUABQAE8ATwBQAFAAUABQAFAATwBQAFAATwBQAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAUABQAFAATwBPAE8ATwBPAE8ATwBPAE8ATwBQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABPAB4AHgArACsAKwArAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHQAdAB4AHgAeAB0AHQAeAB4AHQAeAB4AHgAdAB4AHQAbABsAHgAdAB4AHgAeAB4AHQAeAB4AHQAdAB0AHQAeAB4AHQAeAB0AHgAdAB0AHQAdAB0AHQAeAB0AHgAeAB4AHgAeAB0AHQAdAB0AHgAeAB4AHgAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB0AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAdAB0AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAWABEAHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AHQAdAB0AHgAeAB0AHgAeAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlAB4AHQAdAB4AHgAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AJQAlAB0AHQAlAB4AJQAlACUAIAAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAdAB0AHQAeAB0AJQAdAB0AHgAdAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAdAB0AHQAdACUAHgAlACUAJQAdACUAJQAdAB0AHQAlACUAHQAdACUAHQAdACUAJQAlAB4AHQAeAB4AHgAeAB0AHQAlAB0AHQAdAB0AHQAdACUAJQAlACUAJQAdACUAJQAgACUAHQAdACUAJQAlACUAJQAlACUAJQAeAB4AHgAlACUAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AFwAXABcAFwAXABcAHgATABMAJQAeAB4AHgAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARABYAEQAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAeAB4AKwArACsAKwArABMADQANAA0AUAATAA0AUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUAANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAA0ADQANAA0ADQANAA0ADQAeAA0AFgANAB4AHgAXABcAHgAeABcAFwAWABEAFgARABYAEQAWABEADQANAA0ADQATAFAADQANAB4ADQANAB4AHgAeAB4AHgAMAAwADQANAA0AHgANAA0AFgANAA0ADQANAA0ADQANAA0AHgANAB4ADQANAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArAA0AEQARACUAJQBHAFcAVwAWABEAFgARABYAEQAWABEAFgARACUAJQAWABEAFgARABYAEQAWABEAFQAWABEAEQAlAFcAVwBXAFcAVwBXAFcAVwBXAAQABAAEAAQABAAEACUAVwBXAFcAVwA2ACUAJQBXAFcAVwBHAEcAJQAlACUAKwBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBRAFcAUQBXAFEAVwBXAFcAVwBXAFcAUQBXAFcAVwBXAFcAVwBRAFEAKwArAAQABAAVABUARwBHAFcAFQBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBRAFcAVwBXAFcAVwBXAFEAUQBXAFcAVwBXABUAUQBHAEcAVwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwAlACUAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACsAKwArACsAKwArACsAKwArACsAKwArAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBPAE8ATwBPAE8ATwBPAE8AJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADQATAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQAHgBQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAeAA0ADQANAA0ADQArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAAQAUABQAFAABABQAFAAUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAeAB4AHgAeAAQAKwArACsAUABQAFAAUABQAFAAHgAeABoAHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADgAOABMAEwArACsAKwArACsAKwArACsABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUAAeAB4AHgBQAA4AUABQAAQAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAB4AWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYACsAKwArAAQAHgAeAB4AHgAeAB4ADQANAA0AHgAeAB4AHgArAFAASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArAB4AHgBcAFwAXABcAFwAKgBcAFwAXABcAFwAXABcAFwAXABcAEsASwBLAEsASwBLAEsASwBLAEsAXABcAFwAXABcACsAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAFAAUABQAAQAUABQAFAAUABQAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAHgANAA0ADQBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAKgAqACoAXABcACoAKgBcAFwAXABcAFwAKgAqAFwAKgBcACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAA0ADQBQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQADQAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAVABVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBUAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVACsAKwArACsAKwArACsAKwArACsAKwArAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAKwArACsAKwBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAKwArACsAKwAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArACsAKwArAFYABABWAFYAVgBWAFYAVgBWAFYAVgBWAB4AVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgArAFYAVgBWAFYAVgArAFYAKwBWAFYAKwBWAFYAKwBWAFYAVgBWAFYAVgBWAFYAVgBWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAEQAWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAaAB4AKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAGAARABEAGAAYABMAEwAWABEAFAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACUAJQAlACUAJQAWABEAFgARABYAEQAWABEAFgARABYAEQAlACUAFgARACUAJQAlACUAJQAlACUAEQAlABEAKwAVABUAEwATACUAFgARABYAEQAWABEAJQAlACUAJQAlACUAJQAlACsAJQAbABoAJQArACsAKwArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAcAKwATACUAJQAbABoAJQAlABYAEQAlACUAEQAlABEAJQBXAFcAVwBXAFcAVwBXAFcAVwBXABUAFQAlACUAJQATACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXABYAJQARACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAWACUAEQAlABYAEQARABYAEQARABUAVwBRAFEAUQBRAFEAUQBRAFEAUQBRAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcARwArACsAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXACsAKwBXAFcAVwBXAFcAVwArACsAVwBXAFcAKwArACsAGgAbACUAJQAlABsAGwArAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAAQAB0AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsADQANAA0AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAA0AUABQAFAAUAArACsAKwArAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwBQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAUABQAFAAUABQAAQABAAEACsABAAEACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAKwBQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAA0ADQANAA0ADQANAA0ADQAeACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAArACsAKwArAFAAUABQAFAAUAANAA0ADQANAA0ADQAUACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsADQANAA0ADQANAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArAAQABAANACsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAB4AHgAeAB4AHgArACsAKwArACsAKwAEAAQABAAEAAQABAAEAA0ADQAeAB4AHgAeAB4AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsASwBLAEsASwBLAEsASwBLAEsASwANAA0ADQANAFAABAAEAFAAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAeAA4AUAArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAADQANAB4ADQAEAAQABAAEAB4ABAAEAEsASwBLAEsASwBLAEsASwBLAEsAUAAOAFAADQANAA0AKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAA0AHgANAA0AHgAEACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAA0AKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsABAAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAUAArACsAKwArACsAKwAEACsAKwArACsAKwBQAFAAUABQAFAABAAEACsAKwAEAAQABAAEAAQABAAEACsAKwArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABABQAFAAUABQAA0ADQANAA0AHgBLAEsASwBLAEsASwBLAEsASwBLAA0ADQArAB4ABABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUAAeAFAAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABAAEAAQADgANAA0AEwATAB4AHgAeAA0ADQANAA0ADQANAA0ADQANAA0ADQANAA0ADQANAFAAUABQAFAABAAEACsAKwAEAA0ADQAeAFAAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKwArACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBcAFwADQANAA0AKgBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQAKwAEAAQAKwArAAQABAAEAAQAUAAEAFAABAAEAA0ADQANACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABABQAA4AUAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAOAB4ADQANAA0ADQAOAB4ABAArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAA0ADQANAFAADgAOAA4ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAFAADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAOABMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAArACsAKwAEACsABAAEACsABAAEAAQABAAEAAQABABQAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAaABoAGgAaAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABIAEgAQwBDAEMAUABQAFAAUABDAFAAUABQAEgAQwBIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABDAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAJAAkACQAJAAkACQAJABYAEQArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwANAA0AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAANACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQANAB4AHgAeAB4AHgAeAFAAUABQAFAADQAeACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAA0AHgAeACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAARwBHABUARwAJACsAKwArACsAKwArACsAKwArACsAKwAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUQBRAFEAKwArACsAKwArACsAKwArACsAKwArACsAKwBRAFEAUQBRACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAHgAEAAQADQAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQABAAEAAQABAAeAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQAHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAKwArAFAAKwArAFAAUAArACsAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUAArAFAAUABQAFAAUABQAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAHgAeAFAAUABQAFAAUAArAFAAKwArACsAUABQAFAAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeACsAKwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4ABAAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAHgAeAA0ADQANAA0AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArAAQABAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwBQAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArABsAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAB4AHgAeAB4ABAAEAAQABAAEAAQABABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArABYAFgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAGgBQAFAAUAAaAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUAArACsAKwArACsAKwBQACsAKwArACsAUAArAFAAKwBQACsAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUAArAFAAKwBQACsAUAArAFAAUAArAFAAKwArAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAKwBQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AJQAlACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeACUAJQAlAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAlACUAJQAlACUAHgAlACUAJQAlACUAIAAgACAAJQAlACAAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACEAIQAhACEAIQAlACUAIAAgACUAJQAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAIAAlACUAJQAlACAAIAAgACUAIAAgACAAJQAlACUAJQAlACUAJQAgACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAlAB4AJQAeACUAJQAlACUAJQAgACUAJQAlACUAHgAlAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACAAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABcAFwAXABUAFQAVAB4AHgAeAB4AJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAgACUAJQAgACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAIAAgACUAJQAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACAAIAAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACAAIAAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAA==", yu = 50, bu = 1, xu = 2, Su = 3, Cu = 4, wu = 5, Tu = 7, Eu = 8, Du = 9, Ou = 10, ku = 11, Au = 12, ju = 13, Mu = 14, Nu = 15, Pu = 16, Fu = 17, Iu = 18, Lu = 19, Ru = 20, zu = 21, Bu = 22, Vu = 23, Hu = 24, Uu = 25, Wu = 26, Gu = 27, Ku = 28, qu = 29, Ju = 30, Yu = 31, Xu = 32, Zu = 33, Qu = 34, $u = 35, ed = 36, td = 37, nd = 38, rd = 39, id = 40, ad = 41, od = 42, sd = 43, cd = [9001, 65288], ld = "!", ud = "×", dd = "÷", fd = pu(vu), pd = [Ju, ed], md = [
			bu,
			xu,
			Su,
			wu
		], hd = [Ou, Eu], gd = [Gu, Wu], _d = md.concat(hd), vd = [
			nd,
			rd,
			id,
			Qu,
			$u
		], yd = [Nu, ju], bd = function(x, w) {
			w === void 0 && (w = "strict");
			var V = [], U = [], W = [];
			return x.forEach(function(x, G) {
				var K = fd.get(x);
				if (K > yu ? (W.push(!0), K -= yu) : W.push(!1), [
					"normal",
					"auto",
					"loose"
				].indexOf(w) !== -1 && [
					8208,
					8211,
					12316,
					12448
				].indexOf(x) !== -1) return U.push(G), V.push(Pu);
				if (K === Cu || K === ku) {
					if (G === 0) return U.push(G), V.push(Ju);
					var J = V[G - 1];
					return _d.indexOf(J) === -1 ? (U.push(U[G - 1]), V.push(J)) : (U.push(G), V.push(Ju));
				}
				if (U.push(G), K === Yu) return V.push(w === "strict" ? zu : td);
				if (K === od || K === qu) return V.push(Ju);
				if (K === sd) return x >= 131072 && x <= 196605 || x >= 196608 && x <= 262141 ? V.push(td) : V.push(Ju);
				V.push(K);
			}), [
				U,
				V,
				W
			];
		}, xd = function(x, w, V, U) {
			var W = U[V];
			if (Array.isArray(x) ? x.indexOf(W) !== -1 : x === W) for (var G = V; G <= U.length;) {
				G++;
				var K = U[G];
				if (K === w) return !0;
				if (K !== Ou) break;
			}
			if (W === Ou) for (var G = V; G > 0;) {
				G--;
				var J = U[G];
				if (Array.isArray(x) ? x.indexOf(J) !== -1 : x === J) for (var Y = V; Y <= U.length;) {
					Y++;
					var K = U[Y];
					if (K === w) return !0;
					if (K !== Ou) break;
				}
				if (J !== Ou) break;
			}
			return !1;
		}, Sd = function(x, w) {
			for (var V = x; V >= 0;) {
				var U = w[V];
				if (U === Ou) V--;
				else return U;
			}
			return 0;
		}, Cd = function(x, w, V, U, W) {
			if (V[U] === 0) return ud;
			var G = U - 1;
			if (Array.isArray(W) && W[G] === !0) return ud;
			var K = G - 1, J = G + 1, Y = w[G], Z = K >= 0 ? w[K] : 0, $ = w[J];
			if (Y === xu && $ === Su) return ud;
			if (md.indexOf(Y) !== -1) return ld;
			if (md.indexOf($) !== -1 || hd.indexOf($) !== -1) return ud;
			if (Sd(G, w) === Eu) return dd;
			if (fd.get(x[G]) === ku || (Y === Xu || Y === Zu) && fd.get(x[J]) === ku || Y === Tu || $ === Tu || Y === Du || [
				Ou,
				ju,
				Nu
			].indexOf(Y) === -1 && $ === Du || [
				Fu,
				Iu,
				Lu,
				Hu,
				Ku
			].indexOf($) !== -1 || Sd(G, w) === Bu || xd(Vu, Bu, G, w) || xd([Fu, Iu], zu, G, w) || xd(Au, Au, G, w)) return ud;
			if (Y === Ou) return dd;
			if (Y === Vu || $ === Vu) return ud;
			if ($ === Pu || Y === Pu) return dd;
			if ([
				ju,
				Nu,
				zu
			].indexOf($) !== -1 || Y === Mu || Z === ed && yd.indexOf(Y) !== -1 || Y === Ku && $ === ed || $ === Ru || pd.indexOf($) !== -1 && Y === Uu || pd.indexOf(Y) !== -1 && $ === Uu || Y === Gu && [
				td,
				Xu,
				Zu
			].indexOf($) !== -1 || [
				td,
				Xu,
				Zu
			].indexOf(Y) !== -1 && $ === Wu || pd.indexOf(Y) !== -1 && gd.indexOf($) !== -1 || gd.indexOf(Y) !== -1 && pd.indexOf($) !== -1 || [Gu, Wu].indexOf(Y) !== -1 && ($ === Uu || [Bu, Nu].indexOf($) !== -1 && w[J + 1] === Uu) || [Bu, Nu].indexOf(Y) !== -1 && $ === Uu || Y === Uu && [
				Uu,
				Ku,
				Hu
			].indexOf($) !== -1) return ud;
			if ([
				Uu,
				Ku,
				Hu,
				Fu,
				Iu
			].indexOf($) !== -1) for (var ql = G; ql >= 0;) {
				var Jl = w[ql];
				if (Jl === Uu) return ud;
				if ([Ku, Hu].indexOf(Jl) !== -1) ql--;
				else break;
			}
			if ([Gu, Wu].indexOf($) !== -1) for (var ql = [Fu, Iu].indexOf(Y) === -1 ? G : K; ql >= 0;) {
				var Jl = w[ql];
				if (Jl === Uu) return ud;
				if ([Ku, Hu].indexOf(Jl) !== -1) ql--;
				else break;
			}
			if (nd === Y && [
				nd,
				rd,
				Qu,
				$u
			].indexOf($) !== -1 || [rd, Qu].indexOf(Y) !== -1 && [rd, id].indexOf($) !== -1 || [id, $u].indexOf(Y) !== -1 && $ === id || vd.indexOf(Y) !== -1 && [Ru, Wu].indexOf($) !== -1 || vd.indexOf($) !== -1 && Y === Gu || pd.indexOf(Y) !== -1 && pd.indexOf($) !== -1 || Y === Hu && pd.indexOf($) !== -1 || pd.concat(Uu).indexOf(Y) !== -1 && $ === Bu && cd.indexOf(x[J]) === -1 || pd.concat(Uu).indexOf($) !== -1 && Y === Iu) return ud;
			if (Y === ad && $ === ad) {
				for (var Yl = V[G], Xl = 1; Yl > 0 && (Yl--, w[Yl] === ad);) Xl++;
				if (Xl % 2 != 0) return ud;
			}
			return Y === Xu && $ === Zu ? ud : dd;
		}, wd = function(x, w) {
			w ||= {
				lineBreak: "normal",
				wordBreak: "normal"
			};
			var V = bd(x, w.lineBreak), U = V[0], W = V[1], G = V[2];
			(w.wordBreak === "break-all" || w.wordBreak === "break-word") && (W = W.map(function(x) {
				return [
					Uu,
					Ju,
					od
				].indexOf(x) === -1 ? x : td;
			}));
			var K = w.wordBreak === "keep-all" ? G.map(function(w, V) {
				return w && x[V] >= 19968 && x[V] <= 40959;
			}) : void 0;
			return [
				U,
				W,
				K
			];
		}, Td = function() {
			function x(x, w, V, U) {
				this.codePoints = x, this.required = w === ld, this.start = V, this.end = U;
			}
			return x.prototype.slice = function() {
				return $.apply(void 0, this.codePoints.slice(this.start, this.end));
			}, x;
		}(), Ed = function(x, w) {
			var V = Z(x), U = wd(V, w), W = U[0], G = U[1], K = U[2], J = V.length, Y = 0, $ = 0;
			return { next: function() {
				if ($ >= J) return {
					done: !0,
					value: null
				};
				for (var x = ud; $ < J && (x = Cd(V, G, W, ++$, K)) === ud;);
				if (x !== ud || $ === J) {
					var w = new Td(V, x, Y, $);
					return Y = $, {
						value: w,
						done: !1
					};
				}
				return {
					done: !0,
					value: null
				};
			} };
		}, Dd = 1, Od = 2, kd = 4, Ad = 8, jd = 10, Md = 47, Nd = 92, Pd = 9, Fd = 32, Id = 34, Ld = 61, Rd = 35, zd = 36, Bd = 37, Vd = 39, Hd = 40, Ud = 41, Wd = 95, Gd = 45, Kd = 33, qd = 60, Jd = 62, Yd = 64, Xd = 91, Zd = 93, Qd = 61, $d = 123, ef = 63, tf = 125, nf = 124, rf = 126, af = 128, of = 65533, sf = 42, cf = 43, lf = 44, uf = 58, df = 59, ff = 46, pf = 0, mf = 8, hf = 11, gf = 14, _f = 31, vf = 127, yf = -1, bf = 48, xf = 97, Sf = 101, Cf = 102, wf = 117, Tf = 122, Ef = 65, Df = 69, Of = 70, kf = 85, Af = 90, jf = function(x) {
			return x >= bf && x <= 57;
		}, Mf = function(x) {
			return x >= 55296 && x <= 57343;
		}, Nf = function(x) {
			return jf(x) || x >= Ef && x <= Of || x >= xf && x <= Cf;
		}, Pf = function(x) {
			return x >= xf && x <= Tf;
		}, Ff = function(x) {
			return x >= Ef && x <= Af;
		}, If = function(x) {
			return Pf(x) || Ff(x);
		}, Lf = function(x) {
			return x >= af;
		}, Rf = function(x) {
			return x === jd || x === Pd || x === Fd;
		}, zf = function(x) {
			return If(x) || Lf(x) || x === Wd;
		}, Bf = function(x) {
			return zf(x) || jf(x) || x === Gd;
		}, Vf = function(x) {
			return x >= pf && x <= mf || x === hf || x >= gf && x <= _f || x === vf;
		}, Hf = function(x, w) {
			return x === Nd ? w !== jd : !1;
		}, Uf = function(x, w, V) {
			return x === Gd ? zf(w) || Hf(w, V) : zf(x) ? !0 : !!(x === Nd && Hf(x, w));
		}, Wf = function(x, w, V) {
			return x === cf || x === Gd ? jf(w) ? !0 : w === ff && jf(V) : jf(x === ff ? w : x);
		}, Gf = function(x) {
			var w = 0, V = 1;
			(x[w] === cf || x[w] === Gd) && (x[w] === Gd && (V = -1), w++);
			for (var U = []; jf(x[w]);) U.push(x[w++]);
			var W = U.length ? parseInt($.apply(void 0, U), 10) : 0;
			x[w] === ff && w++;
			for (var G = []; jf(x[w]);) G.push(x[w++]);
			var K = G.length, J = K ? parseInt($.apply(void 0, G), 10) : 0;
			(x[w] === Df || x[w] === Sf) && w++;
			var Y = 1;
			(x[w] === cf || x[w] === Gd) && (x[w] === Gd && (Y = -1), w++);
			for (var Z = []; jf(x[w]);) Z.push(x[w++]);
			var ql = Z.length ? parseInt($.apply(void 0, Z), 10) : 0;
			return V * (W + J * 10 ** -K) * 10 ** (Y * ql);
		}, Kf = { type: 2 }, qf = { type: 3 }, Jf = { type: 4 }, Yf = { type: 13 }, Xf = { type: 8 }, Zf = { type: 21 }, Qf = { type: 9 }, $f = { type: 10 }, ep = { type: 11 }, tp = { type: 12 }, np = { type: 14 }, rp = { type: 23 }, ip = { type: 1 }, ap = { type: 25 }, op = { type: 24 }, sp = { type: 26 }, cp = { type: 27 }, lp = { type: 28 }, up = { type: 29 }, dp = { type: 31 }, fp = { type: 32 }, pp = function() {
			function x() {
				this._value = [];
			}
			return x.prototype.write = function(x) {
				this._value = this._value.concat(Z(x));
			}, x.prototype.read = function() {
				for (var x = [], w = this.consumeToken(); w !== fp;) x.push(w), w = this.consumeToken();
				return x;
			}, x.prototype.consumeToken = function() {
				var x = this.consumeCodePoint();
				switch (x) {
					case Id: return this.consumeStringToken(Id);
					case Rd:
						var w = this.peekCodePoint(0), V = this.peekCodePoint(1), U = this.peekCodePoint(2);
						if (Bf(w) || Hf(V, U)) {
							var W = Uf(w, V, U) ? Od : Dd, G = this.consumeName();
							return {
								type: 5,
								value: G,
								flags: W
							};
						}
						break;
					case zd:
						if (this.peekCodePoint(0) === Ld) return this.consumeCodePoint(), Yf;
						break;
					case Vd: return this.consumeStringToken(Vd);
					case Hd: return Kf;
					case Ud: return qf;
					case sf:
						if (this.peekCodePoint(0) === Ld) return this.consumeCodePoint(), np;
						break;
					case cf:
						if (Wf(x, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(x), this.consumeNumericToken();
						break;
					case lf: return Jf;
					case Gd:
						var K = x, J = this.peekCodePoint(0), Y = this.peekCodePoint(1);
						if (Wf(K, J, Y)) return this.reconsumeCodePoint(x), this.consumeNumericToken();
						if (Uf(K, J, Y)) return this.reconsumeCodePoint(x), this.consumeIdentLikeToken();
						if (J === Gd && Y === Jd) return this.consumeCodePoint(), this.consumeCodePoint(), op;
						break;
					case ff:
						if (Wf(x, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(x), this.consumeNumericToken();
						break;
					case Md:
						if (this.peekCodePoint(0) === sf) for (this.consumeCodePoint();;) {
							var Z = this.consumeCodePoint();
							if (Z === sf && (Z = this.consumeCodePoint(), Z === Md) || Z === yf) return this.consumeToken();
						}
						break;
					case uf: return sp;
					case df: return cp;
					case qd:
						if (this.peekCodePoint(0) === Kd && this.peekCodePoint(1) === Gd && this.peekCodePoint(2) === Gd) return this.consumeCodePoint(), this.consumeCodePoint(), ap;
						break;
					case Yd:
						if (Uf(this.peekCodePoint(0), this.peekCodePoint(1), this.peekCodePoint(2))) {
							var G = this.consumeName();
							return {
								type: 7,
								value: G
							};
						}
						break;
					case Xd: return lp;
					case Nd:
						if (Hf(x, this.peekCodePoint(0))) return this.reconsumeCodePoint(x), this.consumeIdentLikeToken();
						break;
					case Zd: return up;
					case Qd:
						if (this.peekCodePoint(0) === Ld) return this.consumeCodePoint(), Xf;
						break;
					case $d: return ep;
					case tf: return tp;
					case wf:
					case kf:
						var ql = this.peekCodePoint(0), Jl = this.peekCodePoint(1);
						return ql === cf && (Nf(Jl) || Jl === ef) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(x), this.consumeIdentLikeToken();
					case nf:
						if (this.peekCodePoint(0) === Ld) return this.consumeCodePoint(), Qf;
						if (this.peekCodePoint(0) === nf) return this.consumeCodePoint(), Zf;
						break;
					case rf:
						if (this.peekCodePoint(0) === Ld) return this.consumeCodePoint(), $f;
						break;
					case yf: return fp;
				}
				return Rf(x) ? (this.consumeWhiteSpace(), dp) : jf(x) ? (this.reconsumeCodePoint(x), this.consumeNumericToken()) : zf(x) ? (this.reconsumeCodePoint(x), this.consumeIdentLikeToken()) : {
					type: 6,
					value: $(x)
				};
			}, x.prototype.consumeCodePoint = function() {
				var x = this._value.shift();
				return x === void 0 ? -1 : x;
			}, x.prototype.reconsumeCodePoint = function(x) {
				this._value.unshift(x);
			}, x.prototype.peekCodePoint = function(x) {
				return x >= this._value.length ? -1 : this._value[x];
			}, x.prototype.consumeUnicodeRangeToken = function() {
				for (var x = [], w = this.consumeCodePoint(); Nf(w) && x.length < 6;) x.push(w), w = this.consumeCodePoint();
				for (var V = !1; w === ef && x.length < 6;) x.push(w), w = this.consumeCodePoint(), V = !0;
				if (V) {
					var U = parseInt($.apply(void 0, x.map(function(x) {
						return x === ef ? bf : x;
					})), 16), W = parseInt($.apply(void 0, x.map(function(x) {
						return x === ef ? Of : x;
					})), 16);
					return {
						type: 30,
						start: U,
						end: W
					};
				}
				var G = parseInt($.apply(void 0, x), 16);
				if (this.peekCodePoint(0) === Gd && Nf(this.peekCodePoint(1))) {
					this.consumeCodePoint(), w = this.consumeCodePoint();
					for (var K = []; Nf(w) && K.length < 6;) K.push(w), w = this.consumeCodePoint();
					var W = parseInt($.apply(void 0, K), 16);
					return {
						type: 30,
						start: G,
						end: W
					};
				} else return {
					type: 30,
					start: G,
					end: G
				};
			}, x.prototype.consumeIdentLikeToken = function() {
				var x = this.consumeName();
				return x.toLowerCase() === "url" && this.peekCodePoint(0) === Hd ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === Hd ? (this.consumeCodePoint(), {
					type: 19,
					value: x
				}) : {
					type: 20,
					value: x
				};
			}, x.prototype.consumeUrlToken = function() {
				var x = [];
				if (this.consumeWhiteSpace(), this.peekCodePoint(0) === yf) return {
					type: 22,
					value: ""
				};
				var w = this.peekCodePoint(0);
				if (w === Vd || w === Id) {
					var V = this.consumeStringToken(this.consumeCodePoint());
					return V.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === yf || this.peekCodePoint(0) === Ud) ? (this.consumeCodePoint(), {
						type: 22,
						value: V.value
					}) : (this.consumeBadUrlRemnants(), rp);
				}
				for (;;) {
					var U = this.consumeCodePoint();
					if (U === yf || U === Ud) return {
						type: 22,
						value: $.apply(void 0, x)
					};
					if (Rf(U)) return this.consumeWhiteSpace(), this.peekCodePoint(0) === yf || this.peekCodePoint(0) === Ud ? (this.consumeCodePoint(), {
						type: 22,
						value: $.apply(void 0, x)
					}) : (this.consumeBadUrlRemnants(), rp);
					if (U === Id || U === Vd || U === Hd || Vf(U)) return this.consumeBadUrlRemnants(), rp;
					if (U === Nd) if (Hf(U, this.peekCodePoint(0))) x.push(this.consumeEscapedCodePoint());
					else return this.consumeBadUrlRemnants(), rp;
					else x.push(U);
				}
			}, x.prototype.consumeWhiteSpace = function() {
				for (; Rf(this.peekCodePoint(0));) this.consumeCodePoint();
			}, x.prototype.consumeBadUrlRemnants = function() {
				for (;;) {
					var x = this.consumeCodePoint();
					if (x === Ud || x === yf) return;
					Hf(x, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
				}
			}, x.prototype.consumeStringSlice = function(x) {
				for (var w = 5e4, V = ""; x > 0;) {
					var U = Math.min(w, x);
					V += $.apply(void 0, this._value.splice(0, U)), x -= U;
				}
				return this._value.shift(), V;
			}, x.prototype.consumeStringToken = function(x) {
				var w = "", V = 0;
				do {
					var U = this._value[V];
					if (U === yf || U === void 0 || U === x) return w += this.consumeStringSlice(V), {
						type: 0,
						value: w
					};
					if (U === jd) return this._value.splice(0, V), ip;
					if (U === Nd) {
						var W = this._value[V + 1];
						W !== yf && W !== void 0 && (W === jd ? (w += this.consumeStringSlice(V), V = -1, this._value.shift()) : Hf(U, W) && (w += this.consumeStringSlice(V), w += $(this.consumeEscapedCodePoint()), V = -1));
					}
					V++;
				} while (!0);
			}, x.prototype.consumeNumber = function() {
				var x = [], w = kd, V = this.peekCodePoint(0);
				for ((V === cf || V === Gd) && x.push(this.consumeCodePoint()); jf(this.peekCodePoint(0));) x.push(this.consumeCodePoint());
				V = this.peekCodePoint(0);
				var U = this.peekCodePoint(1);
				if (V === ff && jf(U)) for (x.push(this.consumeCodePoint(), this.consumeCodePoint()), w = Ad; jf(this.peekCodePoint(0));) x.push(this.consumeCodePoint());
				V = this.peekCodePoint(0), U = this.peekCodePoint(1);
				var W = this.peekCodePoint(2);
				if ((V === Df || V === Sf) && ((U === cf || U === Gd) && jf(W) || jf(U))) for (x.push(this.consumeCodePoint(), this.consumeCodePoint()), w = Ad; jf(this.peekCodePoint(0));) x.push(this.consumeCodePoint());
				return [Gf(x), w];
			}, x.prototype.consumeNumericToken = function() {
				var x = this.consumeNumber(), w = x[0], V = x[1], U = this.peekCodePoint(0);
				return Uf(U, this.peekCodePoint(1), this.peekCodePoint(2)) ? {
					type: 15,
					number: w,
					flags: V,
					unit: this.consumeName()
				} : U === Bd ? (this.consumeCodePoint(), {
					type: 16,
					number: w,
					flags: V
				}) : {
					type: 17,
					number: w,
					flags: V
				};
			}, x.prototype.consumeEscapedCodePoint = function() {
				var x = this.consumeCodePoint();
				if (Nf(x)) {
					for (var w = $(x); Nf(this.peekCodePoint(0)) && w.length < 6;) w += $(this.consumeCodePoint());
					Rf(this.peekCodePoint(0)) && this.consumeCodePoint();
					var V = parseInt(w, 16);
					return V === 0 || Mf(V) || V > 1114111 ? of : V;
				}
				return x === yf ? of : x;
			}, x.prototype.consumeName = function() {
				for (var x = "";;) {
					var w = this.consumeCodePoint();
					if (Bf(w)) x += $(w);
					else if (Hf(w, this.peekCodePoint(0))) x += $(this.consumeEscapedCodePoint());
					else return this.reconsumeCodePoint(w), x;
				}
			}, x;
		}(), mp = function() {
			function x(x) {
				this._tokens = x;
			}
			return x.create = function(w) {
				var V = new pp();
				return V.write(w), new x(V.read());
			}, x.parseValue = function(w) {
				return x.create(w).parseComponentValue();
			}, x.parseValues = function(w) {
				return x.create(w).parseComponentValues();
			}, x.prototype.parseComponentValue = function() {
				for (var x = this.consumeToken(); x.type === 31;) x = this.consumeToken();
				if (x.type === 32) throw SyntaxError("Error parsing CSS component value, unexpected EOF");
				this.reconsumeToken(x);
				var w = this.consumeComponentValue();
				do
					x = this.consumeToken();
				while (x.type === 31);
				if (x.type === 32) return w;
				throw SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
			}, x.prototype.parseComponentValues = function() {
				for (var x = [];;) {
					var w = this.consumeComponentValue();
					if (w.type === 32) return x;
					x.push(w), x.push();
				}
			}, x.prototype.consumeComponentValue = function() {
				var x = this.consumeToken();
				switch (x.type) {
					case 11:
					case 28:
					case 2: return this.consumeSimpleBlock(x.type);
					case 19: return this.consumeFunction(x);
				}
				return x;
			}, x.prototype.consumeSimpleBlock = function(x) {
				for (var w = {
					type: x,
					values: []
				}, V = this.consumeToken();;) {
					if (V.type === 32 || Cp(V, x)) return w;
					this.reconsumeToken(V), w.values.push(this.consumeComponentValue()), V = this.consumeToken();
				}
			}, x.prototype.consumeFunction = function(x) {
				for (var w = {
					name: x.value,
					values: [],
					type: 18
				};;) {
					var V = this.consumeToken();
					if (V.type === 32 || V.type === 3) return w;
					this.reconsumeToken(V), w.values.push(this.consumeComponentValue());
				}
			}, x.prototype.consumeToken = function() {
				var x = this._tokens.shift();
				return x === void 0 ? fp : x;
			}, x.prototype.reconsumeToken = function(x) {
				this._tokens.unshift(x);
			}, x;
		}(), hp = function(x) {
			return x.type === 15;
		}, gp = function(x) {
			return x.type === 17;
		}, _p = function(x) {
			return x.type === 20;
		}, vp = function(x) {
			return x.type === 0;
		}, yp = function(x, w) {
			return _p(x) && x.value === w;
		}, bp = function(x) {
			return x.type !== 31;
		}, xp = function(x) {
			return x.type !== 31 && x.type !== 4;
		}, Sp = function(x) {
			var w = [], V = [];
			return x.forEach(function(x) {
				if (x.type === 4) {
					if (V.length === 0) throw Error("Error parsing function args, zero tokens for arg");
					w.push(V), V = [];
					return;
				}
				x.type !== 31 && V.push(x);
			}), V.length && w.push(V), w;
		}, Cp = function(x, w) {
			return w === 11 && x.type === 12 || w === 28 && x.type === 29 ? !0 : w === 2 && x.type === 3;
		}, wp = function(x) {
			return x.type === 17 || x.type === 15;
		}, Tp = function(x) {
			return x.type === 16 || wp(x);
		}, Ep = function(x) {
			return x.length > 1 ? [x[0], x[1]] : [x[0]];
		}, Dp = {
			type: 17,
			number: 0,
			flags: kd
		}, Op = {
			type: 16,
			number: 50,
			flags: kd
		}, kp = {
			type: 16,
			number: 100,
			flags: kd
		}, Ap = function(x, w, V) {
			var U = x[0], W = x[1];
			return [jp(U, w), jp(W === void 0 ? U : W, V)];
		}, jp = function(x, w) {
			if (x.type === 16) return x.number / 100 * w;
			if (hp(x)) switch (x.unit) {
				case "rem":
				case "em": return 16 * x.number;
				case "px":
				default: return x.number;
			}
			return x.number;
		}, Mp = "deg", Np = "grad", Pp = "rad", Fp = "turn", Ip = {
			name: "angle",
			parse: function(x, w) {
				if (w.type === 15) switch (w.unit) {
					case Mp: return Math.PI * w.number / 180;
					case Np: return Math.PI / 200 * w.number;
					case Pp: return w.number;
					case Fp: return Math.PI * 2 * w.number;
				}
				throw Error("Unsupported angle type");
			}
		}, Lp = function(x) {
			return x.type === 15 && (x.unit === Mp || x.unit === Np || x.unit === Pp || x.unit === Fp);
		}, Rp = function(x) {
			switch (x.filter(_p).map(function(x) {
				return x.value;
			}).join(" ")) {
				case "to bottom right":
				case "to right bottom":
				case "left top":
				case "top left": return [Dp, Dp];
				case "to top":
				case "bottom": return zp(0);
				case "to bottom left":
				case "to left bottom":
				case "right top":
				case "top right": return [Dp, kp];
				case "to right":
				case "left": return zp(90);
				case "to top left":
				case "to left top":
				case "right bottom":
				case "bottom right": return [kp, kp];
				case "to bottom":
				case "top": return zp(180);
				case "to top right":
				case "to right top":
				case "left bottom":
				case "bottom left": return [kp, Dp];
				case "to left":
				case "right": return zp(270);
			}
			return 0;
		}, zp = function(x) {
			return Math.PI * x / 180;
		}, Bp = {
			name: "color",
			parse: function(x, w) {
				if (w.type === 18) {
					var V = Jp[w.name];
					if (V === void 0) throw Error("Attempting to parse an unsupported color function \"" + w.name + "\"");
					return V(x, w.values);
				}
				if (w.type === 5) {
					if (w.value.length === 3) {
						var U = w.value.substring(0, 1), W = w.value.substring(1, 2), G = w.value.substring(2, 3);
						return Up(parseInt(U + U, 16), parseInt(W + W, 16), parseInt(G + G, 16), 1);
					}
					if (w.value.length === 4) {
						var U = w.value.substring(0, 1), W = w.value.substring(1, 2), G = w.value.substring(2, 3), K = w.value.substring(3, 4);
						return Up(parseInt(U + U, 16), parseInt(W + W, 16), parseInt(G + G, 16), parseInt(K + K, 16) / 255);
					}
					if (w.value.length === 6) {
						var U = w.value.substring(0, 2), W = w.value.substring(2, 4), G = w.value.substring(4, 6);
						return Up(parseInt(U, 16), parseInt(W, 16), parseInt(G, 16), 1);
					}
					if (w.value.length === 8) {
						var U = w.value.substring(0, 2), W = w.value.substring(2, 4), G = w.value.substring(4, 6), K = w.value.substring(6, 8);
						return Up(parseInt(U, 16), parseInt(W, 16), parseInt(G, 16), parseInt(K, 16) / 255);
					}
				}
				if (w.type === 20) {
					var J = Xp[w.value.toUpperCase()];
					if (J !== void 0) return J;
				}
				return Xp.TRANSPARENT;
			}
		}, Vp = function(x) {
			return (255 & x) == 0;
		}, Hp = function(x) {
			var w = 255 & x, V = 255 & x >> 8, U = 255 & x >> 16, W = 255 & x >> 24;
			return w < 255 ? "rgba(" + W + "," + U + "," + V + "," + w / 255 + ")" : "rgb(" + W + "," + U + "," + V + ")";
		}, Up = function(x, w, V, U) {
			return (x << 24 | w << 16 | V << 8 | Math.round(U * 255) << 0) >>> 0;
		}, Wp = function(x, w) {
			if (x.type === 17) return x.number;
			if (x.type === 16) {
				var V = w === 3 ? 1 : 255;
				return w === 3 ? x.number / 100 * V : Math.round(x.number / 100 * V);
			}
			return 0;
		}, Gp = function(x, w) {
			var V = w.filter(xp);
			if (V.length === 3) {
				var U = V.map(Wp), W = U[0], G = U[1], K = U[2];
				return Up(W, G, K, 1);
			}
			if (V.length === 4) {
				var J = V.map(Wp), W = J[0], G = J[1], K = J[2], Y = J[3];
				return Up(W, G, K, Y);
			}
			return 0;
		};
		function Kp(x, w, V) {
			return V < 0 && (V += 1), V >= 1 && --V, V < 1 / 6 ? (w - x) * V * 6 + x : V < 1 / 2 ? w : V < 2 / 3 ? (w - x) * 6 * (2 / 3 - V) + x : x;
		}
		var qp = function(x, w) {
			var V = w.filter(xp), U = V[0], W = V[1], G = V[2], K = V[3], J = (U.type === 17 ? zp(U.number) : Ip.parse(x, U)) / (Math.PI * 2), Y = Tp(W) ? W.number / 100 : 0, Z = Tp(G) ? G.number / 100 : 0, $ = K !== void 0 && Tp(K) ? jp(K, 1) : 1;
			if (Y === 0) return Up(Z * 255, Z * 255, Z * 255, 1);
			var ql = Z <= .5 ? Z * (Y + 1) : Z + Y - Z * Y, Jl = Z * 2 - ql, Yl = Kp(Jl, ql, J + 1 / 3), Xl = Kp(Jl, ql, J), Zl = Kp(Jl, ql, J - 1 / 3);
			return Up(Yl * 255, Xl * 255, Zl * 255, $);
		}, Jp = {
			hsl: qp,
			hsla: qp,
			rgb: Gp,
			rgba: Gp
		}, Yp = function(x, w) {
			return Bp.parse(x, mp.create(w).parseComponentValue());
		}, Xp = {
			ALICEBLUE: 4042850303,
			ANTIQUEWHITE: 4209760255,
			AQUA: 16777215,
			AQUAMARINE: 2147472639,
			AZURE: 4043309055,
			BEIGE: 4126530815,
			BISQUE: 4293182719,
			BLACK: 255,
			BLANCHEDALMOND: 4293643775,
			BLUE: 65535,
			BLUEVIOLET: 2318131967,
			BROWN: 2771004159,
			BURLYWOOD: 3736635391,
			CADETBLUE: 1604231423,
			CHARTREUSE: 2147418367,
			CHOCOLATE: 3530104575,
			CORAL: 4286533887,
			CORNFLOWERBLUE: 1687547391,
			CORNSILK: 4294499583,
			CRIMSON: 3692313855,
			CYAN: 16777215,
			DARKBLUE: 35839,
			DARKCYAN: 9145343,
			DARKGOLDENROD: 3095837695,
			DARKGRAY: 2846468607,
			DARKGREEN: 6553855,
			DARKGREY: 2846468607,
			DARKKHAKI: 3182914559,
			DARKMAGENTA: 2332068863,
			DARKOLIVEGREEN: 1433087999,
			DARKORANGE: 4287365375,
			DARKORCHID: 2570243327,
			DARKRED: 2332033279,
			DARKSALMON: 3918953215,
			DARKSEAGREEN: 2411499519,
			DARKSLATEBLUE: 1211993087,
			DARKSLATEGRAY: 793726975,
			DARKSLATEGREY: 793726975,
			DARKTURQUOISE: 13554175,
			DARKVIOLET: 2483082239,
			DEEPPINK: 4279538687,
			DEEPSKYBLUE: 12582911,
			DIMGRAY: 1768516095,
			DIMGREY: 1768516095,
			DODGERBLUE: 512819199,
			FIREBRICK: 2988581631,
			FLORALWHITE: 4294635775,
			FORESTGREEN: 579543807,
			FUCHSIA: 4278255615,
			GAINSBORO: 3705462015,
			GHOSTWHITE: 4177068031,
			GOLD: 4292280575,
			GOLDENROD: 3668254975,
			GRAY: 2155905279,
			GREEN: 8388863,
			GREENYELLOW: 2919182335,
			GREY: 2155905279,
			HONEYDEW: 4043305215,
			HOTPINK: 4285117695,
			INDIANRED: 3445382399,
			INDIGO: 1258324735,
			IVORY: 4294963455,
			KHAKI: 4041641215,
			LAVENDER: 3873897215,
			LAVENDERBLUSH: 4293981695,
			LAWNGREEN: 2096890111,
			LEMONCHIFFON: 4294626815,
			LIGHTBLUE: 2916673279,
			LIGHTCORAL: 4034953471,
			LIGHTCYAN: 3774873599,
			LIGHTGOLDENRODYELLOW: 4210742015,
			LIGHTGRAY: 3553874943,
			LIGHTGREEN: 2431553791,
			LIGHTGREY: 3553874943,
			LIGHTPINK: 4290167295,
			LIGHTSALMON: 4288707327,
			LIGHTSEAGREEN: 548580095,
			LIGHTSKYBLUE: 2278488831,
			LIGHTSLATEGRAY: 2005441023,
			LIGHTSLATEGREY: 2005441023,
			LIGHTSTEELBLUE: 2965692159,
			LIGHTYELLOW: 4294959359,
			LIME: 16711935,
			LIMEGREEN: 852308735,
			LINEN: 4210091775,
			MAGENTA: 4278255615,
			MAROON: 2147483903,
			MEDIUMAQUAMARINE: 1724754687,
			MEDIUMBLUE: 52735,
			MEDIUMORCHID: 3126187007,
			MEDIUMPURPLE: 2473647103,
			MEDIUMSEAGREEN: 1018393087,
			MEDIUMSLATEBLUE: 2070474495,
			MEDIUMSPRINGGREEN: 16423679,
			MEDIUMTURQUOISE: 1221709055,
			MEDIUMVIOLETRED: 3340076543,
			MIDNIGHTBLUE: 421097727,
			MINTCREAM: 4127193855,
			MISTYROSE: 4293190143,
			MOCCASIN: 4293178879,
			NAVAJOWHITE: 4292783615,
			NAVY: 33023,
			OLDLACE: 4260751103,
			OLIVE: 2155872511,
			OLIVEDRAB: 1804477439,
			ORANGE: 4289003775,
			ORANGERED: 4282712319,
			ORCHID: 3664828159,
			PALEGOLDENROD: 4008225535,
			PALEGREEN: 2566625535,
			PALETURQUOISE: 2951671551,
			PALEVIOLETRED: 3681588223,
			PAPAYAWHIP: 4293907967,
			PEACHPUFF: 4292524543,
			PERU: 3448061951,
			PINK: 4290825215,
			PLUM: 3718307327,
			POWDERBLUE: 2967529215,
			PURPLE: 2147516671,
			REBECCAPURPLE: 1714657791,
			RED: 4278190335,
			ROSYBROWN: 3163525119,
			ROYALBLUE: 1097458175,
			SADDLEBROWN: 2336560127,
			SALMON: 4202722047,
			SANDYBROWN: 4104413439,
			SEAGREEN: 780883967,
			SEASHELL: 4294307583,
			SIENNA: 2689740287,
			SILVER: 3233857791,
			SKYBLUE: 2278484991,
			SLATEBLUE: 1784335871,
			SLATEGRAY: 1887473919,
			SLATEGREY: 1887473919,
			SNOW: 4294638335,
			SPRINGGREEN: 16744447,
			STEELBLUE: 1182971135,
			TAN: 3535047935,
			TEAL: 8421631,
			THISTLE: 3636451583,
			TOMATO: 4284696575,
			TRANSPARENT: 0,
			TURQUOISE: 1088475391,
			VIOLET: 4001558271,
			WHEAT: 4125012991,
			WHITE: 4294967295,
			WHITESMOKE: 4126537215,
			YELLOW: 4294902015,
			YELLOWGREEN: 2597139199
		}, Zp = {
			name: "background-clip",
			initialValue: "border-box",
			prefix: !1,
			type: 1,
			parse: function(x, w) {
				return w.map(function(x) {
					if (_p(x)) switch (x.value) {
						case "padding-box": return 1;
						case "content-box": return 2;
					}
					return 0;
				});
			}
		}, Qp = {
			name: "background-color",
			initialValue: "transparent",
			prefix: !1,
			type: 3,
			format: "color"
		}, $p = function(x, w) {
			var V = Bp.parse(x, w[0]), U = w[1];
			return U && Tp(U) ? {
				color: V,
				stop: U
			} : {
				color: V,
				stop: null
			};
		}, em = function(x, w) {
			var V = x[0], U = x[x.length - 1];
			V.stop === null && (V.stop = Dp), U.stop === null && (U.stop = kp);
			for (var W = [], G = 0, K = 0; K < x.length; K++) {
				var J = x[K].stop;
				if (J !== null) {
					var Y = jp(J, w);
					Y > G ? W.push(Y) : W.push(G), G = Y;
				} else W.push(null);
			}
			for (var Z = null, K = 0; K < W.length; K++) {
				var $ = W[K];
				if ($ === null) Z === null && (Z = K);
				else if (Z !== null) {
					for (var ql = K - Z, Jl = ($ - W[Z - 1]) / (ql + 1), Yl = 1; Yl <= ql; Yl++) W[Z + Yl - 1] = Jl * Yl;
					Z = null;
				}
			}
			return x.map(function(x, V) {
				return {
					color: x.color,
					stop: Math.max(Math.min(1, W[V] / w), 0)
				};
			});
		}, tm = function(x, w, V) {
			var U = w / 2, W = V / 2, G = jp(x[0], w) - U, K = W - jp(x[1], V);
			return (Math.atan2(K, G) + Math.PI * 2) % (Math.PI * 2);
		}, nm = function(x, w, V) {
			var U = typeof x == "number" ? x : tm(x, w, V), W = Math.abs(w * Math.sin(U)) + Math.abs(V * Math.cos(U)), G = w / 2, K = V / 2, J = W / 2, Y = Math.sin(U - Math.PI / 2) * J, Z = Math.cos(U - Math.PI / 2) * J;
			return [
				W,
				G - Z,
				G + Z,
				K - Y,
				K + Y
			];
		}, rm = function(x, w) {
			return Math.sqrt(x * x + w * w);
		}, im = function(x, w, V, U, W) {
			return [
				[0, 0],
				[0, w],
				[x, 0],
				[x, w]
			].reduce(function(x, w) {
				var G = w[0], K = w[1], J = rm(V - G, U - K);
				return (W ? J < x.optimumDistance : J > x.optimumDistance) ? {
					optimumCorner: w,
					optimumDistance: J
				} : x;
			}, {
				optimumDistance: W ? Infinity : -Infinity,
				optimumCorner: null
			}).optimumCorner;
		}, am = function(x, w, V, U, W) {
			var G = 0, K = 0;
			switch (x.size) {
				case 0:
					x.shape === 0 ? G = K = Math.min(Math.abs(w), Math.abs(w - U), Math.abs(V), Math.abs(V - W)) : x.shape === 1 && (G = Math.min(Math.abs(w), Math.abs(w - U)), K = Math.min(Math.abs(V), Math.abs(V - W)));
					break;
				case 2:
					if (x.shape === 0) G = K = Math.min(rm(w, V), rm(w, V - W), rm(w - U, V), rm(w - U, V - W));
					else if (x.shape === 1) {
						var J = Math.min(Math.abs(V), Math.abs(V - W)) / Math.min(Math.abs(w), Math.abs(w - U)), Y = im(U, W, w, V, !0), Z = Y[0], $ = Y[1];
						G = rm(Z - w, ($ - V) / J), K = J * G;
					}
					break;
				case 1:
					x.shape === 0 ? G = K = Math.max(Math.abs(w), Math.abs(w - U), Math.abs(V), Math.abs(V - W)) : x.shape === 1 && (G = Math.max(Math.abs(w), Math.abs(w - U)), K = Math.max(Math.abs(V), Math.abs(V - W)));
					break;
				case 3:
					if (x.shape === 0) G = K = Math.max(rm(w, V), rm(w, V - W), rm(w - U, V), rm(w - U, V - W));
					else if (x.shape === 1) {
						var J = Math.max(Math.abs(V), Math.abs(V - W)) / Math.max(Math.abs(w), Math.abs(w - U)), ql = im(U, W, w, V, !1), Z = ql[0], $ = ql[1];
						G = rm(Z - w, ($ - V) / J), K = J * G;
					}
					break;
			}
			return Array.isArray(x.size) && (G = jp(x.size[0], U), K = x.size.length === 2 ? jp(x.size[1], W) : G), [G, K];
		}, om = function(x, w) {
			var V = zp(180), U = [];
			return Sp(w).forEach(function(w, W) {
				if (W === 0) {
					var G = w[0];
					if (G.type === 20 && G.value === "to") {
						V = Rp(w);
						return;
					} else if (Lp(G)) {
						V = Ip.parse(x, G);
						return;
					}
				}
				var K = $p(x, w);
				U.push(K);
			}), {
				angle: V,
				stops: U,
				type: 1
			};
		}, sm = function(x, w) {
			var V = zp(180), U = [];
			return Sp(w).forEach(function(w, W) {
				if (W === 0) {
					var G = w[0];
					if (G.type === 20 && [
						"top",
						"left",
						"right",
						"bottom"
					].indexOf(G.value) !== -1) {
						V = Rp(w);
						return;
					} else if (Lp(G)) {
						V = (Ip.parse(x, G) + zp(270)) % zp(360);
						return;
					}
				}
				var K = $p(x, w);
				U.push(K);
			}), {
				angle: V,
				stops: U,
				type: 1
			};
		}, cm = function(x, w) {
			var V = zp(180), U = [], W = 1;
			return Sp(w).forEach(function(w, V) {
				var G = w[0];
				if (V === 0) {
					if (_p(G) && G.value === "linear") {
						W = 1;
						return;
					} else if (_p(G) && G.value === "radial") {
						W = 2;
						return;
					}
				}
				if (G.type === 18) {
					if (G.name === "from") {
						var K = Bp.parse(x, G.values[0]);
						U.push({
							stop: Dp,
							color: K
						});
					} else if (G.name === "to") {
						var K = Bp.parse(x, G.values[0]);
						U.push({
							stop: kp,
							color: K
						});
					} else if (G.name === "color-stop") {
						var J = G.values.filter(xp);
						if (J.length === 2) {
							var K = Bp.parse(x, J[1]), Y = J[0];
							gp(Y) && U.push({
								stop: {
									type: 16,
									number: Y.number * 100,
									flags: Y.flags
								},
								color: K
							});
						}
					}
				}
			}), W === 1 ? {
				angle: (V + zp(180)) % zp(360),
				stops: U,
				type: W
			} : {
				size: 3,
				shape: 0,
				stops: U,
				position: [],
				type: W
			};
		}, lm = "closest-side", um = "farthest-side", dm = "closest-corner", fm = "farthest-corner", pm = "circle", mm = "ellipse", hm = "cover", gm = "contain", _m = function(x, w) {
			var V = 0, U = 3, W = [], G = [];
			return Sp(w).forEach(function(w, K) {
				var J = !0;
				if (K === 0) {
					var Y = !1;
					J = w.reduce(function(x, w) {
						if (Y) if (_p(w)) switch (w.value) {
							case "center": return G.push(Op), x;
							case "top":
							case "left": return G.push(Dp), x;
							case "right":
							case "bottom": return G.push(kp), x;
						}
						else (Tp(w) || wp(w)) && G.push(w);
						else if (_p(w)) switch (w.value) {
							case pm: return V = 0, !1;
							case mm: return V = 1, !1;
							case "at": return Y = !0, !1;
							case lm: return U = 0, !1;
							case hm:
							case um: return U = 1, !1;
							case gm:
							case dm: return U = 2, !1;
							case fm: return U = 3, !1;
						}
						else if (wp(w) || Tp(w)) return Array.isArray(U) || (U = []), U.push(w), !1;
						return x;
					}, J);
				}
				if (J) {
					var Z = $p(x, w);
					W.push(Z);
				}
			}), {
				size: U,
				shape: V,
				stops: W,
				position: G,
				type: 2
			};
		}, vm = function(x, w) {
			var V = 0, U = 3, W = [], G = [];
			return Sp(w).forEach(function(w, K) {
				var J = !0;
				if (K === 0 ? J = w.reduce(function(x, w) {
					if (_p(w)) switch (w.value) {
						case "center": return G.push(Op), !1;
						case "top":
						case "left": return G.push(Dp), !1;
						case "right":
						case "bottom": return G.push(kp), !1;
					}
					else if (Tp(w) || wp(w)) return G.push(w), !1;
					return x;
				}, J) : K === 1 && (J = w.reduce(function(x, w) {
					if (_p(w)) switch (w.value) {
						case pm: return V = 0, !1;
						case mm: return V = 1, !1;
						case gm:
						case lm: return U = 0, !1;
						case um: return U = 1, !1;
						case dm: return U = 2, !1;
						case hm:
						case fm: return U = 3, !1;
					}
					else if (wp(w) || Tp(w)) return Array.isArray(U) || (U = []), U.push(w), !1;
					return x;
				}, J)), J) {
					var Y = $p(x, w);
					W.push(Y);
				}
			}), {
				size: U,
				shape: V,
				stops: W,
				position: G,
				type: 2
			};
		}, ym = function(x) {
			return x.type === 1;
		}, bm = function(x) {
			return x.type === 2;
		}, xm = {
			name: "image",
			parse: function(x, w) {
				if (w.type === 22) {
					var V = {
						url: w.value,
						type: 0
					};
					return x.cache.addImage(w.value), V;
				}
				if (w.type === 18) {
					var U = Cm[w.name];
					if (U === void 0) throw Error("Attempting to parse an unsupported image function \"" + w.name + "\"");
					return U(x, w.values);
				}
				throw Error("Unsupported image type " + w.type);
			}
		};
		function Sm(x) {
			return !(x.type === 20 && x.value === "none") && (x.type !== 18 || !!Cm[x.name]);
		}
		var Cm = {
			"linear-gradient": om,
			"-moz-linear-gradient": sm,
			"-ms-linear-gradient": sm,
			"-o-linear-gradient": sm,
			"-webkit-linear-gradient": sm,
			"radial-gradient": _m,
			"-moz-radial-gradient": vm,
			"-ms-radial-gradient": vm,
			"-o-radial-gradient": vm,
			"-webkit-radial-gradient": vm,
			"-webkit-gradient": cm
		}, wm = {
			name: "background-image",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(x, w) {
				if (w.length === 0) return [];
				var V = w[0];
				return V.type === 20 && V.value === "none" ? [] : w.filter(function(x) {
					return xp(x) && Sm(x);
				}).map(function(w) {
					return xm.parse(x, w);
				});
			}
		}, Tm = {
			name: "background-origin",
			initialValue: "border-box",
			prefix: !1,
			type: 1,
			parse: function(x, w) {
				return w.map(function(x) {
					if (_p(x)) switch (x.value) {
						case "padding-box": return 1;
						case "content-box": return 2;
					}
					return 0;
				});
			}
		}, Em = {
			name: "background-position",
			initialValue: "0% 0%",
			type: 1,
			prefix: !1,
			parse: function(x, w) {
				return Sp(w).map(function(x) {
					return x.filter(Tp);
				}).map(Ep);
			}
		}, Dm = {
			name: "background-repeat",
			initialValue: "repeat",
			prefix: !1,
			type: 1,
			parse: function(x, w) {
				return Sp(w).map(function(x) {
					return x.filter(_p).map(function(x) {
						return x.value;
					}).join(" ");
				}).map(Om);
			}
		}, Om = function(x) {
			switch (x) {
				case "no-repeat": return 1;
				case "repeat-x":
				case "repeat no-repeat": return 2;
				case "repeat-y":
				case "no-repeat repeat": return 3;
				case "repeat":
				default: return 0;
			}
		}, km;
		(function(x) {
			x.AUTO = "auto", x.CONTAIN = "contain", x.COVER = "cover";
		})(km ||= {});
		var Am = {
			name: "background-size",
			initialValue: "0",
			prefix: !1,
			type: 1,
			parse: function(x, w) {
				return Sp(w).map(function(x) {
					return x.filter(jm);
				});
			}
		}, jm = function(x) {
			return _p(x) || Tp(x);
		}, Mm = function(x) {
			return {
				name: "border-" + x + "-color",
				initialValue: "transparent",
				prefix: !1,
				type: 3,
				format: "color"
			};
		}, Nm = Mm("top"), Pm = Mm("right"), Fm = Mm("bottom"), Im = Mm("left"), Lm = function(x) {
			return {
				name: "border-radius-" + x,
				initialValue: "0 0",
				prefix: !1,
				type: 1,
				parse: function(x, w) {
					return Ep(w.filter(Tp));
				}
			};
		}, Rm = Lm("top-left"), zm = Lm("top-right"), Bm = Lm("bottom-right"), Vm = Lm("bottom-left"), Hm = function(x) {
			return {
				name: "border-" + x + "-style",
				initialValue: "solid",
				prefix: !1,
				type: 2,
				parse: function(x, w) {
					switch (w) {
						case "none": return 0;
						case "dashed": return 2;
						case "dotted": return 3;
						case "double": return 4;
					}
					return 1;
				}
			};
		}, Um = Hm("top"), Wm = Hm("right"), Gm = Hm("bottom"), Km = Hm("left"), qm = function(x) {
			return {
				name: "border-" + x + "-width",
				initialValue: "0",
				type: 0,
				prefix: !1,
				parse: function(x, w) {
					return hp(w) ? w.number : 0;
				}
			};
		}, Jm = qm("top"), Ym = qm("right"), Xm = qm("bottom"), Zm = qm("left"), Qm = {
			name: "color",
			initialValue: "transparent",
			prefix: !1,
			type: 3,
			format: "color"
		}, $m = {
			name: "direction",
			initialValue: "ltr",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "rtl": return 1;
					case "ltr":
					default: return 0;
				}
			}
		}, eh = {
			name: "display",
			initialValue: "inline-block",
			prefix: !1,
			type: 1,
			parse: function(x, w) {
				return w.filter(_p).reduce(function(x, w) {
					return x | th(w.value);
				}, 0);
			}
		}, th = function(x) {
			switch (x) {
				case "block":
				case "-webkit-box": return 2;
				case "inline": return 4;
				case "run-in": return 8;
				case "flow": return 16;
				case "flow-root": return 32;
				case "table": return 64;
				case "flex":
				case "-webkit-flex": return 128;
				case "grid":
				case "-ms-grid": return 256;
				case "ruby": return 512;
				case "subgrid": return 1024;
				case "list-item": return 2048;
				case "table-row-group": return 4096;
				case "table-header-group": return 8192;
				case "table-footer-group": return 16384;
				case "table-row": return 32768;
				case "table-cell": return 65536;
				case "table-column-group": return 131072;
				case "table-column": return 262144;
				case "table-caption": return 524288;
				case "ruby-base": return 1048576;
				case "ruby-text": return 2097152;
				case "ruby-base-container": return 4194304;
				case "ruby-text-container": return 8388608;
				case "contents": return 16777216;
				case "inline-block": return 33554432;
				case "inline-list-item": return 67108864;
				case "inline-table": return 134217728;
				case "inline-flex": return 268435456;
				case "inline-grid": return 536870912;
			}
			return 0;
		}, nh = {
			name: "float",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "left": return 1;
					case "right": return 2;
					case "inline-start": return 3;
					case "inline-end": return 4;
				}
				return 0;
			}
		}, rh = {
			name: "letter-spacing",
			initialValue: "0",
			prefix: !1,
			type: 0,
			parse: function(x, w) {
				return w.type === 20 && w.value === "normal" ? 0 : w.type === 17 || w.type === 15 ? w.number : 0;
			}
		}, ih;
		(function(x) {
			x.NORMAL = "normal", x.STRICT = "strict";
		})(ih ||= {});
		var ah = {
			name: "line-break",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "strict": return ih.STRICT;
					case "normal":
					default: return ih.NORMAL;
				}
			}
		}, oh = {
			name: "line-height",
			initialValue: "normal",
			prefix: !1,
			type: 4
		}, sh = function(x, w) {
			return _p(x) && x.value === "normal" ? 1.2 * w : x.type === 17 ? w * x.number : Tp(x) ? jp(x, w) : w;
		}, ch = {
			name: "list-style-image",
			initialValue: "none",
			type: 0,
			prefix: !1,
			parse: function(x, w) {
				return w.type === 20 && w.value === "none" ? null : xm.parse(x, w);
			}
		}, lh = {
			name: "list-style-position",
			initialValue: "outside",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "inside": return 0;
					case "outside":
					default: return 1;
				}
			}
		}, uh = {
			name: "list-style-type",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "disc": return 0;
					case "circle": return 1;
					case "square": return 2;
					case "decimal": return 3;
					case "cjk-decimal": return 4;
					case "decimal-leading-zero": return 5;
					case "lower-roman": return 6;
					case "upper-roman": return 7;
					case "lower-greek": return 8;
					case "lower-alpha": return 9;
					case "upper-alpha": return 10;
					case "arabic-indic": return 11;
					case "armenian": return 12;
					case "bengali": return 13;
					case "cambodian": return 14;
					case "cjk-earthly-branch": return 15;
					case "cjk-heavenly-stem": return 16;
					case "cjk-ideographic": return 17;
					case "devanagari": return 18;
					case "ethiopic-numeric": return 19;
					case "georgian": return 20;
					case "gujarati": return 21;
					case "gurmukhi": return 22;
					case "hebrew": return 22;
					case "hiragana": return 23;
					case "hiragana-iroha": return 24;
					case "japanese-formal": return 25;
					case "japanese-informal": return 26;
					case "kannada": return 27;
					case "katakana": return 28;
					case "katakana-iroha": return 29;
					case "khmer": return 30;
					case "korean-hangul-formal": return 31;
					case "korean-hanja-formal": return 32;
					case "korean-hanja-informal": return 33;
					case "lao": return 34;
					case "lower-armenian": return 35;
					case "malayalam": return 36;
					case "mongolian": return 37;
					case "myanmar": return 38;
					case "oriya": return 39;
					case "persian": return 40;
					case "simp-chinese-formal": return 41;
					case "simp-chinese-informal": return 42;
					case "tamil": return 43;
					case "telugu": return 44;
					case "thai": return 45;
					case "tibetan": return 46;
					case "trad-chinese-formal": return 47;
					case "trad-chinese-informal": return 48;
					case "upper-armenian": return 49;
					case "disclosure-open": return 50;
					case "disclosure-closed": return 51;
					case "none":
					default: return -1;
				}
			}
		}, dh = function(x) {
			return {
				name: "margin-" + x,
				initialValue: "0",
				prefix: !1,
				type: 4
			};
		}, fh = dh("top"), ph = dh("right"), mh = dh("bottom"), hh = dh("left"), gh = {
			name: "overflow",
			initialValue: "visible",
			prefix: !1,
			type: 1,
			parse: function(x, w) {
				return w.filter(_p).map(function(x) {
					switch (x.value) {
						case "hidden": return 1;
						case "scroll": return 2;
						case "clip": return 3;
						case "auto": return 4;
						case "visible":
						default: return 0;
					}
				});
			}
		}, _h = {
			name: "overflow-wrap",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "break-word": return "break-word";
					case "normal":
					default: return "normal";
				}
			}
		}, vh = function(x) {
			return {
				name: "padding-" + x,
				initialValue: "0",
				prefix: !1,
				type: 3,
				format: "length-percentage"
			};
		}, yh = vh("top"), bh = vh("right"), xh = vh("bottom"), Sh = vh("left"), Ch = {
			name: "text-align",
			initialValue: "left",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "right": return 2;
					case "center":
					case "justify": return 1;
					case "left":
					default: return 0;
				}
			}
		}, wh = {
			name: "position",
			initialValue: "static",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "relative": return 1;
					case "absolute": return 2;
					case "fixed": return 3;
					case "sticky": return 4;
				}
				return 0;
			}
		}, Th = {
			name: "text-shadow",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(x, w) {
				return w.length === 1 && yp(w[0], "none") ? [] : Sp(w).map(function(w) {
					for (var V = {
						color: Xp.TRANSPARENT,
						offsetX: Dp,
						offsetY: Dp,
						blur: Dp
					}, U = 0, W = 0; W < w.length; W++) {
						var G = w[W];
						wp(G) ? (U === 0 ? V.offsetX = G : U === 1 ? V.offsetY = G : V.blur = G, U++) : V.color = Bp.parse(x, G);
					}
					return V;
				});
			}
		}, Eh = {
			name: "text-transform",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "uppercase": return 2;
					case "lowercase": return 1;
					case "capitalize": return 3;
				}
				return 0;
			}
		}, Dh = {
			name: "transform",
			initialValue: "none",
			prefix: !0,
			type: 0,
			parse: function(x, w) {
				if (w.type === 20 && w.value === "none") return null;
				if (w.type === 18) {
					var V = Oh[w.name];
					if (V === void 0) throw Error("Attempting to parse an unsupported transform function \"" + w.name + "\"");
					return V(w.values);
				}
				return null;
			}
		}, Oh = {
			matrix: function(x) {
				var w = x.filter(function(x) {
					return x.type === 17;
				}).map(function(x) {
					return x.number;
				});
				return w.length === 6 ? w : null;
			},
			matrix3d: function(x) {
				var w = x.filter(function(x) {
					return x.type === 17;
				}).map(function(x) {
					return x.number;
				}), V = w[0], U = w[1];
				w[2], w[3];
				var W = w[4], G = w[5];
				w[6], w[7], w[8], w[9], w[10], w[11];
				var K = w[12], J = w[13];
				return w[14], w[15], w.length === 16 ? [
					V,
					U,
					W,
					G,
					K,
					J
				] : null;
			}
		}, kh = {
			type: 16,
			number: 50,
			flags: kd
		}, Ah = [kh, kh], jh = {
			name: "transform-origin",
			initialValue: "50% 50%",
			prefix: !0,
			type: 1,
			parse: function(x, w) {
				var V = w.filter(Tp);
				return V.length === 2 ? [V[0], V[1]] : Ah;
			}
		}, Mh = {
			name: "visible",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "hidden": return 1;
					case "collapse": return 2;
					case "visible":
					default: return 0;
				}
			}
		}, Nh;
		(function(x) {
			x.NORMAL = "normal", x.BREAK_ALL = "break-all", x.KEEP_ALL = "keep-all";
		})(Nh ||= {});
		for (var Ph = {
			name: "word-break",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "break-all": return Nh.BREAK_ALL;
					case "keep-all": return Nh.KEEP_ALL;
					case "normal":
					default: return Nh.NORMAL;
				}
			}
		}, Fh = {
			name: "z-index",
			initialValue: "auto",
			prefix: !1,
			type: 0,
			parse: function(x, w) {
				if (w.type === 20) return {
					auto: !0,
					order: 0
				};
				if (gp(w)) return {
					auto: !1,
					order: w.number
				};
				throw Error("Invalid z-index number parsed");
			}
		}, Ih = {
			name: "time",
			parse: function(x, w) {
				if (w.type === 15) switch (w.unit.toLowerCase()) {
					case "s": return 1e3 * w.number;
					case "ms": return w.number;
				}
				throw Error("Unsupported time type");
			}
		}, Lh = {
			name: "opacity",
			initialValue: "1",
			type: 0,
			prefix: !1,
			parse: function(x, w) {
				return gp(w) ? w.number : 1;
			}
		}, Rh = {
			name: "text-decoration-color",
			initialValue: "transparent",
			prefix: !1,
			type: 3,
			format: "color"
		}, zh = {
			name: "text-decoration-line",
			initialValue: "none",
			prefix: !1,
			type: 1,
			parse: function(x, w) {
				return w.filter(_p).map(function(x) {
					switch (x.value) {
						case "underline": return 1;
						case "overline": return 2;
						case "line-through": return 3;
						case "none": return 4;
					}
					return 0;
				}).filter(function(x) {
					return x !== 0;
				});
			}
		}, Bh = {
			name: "font-family",
			initialValue: "",
			prefix: !1,
			type: 1,
			parse: function(x, w) {
				var V = [], U = [];
				return w.forEach(function(x) {
					switch (x.type) {
						case 20:
						case 0:
							V.push(x.value);
							break;
						case 17:
							V.push(x.number.toString());
							break;
						case 4:
							U.push(V.join(" ")), V.length = 0;
							break;
					}
				}), V.length && U.push(V.join(" ")), U.map(function(x) {
					return x.indexOf(" ") === -1 ? x : "'" + x + "'";
				});
			}
		}, Vh = {
			name: "font-size",
			initialValue: "0",
			prefix: !1,
			type: 3,
			format: "length"
		}, Hh = {
			name: "font-weight",
			initialValue: "normal",
			type: 0,
			prefix: !1,
			parse: function(x, w) {
				if (gp(w)) return w.number;
				if (_p(w)) switch (w.value) {
					case "bold": return 700;
					case "normal":
					default: return 400;
				}
				return 400;
			}
		}, Uh = {
			name: "font-variant",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(x, w) {
				return w.filter(_p).map(function(x) {
					return x.value;
				});
			}
		}, Wh = {
			name: "font-style",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(x, w) {
				switch (w) {
					case "oblique": return "oblique";
					case "italic": return "italic";
					case "normal":
					default: return "normal";
				}
			}
		}, Gh = function(x, w) {
			return (x & w) !== 0;
		}, Kh = {
			name: "content",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(x, w) {
				if (w.length === 0) return [];
				var V = w[0];
				return V.type === 20 && V.value === "none" ? [] : w;
			}
		}, qh = {
			name: "counter-increment",
			initialValue: "none",
			prefix: !0,
			type: 1,
			parse: function(x, w) {
				if (w.length === 0) return null;
				var V = w[0];
				if (V.type === 20 && V.value === "none") return null;
				for (var U = [], W = w.filter(bp), G = 0; G < W.length; G++) {
					var K = W[G], J = W[G + 1];
					if (K.type === 20) {
						var Y = J && gp(J) ? J.number : 1;
						U.push({
							counter: K.value,
							increment: Y
						});
					}
				}
				return U;
			}
		}, Jh = {
			name: "counter-reset",
			initialValue: "none",
			prefix: !0,
			type: 1,
			parse: function(x, w) {
				if (w.length === 0) return [];
				for (var V = [], U = w.filter(bp), W = 0; W < U.length; W++) {
					var G = U[W], K = U[W + 1];
					if (_p(G) && G.value !== "none") {
						var J = K && gp(K) ? K.number : 0;
						V.push({
							counter: G.value,
							reset: J
						});
					}
				}
				return V;
			}
		}, Yh = {
			name: "duration",
			initialValue: "0s",
			prefix: !1,
			type: 1,
			parse: function(x, w) {
				return w.filter(hp).map(function(w) {
					return Ih.parse(x, w);
				});
			}
		}, Xh = {
			name: "quotes",
			initialValue: "none",
			prefix: !0,
			type: 1,
			parse: function(x, w) {
				if (w.length === 0) return null;
				var V = w[0];
				if (V.type === 20 && V.value === "none") return null;
				var U = [], W = w.filter(vp);
				if (W.length % 2 != 0) return null;
				for (var G = 0; G < W.length; G += 2) {
					var K = W[G].value, J = W[G + 1].value;
					U.push({
						open: K,
						close: J
					});
				}
				return U;
			}
		}, Zh = function(x, w, V) {
			if (!x) return "";
			var U = x[Math.min(w, x.length - 1)];
			return U ? V ? U.open : U.close : "";
		}, Qh = {
			name: "box-shadow",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(x, w) {
				return w.length === 1 && yp(w[0], "none") ? [] : Sp(w).map(function(w) {
					for (var V = {
						color: 255,
						offsetX: Dp,
						offsetY: Dp,
						blur: Dp,
						spread: Dp,
						inset: !1
					}, U = 0, W = 0; W < w.length; W++) {
						var G = w[W];
						yp(G, "inset") ? V.inset = !0 : wp(G) ? (U === 0 ? V.offsetX = G : U === 1 ? V.offsetY = G : U === 2 ? V.blur = G : V.spread = G, U++) : V.color = Bp.parse(x, G);
					}
					return V;
				});
			}
		}, $h = {
			name: "paint-order",
			initialValue: "normal",
			prefix: !1,
			type: 1,
			parse: function(x, w) {
				var V = [
					0,
					1,
					2
				], U = [];
				return w.filter(_p).forEach(function(x) {
					switch (x.value) {
						case "stroke":
							U.push(1);
							break;
						case "fill":
							U.push(0);
							break;
						case "markers":
							U.push(2);
							break;
					}
				}), V.forEach(function(x) {
					U.indexOf(x) === -1 && U.push(x);
				}), U;
			}
		}, eg = {
			name: "-webkit-text-stroke-color",
			initialValue: "currentcolor",
			prefix: !1,
			type: 3,
			format: "color"
		}, tg = {
			name: "-webkit-text-stroke-width",
			initialValue: "0",
			type: 0,
			prefix: !1,
			parse: function(x, w) {
				return hp(w) ? w.number : 0;
			}
		}, ng = function() {
			function x(x, w) {
				this.animationDuration = ag(x, Yh, w.animationDuration), this.backgroundClip = ag(x, Zp, w.backgroundClip), this.backgroundColor = ag(x, Qp, w.backgroundColor), this.backgroundImage = ag(x, wm, w.backgroundImage), this.backgroundOrigin = ag(x, Tm, w.backgroundOrigin), this.backgroundPosition = ag(x, Em, w.backgroundPosition), this.backgroundRepeat = ag(x, Dm, w.backgroundRepeat), this.backgroundSize = ag(x, Am, w.backgroundSize), this.borderTopColor = ag(x, Nm, w.borderTopColor), this.borderRightColor = ag(x, Pm, w.borderRightColor), this.borderBottomColor = ag(x, Fm, w.borderBottomColor), this.borderLeftColor = ag(x, Im, w.borderLeftColor), this.borderTopLeftRadius = ag(x, Rm, w.borderTopLeftRadius), this.borderTopRightRadius = ag(x, zm, w.borderTopRightRadius), this.borderBottomRightRadius = ag(x, Bm, w.borderBottomRightRadius), this.borderBottomLeftRadius = ag(x, Vm, w.borderBottomLeftRadius), this.borderTopStyle = ag(x, Um, w.borderTopStyle), this.borderRightStyle = ag(x, Wm, w.borderRightStyle), this.borderBottomStyle = ag(x, Gm, w.borderBottomStyle), this.borderLeftStyle = ag(x, Km, w.borderLeftStyle), this.borderTopWidth = ag(x, Jm, w.borderTopWidth), this.borderRightWidth = ag(x, Ym, w.borderRightWidth), this.borderBottomWidth = ag(x, Xm, w.borderBottomWidth), this.borderLeftWidth = ag(x, Zm, w.borderLeftWidth), this.boxShadow = ag(x, Qh, w.boxShadow), this.color = ag(x, Qm, w.color), this.direction = ag(x, $m, w.direction), this.display = ag(x, eh, w.display), this.float = ag(x, nh, w.cssFloat), this.fontFamily = ag(x, Bh, w.fontFamily), this.fontSize = ag(x, Vh, w.fontSize), this.fontStyle = ag(x, Wh, w.fontStyle), this.fontVariant = ag(x, Uh, w.fontVariant), this.fontWeight = ag(x, Hh, w.fontWeight), this.letterSpacing = ag(x, rh, w.letterSpacing), this.lineBreak = ag(x, ah, w.lineBreak), this.lineHeight = ag(x, oh, w.lineHeight), this.listStyleImage = ag(x, ch, w.listStyleImage), this.listStylePosition = ag(x, lh, w.listStylePosition), this.listStyleType = ag(x, uh, w.listStyleType), this.marginTop = ag(x, fh, w.marginTop), this.marginRight = ag(x, ph, w.marginRight), this.marginBottom = ag(x, mh, w.marginBottom), this.marginLeft = ag(x, hh, w.marginLeft), this.opacity = ag(x, Lh, w.opacity);
				var V = ag(x, gh, w.overflow);
				this.overflowX = V[0], this.overflowY = V[V.length > 1 ? 1 : 0], this.overflowWrap = ag(x, _h, w.overflowWrap), this.paddingTop = ag(x, yh, w.paddingTop), this.paddingRight = ag(x, bh, w.paddingRight), this.paddingBottom = ag(x, xh, w.paddingBottom), this.paddingLeft = ag(x, Sh, w.paddingLeft), this.paintOrder = ag(x, $h, w.paintOrder), this.position = ag(x, wh, w.position), this.textAlign = ag(x, Ch, w.textAlign), this.textDecorationColor = ag(x, Rh, w.textDecorationColor ?? w.color), this.textDecorationLine = ag(x, zh, w.textDecorationLine ?? w.textDecoration), this.textShadow = ag(x, Th, w.textShadow), this.textTransform = ag(x, Eh, w.textTransform), this.transform = ag(x, Dh, w.transform), this.transformOrigin = ag(x, jh, w.transformOrigin), this.visibility = ag(x, Mh, w.visibility), this.webkitTextStrokeColor = ag(x, eg, w.webkitTextStrokeColor), this.webkitTextStrokeWidth = ag(x, tg, w.webkitTextStrokeWidth), this.wordBreak = ag(x, Ph, w.wordBreak), this.zIndex = ag(x, Fh, w.zIndex);
			}
			return x.prototype.isVisible = function() {
				return this.display > 0 && this.opacity > 0 && this.visibility === 0;
			}, x.prototype.isTransparent = function() {
				return Vp(this.backgroundColor);
			}, x.prototype.isTransformed = function() {
				return this.transform !== null;
			}, x.prototype.isPositioned = function() {
				return this.position !== 0;
			}, x.prototype.isPositionedWithZIndex = function() {
				return this.isPositioned() && !this.zIndex.auto;
			}, x.prototype.isFloating = function() {
				return this.float !== 0;
			}, x.prototype.isInlineLevel = function() {
				return Gh(this.display, 4) || Gh(this.display, 33554432) || Gh(this.display, 268435456) || Gh(this.display, 536870912) || Gh(this.display, 67108864) || Gh(this.display, 134217728);
			}, x;
		}(), rg = function() {
			function x(x, w) {
				this.content = ag(x, Kh, w.content), this.quotes = ag(x, Xh, w.quotes);
			}
			return x;
		}(), ig = function() {
			function x(x, w) {
				this.counterIncrement = ag(x, qh, w.counterIncrement), this.counterReset = ag(x, Jh, w.counterReset);
			}
			return x;
		}(), ag = function(x, w, V) {
			var U = new pp(), W = V == null ? w.initialValue : V.toString();
			U.write(W);
			var G = new mp(U.read());
			switch (w.type) {
				case 2:
					var K = G.parseComponentValue();
					return w.parse(x, _p(K) ? K.value : w.initialValue);
				case 0: return w.parse(x, G.parseComponentValue());
				case 1: return w.parse(x, G.parseComponentValues());
				case 4: return G.parseComponentValue();
				case 3:
					switch (w.format) {
						case "angle": return Ip.parse(x, G.parseComponentValue());
						case "color": return Bp.parse(x, G.parseComponentValue());
						case "image": return xm.parse(x, G.parseComponentValue());
						case "length":
							var J = G.parseComponentValue();
							return wp(J) ? J : Dp;
						case "length-percentage":
							var Y = G.parseComponentValue();
							return Tp(Y) ? Y : Dp;
						case "time": return Ih.parse(x, G.parseComponentValue());
					}
					break;
			}
		}, og = "data-html2canvas-debug", sg = function(x) {
			switch (x.getAttribute(og)) {
				case "all": return 1;
				case "clone": return 2;
				case "parse": return 3;
				case "render": return 4;
				default: return 0;
			}
		}, cg = function(x, w) {
			var V = sg(x);
			return V === 1 || w === V;
		}, lg = function() {
			function x(x, w) {
				if (this.context = x, this.textNodes = [], this.elements = [], this.flags = 0, cg(w, 3)) debugger;
				this.styles = new ng(x, window.getComputedStyle(w, null)), X_(w) && (this.styles.animationDuration.some(function(x) {
					return x > 0;
				}) && (w.style.animationDuration = "0s"), this.styles.transform !== null && (w.style.transform = "none")), this.bounds = J(this.context, w), cg(w, 4) && (this.flags |= 16);
			}
			return x;
		}(), ug = "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", dg = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", fg = typeof Uint8Array > "u" ? [] : new Uint8Array(256), pg = 0; pg < dg.length; pg++) fg[dg.charCodeAt(pg)] = pg;
		for (var mg = function(x) {
			var w = x.length * .75, V = x.length, U, W = 0, G, K, J, Y;
			x[x.length - 1] === "=" && (w--, x[x.length - 2] === "=" && w--);
			var Z = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && Uint8Array.prototype.slice !== void 0 ? new ArrayBuffer(w) : Array(w), $ = Array.isArray(Z) ? Z : new Uint8Array(Z);
			for (U = 0; U < V; U += 4) G = fg[x.charCodeAt(U)], K = fg[x.charCodeAt(U + 1)], J = fg[x.charCodeAt(U + 2)], Y = fg[x.charCodeAt(U + 3)], $[W++] = G << 2 | K >> 4, $[W++] = (K & 15) << 4 | J >> 2, $[W++] = (J & 3) << 6 | Y & 63;
			return Z;
		}, hg = function(x) {
			for (var w = x.length, V = [], U = 0; U < w; U += 2) V.push(x[U + 1] << 8 | x[U]);
			return V;
		}, gg = function(x) {
			for (var w = x.length, V = [], U = 0; U < w; U += 4) V.push(x[U + 3] << 24 | x[U + 2] << 16 | x[U + 1] << 8 | x[U]);
			return V;
		}, _g = 5, vg = 11, yg = 2, bg = vg - _g, xg = 65536 >> _g, Sg = (1 << _g) - 1, Cg = xg + (1024 >> _g) + 32, wg = 65536 >> vg, Tg = (1 << bg) - 1, Eg = function(x, w, V) {
			return x.slice ? x.slice(w, V) : new Uint16Array(Array.prototype.slice.call(x, w, V));
		}, Dg = function(x, w, V) {
			return x.slice ? x.slice(w, V) : new Uint32Array(Array.prototype.slice.call(x, w, V));
		}, Og = function(x, w) {
			var V = mg(x), U = Array.isArray(V) ? gg(V) : new Uint32Array(V), W = Array.isArray(V) ? hg(V) : new Uint16Array(V), G = 24, K = Eg(W, G / 2, U[4] / 2), J = U[5] === 2 ? Eg(W, (G + U[4]) / 2) : Dg(U, Math.ceil((G + U[4]) / 4));
			return new kg(U[0], U[1], U[2], U[3], K, J);
		}, kg = function() {
			function x(x, w, V, U, W, G) {
				this.initialValue = x, this.errorValue = w, this.highStart = V, this.highValueIndex = U, this.index = W, this.data = G;
			}
			return x.prototype.get = function(x) {
				var w;
				if (x >= 0) {
					if (x < 55296 || x > 56319 && x <= 65535) return w = this.index[x >> _g], w = (w << yg) + (x & Sg), this.data[w];
					if (x <= 65535) return w = this.index[xg + (x - 55296 >> _g)], w = (w << yg) + (x & Sg), this.data[w];
					if (x < this.highStart) return w = Cg - wg + (x >> vg), w = this.index[w], w += x >> _g & Tg, w = this.index[w], w = (w << yg) + (x & Sg), this.data[w];
					if (x <= 1114111) return this.data[this.highValueIndex];
				}
				return this.errorValue;
			}, x;
		}(), Ag = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", jg = typeof Uint8Array > "u" ? [] : new Uint8Array(256), Mg = 0; Mg < Ag.length; Mg++) jg[Ag.charCodeAt(Mg)] = Mg;
		var Ng = 1, Pg = 2, Fg = 3, Ig = 4, Lg = 5, Rg = 7, zg = 8, Bg = 9, Vg = 10, Hg = 11, Ug = 12, Wg = 13, Gg = 14, Kg = 15, qg = function(x) {
			for (var w = [], V = 0, U = x.length; V < U;) {
				var W = x.charCodeAt(V++);
				if (W >= 55296 && W <= 56319 && V < U) {
					var G = x.charCodeAt(V++);
					(G & 64512) == 56320 ? w.push(((W & 1023) << 10) + (G & 1023) + 65536) : (w.push(W), V--);
				} else w.push(W);
			}
			return w;
		}, Jg = function() {
			var x = [...arguments];
			if (String.fromCodePoint) return String.fromCodePoint.apply(String, x);
			var w = x.length;
			if (!w) return "";
			for (var V = [], U = -1, W = ""; ++U < w;) {
				var G = x[U];
				G <= 65535 ? V.push(G) : (G -= 65536, V.push((G >> 10) + 55296, G % 1024 + 56320)), (U + 1 === w || V.length > 16384) && (W += String.fromCharCode.apply(String, V), V.length = 0);
			}
			return W;
		}, Yg = Og(ug), Xg = "×", Zg = "÷", Qg = function(x) {
			return Yg.get(x);
		}, $g = function(x, w, V) {
			var U = V - 2, W = w[U], G = w[V - 1], K = w[V];
			if (G === Pg && K === Fg) return Xg;
			if (G === Pg || G === Fg || G === Ig || K === Pg || K === Fg || K === Ig) return Zg;
			if (G === zg && [
				zg,
				Bg,
				Hg,
				Ug
			].indexOf(K) !== -1 || (G === Hg || G === Bg) && (K === Bg || K === Vg) || (G === Ug || G === Vg) && K === Vg || K === Wg || K === Lg || K === Rg || G === Ng) return Xg;
			if (G === Wg && K === Gg) {
				for (; W === Lg;) W = w[--U];
				if (W === Gg) return Xg;
			}
			if (G === Kg && K === Kg) {
				for (var J = 0; W === Kg;) J++, W = w[--U];
				if (J % 2 == 0) return Xg;
			}
			return Zg;
		}, e_ = function(x) {
			var w = qg(x), V = w.length, U = 0, W = 0, G = w.map(Qg);
			return { next: function() {
				if (U >= V) return {
					done: !0,
					value: null
				};
				for (var x = Xg; U < V && (x = $g(w, G, ++U)) === Xg;);
				if (x !== Xg || U === V) {
					var K = Jg.apply(null, w.slice(W, U));
					return W = U, {
						value: K,
						done: !1
					};
				}
				return {
					done: !0,
					value: null
				};
			} };
		}, t_ = function(x) {
			for (var w = e_(x), V = [], U; !(U = w.next()).done;) U.value && V.push(U.value.slice());
			return V;
		}, n_ = function(x) {
			var w = 123;
			if (x.createRange) {
				var V = x.createRange();
				if (V.getBoundingClientRect) {
					var U = x.createElement("boundtest");
					U.style.height = w + "px", U.style.display = "block", x.body.appendChild(U), V.selectNode(U);
					var W = V.getBoundingClientRect(), G = Math.round(W.height);
					if (x.body.removeChild(U), G === w) return !0;
				}
			}
			return !1;
		}, r_ = function(x) {
			var w = x.createElement("boundtest");
			w.style.width = "50px", w.style.display = "block", w.style.fontSize = "12px", w.style.letterSpacing = "0px", w.style.wordSpacing = "0px", x.body.appendChild(w);
			var V = x.createRange();
			w.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
			var U = w.firstChild, W = Z(U.data).map(function(x) {
				return $(x);
			}), G = 0, K = {}, J = W.every(function(x, w) {
				V.setStart(U, G), V.setEnd(U, G + x.length);
				var W = V.getBoundingClientRect();
				G += x.length;
				var J = W.x > K.x || W.y > K.y;
				return K = W, w === 0 ? !0 : J;
			});
			return x.body.removeChild(w), J;
		}, i_ = function() {
			return new Image().crossOrigin !== void 0;
		}, a_ = function() {
			return typeof new XMLHttpRequest().responseType == "string";
		}, o_ = function(x) {
			var w = new Image(), V = x.createElement("canvas"), U = V.getContext("2d");
			if (!U) return !1;
			w.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
			try {
				U.drawImage(w, 0, 0), V.toDataURL();
			} catch {
				return !1;
			}
			return !0;
		}, s_ = function(x) {
			return x[0] === 0 && x[1] === 255 && x[2] === 0 && x[3] === 255;
		}, c_ = function(x) {
			var w = x.createElement("canvas"), V = 100;
			w.width = V, w.height = V;
			var U = w.getContext("2d");
			if (!U) return Promise.reject(!1);
			U.fillStyle = "rgb(0, 255, 0)", U.fillRect(0, 0, V, V);
			var W = new Image(), G = w.toDataURL();
			W.src = G;
			var K = l_(V, V, 0, 0, W);
			return U.fillStyle = "red", U.fillRect(0, 0, V, V), u_(K).then(function(w) {
				U.drawImage(w, 0, 0);
				var W = U.getImageData(0, 0, V, V).data;
				U.fillStyle = "red", U.fillRect(0, 0, V, V);
				var K = x.createElement("div");
				return K.style.backgroundImage = "url(" + G + ")", K.style.height = V + "px", s_(W) ? u_(l_(V, V, 0, 0, K)) : Promise.reject(!1);
			}).then(function(x) {
				return U.drawImage(x, 0, 0), s_(U.getImageData(0, 0, V, V).data);
			}).catch(function() {
				return !1;
			});
		}, l_ = function(x, w, V, U, W) {
			var G = "http://www.w3.org/2000/svg", K = document.createElementNS(G, "svg"), J = document.createElementNS(G, "foreignObject");
			return K.setAttributeNS(null, "width", x.toString()), K.setAttributeNS(null, "height", w.toString()), J.setAttributeNS(null, "width", "100%"), J.setAttributeNS(null, "height", "100%"), J.setAttributeNS(null, "x", V.toString()), J.setAttributeNS(null, "y", U.toString()), J.setAttributeNS(null, "externalResourcesRequired", "true"), K.appendChild(J), J.appendChild(W), K;
		}, u_ = function(x) {
			return new Promise(function(w, V) {
				var U = new Image();
				U.onload = function() {
					return w(U);
				}, U.onerror = V, U.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(x));
			});
		}, d_ = {
			get SUPPORT_RANGE_BOUNDS() {
				var x = n_(document);
				return Object.defineProperty(d_, "SUPPORT_RANGE_BOUNDS", { value: x }), x;
			},
			get SUPPORT_WORD_BREAKING() {
				var x = d_.SUPPORT_RANGE_BOUNDS && r_(document);
				return Object.defineProperty(d_, "SUPPORT_WORD_BREAKING", { value: x }), x;
			},
			get SUPPORT_SVG_DRAWING() {
				var x = o_(document);
				return Object.defineProperty(d_, "SUPPORT_SVG_DRAWING", { value: x }), x;
			},
			get SUPPORT_FOREIGNOBJECT_DRAWING() {
				var x = typeof Array.from == "function" && typeof window.fetch == "function" ? c_(document) : Promise.resolve(!1);
				return Object.defineProperty(d_, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: x }), x;
			},
			get SUPPORT_CORS_IMAGES() {
				var x = i_();
				return Object.defineProperty(d_, "SUPPORT_CORS_IMAGES", { value: x }), x;
			},
			get SUPPORT_RESPONSE_TYPE() {
				var x = a_();
				return Object.defineProperty(d_, "SUPPORT_RESPONSE_TYPE", { value: x }), x;
			},
			get SUPPORT_CORS_XHR() {
				var x = "withCredentials" in new XMLHttpRequest();
				return Object.defineProperty(d_, "SUPPORT_CORS_XHR", { value: x }), x;
			},
			get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
				var x = !!(typeof Intl < "u" && Intl.Segmenter);
				return Object.defineProperty(d_, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: x }), x;
			}
		}, f_ = function() {
			function x(x, w) {
				this.text = x, this.bounds = w;
			}
			return x;
		}(), p_ = function(x, w, V, U) {
			var W = v_(w, V), G = [], J = 0;
			return W.forEach(function(w) {
				if (V.textDecorationLine.length || w.trim().length > 0) if (d_.SUPPORT_RANGE_BOUNDS) {
					var W = h_(U, J, w.length).getClientRects();
					if (W.length > 1) {
						var Y = g_(w), Z = 0;
						Y.forEach(function(w) {
							G.push(new f_(w, K.fromDOMRectList(x, h_(U, Z + J, w.length).getClientRects()))), Z += w.length;
						});
					} else G.push(new f_(w, K.fromDOMRectList(x, W)));
				} else {
					var $ = U.splitText(w.length);
					G.push(new f_(w, m_(x, U))), U = $;
				}
				else d_.SUPPORT_RANGE_BOUNDS || (U = U.splitText(w.length));
				J += w.length;
			}), G;
		}, m_ = function(x, w) {
			var V = w.ownerDocument;
			if (V) {
				var U = V.createElement("html2canvaswrapper");
				U.appendChild(w.cloneNode(!0));
				var W = w.parentNode;
				if (W) {
					W.replaceChild(U, w);
					var G = J(x, U);
					return U.firstChild && W.replaceChild(U.firstChild, U), G;
				}
			}
			return K.EMPTY;
		}, h_ = function(x, w, V) {
			var U = x.ownerDocument;
			if (!U) throw Error("Node has no owner document");
			var W = U.createRange();
			return W.setStart(x, w), W.setEnd(x, w + V), W;
		}, g_ = function(x) {
			if (d_.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
				var w = new Intl.Segmenter(void 0, { granularity: "grapheme" });
				return Array.from(w.segment(x)).map(function(x) {
					return x.segment;
				});
			}
			return t_(x);
		}, __ = function(x, w) {
			if (d_.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
				var V = new Intl.Segmenter(void 0, { granularity: "word" });
				return Array.from(V.segment(x)).map(function(x) {
					return x.segment;
				});
			}
			return b_(x, w);
		}, v_ = function(x, w) {
			return w.letterSpacing === 0 ? __(x, w) : g_(x);
		}, y_ = [
			32,
			160,
			4961,
			65792,
			65793,
			4153,
			4241
		], b_ = function(x, w) {
			for (var V = Ed(x, {
				lineBreak: w.lineBreak,
				wordBreak: w.overflowWrap === "break-word" ? "break-word" : w.wordBreak
			}), U = [], W, G = function() {
				if (W.value) {
					var x = Z(W.value.slice()), w = "";
					x.forEach(function(x) {
						y_.indexOf(x) === -1 ? w += $(x) : (w.length && U.push(w), U.push($(x)), w = "");
					}), w.length && U.push(w);
				}
			}; !(W = V.next()).done;) G();
			return U;
		}, x_ = function() {
			function x(x, w, V) {
				this.text = S_(w.data, V.textTransform), this.textBounds = p_(x, this.text, V, w);
			}
			return x;
		}(), S_ = function(x, w) {
			switch (w) {
				case 1: return x.toLowerCase();
				case 3: return x.replace(C_, w_);
				case 2: return x.toUpperCase();
				default: return x;
			}
		}, C_ = /(^|\s|:|-|\(|\))([a-z])/g, w_ = function(x, w, V) {
			return x.length > 0 ? w + V.toUpperCase() : x;
		}, T_ = function(x) {
			w(V, x);
			function V(w, V) {
				var U = x.call(this, w, V) || this;
				return U.src = V.currentSrc || V.src, U.intrinsicWidth = V.naturalWidth, U.intrinsicHeight = V.naturalHeight, U.context.cache.addImage(U.src), U;
			}
			return V;
		}(lg), E_ = function(x) {
			w(V, x);
			function V(w, V) {
				var U = x.call(this, w, V) || this;
				return U.canvas = V, U.intrinsicWidth = V.width, U.intrinsicHeight = V.height, U;
			}
			return V;
		}(lg), D_ = function(x) {
			w(V, x);
			function V(w, V) {
				var U = x.call(this, w, V) || this, W = new XMLSerializer(), G = J(w, V);
				return V.setAttribute("width", G.width + "px"), V.setAttribute("height", G.height + "px"), U.svg = "data:image/svg+xml," + encodeURIComponent(W.serializeToString(V)), U.intrinsicWidth = V.width.baseVal.value, U.intrinsicHeight = V.height.baseVal.value, U.context.cache.addImage(U.svg), U;
			}
			return V;
		}(lg), O_ = function(x) {
			w(V, x);
			function V(w, V) {
				var U = x.call(this, w, V) || this;
				return U.value = V.value, U;
			}
			return V;
		}(lg), k_ = function(x) {
			w(V, x);
			function V(w, V) {
				var U = x.call(this, w, V) || this;
				return U.start = V.start, U.reversed = typeof V.reversed == "boolean" && V.reversed === !0, U;
			}
			return V;
		}(lg), A_ = [{
			type: 15,
			flags: 0,
			unit: "px",
			number: 3
		}], j_ = [{
			type: 16,
			flags: 0,
			number: 50
		}], M_ = function(x) {
			return x.width > x.height ? new K(x.left + (x.width - x.height) / 2, x.top, x.height, x.height) : x.width < x.height ? new K(x.left, x.top + (x.height - x.width) / 2, x.width, x.width) : x;
		}, N_ = function(x) {
			var w = x.type === I_ ? Array(x.value.length + 1).join("•") : x.value;
			return w.length === 0 ? x.placeholder || "" : w;
		}, P_ = "checkbox", F_ = "radio", I_ = "password", L_ = 707406591, R_ = function(x) {
			w(V, x);
			function V(w, V) {
				var U = x.call(this, w, V) || this;
				switch (U.type = V.type.toLowerCase(), U.checked = V.checked, U.value = N_(V), (U.type === P_ || U.type === F_) && (U.styles.backgroundColor = 3739148031, U.styles.borderTopColor = U.styles.borderRightColor = U.styles.borderBottomColor = U.styles.borderLeftColor = 2779096575, U.styles.borderTopWidth = U.styles.borderRightWidth = U.styles.borderBottomWidth = U.styles.borderLeftWidth = 1, U.styles.borderTopStyle = U.styles.borderRightStyle = U.styles.borderBottomStyle = U.styles.borderLeftStyle = 1, U.styles.backgroundClip = [0], U.styles.backgroundOrigin = [0], U.bounds = M_(U.bounds)), U.type) {
					case P_:
						U.styles.borderTopRightRadius = U.styles.borderTopLeftRadius = U.styles.borderBottomRightRadius = U.styles.borderBottomLeftRadius = A_;
						break;
					case F_:
						U.styles.borderTopRightRadius = U.styles.borderTopLeftRadius = U.styles.borderBottomRightRadius = U.styles.borderBottomLeftRadius = j_;
						break;
				}
				return U;
			}
			return V;
		}(lg), z_ = function(x) {
			w(V, x);
			function V(w, V) {
				var U = x.call(this, w, V) || this, W = V.options[V.selectedIndex || 0];
				return U.value = W && W.text || "", U;
			}
			return V;
		}(lg), B_ = function(x) {
			w(V, x);
			function V(w, V) {
				var U = x.call(this, w, V) || this;
				return U.value = V.value, U;
			}
			return V;
		}(lg), V_ = function(x) {
			w(V, x);
			function V(w, V) {
				var U = x.call(this, w, V) || this;
				U.src = V.src, U.width = parseInt(V.width, 10) || 0, U.height = parseInt(V.height, 10) || 0, U.backgroundColor = U.styles.backgroundColor;
				try {
					if (V.contentWindow && V.contentWindow.document && V.contentWindow.document.documentElement) {
						U.tree = G_(w, V.contentWindow.document.documentElement);
						var W = V.contentWindow.document.documentElement ? Yp(w, getComputedStyle(V.contentWindow.document.documentElement).backgroundColor) : Xp.TRANSPARENT, G = V.contentWindow.document.body ? Yp(w, getComputedStyle(V.contentWindow.document.body).backgroundColor) : Xp.TRANSPARENT;
						U.backgroundColor = Vp(W) ? Vp(G) ? U.styles.backgroundColor : G : W;
					}
				} catch {}
				return U;
			}
			return V;
		}(lg), H_ = [
			"OL",
			"UL",
			"MENU"
		], U_ = function(x, w, V, U) {
			for (var W = w.firstChild, G = void 0; W; W = G) if (G = W.nextSibling, J_(W) && W.data.trim().length > 0) V.textNodes.push(new x_(x, W, V.styles));
			else if (Y_(W)) if (fv(W) && W.assignedNodes) W.assignedNodes().forEach(function(w) {
				return U_(x, w, V, U);
			});
			else {
				var K = W_(x, W);
				K.styles.isVisible() && (K_(W, K, U) ? K.flags |= 4 : q_(K.styles) && (K.flags |= 2), H_.indexOf(W.tagName) !== -1 && (K.flags |= 8), V.elements.push(K), W.slot, W.shadowRoot ? U_(x, W.shadowRoot, K, U) : !uv(W) && !nv(W) && !dv(W) && U_(x, W, K, U));
			}
		}, W_ = function(x, w) {
			return ov(w) ? new T_(x, w) : iv(w) ? new E_(x, w) : nv(w) ? new D_(x, w) : Q_(w) ? new O_(x, w) : $_(w) ? new k_(x, w) : ev(w) ? new R_(x, w) : dv(w) ? new z_(x, w) : uv(w) ? new B_(x, w) : sv(w) ? new V_(x, w) : new lg(x, w);
		}, G_ = function(x, w) {
			var V = W_(x, w);
			return V.flags |= 4, U_(x, w, V, V), V;
		}, K_ = function(x, w, V) {
			return w.styles.isPositionedWithZIndex() || w.styles.opacity < 1 || w.styles.isTransformed() || rv(x) && V.styles.isTransparent();
		}, q_ = function(x) {
			return x.isPositioned() || x.isFloating();
		}, J_ = function(x) {
			return x.nodeType === Node.TEXT_NODE;
		}, Y_ = function(x) {
			return x.nodeType === Node.ELEMENT_NODE;
		}, X_ = function(x) {
			return Y_(x) && x.style !== void 0 && !Z_(x);
		}, Z_ = function(x) {
			return typeof x.className == "object";
		}, Q_ = function(x) {
			return x.tagName === "LI";
		}, $_ = function(x) {
			return x.tagName === "OL";
		}, ev = function(x) {
			return x.tagName === "INPUT";
		}, tv = function(x) {
			return x.tagName === "HTML";
		}, nv = function(x) {
			return x.tagName === "svg";
		}, rv = function(x) {
			return x.tagName === "BODY";
		}, iv = function(x) {
			return x.tagName === "CANVAS";
		}, av = function(x) {
			return x.tagName === "VIDEO";
		}, ov = function(x) {
			return x.tagName === "IMG";
		}, sv = function(x) {
			return x.tagName === "IFRAME";
		}, cv = function(x) {
			return x.tagName === "STYLE";
		}, lv = function(x) {
			return x.tagName === "SCRIPT";
		}, uv = function(x) {
			return x.tagName === "TEXTAREA";
		}, dv = function(x) {
			return x.tagName === "SELECT";
		}, fv = function(x) {
			return x.tagName === "SLOT";
		}, pv = function(x) {
			return x.tagName.indexOf("-") > 0;
		}, mv = function() {
			function x() {
				this.counters = {};
			}
			return x.prototype.getCounterValue = function(x) {
				var w = this.counters[x];
				return w && w.length ? w[w.length - 1] : 1;
			}, x.prototype.getCounterValues = function(x) {
				return this.counters[x] || [];
			}, x.prototype.pop = function(x) {
				var w = this;
				x.forEach(function(x) {
					return w.counters[x].pop();
				});
			}, x.prototype.parse = function(x) {
				var w = this, V = x.counterIncrement, U = x.counterReset, W = !0;
				V !== null && V.forEach(function(x) {
					var V = w.counters[x.counter];
					V && x.increment !== 0 && (W = !1, V.length || V.push(1), V[Math.max(0, V.length - 1)] += x.increment);
				});
				var G = [];
				return W && U.forEach(function(x) {
					var V = w.counters[x.counter];
					G.push(x.counter), V ||= w.counters[x.counter] = [], V.push(x.reset);
				}), G;
			}, x;
		}(), hv = {
			integers: [
				1e3,
				900,
				500,
				400,
				100,
				90,
				50,
				40,
				10,
				9,
				5,
				4,
				1
			],
			values: [
				"M",
				"CM",
				"D",
				"CD",
				"C",
				"XC",
				"L",
				"XL",
				"X",
				"IX",
				"V",
				"IV",
				"I"
			]
		}, gv = {
			integers: [
				9e3,
				8e3,
				7e3,
				6e3,
				5e3,
				4e3,
				3e3,
				2e3,
				1e3,
				900,
				800,
				700,
				600,
				500,
				400,
				300,
				200,
				100,
				90,
				80,
				70,
				60,
				50,
				40,
				30,
				20,
				10,
				9,
				8,
				7,
				6,
				5,
				4,
				3,
				2,
				1
			],
			values: /* @__PURE__ */ "Ք.Փ.Ւ.Ց.Ր.Տ.Վ.Ս.Ռ.Ջ.Պ.Չ.Ո.Շ.Ն.Յ.Մ.Ճ.Ղ.Ձ.Հ.Կ.Ծ.Խ.Լ.Ի.Ժ.Թ.Ը.Է.Զ.Ե.Դ.Գ.Բ.Ա".split(".")
		}, _v = {
			integers: [
				1e4,
				9e3,
				8e3,
				7e3,
				6e3,
				5e3,
				4e3,
				3e3,
				2e3,
				1e3,
				400,
				300,
				200,
				100,
				90,
				80,
				70,
				60,
				50,
				40,
				30,
				20,
				19,
				18,
				17,
				16,
				15,
				10,
				9,
				8,
				7,
				6,
				5,
				4,
				3,
				2,
				1
			],
			values: /* @__PURE__ */ "י׳.ט׳.ח׳.ז׳.ו׳.ה׳.ד׳.ג׳.ב׳.א׳.ת.ש.ר.ק.צ.פ.ע.ס.נ.מ.ל.כ.יט.יח.יז.טז.טו.י.ט.ח.ז.ו.ה.ד.ג.ב.א".split(".")
		}, vv = {
			integers: [
				1e4,
				9e3,
				8e3,
				7e3,
				6e3,
				5e3,
				4e3,
				3e3,
				2e3,
				1e3,
				900,
				800,
				700,
				600,
				500,
				400,
				300,
				200,
				100,
				90,
				80,
				70,
				60,
				50,
				40,
				30,
				20,
				10,
				9,
				8,
				7,
				6,
				5,
				4,
				3,
				2,
				1
			],
			values: /* @__PURE__ */ "ჵ.ჰ.ჯ.ჴ.ხ.ჭ.წ.ძ.ც.ჩ.შ.ყ.ღ.ქ.ფ.ჳ.ტ.ს.რ.ჟ.პ.ო.ჲ.ნ.მ.ლ.კ.ი.თ.ჱ.ზ.ვ.ე.დ.გ.ბ.ა".split(".")
		}, yv = function(x, w, V, U, W, G) {
			return x < w || x > V ? Mv(x, W, G.length > 0) : U.integers.reduce(function(w, V, W) {
				for (; x >= V;) x -= V, w += U.values[W];
				return w;
			}, "") + G;
		}, bv = function(x, w, V, U) {
			var W = "";
			do
				V || x--, W = U(x) + W, x /= w;
			while (x * w >= w);
			return W;
		}, xv = function(x, w, V, U, W) {
			var G = V - w + 1;
			return (x < 0 ? "-" : "") + (bv(Math.abs(x), G, U, function(x) {
				return $(Math.floor(x % G) + w);
			}) + W);
		}, Sv = function(x, w, V) {
			V === void 0 && (V = ". ");
			var U = w.length;
			return bv(Math.abs(x), U, !1, function(x) {
				return w[Math.floor(x % U)];
			}) + V;
		}, Cv = 1, wv = 2, Tv = 4, Ev = 8, Dv = function(x, w, V, U, W, G) {
			if (x < -9999 || x > 9999) return Mv(x, 4, W.length > 0);
			var K = Math.abs(x), J = W;
			if (K === 0) return w[0] + J;
			for (var Y = 0; K > 0 && Y <= 4; Y++) {
				var Z = K % 10;
				Z === 0 && Gh(G, Cv) && J !== "" ? J = w[Z] + J : Z > 1 || Z === 1 && Y === 0 || Z === 1 && Y === 1 && Gh(G, wv) || Z === 1 && Y === 1 && Gh(G, Tv) && x > 100 || Z === 1 && Y > 1 && Gh(G, Ev) ? J = w[Z] + (Y > 0 ? V[Y - 1] : "") + J : Z === 1 && Y > 0 && (J = V[Y - 1] + J), K = Math.floor(K / 10);
			}
			return (x < 0 ? U : "") + J;
		}, Ov = "十百千萬", kv = "拾佰仟萬", Av = "マイナス", jv = "마이너스", Mv = function(x, w, V) {
			var U = V ? ". " : "", W = V ? "、" : "", G = V ? ", " : "", K = V ? " " : "";
			switch (w) {
				case 0: return "•" + K;
				case 1: return "◦" + K;
				case 2: return "◾" + K;
				case 5:
					var J = xv(x, 48, 57, !0, U);
					return J.length < 4 ? "0" + J : J;
				case 4: return Sv(x, "〇一二三四五六七八九", W);
				case 6: return yv(x, 1, 3999, hv, 3, U).toLowerCase();
				case 7: return yv(x, 1, 3999, hv, 3, U);
				case 8: return xv(x, 945, 969, !1, U);
				case 9: return xv(x, 97, 122, !1, U);
				case 10: return xv(x, 65, 90, !1, U);
				case 11: return xv(x, 1632, 1641, !0, U);
				case 12:
				case 49: return yv(x, 1, 9999, gv, 3, U);
				case 35: return yv(x, 1, 9999, gv, 3, U).toLowerCase();
				case 13: return xv(x, 2534, 2543, !0, U);
				case 14:
				case 30: return xv(x, 6112, 6121, !0, U);
				case 15: return Sv(x, "子丑寅卯辰巳午未申酉戌亥", W);
				case 16: return Sv(x, "甲乙丙丁戊己庚辛壬癸", W);
				case 17:
				case 48: return Dv(x, "零一二三四五六七八九", Ov, "負", W, wv | Tv | Ev);
				case 47: return Dv(x, "零壹貳參肆伍陸柒捌玖", kv, "負", W, Cv | wv | Tv | Ev);
				case 42: return Dv(x, "零一二三四五六七八九", Ov, "负", W, wv | Tv | Ev);
				case 41: return Dv(x, "零壹贰叁肆伍陆柒捌玖", kv, "负", W, Cv | wv | Tv | Ev);
				case 26: return Dv(x, "〇一二三四五六七八九", "十百千万", Av, W, 0);
				case 25: return Dv(x, "零壱弐参四伍六七八九", "拾百千万", Av, W, Cv | wv | Tv);
				case 31: return Dv(x, "영일이삼사오육칠팔구", "십백천만", jv, G, Cv | wv | Tv);
				case 33: return Dv(x, "零一二三四五六七八九", "十百千萬", jv, G, 0);
				case 32: return Dv(x, "零壹貳參四五六七八九", "拾百千", jv, G, Cv | wv | Tv);
				case 18: return xv(x, 2406, 2415, !0, U);
				case 20: return yv(x, 1, 19999, vv, 3, U);
				case 21: return xv(x, 2790, 2799, !0, U);
				case 22: return xv(x, 2662, 2671, !0, U);
				case 22: return yv(x, 1, 10999, _v, 3, U);
				case 23: return Sv(x, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
				case 24: return Sv(x, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
				case 27: return xv(x, 3302, 3311, !0, U);
				case 28: return Sv(x, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", W);
				case 29: return Sv(x, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", W);
				case 34: return xv(x, 3792, 3801, !0, U);
				case 37: return xv(x, 6160, 6169, !0, U);
				case 38: return xv(x, 4160, 4169, !0, U);
				case 39: return xv(x, 2918, 2927, !0, U);
				case 40: return xv(x, 1776, 1785, !0, U);
				case 43: return xv(x, 3046, 3055, !0, U);
				case 44: return xv(x, 3174, 3183, !0, U);
				case 45: return xv(x, 3664, 3673, !0, U);
				case 46: return xv(x, 3872, 3881, !0, U);
				case 3:
				default: return xv(x, 48, 57, !0, U);
			}
		}, Nv = "data-html2canvas-ignore", Pv = function() {
			function x(x, w, V) {
				if (this.context = x, this.options = V, this.scrolledElements = [], this.referenceElement = w, this.counters = new mv(), this.quoteDepth = 0, !w.ownerDocument) throw Error("Cloned element does not have an owner document");
				this.documentElement = this.cloneNode(w.ownerDocument.documentElement, !1);
			}
			return x.prototype.toIFrame = function(x, w) {
				var V = this, G = Iv(x, w);
				if (!G.contentWindow) return Promise.reject("Unable to find iframe window");
				var K = x.defaultView.pageXOffset, J = x.defaultView.pageYOffset, Y = G.contentWindow, Z = Y.document, $ = zv(G).then(function() {
					return U(V, void 0, void 0, function() {
						var x, V;
						return W(this, function(U) {
							switch (U.label) {
								case 0: return this.scrolledElements.forEach(Wv), Y && (Y.scrollTo(w.left, w.top), /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (Y.scrollY !== w.top || Y.scrollX !== w.left) && (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(Y.scrollX - w.left, Y.scrollY - w.top, 0, 0))), x = this.options.onclone, V = this.clonedReferenceElement, V === void 0 ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : Z.fonts && Z.fonts.ready ? [4, Z.fonts.ready] : [3, 2];
								case 1: U.sent(), U.label = 2;
								case 2: return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, Rv(Z)] : [3, 4];
								case 3: U.sent(), U.label = 4;
								case 4: return typeof x == "function" ? [2, Promise.resolve().then(function() {
									return x(Z, V);
								}).then(function() {
									return G;
								})] : [2, G];
							}
						});
					});
				});
				return Z.open(), Z.write(Hv(document.doctype) + "<html></html>"), Uv(this.referenceElement.ownerDocument, K, J), Z.replaceChild(Z.adoptNode(this.documentElement), Z.documentElement), Z.close(), $;
			}, x.prototype.createElementClone = function(x) {
				if (cg(x, 2)) debugger;
				if (iv(x)) return this.createCanvasClone(x);
				if (av(x)) return this.createVideoClone(x);
				if (cv(x)) return this.createStyleClone(x);
				var w = x.cloneNode(!1);
				return ov(w) && (ov(x) && x.currentSrc && x.currentSrc !== x.src && (w.src = x.currentSrc, w.srcset = ""), w.loading === "lazy" && (w.loading = "eager")), pv(w) ? this.createCustomElementClone(w) : w;
			}, x.prototype.createCustomElementClone = function(x) {
				var w = document.createElement("html2canvascustomelement");
				return Vv(x.style, w), w;
			}, x.prototype.createStyleClone = function(x) {
				try {
					var w = x.sheet;
					if (w && w.cssRules) {
						var V = [].slice.call(w.cssRules, 0).reduce(function(x, w) {
							return w && typeof w.cssText == "string" ? x + w.cssText : x;
						}, ""), U = x.cloneNode(!1);
						return U.textContent = V, U;
					}
				} catch (x) {
					if (this.context.logger.error("Unable to access cssRules property", x), x.name !== "SecurityError") throw x;
				}
				return x.cloneNode(!1);
			}, x.prototype.createCanvasClone = function(x) {
				if (this.options.inlineImages && x.ownerDocument) {
					var w = x.ownerDocument.createElement("img");
					try {
						return w.src = x.toDataURL(), w;
					} catch {
						this.context.logger.info("Unable to inline canvas contents, canvas is tainted", x);
					}
				}
				var V = x.cloneNode(!1);
				try {
					V.width = x.width, V.height = x.height;
					var U = x.getContext("2d"), W = V.getContext("2d");
					if (W) if (!this.options.allowTaint && U) W.putImageData(U.getImageData(0, 0, x.width, x.height), 0, 0);
					else {
						var G = x.getContext("webgl2") ?? x.getContext("webgl");
						G && G.getContextAttributes()?.preserveDrawingBuffer === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", x), W.drawImage(x, 0, 0);
					}
					return V;
				} catch {
					this.context.logger.info("Unable to clone canvas as it is tainted", x);
				}
				return V;
			}, x.prototype.createVideoClone = function(x) {
				var w = x.ownerDocument.createElement("canvas");
				w.width = x.offsetWidth, w.height = x.offsetHeight;
				var V = w.getContext("2d");
				try {
					return V && (V.drawImage(x, 0, 0, w.width, w.height), this.options.allowTaint || V.getImageData(0, 0, w.width, w.height)), w;
				} catch {
					this.context.logger.info("Unable to clone video as it is tainted", x);
				}
				var U = x.ownerDocument.createElement("canvas");
				return U.width = x.offsetWidth, U.height = x.offsetHeight, U;
			}, x.prototype.appendChildNode = function(x, w, V) {
				(!Y_(w) || !lv(w) && !w.hasAttribute(Nv) && (typeof this.options.ignoreElements != "function" || !this.options.ignoreElements(w))) && (!this.options.copyStyles || !Y_(w) || !cv(w)) && x.appendChild(this.cloneNode(w, V));
			}, x.prototype.cloneChildNodes = function(x, w, V) {
				for (var U = this, W = x.shadowRoot ? x.shadowRoot.firstChild : x.firstChild; W; W = W.nextSibling) if (Y_(W) && fv(W) && typeof W.assignedNodes == "function") {
					var G = W.assignedNodes();
					G.length && G.forEach(function(x) {
						return U.appendChildNode(w, x, V);
					});
				} else this.appendChildNode(w, W, V);
			}, x.prototype.cloneNode = function(x, w) {
				if (J_(x)) return document.createTextNode(x.data);
				if (!x.ownerDocument) return x.cloneNode(!1);
				var V = x.ownerDocument.defaultView;
				if (V && Y_(x) && (X_(x) || Z_(x))) {
					var U = this.createElementClone(x);
					U.style.transitionProperty = "none";
					var W = V.getComputedStyle(x), G = V.getComputedStyle(x, ":before"), K = V.getComputedStyle(x, ":after");
					this.referenceElement === x && X_(U) && (this.clonedReferenceElement = U), rv(U) && Xv(U);
					var J = this.counters.parse(new ig(this.context, W)), Y = this.resolvePseudoContent(x, U, G, Fv.BEFORE);
					pv(x) && (w = !0), av(x) || this.cloneChildNodes(x, U, w), Y && U.insertBefore(Y, U.firstChild);
					var Z = this.resolvePseudoContent(x, U, K, Fv.AFTER);
					return Z && U.appendChild(Z), this.counters.pop(J), (W && (this.options.copyStyles || Z_(x)) && !sv(x) || w) && Vv(W, U), (x.scrollTop !== 0 || x.scrollLeft !== 0) && this.scrolledElements.push([
						U,
						x.scrollLeft,
						x.scrollTop
					]), (uv(x) || dv(x)) && (uv(U) || dv(U)) && (U.value = x.value), U;
				}
				return x.cloneNode(!1);
			}, x.prototype.resolvePseudoContent = function(x, w, V, U) {
				var W = this;
				if (V) {
					var G = V.content, K = w.ownerDocument;
					if (!(!K || !G || G === "none" || G === "-moz-alt-content" || V.display === "none")) {
						this.counters.parse(new ig(this.context, V));
						var J = new rg(this.context, V), Y = K.createElement("html2canvaspseudoelement");
						Vv(V, Y), J.content.forEach(function(w) {
							if (w.type === 0) Y.appendChild(K.createTextNode(w.value));
							else if (w.type === 22) {
								var V = K.createElement("img");
								V.src = w.value, V.style.opacity = "1", Y.appendChild(V);
							} else if (w.type === 18) {
								if (w.name === "attr") {
									var U = w.values.filter(_p);
									U.length && Y.appendChild(K.createTextNode(x.getAttribute(U[0].value) || ""));
								} else if (w.name === "counter") {
									var G = w.values.filter(xp), Z = G[0], $ = G[1];
									if (Z && _p(Z)) {
										var ql = W.counters.getCounterValue(Z.value), Jl = $ && _p($) ? uh.parse(W.context, $.value) : 3;
										Y.appendChild(K.createTextNode(Mv(ql, Jl, !1)));
									}
								} else if (w.name === "counters") {
									var Yl = w.values.filter(xp), Z = Yl[0], Xl = Yl[1], $ = Yl[2];
									if (Z && _p(Z)) {
										var Zl = W.counters.getCounterValues(Z.value), Ql = $ && _p($) ? uh.parse(W.context, $.value) : 3, $l = Xl && Xl.type === 0 ? Xl.value : "", eu = Zl.map(function(x) {
											return Mv(x, Ql, !1);
										}).join($l);
										Y.appendChild(K.createTextNode(eu));
									}
								}
							} else if (w.type === 20) switch (w.value) {
								case "open-quote":
									Y.appendChild(K.createTextNode(Zh(J.quotes, W.quoteDepth++, !0)));
									break;
								case "close-quote":
									Y.appendChild(K.createTextNode(Zh(J.quotes, --W.quoteDepth, !1)));
									break;
								default: Y.appendChild(K.createTextNode(w.value));
							}
						}), Y.className = qv + " " + Jv;
						var Z = U === Fv.BEFORE ? " " + qv : " " + Jv;
						return Z_(w) ? w.className.baseValue += Z : w.className += Z, Y;
					}
				}
			}, x.destroy = function(x) {
				return x.parentNode ? (x.parentNode.removeChild(x), !0) : !1;
			}, x;
		}(), Fv;
		(function(x) {
			x[x.BEFORE = 0] = "BEFORE", x[x.AFTER = 1] = "AFTER";
		})(Fv ||= {});
		var Iv = function(x, w) {
			var V = x.createElement("iframe");
			return V.className = "html2canvas-container", V.style.visibility = "hidden", V.style.position = "fixed", V.style.left = "-10000px", V.style.top = "0px", V.style.border = "0", V.width = w.width.toString(), V.height = w.height.toString(), V.scrolling = "no", V.setAttribute(Nv, "true"), x.body.appendChild(V), V;
		}, Lv = function(x) {
			return new Promise(function(w) {
				if (x.complete) {
					w();
					return;
				}
				if (!x.src) {
					w();
					return;
				}
				x.onload = w, x.onerror = w;
			});
		}, Rv = function(x) {
			return Promise.all([].slice.call(x.images, 0).map(Lv));
		}, zv = function(x) {
			return new Promise(function(w, V) {
				var U = x.contentWindow;
				if (!U) return V("No window assigned for iframe");
				var W = U.document;
				U.onload = x.onload = function() {
					U.onload = x.onload = null;
					var V = setInterval(function() {
						W.body.childNodes.length > 0 && W.readyState === "complete" && (clearInterval(V), w(x));
					}, 50);
				};
			});
		}, Bv = [
			"all",
			"d",
			"content"
		], Vv = function(x, w) {
			for (var V = x.length - 1; V >= 0; V--) {
				var U = x.item(V);
				Bv.indexOf(U) === -1 && w.style.setProperty(U, x.getPropertyValue(U));
			}
			return w;
		}, Hv = function(x) {
			var w = "";
			return x && (w += "<!DOCTYPE ", x.name && (w += x.name), x.internalSubset && (w += x.internalSubset), x.publicId && (w += "\"" + x.publicId + "\""), x.systemId && (w += "\"" + x.systemId + "\""), w += ">"), w;
		}, Uv = function(x, w, V) {
			x && x.defaultView && (w !== x.defaultView.pageXOffset || V !== x.defaultView.pageYOffset) && x.defaultView.scrollTo(w, V);
		}, Wv = function(x) {
			var w = x[0], V = x[1], U = x[2];
			w.scrollLeft = V, w.scrollTop = U;
		}, Gv = ":before", Kv = ":after", qv = "___html2canvas___pseudoelement_before", Jv = "___html2canvas___pseudoelement_after", Yv = "{\n    content: \"\" !important;\n    display: none !important;\n}", Xv = function(x) {
			Zv(x, "." + qv + Gv + Yv + "\n         ." + Jv + Kv + Yv);
		}, Zv = function(x, w) {
			var V = x.ownerDocument;
			if (V) {
				var U = V.createElement("style");
				U.textContent = w, x.appendChild(U);
			}
		}, Qv = function() {
			function x() {}
			return x.getOrigin = function(w) {
				var V = x._link;
				return V ? (V.href = w, V.href = V.href, V.protocol + V.hostname + V.port) : "about:blank";
			}, x.isSameOrigin = function(w) {
				return x.getOrigin(w) === x._origin;
			}, x.setContext = function(w) {
				x._link = w.document.createElement("a"), x._origin = x.getOrigin(w.location.href);
			}, x._origin = "about:blank", x;
		}(), $v = function() {
			function x(x, w) {
				this.context = x, this._options = w, this._cache = {};
			}
			return x.prototype.addImage = function(x) {
				var w = Promise.resolve();
				return this.has(x) || (oy(x) || ry(x)) && (this._cache[x] = this.loadImage(x)).catch(function() {}), w;
			}, x.prototype.match = function(x) {
				return this._cache[x];
			}, x.prototype.loadImage = function(x) {
				return U(this, void 0, void 0, function() {
					var w, V, U, G, K = this;
					return W(this, function(W) {
						switch (W.label) {
							case 0: return w = Qv.isSameOrigin(x), V = !iy(x) && this._options.useCORS === !0 && d_.SUPPORT_CORS_IMAGES && !w, U = !iy(x) && !w && !oy(x) && typeof this._options.proxy == "string" && d_.SUPPORT_CORS_XHR && !V, !w && this._options.allowTaint === !1 && !iy(x) && !oy(x) && !U && !V ? [2] : (G = x, U ? [4, this.proxy(G)] : [3, 2]);
							case 1: G = W.sent(), W.label = 2;
							case 2: return this.context.logger.debug("Added image " + x.substring(0, 256)), [4, new Promise(function(x, w) {
								var U = new Image();
								U.onload = function() {
									return x(U);
								}, U.onerror = w, (ay(G) || V) && (U.crossOrigin = "anonymous"), U.src = G, U.complete === !0 && setTimeout(function() {
									return x(U);
								}, 500), K._options.imageTimeout > 0 && setTimeout(function() {
									return w("Timed out (" + K._options.imageTimeout + "ms) loading image");
								}, K._options.imageTimeout);
							})];
							case 3: return [2, W.sent()];
						}
					});
				});
			}, x.prototype.has = function(x) {
				return this._cache[x] !== void 0;
			}, x.prototype.keys = function() {
				return Promise.resolve(Object.keys(this._cache));
			}, x.prototype.proxy = function(x) {
				var w = this, V = this._options.proxy;
				if (!V) throw Error("No proxy defined");
				var U = x.substring(0, 256);
				return new Promise(function(W, G) {
					var K = d_.SUPPORT_RESPONSE_TYPE ? "blob" : "text", J = new XMLHttpRequest();
					J.onload = function() {
						if (J.status === 200) if (K === "text") W(J.response);
						else {
							var x = new FileReader();
							x.addEventListener("load", function() {
								return W(x.result);
							}, !1), x.addEventListener("error", function(x) {
								return G(x);
							}, !1), x.readAsDataURL(J.response);
						}
						else G("Failed to proxy resource " + U + " with status code " + J.status);
					}, J.onerror = G;
					var Y = V.indexOf("?") > -1 ? "&" : "?";
					if (J.open("GET", "" + V + Y + "url=" + encodeURIComponent(x) + "&responseType=" + K), K !== "text" && J instanceof XMLHttpRequest && (J.responseType = K), w._options.imageTimeout) {
						var Z = w._options.imageTimeout;
						J.timeout = Z, J.ontimeout = function() {
							return G("Timed out (" + Z + "ms) proxying " + U);
						};
					}
					J.send();
				});
			}, x;
		}(), ey = /^data:image\/svg\+xml/i, ty = /^data:image\/.*;base64,/i, ny = /^data:image\/.*/i, ry = function(x) {
			return d_.SUPPORT_SVG_DRAWING || !sy(x);
		}, iy = function(x) {
			return ny.test(x);
		}, ay = function(x) {
			return ty.test(x);
		}, oy = function(x) {
			return x.substr(0, 4) === "blob";
		}, sy = function(x) {
			return x.substr(-3).toLowerCase() === "svg" || ey.test(x);
		}, cy = function() {
			function x(x, w) {
				this.type = 0, this.x = x, this.y = w;
			}
			return x.prototype.add = function(w, V) {
				return new x(this.x + w, this.y + V);
			}, x;
		}(), ly = function(x, w, V) {
			return new cy(x.x + (w.x - x.x) * V, x.y + (w.y - x.y) * V);
		}, uy = function() {
			function x(x, w, V, U) {
				this.type = 1, this.start = x, this.startControl = w, this.endControl = V, this.end = U;
			}
			return x.prototype.subdivide = function(w, V) {
				var U = ly(this.start, this.startControl, w), W = ly(this.startControl, this.endControl, w), G = ly(this.endControl, this.end, w), K = ly(U, W, w), J = ly(W, G, w), Y = ly(K, J, w);
				return V ? new x(this.start, U, K, Y) : new x(Y, J, G, this.end);
			}, x.prototype.add = function(w, V) {
				return new x(this.start.add(w, V), this.startControl.add(w, V), this.endControl.add(w, V), this.end.add(w, V));
			}, x.prototype.reverse = function() {
				return new x(this.end, this.endControl, this.startControl, this.start);
			}, x;
		}(), dy = function(x) {
			return x.type === 1;
		}, fy = function() {
			function x(x) {
				var w = x.styles, V = x.bounds, U = Ap(w.borderTopLeftRadius, V.width, V.height), W = U[0], G = U[1], K = Ap(w.borderTopRightRadius, V.width, V.height), J = K[0], Y = K[1], Z = Ap(w.borderBottomRightRadius, V.width, V.height), $ = Z[0], ql = Z[1], Jl = Ap(w.borderBottomLeftRadius, V.width, V.height), Yl = Jl[0], Xl = Jl[1], Zl = [];
				Zl.push((W + J) / V.width), Zl.push((Yl + $) / V.width), Zl.push((G + Xl) / V.height), Zl.push((Y + ql) / V.height);
				var Ql = Math.max.apply(Math, Zl);
				Ql > 1 && (W /= Ql, G /= Ql, J /= Ql, Y /= Ql, $ /= Ql, ql /= Ql, Yl /= Ql, Xl /= Ql);
				var $l = V.width - J, eu = V.height - ql, tu = V.width - $, nu = V.height - Xl, ru = w.borderTopWidth, iu = w.borderRightWidth, au = w.borderBottomWidth, ou = w.borderLeftWidth, su = jp(w.paddingTop, x.bounds.width), cu = jp(w.paddingRight, x.bounds.width), lu = jp(w.paddingBottom, x.bounds.width), uu = jp(w.paddingLeft, x.bounds.width);
				this.topLeftBorderDoubleOuterBox = W > 0 || G > 0 ? my(V.left + ou / 3, V.top + ru / 3, W - ou / 3, G - ru / 3, py.TOP_LEFT) : new cy(V.left + ou / 3, V.top + ru / 3), this.topRightBorderDoubleOuterBox = W > 0 || G > 0 ? my(V.left + $l, V.top + ru / 3, J - iu / 3, Y - ru / 3, py.TOP_RIGHT) : new cy(V.left + V.width - iu / 3, V.top + ru / 3), this.bottomRightBorderDoubleOuterBox = $ > 0 || ql > 0 ? my(V.left + tu, V.top + eu, $ - iu / 3, ql - au / 3, py.BOTTOM_RIGHT) : new cy(V.left + V.width - iu / 3, V.top + V.height - au / 3), this.bottomLeftBorderDoubleOuterBox = Yl > 0 || Xl > 0 ? my(V.left + ou / 3, V.top + nu, Yl - ou / 3, Xl - au / 3, py.BOTTOM_LEFT) : new cy(V.left + ou / 3, V.top + V.height - au / 3), this.topLeftBorderDoubleInnerBox = W > 0 || G > 0 ? my(V.left + ou * 2 / 3, V.top + ru * 2 / 3, W - ou * 2 / 3, G - ru * 2 / 3, py.TOP_LEFT) : new cy(V.left + ou * 2 / 3, V.top + ru * 2 / 3), this.topRightBorderDoubleInnerBox = W > 0 || G > 0 ? my(V.left + $l, V.top + ru * 2 / 3, J - iu * 2 / 3, Y - ru * 2 / 3, py.TOP_RIGHT) : new cy(V.left + V.width - iu * 2 / 3, V.top + ru * 2 / 3), this.bottomRightBorderDoubleInnerBox = $ > 0 || ql > 0 ? my(V.left + tu, V.top + eu, $ - iu * 2 / 3, ql - au * 2 / 3, py.BOTTOM_RIGHT) : new cy(V.left + V.width - iu * 2 / 3, V.top + V.height - au * 2 / 3), this.bottomLeftBorderDoubleInnerBox = Yl > 0 || Xl > 0 ? my(V.left + ou * 2 / 3, V.top + nu, Yl - ou * 2 / 3, Xl - au * 2 / 3, py.BOTTOM_LEFT) : new cy(V.left + ou * 2 / 3, V.top + V.height - au * 2 / 3), this.topLeftBorderStroke = W > 0 || G > 0 ? my(V.left + ou / 2, V.top + ru / 2, W - ou / 2, G - ru / 2, py.TOP_LEFT) : new cy(V.left + ou / 2, V.top + ru / 2), this.topRightBorderStroke = W > 0 || G > 0 ? my(V.left + $l, V.top + ru / 2, J - iu / 2, Y - ru / 2, py.TOP_RIGHT) : new cy(V.left + V.width - iu / 2, V.top + ru / 2), this.bottomRightBorderStroke = $ > 0 || ql > 0 ? my(V.left + tu, V.top + eu, $ - iu / 2, ql - au / 2, py.BOTTOM_RIGHT) : new cy(V.left + V.width - iu / 2, V.top + V.height - au / 2), this.bottomLeftBorderStroke = Yl > 0 || Xl > 0 ? my(V.left + ou / 2, V.top + nu, Yl - ou / 2, Xl - au / 2, py.BOTTOM_LEFT) : new cy(V.left + ou / 2, V.top + V.height - au / 2), this.topLeftBorderBox = W > 0 || G > 0 ? my(V.left, V.top, W, G, py.TOP_LEFT) : new cy(V.left, V.top), this.topRightBorderBox = J > 0 || Y > 0 ? my(V.left + $l, V.top, J, Y, py.TOP_RIGHT) : new cy(V.left + V.width, V.top), this.bottomRightBorderBox = $ > 0 || ql > 0 ? my(V.left + tu, V.top + eu, $, ql, py.BOTTOM_RIGHT) : new cy(V.left + V.width, V.top + V.height), this.bottomLeftBorderBox = Yl > 0 || Xl > 0 ? my(V.left, V.top + nu, Yl, Xl, py.BOTTOM_LEFT) : new cy(V.left, V.top + V.height), this.topLeftPaddingBox = W > 0 || G > 0 ? my(V.left + ou, V.top + ru, Math.max(0, W - ou), Math.max(0, G - ru), py.TOP_LEFT) : new cy(V.left + ou, V.top + ru), this.topRightPaddingBox = J > 0 || Y > 0 ? my(V.left + Math.min($l, V.width - iu), V.top + ru, $l > V.width + iu ? 0 : Math.max(0, J - iu), Math.max(0, Y - ru), py.TOP_RIGHT) : new cy(V.left + V.width - iu, V.top + ru), this.bottomRightPaddingBox = $ > 0 || ql > 0 ? my(V.left + Math.min(tu, V.width - ou), V.top + Math.min(eu, V.height - au), Math.max(0, $ - iu), Math.max(0, ql - au), py.BOTTOM_RIGHT) : new cy(V.left + V.width - iu, V.top + V.height - au), this.bottomLeftPaddingBox = Yl > 0 || Xl > 0 ? my(V.left + ou, V.top + Math.min(nu, V.height - au), Math.max(0, Yl - ou), Math.max(0, Xl - au), py.BOTTOM_LEFT) : new cy(V.left + ou, V.top + V.height - au), this.topLeftContentBox = W > 0 || G > 0 ? my(V.left + ou + uu, V.top + ru + su, Math.max(0, W - (ou + uu)), Math.max(0, G - (ru + su)), py.TOP_LEFT) : new cy(V.left + ou + uu, V.top + ru + su), this.topRightContentBox = J > 0 || Y > 0 ? my(V.left + Math.min($l, V.width + ou + uu), V.top + ru + su, $l > V.width + ou + uu ? 0 : J - ou + uu, Y - (ru + su), py.TOP_RIGHT) : new cy(V.left + V.width - (iu + cu), V.top + ru + su), this.bottomRightContentBox = $ > 0 || ql > 0 ? my(V.left + Math.min(tu, V.width - (ou + uu)), V.top + Math.min(eu, V.height + ru + su), Math.max(0, $ - (iu + cu)), ql - (au + lu), py.BOTTOM_RIGHT) : new cy(V.left + V.width - (iu + cu), V.top + V.height - (au + lu)), this.bottomLeftContentBox = Yl > 0 || Xl > 0 ? my(V.left + ou + uu, V.top + nu, Math.max(0, Yl - (ou + uu)), Xl - (au + lu), py.BOTTOM_LEFT) : new cy(V.left + ou + uu, V.top + V.height - (au + lu));
			}
			return x;
		}(), py;
		(function(x) {
			x[x.TOP_LEFT = 0] = "TOP_LEFT", x[x.TOP_RIGHT = 1] = "TOP_RIGHT", x[x.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", x[x.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
		})(py ||= {});
		var my = function(x, w, V, U, W) {
			var G = 4 * ((Math.sqrt(2) - 1) / 3), K = V * G, J = U * G, Y = x + V, Z = w + U;
			switch (W) {
				case py.TOP_LEFT: return new uy(new cy(x, Z), new cy(x, Z - J), new cy(Y - K, w), new cy(Y, w));
				case py.TOP_RIGHT: return new uy(new cy(x, w), new cy(x + K, w), new cy(Y, Z - J), new cy(Y, Z));
				case py.BOTTOM_RIGHT: return new uy(new cy(Y, w), new cy(Y, w + J), new cy(x + K, Z), new cy(x, Z));
				case py.BOTTOM_LEFT:
				default: return new uy(new cy(Y, Z), new cy(Y - K, Z), new cy(x, w + J), new cy(x, w));
			}
		}, hy = function(x) {
			return [
				x.topLeftBorderBox,
				x.topRightBorderBox,
				x.bottomRightBorderBox,
				x.bottomLeftBorderBox
			];
		}, gy = function(x) {
			return [
				x.topLeftContentBox,
				x.topRightContentBox,
				x.bottomRightContentBox,
				x.bottomLeftContentBox
			];
		}, _y = function(x) {
			return [
				x.topLeftPaddingBox,
				x.topRightPaddingBox,
				x.bottomRightPaddingBox,
				x.bottomLeftPaddingBox
			];
		}, vy = function() {
			function x(x, w, V) {
				this.offsetX = x, this.offsetY = w, this.matrix = V, this.type = 0, this.target = 6;
			}
			return x;
		}(), yy = function() {
			function x(x, w) {
				this.path = x, this.target = w, this.type = 1;
			}
			return x;
		}(), by = function() {
			function x(x) {
				this.opacity = x, this.type = 2, this.target = 6;
			}
			return x;
		}(), xy = function(x) {
			return x.type === 0;
		}, Sy = function(x) {
			return x.type === 1;
		}, Cy = function(x) {
			return x.type === 2;
		}, wy = function(x, w) {
			return x.length === w.length ? x.some(function(x, V) {
				return x === w[V];
			}) : !1;
		}, Ty = function(x, w, V, U, W) {
			return x.map(function(x, G) {
				switch (G) {
					case 0: return x.add(w, V);
					case 1: return x.add(w + U, V);
					case 2: return x.add(w + U, V + W);
					case 3: return x.add(w, V + W);
				}
				return x;
			});
		}, Ey = function() {
			function x(x) {
				this.element = x, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
			}
			return x;
		}(), Dy = function() {
			function x(x, w) {
				if (this.container = x, this.parent = w, this.effects = [], this.curves = new fy(this.container), this.container.styles.opacity < 1 && this.effects.push(new by(this.container.styles.opacity)), this.container.styles.transform !== null) {
					var V = this.container.bounds.left + this.container.styles.transformOrigin[0].number, U = this.container.bounds.top + this.container.styles.transformOrigin[1].number, W = this.container.styles.transform;
					this.effects.push(new vy(V, U, W));
				}
				if (this.container.styles.overflowX !== 0) {
					var G = hy(this.curves), K = _y(this.curves);
					wy(G, K) ? this.effects.push(new yy(G, 6)) : (this.effects.push(new yy(G, 2)), this.effects.push(new yy(K, 4)));
				}
			}
			return x.prototype.getEffects = function(x) {
				for (var w = [2, 3].indexOf(this.container.styles.position) === -1, V = this.parent, U = this.effects.slice(0); V;) {
					var W = V.effects.filter(function(x) {
						return !Sy(x);
					});
					if (w || V.container.styles.position !== 0 || !V.parent) {
						if (U.unshift.apply(U, W), w = [2, 3].indexOf(V.container.styles.position) === -1, V.container.styles.overflowX !== 0) {
							var G = hy(V.curves), K = _y(V.curves);
							wy(G, K) || U.unshift(new yy(K, 6));
						}
					} else U.unshift.apply(U, W);
					V = V.parent;
				}
				return U.filter(function(w) {
					return Gh(w.target, x);
				});
			}, x;
		}(), Oy = function(x, w, V, U) {
			x.container.elements.forEach(function(W) {
				var G = Gh(W.flags, 4), K = Gh(W.flags, 2), J = new Dy(W, x);
				Gh(W.styles.display, 2048) && U.push(J);
				var Y = Gh(W.flags, 8) ? [] : U;
				if (G || K) {
					var Z = G || W.styles.isPositioned() ? V : w, $ = new Ey(J);
					if (W.styles.isPositioned() || W.styles.opacity < 1 || W.styles.isTransformed()) {
						var ql = W.styles.zIndex.order;
						if (ql < 0) {
							var Jl = 0;
							Z.negativeZIndex.some(function(x, w) {
								return ql > x.element.container.styles.zIndex.order ? (Jl = w, !1) : Jl > 0;
							}), Z.negativeZIndex.splice(Jl, 0, $);
						} else if (ql > 0) {
							var Yl = 0;
							Z.positiveZIndex.some(function(x, w) {
								return ql >= x.element.container.styles.zIndex.order ? (Yl = w + 1, !1) : Yl > 0;
							}), Z.positiveZIndex.splice(Yl, 0, $);
						} else Z.zeroOrAutoZIndexOrTransformedOrOpacity.push($);
					} else W.styles.isFloating() ? Z.nonPositionedFloats.push($) : Z.nonPositionedInlineLevel.push($);
					Oy(J, $, G ? $ : V, Y);
				} else W.styles.isInlineLevel() ? w.inlineLevel.push(J) : w.nonInlineLevel.push(J), Oy(J, w, V, Y);
				Gh(W.flags, 8) && ky(W, Y);
			});
		}, ky = function(x, w) {
			for (var V = x instanceof k_ ? x.start : 1, U = x instanceof k_ ? x.reversed : !1, W = 0; W < w.length; W++) {
				var G = w[W];
				G.container instanceof O_ && typeof G.container.value == "number" && G.container.value !== 0 && (V = G.container.value), G.listValue = Mv(V, G.container.styles.listStyleType, !0), V += U ? -1 : 1;
			}
		}, Ay = function(x) {
			var w = new Dy(x, null), V = new Ey(w), U = [];
			return Oy(w, V, V, U), ky(w.container, U), V;
		}, jy = function(x, w) {
			switch (w) {
				case 0: return Iy(x.topLeftBorderBox, x.topLeftPaddingBox, x.topRightBorderBox, x.topRightPaddingBox);
				case 1: return Iy(x.topRightBorderBox, x.topRightPaddingBox, x.bottomRightBorderBox, x.bottomRightPaddingBox);
				case 2: return Iy(x.bottomRightBorderBox, x.bottomRightPaddingBox, x.bottomLeftBorderBox, x.bottomLeftPaddingBox);
				case 3:
				default: return Iy(x.bottomLeftBorderBox, x.bottomLeftPaddingBox, x.topLeftBorderBox, x.topLeftPaddingBox);
			}
		}, My = function(x, w) {
			switch (w) {
				case 0: return Iy(x.topLeftBorderBox, x.topLeftBorderDoubleOuterBox, x.topRightBorderBox, x.topRightBorderDoubleOuterBox);
				case 1: return Iy(x.topRightBorderBox, x.topRightBorderDoubleOuterBox, x.bottomRightBorderBox, x.bottomRightBorderDoubleOuterBox);
				case 2: return Iy(x.bottomRightBorderBox, x.bottomRightBorderDoubleOuterBox, x.bottomLeftBorderBox, x.bottomLeftBorderDoubleOuterBox);
				case 3:
				default: return Iy(x.bottomLeftBorderBox, x.bottomLeftBorderDoubleOuterBox, x.topLeftBorderBox, x.topLeftBorderDoubleOuterBox);
			}
		}, Ny = function(x, w) {
			switch (w) {
				case 0: return Iy(x.topLeftBorderDoubleInnerBox, x.topLeftPaddingBox, x.topRightBorderDoubleInnerBox, x.topRightPaddingBox);
				case 1: return Iy(x.topRightBorderDoubleInnerBox, x.topRightPaddingBox, x.bottomRightBorderDoubleInnerBox, x.bottomRightPaddingBox);
				case 2: return Iy(x.bottomRightBorderDoubleInnerBox, x.bottomRightPaddingBox, x.bottomLeftBorderDoubleInnerBox, x.bottomLeftPaddingBox);
				case 3:
				default: return Iy(x.bottomLeftBorderDoubleInnerBox, x.bottomLeftPaddingBox, x.topLeftBorderDoubleInnerBox, x.topLeftPaddingBox);
			}
		}, Py = function(x, w) {
			switch (w) {
				case 0: return Fy(x.topLeftBorderStroke, x.topRightBorderStroke);
				case 1: return Fy(x.topRightBorderStroke, x.bottomRightBorderStroke);
				case 2: return Fy(x.bottomRightBorderStroke, x.bottomLeftBorderStroke);
				case 3:
				default: return Fy(x.bottomLeftBorderStroke, x.topLeftBorderStroke);
			}
		}, Fy = function(x, w) {
			var V = [];
			return dy(x) ? V.push(x.subdivide(.5, !1)) : V.push(x), dy(w) ? V.push(w.subdivide(.5, !0)) : V.push(w), V;
		}, Iy = function(x, w, V, U) {
			var W = [];
			return dy(x) ? W.push(x.subdivide(.5, !1)) : W.push(x), dy(V) ? W.push(V.subdivide(.5, !0)) : W.push(V), dy(U) ? W.push(U.subdivide(.5, !0).reverse()) : W.push(U), dy(w) ? W.push(w.subdivide(.5, !1).reverse()) : W.push(w), W;
		}, Ly = function(x) {
			var w = x.bounds, V = x.styles;
			return w.add(V.borderLeftWidth, V.borderTopWidth, -(V.borderRightWidth + V.borderLeftWidth), -(V.borderTopWidth + V.borderBottomWidth));
		}, Ry = function(x) {
			var w = x.styles, V = x.bounds, U = jp(w.paddingLeft, V.width), W = jp(w.paddingRight, V.width), G = jp(w.paddingTop, V.width), K = jp(w.paddingBottom, V.width);
			return V.add(U + w.borderLeftWidth, G + w.borderTopWidth, -(w.borderRightWidth + w.borderLeftWidth + U + W), -(w.borderTopWidth + w.borderBottomWidth + G + K));
		}, zy = function(x, w) {
			return x === 0 ? w.bounds : x === 2 ? Ry(w) : Ly(w);
		}, By = function(x, w) {
			return x === 0 ? w.bounds : x === 2 ? Ry(w) : Ly(w);
		}, Vy = function(x, w, V) {
			var U = zy(Gy(x.styles.backgroundOrigin, w), x), W = By(Gy(x.styles.backgroundClip, w), x), G = Wy(Gy(x.styles.backgroundSize, w), V, U), K = G[0], J = G[1], Y = Ap(Gy(x.styles.backgroundPosition, w), U.width - K, U.height - J);
			return [
				Ky(Gy(x.styles.backgroundRepeat, w), Y, G, U, W),
				Math.round(U.left + Y[0]),
				Math.round(U.top + Y[1]),
				K,
				J
			];
		}, Hy = function(x) {
			return _p(x) && x.value === km.AUTO;
		}, Uy = function(x) {
			return typeof x == "number";
		}, Wy = function(x, w, V) {
			var U = w[0], W = w[1], G = w[2], K = x[0], J = x[1];
			if (!K) return [0, 0];
			if (Tp(K) && J && Tp(J)) return [jp(K, V.width), jp(J, V.height)];
			var Y = Uy(G);
			if (_p(K) && (K.value === km.CONTAIN || K.value === km.COVER)) return Uy(G) ? V.width / V.height < G == (K.value === km.COVER) ? [V.height * G, V.height] : [V.width, V.width / G] : [V.width, V.height];
			var Z = Uy(U), $ = Uy(W), ql = Z || $;
			if (Hy(K) && (!J || Hy(J))) return Z && $ ? [U, W] : !Y && !ql ? [V.width, V.height] : ql && Y ? [Z ? U : W * G, $ ? W : U / G] : [Z ? U : V.width, $ ? W : V.height];
			if (Y) {
				var Jl = 0, Yl = 0;
				return Tp(K) ? Jl = jp(K, V.width) : Tp(J) && (Yl = jp(J, V.height)), Hy(K) ? Jl = Yl * G : (!J || Hy(J)) && (Yl = Jl / G), [Jl, Yl];
			}
			var Xl = null, Zl = null;
			if (Tp(K) ? Xl = jp(K, V.width) : J && Tp(J) && (Zl = jp(J, V.height)), Xl !== null && (!J || Hy(J)) && (Zl = Z && $ ? Xl / U * W : V.height), Zl !== null && Hy(K) && (Xl = Z && $ ? Zl / W * U : V.width), Xl !== null && Zl !== null) return [Xl, Zl];
			throw Error("Unable to calculate background-size for element");
		}, Gy = function(x, w) {
			var V = x[w];
			return V === void 0 ? x[0] : V;
		}, Ky = function(x, w, V, U, W) {
			var G = w[0], K = w[1], J = V[0], Y = V[1];
			switch (x) {
				case 2: return [
					new cy(Math.round(U.left), Math.round(U.top + K)),
					new cy(Math.round(U.left + U.width), Math.round(U.top + K)),
					new cy(Math.round(U.left + U.width), Math.round(Y + U.top + K)),
					new cy(Math.round(U.left), Math.round(Y + U.top + K))
				];
				case 3: return [
					new cy(Math.round(U.left + G), Math.round(U.top)),
					new cy(Math.round(U.left + G + J), Math.round(U.top)),
					new cy(Math.round(U.left + G + J), Math.round(U.height + U.top)),
					new cy(Math.round(U.left + G), Math.round(U.height + U.top))
				];
				case 1: return [
					new cy(Math.round(U.left + G), Math.round(U.top + K)),
					new cy(Math.round(U.left + G + J), Math.round(U.top + K)),
					new cy(Math.round(U.left + G + J), Math.round(U.top + K + Y)),
					new cy(Math.round(U.left + G), Math.round(U.top + K + Y))
				];
				default: return [
					new cy(Math.round(W.left), Math.round(W.top)),
					new cy(Math.round(W.left + W.width), Math.round(W.top)),
					new cy(Math.round(W.left + W.width), Math.round(W.height + W.top)),
					new cy(Math.round(W.left), Math.round(W.height + W.top))
				];
			}
		}, qy = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", Jy = "Hidden Text", Yy = function() {
			function x(x) {
				this._data = {}, this._document = x;
			}
			return x.prototype.parseMetrics = function(x, w) {
				var V = this._document.createElement("div"), U = this._document.createElement("img"), W = this._document.createElement("span"), G = this._document.body;
				V.style.visibility = "hidden", V.style.fontFamily = x, V.style.fontSize = w, V.style.margin = "0", V.style.padding = "0", V.style.whiteSpace = "nowrap", G.appendChild(V), U.src = qy, U.width = 1, U.height = 1, U.style.margin = "0", U.style.padding = "0", U.style.verticalAlign = "baseline", W.style.fontFamily = x, W.style.fontSize = w, W.style.margin = "0", W.style.padding = "0", W.appendChild(this._document.createTextNode(Jy)), V.appendChild(W), V.appendChild(U);
				var K = U.offsetTop - W.offsetTop + 2;
				V.removeChild(W), V.appendChild(this._document.createTextNode(Jy)), V.style.lineHeight = "normal", U.style.verticalAlign = "super";
				var J = U.offsetTop - V.offsetTop + 2;
				return G.removeChild(V), {
					baseline: K,
					middle: J
				};
			}, x.prototype.getMetrics = function(x, w) {
				var V = x + " " + w;
				return this._data[V] === void 0 && (this._data[V] = this.parseMetrics(x, w)), this._data[V];
			}, x;
		}(), Xy = function() {
			function x(x, w) {
				this.context = x, this.options = w;
			}
			return x;
		}(), Zy = 1e4, Qy = function(x) {
			w(V, x);
			function V(w, V) {
				var U = x.call(this, w, V) || this;
				return U._activeEffects = [], U.canvas = V.canvas ? V.canvas : document.createElement("canvas"), U.ctx = U.canvas.getContext("2d"), V.canvas || (U.canvas.width = Math.floor(V.width * V.scale), U.canvas.height = Math.floor(V.height * V.scale), U.canvas.style.width = V.width + "px", U.canvas.style.height = V.height + "px"), U.fontMetrics = new Yy(document), U.ctx.scale(U.options.scale, U.options.scale), U.ctx.translate(-V.x, -V.y), U.ctx.textBaseline = "bottom", U._activeEffects = [], U.context.logger.debug("Canvas renderer initialized (" + V.width + "x" + V.height + ") with scale " + V.scale), U;
			}
			return V.prototype.applyEffects = function(x) {
				for (var w = this; this._activeEffects.length;) this.popEffect();
				x.forEach(function(x) {
					return w.applyEffect(x);
				});
			}, V.prototype.applyEffect = function(x) {
				this.ctx.save(), Cy(x) && (this.ctx.globalAlpha = x.opacity), xy(x) && (this.ctx.translate(x.offsetX, x.offsetY), this.ctx.transform(x.matrix[0], x.matrix[1], x.matrix[2], x.matrix[3], x.matrix[4], x.matrix[5]), this.ctx.translate(-x.offsetX, -x.offsetY)), Sy(x) && (this.path(x.path), this.ctx.clip()), this._activeEffects.push(x);
			}, V.prototype.popEffect = function() {
				this._activeEffects.pop(), this.ctx.restore();
			}, V.prototype.renderStack = function(x) {
				return U(this, void 0, void 0, function() {
					var w;
					return W(this, function(V) {
						switch (V.label) {
							case 0: return w = x.element.container.styles, w.isVisible() ? [4, this.renderStackContent(x)] : [3, 2];
							case 1: V.sent(), V.label = 2;
							case 2: return [2];
						}
					});
				});
			}, V.prototype.renderNode = function(x) {
				return U(this, void 0, void 0, function() {
					return W(this, function(w) {
						switch (w.label) {
							case 0:
								if (Gh(x.container.flags, 16)) debugger;
								return x.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(x)] : [3, 3];
							case 1: return w.sent(), [4, this.renderNodeContent(x)];
							case 2: w.sent(), w.label = 3;
							case 3: return [2];
						}
					});
				});
			}, V.prototype.renderTextWithLetterSpacing = function(x, w, V) {
				var U = this;
				w === 0 ? this.ctx.fillText(x.text, x.bounds.left, x.bounds.top + V) : g_(x.text).reduce(function(w, W) {
					return U.ctx.fillText(W, w, x.bounds.top + V), w + U.ctx.measureText(W).width;
				}, x.bounds.left);
			}, V.prototype.createFontStyle = function(x) {
				var w = x.fontVariant.filter(function(x) {
					return x === "normal" || x === "small-caps";
				}).join(""), V = rb(x.fontFamily).join(", "), U = hp(x.fontSize) ? "" + x.fontSize.number + x.fontSize.unit : x.fontSize.number + "px";
				return [
					[
						x.fontStyle,
						w,
						x.fontWeight,
						U,
						V
					].join(" "),
					V,
					U
				];
			}, V.prototype.renderTextNode = function(x, w) {
				return U(this, void 0, void 0, function() {
					var V, U, G, K, J, Y, Z, $, ql = this;
					return W(this, function(W) {
						return V = this.createFontStyle(w), U = V[0], G = V[1], K = V[2], this.ctx.font = U, this.ctx.direction = w.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", J = this.fontMetrics.getMetrics(G, K), Y = J.baseline, Z = J.middle, $ = w.paintOrder, x.textBounds.forEach(function(x) {
							$.forEach(function(V) {
								switch (V) {
									case 0:
										ql.ctx.fillStyle = Hp(w.color), ql.renderTextWithLetterSpacing(x, w.letterSpacing, Y);
										var U = w.textShadow;
										U.length && x.text.trim().length && (U.slice(0).reverse().forEach(function(V) {
											ql.ctx.shadowColor = Hp(V.color), ql.ctx.shadowOffsetX = V.offsetX.number * ql.options.scale, ql.ctx.shadowOffsetY = V.offsetY.number * ql.options.scale, ql.ctx.shadowBlur = V.blur.number, ql.renderTextWithLetterSpacing(x, w.letterSpacing, Y);
										}), ql.ctx.shadowColor = "", ql.ctx.shadowOffsetX = 0, ql.ctx.shadowOffsetY = 0, ql.ctx.shadowBlur = 0), w.textDecorationLine.length && (ql.ctx.fillStyle = Hp(w.textDecorationColor || w.color), w.textDecorationLine.forEach(function(w) {
											switch (w) {
												case 1:
													ql.ctx.fillRect(x.bounds.left, Math.round(x.bounds.top + Y), x.bounds.width, 1);
													break;
												case 2:
													ql.ctx.fillRect(x.bounds.left, Math.round(x.bounds.top), x.bounds.width, 1);
													break;
												case 3:
													ql.ctx.fillRect(x.bounds.left, Math.ceil(x.bounds.top + Z), x.bounds.width, 1);
													break;
											}
										}));
										break;
									case 1:
										w.webkitTextStrokeWidth && x.text.trim().length && (ql.ctx.strokeStyle = Hp(w.webkitTextStrokeColor), ql.ctx.lineWidth = w.webkitTextStrokeWidth, ql.ctx.lineJoin = window.chrome ? "miter" : "round", ql.ctx.strokeText(x.text, x.bounds.left, x.bounds.top + Y)), ql.ctx.strokeStyle = "", ql.ctx.lineWidth = 0, ql.ctx.lineJoin = "miter";
										break;
								}
							});
						}), [2];
					});
				});
			}, V.prototype.renderReplacedElement = function(x, w, V) {
				if (V && x.intrinsicWidth > 0 && x.intrinsicHeight > 0) {
					var U = Ry(x), W = _y(w);
					this.path(W), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(V, 0, 0, x.intrinsicWidth, x.intrinsicHeight, U.left, U.top, U.width, U.height), this.ctx.restore();
				}
			}, V.prototype.renderNodeContent = function(x) {
				return U(this, void 0, void 0, function() {
					var w, U, G, J, Y, Z, $, $, ql, Jl, Yl, Xl, Zl, Ql, $l, eu, tu, nu, ru, $, iu, Zl, eu;
					return W(this, function(W) {
						switch (W.label) {
							case 0: this.applyEffects(x.getEffects(4)), w = x.container, U = x.curves, G = w.styles, J = 0, Y = w.textNodes, W.label = 1;
							case 1: return J < Y.length ? (Z = Y[J], [4, this.renderTextNode(Z, G)]) : [3, 4];
							case 2: W.sent(), W.label = 3;
							case 3: return J++, [3, 1];
							case 4:
								if (!(w instanceof T_)) return [3, 8];
								W.label = 5;
							case 5: return W.trys.push([
								5,
								7,
								,
								8
							]), [4, this.context.cache.match(w.src)];
							case 6: return $ = W.sent(), this.renderReplacedElement(w, U, $), [3, 8];
							case 7: return W.sent(), this.context.logger.error("Error loading image " + w.src), [3, 8];
							case 8:
								if (w instanceof E_ && this.renderReplacedElement(w, U, w.canvas), !(w instanceof D_)) return [3, 12];
								W.label = 9;
							case 9: return W.trys.push([
								9,
								11,
								,
								12
							]), [4, this.context.cache.match(w.svg)];
							case 10: return $ = W.sent(), this.renderReplacedElement(w, U, $), [3, 12];
							case 11: return W.sent(), this.context.logger.error("Error loading svg " + w.svg.substring(0, 255)), [3, 12];
							case 12: return w instanceof V_ && w.tree ? (ql = new V(this.context, {
								scale: this.options.scale,
								backgroundColor: w.backgroundColor,
								x: 0,
								y: 0,
								width: w.width,
								height: w.height
							}), [4, ql.render(w.tree)]) : [3, 14];
							case 13: Jl = W.sent(), w.width && w.height && this.ctx.drawImage(Jl, 0, 0, w.width, w.height, w.bounds.left, w.bounds.top, w.bounds.width, w.bounds.height), W.label = 14;
							case 14:
								if (w instanceof R_ && (Yl = Math.min(w.bounds.width, w.bounds.height), w.type === P_ ? w.checked && (this.ctx.save(), this.path([
									new cy(w.bounds.left + Yl * .39363, w.bounds.top + Yl * .79),
									new cy(w.bounds.left + Yl * .16, w.bounds.top + Yl * .5549),
									new cy(w.bounds.left + Yl * .27347, w.bounds.top + Yl * .44071),
									new cy(w.bounds.left + Yl * .39694, w.bounds.top + Yl * .5649),
									new cy(w.bounds.left + Yl * .72983, w.bounds.top + Yl * .23),
									new cy(w.bounds.left + Yl * .84, w.bounds.top + Yl * .34085),
									new cy(w.bounds.left + Yl * .39363, w.bounds.top + Yl * .79)
								]), this.ctx.fillStyle = Hp(L_), this.ctx.fill(), this.ctx.restore()) : w.type === F_ && w.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(w.bounds.left + Yl / 2, w.bounds.top + Yl / 2, Yl / 4, 0, Math.PI * 2, !0), this.ctx.fillStyle = Hp(L_), this.ctx.fill(), this.ctx.restore())), $y(w) && w.value.length) {
									switch (Xl = this.createFontStyle(G), Zl = Xl[0], Ql = Xl[1], $l = this.fontMetrics.getMetrics(Zl, Ql).baseline, this.ctx.font = Zl, this.ctx.fillStyle = Hp(G.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = tb(w.styles.textAlign), eu = Ry(w), tu = 0, w.styles.textAlign) {
										case 1:
											tu += eu.width / 2;
											break;
										case 2:
											tu += eu.width;
											break;
									}
									nu = eu.add(tu, 0, 0, -eu.height / 2 + 1), this.ctx.save(), this.path([
										new cy(eu.left, eu.top),
										new cy(eu.left + eu.width, eu.top),
										new cy(eu.left + eu.width, eu.top + eu.height),
										new cy(eu.left, eu.top + eu.height)
									]), this.ctx.clip(), this.renderTextWithLetterSpacing(new f_(w.value, nu), G.letterSpacing, $l), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
								}
								if (!Gh(w.styles.display, 2048)) return [3, 20];
								if (w.styles.listStyleImage === null) return [3, 19];
								if (ru = w.styles.listStyleImage, ru.type !== 0) return [3, 18];
								$ = void 0, iu = ru.url, W.label = 15;
							case 15: return W.trys.push([
								15,
								17,
								,
								18
							]), [4, this.context.cache.match(iu)];
							case 16: return $ = W.sent(), this.ctx.drawImage($, w.bounds.left - ($.width + 10), w.bounds.top), [3, 18];
							case 17: return W.sent(), this.context.logger.error("Error loading list-style-image " + iu), [3, 18];
							case 18: return [3, 20];
							case 19: x.listValue && w.styles.listStyleType !== -1 && (Zl = this.createFontStyle(G)[0], this.ctx.font = Zl, this.ctx.fillStyle = Hp(G.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", eu = new K(w.bounds.left, w.bounds.top + jp(w.styles.paddingTop, w.bounds.width), w.bounds.width, sh(G.lineHeight, G.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new f_(x.listValue, eu), G.letterSpacing, sh(G.lineHeight, G.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), W.label = 20;
							case 20: return [2];
						}
					});
				});
			}, V.prototype.renderStackContent = function(x) {
				return U(this, void 0, void 0, function() {
					var w, V, U, G, K, U, J, Y, U, Z, $, U, ql, Jl, U, Yl, Xl, U, Zl, Ql, U;
					return W(this, function(W) {
						switch (W.label) {
							case 0:
								if (Gh(x.element.container.flags, 16)) debugger;
								return [4, this.renderNodeBackgroundAndBorders(x.element)];
							case 1: W.sent(), w = 0, V = x.negativeZIndex, W.label = 2;
							case 2: return w < V.length ? (U = V[w], [4, this.renderStack(U)]) : [3, 5];
							case 3: W.sent(), W.label = 4;
							case 4: return w++, [3, 2];
							case 5: return [4, this.renderNodeContent(x.element)];
							case 6: W.sent(), G = 0, K = x.nonInlineLevel, W.label = 7;
							case 7: return G < K.length ? (U = K[G], [4, this.renderNode(U)]) : [3, 10];
							case 8: W.sent(), W.label = 9;
							case 9: return G++, [3, 7];
							case 10: J = 0, Y = x.nonPositionedFloats, W.label = 11;
							case 11: return J < Y.length ? (U = Y[J], [4, this.renderStack(U)]) : [3, 14];
							case 12: W.sent(), W.label = 13;
							case 13: return J++, [3, 11];
							case 14: Z = 0, $ = x.nonPositionedInlineLevel, W.label = 15;
							case 15: return Z < $.length ? (U = $[Z], [4, this.renderStack(U)]) : [3, 18];
							case 16: W.sent(), W.label = 17;
							case 17: return Z++, [3, 15];
							case 18: ql = 0, Jl = x.inlineLevel, W.label = 19;
							case 19: return ql < Jl.length ? (U = Jl[ql], [4, this.renderNode(U)]) : [3, 22];
							case 20: W.sent(), W.label = 21;
							case 21: return ql++, [3, 19];
							case 22: Yl = 0, Xl = x.zeroOrAutoZIndexOrTransformedOrOpacity, W.label = 23;
							case 23: return Yl < Xl.length ? (U = Xl[Yl], [4, this.renderStack(U)]) : [3, 26];
							case 24: W.sent(), W.label = 25;
							case 25: return Yl++, [3, 23];
							case 26: Zl = 0, Ql = x.positiveZIndex, W.label = 27;
							case 27: return Zl < Ql.length ? (U = Ql[Zl], [4, this.renderStack(U)]) : [3, 30];
							case 28: W.sent(), W.label = 29;
							case 29: return Zl++, [3, 27];
							case 30: return [2];
						}
					});
				});
			}, V.prototype.mask = function(x) {
				this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(x.slice(0).reverse()), this.ctx.closePath();
			}, V.prototype.path = function(x) {
				this.ctx.beginPath(), this.formatPath(x), this.ctx.closePath();
			}, V.prototype.formatPath = function(x) {
				var w = this;
				x.forEach(function(x, V) {
					var U = dy(x) ? x.start : x;
					V === 0 ? w.ctx.moveTo(U.x, U.y) : w.ctx.lineTo(U.x, U.y), dy(x) && w.ctx.bezierCurveTo(x.startControl.x, x.startControl.y, x.endControl.x, x.endControl.y, x.end.x, x.end.y);
				});
			}, V.prototype.renderRepeat = function(x, w, V, U) {
				this.path(x), this.ctx.fillStyle = w, this.ctx.translate(V, U), this.ctx.fill(), this.ctx.translate(-V, -U);
			}, V.prototype.resizeImage = function(x, w, V) {
				if (x.width === w && x.height === V) return x;
				var U = (this.canvas.ownerDocument ?? document).createElement("canvas");
				return U.width = Math.max(1, w), U.height = Math.max(1, V), U.getContext("2d").drawImage(x, 0, 0, x.width, x.height, 0, 0, w, V), U;
			}, V.prototype.renderBackgroundImage = function(x) {
				return U(this, void 0, void 0, function() {
					var w, V, U, G, K, J;
					return W(this, function(Y) {
						switch (Y.label) {
							case 0: w = x.styles.backgroundImage.length - 1, V = function(V) {
								var G, K, J, Y, Z, $, ql, Jl, Yl, Xl, Y, Z, $, ql, Jl, Zl, Ql, $l, eu, tu, nu, ru, iu, au, Yl, ou, Y, su, cu, ql, Jl, lu, Z, $, uu, du, fu, pu, mu, hu, gu, _u;
								return W(this, function(W) {
									switch (W.label) {
										case 0:
											if (V.type !== 0) return [3, 5];
											G = void 0, K = V.url, W.label = 1;
										case 1: return W.trys.push([
											1,
											3,
											,
											4
										]), [4, U.context.cache.match(K)];
										case 2: return G = W.sent(), [3, 4];
										case 3: return W.sent(), U.context.logger.error("Error loading background-image " + K), [3, 4];
										case 4: return G && (J = Vy(x, w, [
											G.width,
											G.height,
											G.width / G.height
										]), Y = J[0], Z = J[1], $ = J[2], ql = J[3], Jl = J[4], Yl = U.ctx.createPattern(U.resizeImage(G, ql, Jl), "repeat"), U.renderRepeat(Y, Yl, Z, $)), [3, 6];
										case 5: ym(V) ? (Xl = Vy(x, w, [
											null,
											null,
											null
										]), Y = Xl[0], Z = Xl[1], $ = Xl[2], ql = Xl[3], Jl = Xl[4], Zl = nm(V.angle, ql, Jl), Ql = Zl[0], $l = Zl[1], eu = Zl[2], tu = Zl[3], nu = Zl[4], ru = document.createElement("canvas"), ru.width = ql, ru.height = Jl, iu = ru.getContext("2d"), au = iu.createLinearGradient($l, tu, eu, nu), em(V.stops, Ql).forEach(function(x) {
											return au.addColorStop(x.stop, Hp(x.color));
										}), iu.fillStyle = au, iu.fillRect(0, 0, ql, Jl), ql > 0 && Jl > 0 && (Yl = U.ctx.createPattern(ru, "repeat"), U.renderRepeat(Y, Yl, Z, $))) : bm(V) && (ou = Vy(x, w, [
											null,
											null,
											null
										]), Y = ou[0], su = ou[1], cu = ou[2], ql = ou[3], Jl = ou[4], lu = V.position.length === 0 ? [Op] : V.position, Z = jp(lu[0], ql), $ = jp(lu[lu.length - 1], Jl), uu = am(V, Z, $, ql, Jl), du = uu[0], fu = uu[1], du > 0 && fu > 0 && (pu = U.ctx.createRadialGradient(su + Z, cu + $, 0, su + Z, cu + $, du), em(V.stops, du * 2).forEach(function(x) {
											return pu.addColorStop(x.stop, Hp(x.color));
										}), U.path(Y), U.ctx.fillStyle = pu, du === fu ? U.ctx.fill() : (mu = x.bounds.left + .5 * x.bounds.width, hu = x.bounds.top + .5 * x.bounds.height, gu = fu / du, _u = 1 / gu, U.ctx.save(), U.ctx.translate(mu, hu), U.ctx.transform(1, 0, 0, gu, 0, 0), U.ctx.translate(-mu, -hu), U.ctx.fillRect(su, _u * (cu - hu) + hu, ql, Jl * _u), U.ctx.restore()))), W.label = 6;
										case 6: return w--, [2];
									}
								});
							}, U = this, G = 0, K = x.styles.backgroundImage.slice(0).reverse(), Y.label = 1;
							case 1: return G < K.length ? (J = K[G], [5, V(J)]) : [3, 4];
							case 2: Y.sent(), Y.label = 3;
							case 3: return G++, [3, 1];
							case 4: return [2];
						}
					});
				});
			}, V.prototype.renderSolidBorder = function(x, w, V) {
				return U(this, void 0, void 0, function() {
					return W(this, function(U) {
						return this.path(jy(V, w)), this.ctx.fillStyle = Hp(x), this.ctx.fill(), [2];
					});
				});
			}, V.prototype.renderDoubleBorder = function(x, w, V, G) {
				return U(this, void 0, void 0, function() {
					var U, K;
					return W(this, function(W) {
						switch (W.label) {
							case 0: return w < 3 ? [4, this.renderSolidBorder(x, V, G)] : [3, 2];
							case 1: return W.sent(), [2];
							case 2: return U = My(G, V), this.path(U), this.ctx.fillStyle = Hp(x), this.ctx.fill(), K = Ny(G, V), this.path(K), this.ctx.fill(), [2];
						}
					});
				});
			}, V.prototype.renderNodeBackgroundAndBorders = function(x) {
				return U(this, void 0, void 0, function() {
					var w, V, U, G, K, J, Y, Z, $ = this;
					return W(this, function(W) {
						switch (W.label) {
							case 0: return this.applyEffects(x.getEffects(2)), w = x.container.styles, V = !Vp(w.backgroundColor) || w.backgroundImage.length, U = [
								{
									style: w.borderTopStyle,
									color: w.borderTopColor,
									width: w.borderTopWidth
								},
								{
									style: w.borderRightStyle,
									color: w.borderRightColor,
									width: w.borderRightWidth
								},
								{
									style: w.borderBottomStyle,
									color: w.borderBottomColor,
									width: w.borderBottomWidth
								},
								{
									style: w.borderLeftStyle,
									color: w.borderLeftColor,
									width: w.borderLeftWidth
								}
							], G = eb(Gy(w.backgroundClip, 0), x.curves), V || w.boxShadow.length ? (this.ctx.save(), this.path(G), this.ctx.clip(), Vp(w.backgroundColor) || (this.ctx.fillStyle = Hp(w.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(x.container)]) : [3, 2];
							case 1: W.sent(), this.ctx.restore(), w.boxShadow.slice(0).reverse().forEach(function(w) {
								$.ctx.save();
								var V = hy(x.curves), U = w.inset ? 0 : Zy, W = Ty(V, -U + (w.inset ? 1 : -1) * w.spread.number, (w.inset ? 1 : -1) * w.spread.number, w.spread.number * (w.inset ? -2 : 2), w.spread.number * (w.inset ? -2 : 2));
								w.inset ? ($.path(V), $.ctx.clip(), $.mask(W)) : ($.mask(V), $.ctx.clip(), $.path(W)), $.ctx.shadowOffsetX = w.offsetX.number + U, $.ctx.shadowOffsetY = w.offsetY.number, $.ctx.shadowColor = Hp(w.color), $.ctx.shadowBlur = w.blur.number, $.ctx.fillStyle = w.inset ? Hp(w.color) : "rgba(0,0,0,1)", $.ctx.fill(), $.ctx.restore();
							}), W.label = 2;
							case 2: K = 0, J = 0, Y = U, W.label = 3;
							case 3: return J < Y.length ? (Z = Y[J], Z.style !== 0 && !Vp(Z.color) && Z.width > 0 ? Z.style === 2 ? [4, this.renderDashedDottedBorder(Z.color, Z.width, K, x.curves, 2)] : [3, 5] : [3, 11]) : [3, 13];
							case 4: return W.sent(), [3, 11];
							case 5: return Z.style === 3 ? [4, this.renderDashedDottedBorder(Z.color, Z.width, K, x.curves, 3)] : [3, 7];
							case 6: return W.sent(), [3, 11];
							case 7: return Z.style === 4 ? [4, this.renderDoubleBorder(Z.color, Z.width, K, x.curves)] : [3, 9];
							case 8: return W.sent(), [3, 11];
							case 9: return [4, this.renderSolidBorder(Z.color, K, x.curves)];
							case 10: W.sent(), W.label = 11;
							case 11: K++, W.label = 12;
							case 12: return J++, [3, 3];
							case 13: return [2];
						}
					});
				});
			}, V.prototype.renderDashedDottedBorder = function(x, w, V, G, K) {
				return U(this, void 0, void 0, function() {
					var U, J, Y, Z, $, ql, Jl, Yl, Xl, Zl, Ql, $l, eu, tu, nu, ru, nu, ru;
					return W(this, function(W) {
						return this.ctx.save(), U = Py(G, V), J = jy(G, V), K === 2 && (this.path(J), this.ctx.clip()), dy(J[0]) ? (Y = J[0].start.x, Z = J[0].start.y) : (Y = J[0].x, Z = J[0].y), dy(J[1]) ? ($ = J[1].end.x, ql = J[1].end.y) : ($ = J[1].x, ql = J[1].y), Jl = V === 0 || V === 2 ? Math.abs(Y - $) : Math.abs(Z - ql), this.ctx.beginPath(), K === 3 ? this.formatPath(U) : this.formatPath(J.slice(0, 2)), Yl = w < 3 ? w * 3 : w * 2, Xl = w < 3 ? w * 2 : w, K === 3 && (Yl = w, Xl = w), Zl = !0, Jl <= Yl * 2 ? Zl = !1 : Jl <= Yl * 2 + Xl ? (Ql = Jl / (2 * Yl + Xl), Yl *= Ql, Xl *= Ql) : ($l = Math.floor((Jl + Xl) / (Yl + Xl)), eu = (Jl - $l * Yl) / ($l - 1), tu = (Jl - ($l + 1) * Yl) / $l, Xl = tu <= 0 || Math.abs(Xl - eu) < Math.abs(Xl - tu) ? eu : tu), Zl && (K === 3 ? this.ctx.setLineDash([0, Yl + Xl]) : this.ctx.setLineDash([Yl, Xl])), K === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = w) : this.ctx.lineWidth = w * 2 + 1.1, this.ctx.strokeStyle = Hp(x), this.ctx.stroke(), this.ctx.setLineDash([]), K === 2 && (dy(J[0]) && (nu = J[3], ru = J[0], this.ctx.beginPath(), this.formatPath([new cy(nu.end.x, nu.end.y), new cy(ru.start.x, ru.start.y)]), this.ctx.stroke()), dy(J[1]) && (nu = J[1], ru = J[2], this.ctx.beginPath(), this.formatPath([new cy(nu.end.x, nu.end.y), new cy(ru.start.x, ru.start.y)]), this.ctx.stroke())), this.ctx.restore(), [2];
					});
				});
			}, V.prototype.render = function(x) {
				return U(this, void 0, void 0, function() {
					var w;
					return W(this, function(V) {
						switch (V.label) {
							case 0: return this.options.backgroundColor && (this.ctx.fillStyle = Hp(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), w = Ay(x), [4, this.renderStack(w)];
							case 1: return V.sent(), this.applyEffects([]), [2, this.canvas];
						}
					});
				});
			}, V;
		}(Xy), $y = function(x) {
			return x instanceof B_ || x instanceof z_ ? !0 : x instanceof R_ && x.type !== F_ && x.type !== P_;
		}, eb = function(x, w) {
			switch (x) {
				case 0: return hy(w);
				case 2: return gy(w);
				case 1:
				default: return _y(w);
			}
		}, tb = function(x) {
			switch (x) {
				case 1: return "center";
				case 2: return "right";
				case 0:
				default: return "left";
			}
		}, nb = ["-apple-system", "system-ui"], rb = function(x) {
			return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? x.filter(function(x) {
				return nb.indexOf(x) === -1;
			}) : x;
		}, ib = function(x) {
			w(V, x);
			function V(w, V) {
				var U = x.call(this, w, V) || this;
				return U.canvas = V.canvas ? V.canvas : document.createElement("canvas"), U.ctx = U.canvas.getContext("2d"), U.options = V, U.canvas.width = Math.floor(V.width * V.scale), U.canvas.height = Math.floor(V.height * V.scale), U.canvas.style.width = V.width + "px", U.canvas.style.height = V.height + "px", U.ctx.scale(U.options.scale, U.options.scale), U.ctx.translate(-V.x, -V.y), U.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + V.width + "x" + V.height + " at " + V.x + "," + V.y + ") with scale " + V.scale), U;
			}
			return V.prototype.render = function(x) {
				return U(this, void 0, void 0, function() {
					var w, V;
					return W(this, function(U) {
						switch (U.label) {
							case 0: return w = l_(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, x), [4, ab(w)];
							case 1: return V = U.sent(), this.options.backgroundColor && (this.ctx.fillStyle = Hp(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(V, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
						}
					});
				});
			}, V;
		}(Xy), ab = function(x) {
			return new Promise(function(w, V) {
				var U = new Image();
				U.onload = function() {
					w(U);
				}, U.onerror = V, U.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(x));
			});
		}, ob = function() {
			function x(x) {
				var w = x.id, V = x.enabled;
				this.id = w, this.enabled = V, this.start = Date.now();
			}
			return x.prototype.debug = function() {
				var x = [...arguments];
				this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug.apply(console, G([this.id, this.getTime() + "ms"], x)) : this.info.apply(this, x));
			}, x.prototype.getTime = function() {
				return Date.now() - this.start;
			}, x.prototype.info = function() {
				var x = [...arguments];
				this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info.apply(console, G([this.id, this.getTime() + "ms"], x));
			}, x.prototype.warn = function() {
				var x = [...arguments];
				this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn.apply(console, G([this.id, this.getTime() + "ms"], x)) : this.info.apply(this, x));
			}, x.prototype.error = function() {
				var x = [...arguments];
				this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error.apply(console, G([this.id, this.getTime() + "ms"], x)) : this.info.apply(this, x));
			}, x.instances = {}, x;
		}(), sb = function() {
			function x(w, V) {
				this.windowBounds = V, this.instanceName = "#" + x.instanceCount++, this.logger = new ob({
					id: this.instanceName,
					enabled: w.logging
				}), this.cache = w.cache ?? new $v(this, w);
			}
			return x.instanceCount = 1, x;
		}(), cb = function(x, w) {
			return w === void 0 && (w = {}), lb(x, w);
		};
		typeof window < "u" && Qv.setContext(window);
		var lb = function(x, w) {
			return U(void 0, void 0, void 0, function() {
				var U, G, Z, $, ql, Jl, Yl, Xl, Zl, Ql, $l, eu, tu, nu, ru, iu, au, ou, su, cu, lu, uu, lu;
				return W(this, function(W) {
					switch (W.label) {
						case 0:
							if (!x || typeof x != "object") return [2, Promise.reject("Invalid element provided as first argument")];
							if (U = x.ownerDocument, !U) throw Error("Element is not attached to a Document");
							if (G = U.defaultView, !G) throw Error("Document is not attached to a Window");
							return Z = {
								allowTaint: w.allowTaint ?? !1,
								imageTimeout: w.imageTimeout ?? 15e3,
								proxy: w.proxy,
								useCORS: w.useCORS ?? !1
							}, $ = V({
								logging: w.logging ?? !0,
								cache: w.cache
							}, Z), ql = {
								windowWidth: w.windowWidth ?? G.innerWidth,
								windowHeight: w.windowHeight ?? G.innerHeight,
								scrollX: w.scrollX ?? G.pageXOffset,
								scrollY: w.scrollY ?? G.pageYOffset
							}, Jl = new K(ql.scrollX, ql.scrollY, ql.windowWidth, ql.windowHeight), Yl = new sb($, Jl), Xl = w.foreignObjectRendering ?? !1, Zl = {
								allowTaint: w.allowTaint ?? !1,
								onclone: w.onclone,
								ignoreElements: w.ignoreElements,
								inlineImages: Xl,
								copyStyles: Xl
							}, Yl.logger.debug("Starting document clone with size " + Jl.width + "x" + Jl.height + " scrolled to " + -Jl.left + "," + -Jl.top), Ql = new Pv(Yl, x, Zl), $l = Ql.clonedReferenceElement, $l ? [4, Ql.toIFrame(U, Jl)] : [2, Promise.reject("Unable to find element in cloned iframe")];
						case 1: return eu = W.sent(), tu = rv($l) || tv($l) ? Y($l.ownerDocument) : J(Yl, $l), nu = tu.width, ru = tu.height, iu = tu.left, au = tu.top, ou = ub(Yl, $l, w.backgroundColor), su = {
							canvas: w.canvas,
							backgroundColor: ou,
							scale: w.scale ?? G.devicePixelRatio ?? 1,
							x: (w.x ?? 0) + iu,
							y: (w.y ?? 0) + au,
							width: w.width ?? Math.ceil(nu),
							height: w.height ?? Math.ceil(ru)
						}, Xl ? (Yl.logger.debug("Document cloned, using foreign object rendering"), lu = new ib(Yl, su), [4, lu.render($l)]) : [3, 3];
						case 2: return cu = W.sent(), [3, 5];
						case 3: return Yl.logger.debug("Document cloned, element located at " + iu + "," + au + " with size " + nu + "x" + ru + " using computed rendering"), Yl.logger.debug("Starting DOM parsing"), uu = G_(Yl, $l), ou === uu.styles.backgroundColor && (uu.styles.backgroundColor = Xp.TRANSPARENT), Yl.logger.debug("Starting renderer for element at " + su.x + "," + su.y + " with size " + su.width + "x" + su.height), lu = new Qy(Yl, su), [4, lu.render(uu)];
						case 4: cu = W.sent(), W.label = 5;
						case 5: return (w.removeContainer ?? !0) && (Pv.destroy(eu) || Yl.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore")), Yl.logger.debug("Finished rendering"), [2, cu];
					}
				});
			});
		}, ub = function(x, w, V) {
			var U = w.ownerDocument, W = U.documentElement ? Yp(x, getComputedStyle(U.documentElement).backgroundColor) : Xp.TRANSPARENT, G = U.body ? Yp(x, getComputedStyle(U.body).backgroundColor) : Xp.TRANSPARENT, K = typeof V == "string" ? Yp(x, V) : V === null ? Xp.TRANSPARENT : 4294967295;
			return w === U.documentElement ? Vp(W) ? Vp(G) ? K : G : W : K;
		};
		return cb;
	}));
})), darkStyles = {
	body: { background: "rgb(32, 32, 32)" },
	rbgcpInputLabel: { color: "rgb(212, 212, 212)" },
	rbgcpControlBtnWrapper: { background: "rgb(54, 54, 54)" },
	rbgcpInput: {
		border: "none",
		color: "white",
		background: "rgb(54, 54, 54)"
	},
	rbgcpControlBtn: { color: "rgb(212, 212, 212)" },
	rbgcpControlIcon: { stroke: "rgb(212, 212, 212)" },
	rbgcpControlIcon2: { fill: "rgb(212, 212, 212)" },
	rbgcpControlInput: { color: "white" },
	rbgcpControlBtnSelected: {
		background: "black",
		color: "#568cf5"
	},
	rbgcpDegreeIcon: { color: "rgb(212, 212, 212)" },
	rbgcpColorModelDropdown: { background: "rgb(32, 32, 32)" },
	rbgcpComparibleLabel: { color: "rgb(212, 212, 212)" }
}, __assign$8 = function() {
	return __assign$8 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$8.apply(this, arguments);
}, styles = {
	body: {
		boxSizing: "border-box",
		background: "rgb(255, 255, 255)"
	},
	rbgcpControlBtn: {
		paddingLeft: "8px",
		paddingRight: "8px",
		lineHeight: "1",
		borderRadius: "4px",
		fontWeight: 700,
		fontSize: "12px",
		height: "24px",
		transition: "all 160ms ease",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		background: "rgba(255, 255, 255, 0)",
		boxShadow: "1px 1px 3px rgba(0, 0, 0, 0)",
		color: "rgb(86, 86, 86)"
	},
	rbgcpControlIcon: { stroke: "rgb(50, 49, 54)" },
	rbgcpControlIconBtn: {
		width: "30px",
		height: "24px",
		borderRadius: "4px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		position: "relative"
	},
	rbgcpControlBtnWrapper: {
		height: "28px",
		background: "#e9e9f5",
		borderRadius: "6px",
		padding: "2px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		position: "relative"
	},
	rbgcpColorModelDropdown: {
		position: "absolute",
		right: "-2px",
		top: "34px",
		padding: "5px",
		background: "#e9e9f5",
		zIndex: 1e8,
		borderRadius: "6px",
		boxShadow: "1px 1px 14px 1px rgba(0, 0, 0, 0.25)"
	},
	rbgcpEyedropperCover: {
		position: "fixed",
		left: "0px",
		top: "0px",
		zIndex: 1e8,
		width: "100vw",
		height: "100vh",
		cursor: "copy"
	},
	rbgcpControlInput: {
		height: "24px",
		borderRadius: "4px",
		border: "none",
		outline: "none",
		textAlign: "center",
		width: "34px",
		fontWeight: 500,
		color: "rgb(50, 49, 54)",
		fontSize: "13px",
		background: "transparent"
	},
	rbgcpInputLabel: {
		textAlign: "center",
		lineHeight: "1.2",
		fontWeight: 700,
		color: "rgb(86, 86, 86)",
		fontSize: "11px"
	},
	rbgcpInput: {
		height: "32px",
		borderRadius: "6px",
		border: "1px solid #bebebe",
		width: "100%",
		padding: "2px",
		outline: "none",
		color: "black",
		fontWeight: 400,
		textAlign: "center",
		background: "transparent",
		fontSize: "15px"
	},
	rbgcpHandle: {
		position: "absolute",
		border: "2px solid white",
		borderRadius: "50%",
		boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.5)",
		width: "18px",
		height: "18px",
		zIndex: 1e3,
		transition: "all 30ms linear",
		boxSizing: "border-box",
		willChange: "transform",
		outline: "none"
	},
	rbgcpCanvasWrapper: {
		borderRadius: "6px",
		overflow: "hidden",
		height: "294px"
	},
	rbgcpCheckered: {
		background: "linear-gradient(\n      45deg,\n      rgba(0, 0, 0, 0.18) 25%,\n      transparent 25%,\n      transparent 75%,\n      rgba(0, 0, 0, 0.18) 75%,\n      rgba(0, 0, 0, 0.18) 0\n    ),\n    linear-gradient(\n      45deg,\n      rgba(0, 0, 0, 0.18) 25%,\n      transparent 25%,\n      transparent 75%,\n      rgba(0, 0, 0, 0.18) 75%,\n      rgba(0, 0, 0, 0.18) 0\n    ),\n    white",
		backgroundRepeat: "repeat, repeat",
		backgroundPosition: "0px 0, 7px 7px",
		transformOrigin: "0 0 0",
		backgroundOrigin: "padding-box, padding-box",
		backgroundClip: "border-box, border-box",
		backgroundSize: "14px 14px, 14px 14px",
		boxShadow: "none",
		textShadow: "none",
		transition: "none",
		transform: "scaleX(1) scaleY(1) scaleZ(1)",
		borderRadius: "10px"
	},
	rbgcpOpacityOverlay: {
		position: "absolute",
		left: "0px",
		top: "0px",
		width: "100%",
		height: "100%",
		borderRadius: "10px"
	},
	rbgcpGradientHandleWrap: {
		position: "absolute",
		zIndex: 1e4,
		top: "-2px",
		outline: "none"
	},
	rbgcpGradientHandle: {
		border: "2px solid white",
		borderRadius: "50%",
		boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.5)",
		width: "18px",
		height: "18px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	rbgcpControlIcon2: { fill: "#323136" },
	rbgcpControlBtnSelected: {
		background: "white",
		color: "#568cf5",
		boxShadow: "1px 1px 3px rgba(0, 0, 0, 0.2)"
	},
	rbgcpComparibleLabel: { color: "#323136" }
}, getStyles = function(x, w) {
	var V = __assign$8({}, styles);
	if (x) for (var U in darkStyles) Object.prototype.hasOwnProperty.call(darkStyles, U) && (V[U] = __assign$8(__assign$8({}, Object.prototype.hasOwnProperty.call(V, U) ? V[U] : {}), darkStyles[U]));
	for (var U in w) Object.prototype.hasOwnProperty.call(w, U) && (V[U] = __assign$8(__assign$8({}, Object.prototype.hasOwnProperty.call(V, U) ? V[U] : {}), w[U]));
	return V;
}, colorTypeBtnStyles = function(x, w) {
	return x ? __assign$8(__assign$8({}, w.rbgcpControlBtn), w.rbgcpControlBtnSelected) : __assign$8({}, w.rbgcpControlBtn);
}, controlBtnStyles = function(x, w) {
	return x ? __assign$8(__assign$8({}, w.rbgcpControlIconBtn), w.rbgcpControlBtnSelected) : __assign$8({}, w.rbgcpControlIconBtn);
}, modalBtnStyles = function(x, w) {
	return x ? __assign$8(__assign$8(__assign$8({}, w.rbgcpControlBtn), w.rbgcpColorModelDropdownBtn), w.rbgcpControlBtnSelected) : __assign$8(__assign$8({}, w.rbgcpControlBtn), w.rbgcpColorModelDropdownBtn);
}, import_html2canvas = /* @__PURE__ */ __toESM(require_html2canvas(), 1), import_tinycolor$1 = /* @__PURE__ */ __toESM(require_tinycolor(), 1), __assign$7 = function() {
	return __assign$7 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$7.apply(this, arguments);
}, DropperIcon = function(x) {
	var w = x.color, V = usePicker().defaultStyles, U = w ?? "";
	return React.createElement("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		style: { width: 16 }
	}, React.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$7(__assign$7({
			fill: "none",
			strokeWidth: "1.4px"
		}, V.rbgcpControlIcon), U && { stroke: U }),
		d: "M15.6,7h0L7.78,14.86c-.37.37-1.61.38-2,.75s-.5,1.53-.76,2a3.53,3.53,0,0,1-.52.52,1.6,1.6,0,0,1-2.27-.06l-.32-.32a1.61,1.61,0,0,1-.06-2.27A3.25,3.25,0,0,1,2.4,15c.47-.26,1.65-.35,2-.73s.34-1.64.71-2c1.68-1.73,5.61-5.65,7.91-7.93h0l1.14,1.38L15.6,7Z"
	}), React.createElement("polygon", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$7(__assign$7({ strokeWidth: "1.4px" }, V.rbgcpControlIcon2), U && {
			stroke: U,
			fill: U
		}),
		points: "15.7 8.87 11.13 4.29 12.69 2.73 17.25 7.31 15.7 8.87"
	}), React.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		style: __assign$7(__assign$7({ strokeWidth: "1.4px" }, V.rbgcpControlIcon2), U && {
			stroke: U,
			fill: U
		}),
		d: "M18.18,3.71,16.36,5.53a1.33,1.33,0,0,1-1.88,0h0a1.34,1.34,0,0,1,0-1.89l1.81-1.82a1.34,1.34,0,0,1,1.89,0h0A1.34,1.34,0,0,1,18.18,3.71Z"
	}));
}, EyeDropper_default = function(x) {
	var w = x.onSelect, V = usePicker().defaultStyles, U = useState(null), W = U[0], G = U[1], K = useState(!1), J = K[0], Y = K[1], Z = useState(!1), $ = Z[0], ql = Z[1], Jl = function() {
		var x = document.getElementById("root");
		Y(!0), (0, import_html2canvas.default)(x).then(function(w) {
			var V = document.createElement("canvas"), U = V.getContext("2d", { willReadFrequently: !0 });
			x && U && (V.width = x.offsetWidth * 2, V.height = x.offsetHeight * 2, U.drawImage(w, 0, 0)), G(U);
		});
	}, Yl = function(x) {
		if (x.stopPropagation(), W) {
			var V = x.pageX, U = x.pageY, G = V * 2, K = U * 2, J = W.getImageData(G, K, 1, 1).data;
			w(`rgba(${J[0]}, ${J[1]}, ${J[2]}, 1)`);
		}
		ql(!1), Y(!1);
	};
	return React.createElement("div", null, React.createElement("div", {
		onClick: function() {
			if (ql(!0), !window.EyeDropper) Jl();
			else {
				var x = new window.EyeDropper(), V = new window.AbortController();
				x.open({ signal: V.signal }).then(function(x) {
					var V = (0, import_tinycolor$1.default)(x.sRGBHex).toRgb(), U = V.r, W = V.g, G = V.b;
					w(`rgba(${U}, ${W}, ${G}, 1)`), ql(!1);
				}).catch(function(x) {
					console.log(x), ql(!1);
				});
			}
		},
		id: "rbgcp-eyedropper-btn",
		style: __assign$7(__assign$7({}, V.rbgcpEyedropperBtn), controlBtnStyles(J, V))
	}, React.createElement(DropperIcon, { color: $ ? "rgb(86, 140, 245)" : "" })), J && React.createElement(Portal_default, null, React.createElement("div", {
		onClick: function(x) {
			return Yl(x);
		},
		style: V.rbgcpEyedropperCover
	})));
}, import_tinycolor = /* @__PURE__ */ __toESM(require_tinycolor(), 1), __assign$6 = function() {
	return __assign$6 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$6.apply(this, arguments);
}, AdvBar = function(x) {
	var w = x.value, V = x.reffy, U = x.label, W = x.config, G = x.callback, K = x.squareWidth, J = x.openAdvanced, Y = x.defaultStyles, Z = x.pickerIdSuffix, $ = W.barSize, ql = useState(!1), Jl = ql[0], Yl = ql[1], Xl = useState(2), Zl = Xl[0], $l = Xl[1], eu = w * (K - 18);
	useEffect(function() {
		$l(V?.current?.offsetTop - 2);
	}, [J, V]);
	var tu = function() {
		Yl(!1);
	}, nu = function(x) {
		Jl && G(getHandleValue(x, $));
	}, ru = function(x) {
		Jl || G(getHandleValue(x, $));
	};
	return useEffect(function() {
		var x = function() {
			tu();
		};
		return window.addEventListener("mouseup", x), function() {
			window.removeEventListener("mouseup", x);
		};
	}, []), React.createElement("div", { style: {
		width: "100%",
		padding: "3px 0px 3px 0px"
	} }, React.createElement("div", {
		onMouseMove: function(x) {
			return nu(x);
		},
		style: {
			cursor: "resize",
			position: "relative"
		},
		id: `rbgcp-advanced-bar-${U}-wrapper${Z}`
	}, React.createElement("div", {
		style: __assign$6({
			left: eu,
			top: Zl
		}, Y.rbgcpHandle),
		id: `rbgcp-advanced-bar-${U}-handle${Z}`,
		onMouseDown: function() {
			Yl(!0);
		},
		role: "button",
		tabIndex: 0
	}), React.createElement("div", {
		style: {
			textAlign: "center",
			color: "#fff",
			fontSize: 12,
			fontWeight: 500,
			lineHeight: 1,
			position: "absolute",
			left: "50%",
			transform: "translate(-50%, 0%)",
			top: Zl + 2,
			zIndex: 10,
			textShadow: "1px 1px 1px rgba(0,0,0,.6)"
		},
		id: `rbgcp-advanced-bar-${U}-label${Z}`,
		onMouseMove: function(x) {
			return nu(x);
		},
		onClick: function(x) {
			return ru(x);
		},
		tabIndex: 0,
		role: "button",
		onKeyDown: function() {}
	}, U), React.createElement("canvas", {
		ref: V,
		height: "14px",
		width: `${K}px`,
		onClick: function(x) {
			return ru(x);
		},
		style: {
			position: "relative",
			borderRadius: 14
		},
		id: `rbgcp-advanced-bar-${U}-canvas${Z}`
	})));
}, AdvancedControls_default = function(x) {
	var w = x.openAdvanced, V = usePicker(), U = V.config, W = V.tinyColor, G = V.handleChange, K = V.squareWidth, J = V.hc, Y = V.defaultStyles, Z = V.pickerIdSuffix, $ = W.toHsl(), ql = $.s, Jl = $.l, Yl = useRef(null), Xl = useRef(null), Zl = useRef(null);
	return usePaintSat(Yl, J?.h, Jl * 100, K), usePaintLight(Xl, J?.h, ql * 100, K), usePaintBright(Zl, J?.h, ql * 100, K), React.createElement("div", {
		style: {
			width: "100%",
			height: w ? 98 : 0,
			transition: "all 120ms linear"
		},
		id: `rbgcp-advanced-controls-wrapper${Z}`
	}, React.createElement("div", {
		style: {
			paddingTop: 11,
			display: w ? "flex" : "none",
			flexDirection: "column",
			justifyContent: "space-between",
			height: w ? 98 : 0,
			overflow: "hidden",
			transition: "height 100ms linear"
		},
		id: `rbgcp-advanced-controls-inner${Z}`
	}, React.createElement(AdvBar, {
		value: ql,
		reffy: Yl,
		config: U,
		label: "Saturation",
		callback: function(x) {
			var w = (0, import_tinycolor.default)({
				h: J?.h,
				s: x / 100,
				l: Jl
			}).toRgb(), V = w.r, U = w.g, W = w.b;
			G(`rgba(${V},${U},${W},${J?.a})`);
		},
		squareWidth: K,
		openAdvanced: w,
		defaultStyles: Y,
		pickerIdSuffix: Z
	}), React.createElement(AdvBar, {
		value: Jl,
		config: U,
		reffy: Xl,
		label: "Lightness",
		callback: function(x) {
			var w = (0, import_tinycolor.default)({
				h: J?.h,
				s: ql,
				l: x / 100
			}).toRgb(), V = w.r, U = w.g, W = w.b;
			G(`rgba(${V},${U},${W},${J?.a})`);
		},
		squareWidth: K,
		openAdvanced: w,
		defaultStyles: Y,
		pickerIdSuffix: Z
	}), React.createElement(AdvBar, {
		value: J?.v,
		config: U,
		reffy: Zl,
		label: "Brightness",
		callback: function(x) {
			var w = (0, import_tinycolor.default)({
				h: J?.h,
				s: J?.s * 100,
				v: x
			}).toRgb(), V = w.r, U = w.g, W = w.b;
			G(`rgba(${V},${U},${W},${J?.a})`);
		},
		squareWidth: K,
		openAdvanced: w,
		defaultStyles: Y,
		pickerIdSuffix: Z
	})));
}, __assign$5 = function() {
	return __assign$5 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$5.apply(this, arguments);
}, ComparibleColors_default = function(x) {
	var w = x.openComparibles, V = usePicker(), U = V.tinyColor, W = V.handleChange, G = V.defaultStyles, K = V.pickerIdSuffix, J = U.analogous(), Y = U.monochromatic(), Z = U.triad(), $ = U.tetrad(), ql = function(x) {
		var w = x.toRgb(), V = w.r, U = w.g, G = w.b, K = w.a;
		W(`rgba(${V},${U},${G},${K})`);
	};
	return React.createElement("div", {
		style: {
			width: "100%",
			transition: "all 120ms linear",
			height: w ? 216 : 0
		},
		id: `rbgcp-comparible-colors-wrapper${K}`
	}, React.createElement("div", {
		style: {
			paddingTop: 11,
			display: w ? "" : "none",
			position: "relative"
		},
		id: `rbgcp-comparible-colors-inner${K}`
	}, React.createElement("div", {
		style: __assign$5({
			textAlign: "center",
			fontSize: 13,
			fontWeight: 600,
			position: "absolute",
			top: 6.5,
			left: 2
		}, G.rbgcpComparibleLabel),
		id: `rbgcp-comparible-color-guide-label${K}`
	}, "Color Guide"), React.createElement("div", {
		style: __assign$5({
			textAlign: "center",
			fontSize: 12,
			fontWeight: 500,
			marginTop: 3
		}, G.rbgcpComparibleLabel),
		id: `rbgcp-comparible-analogous-colors-label${K}`
	}, "Analogous"), React.createElement("div", {
		style: {
			borderRadius: 5,
			overflow: "hidden",
			display: "flex"
		},
		id: `rbgcp-comparible-analogous-colors${K}`
	}, J?.map(function(x, w) {
		return React.createElement("div", {
			key: w,
			id: `rbgcp-comparible-analogous-color-${w}${K}`,
			style: {
				width: "20%",
				height: 30,
				background: x.toHexString()
			},
			onClick: function() {
				return ql(x);
			}
		});
	})), React.createElement("div", {
		style: __assign$5({
			textAlign: "center",
			fontSize: 12,
			fontWeight: 500,
			marginTop: 3
		}, G.rbgcpComparibleLabel),
		id: `rbgcp-comparible-monochromatic-colors-label${K}`
	}, "Monochromatic"), React.createElement("div", {
		style: {
			borderRadius: 5,
			overflow: "hidden",
			display: "flex",
			justifyContent: "flex-end"
		},
		id: `rbgcp-comparible-monochromatic-colors${K}`
	}, Y?.map(function(x, w) {
		return React.createElement("div", {
			key: w,
			id: `rbgcp-comparible-monochromatic-color-${w}${K}`,
			style: {
				width: "20%",
				height: 30,
				background: x.toHexString()
			},
			onClick: function() {
				return ql(x);
			}
		});
	})), React.createElement("div", {
		style: __assign$5({
			textAlign: "center",
			fontSize: 12,
			fontWeight: 500,
			marginTop: 3
		}, G.rbgcpComparibleLabel),
		id: `rbgcp-comparible-triad-colors-label${K}`
	}, "Triad"), React.createElement("div", {
		style: {
			borderRadius: 5,
			overflow: "hidden",
			display: "flex",
			justifyContent: "flex-end"
		},
		id: `rbgcp-comparible-triad-colors${K}`
	}, Z?.map(function(x, w) {
		return React.createElement("div", {
			key: w,
			id: `rbgcp-comparible-triad-color-${w}${K}`,
			style: {
				width: "calc(100% / 3)",
				height: 28,
				background: x.toHexString()
			},
			onClick: function() {
				return ql(x);
			}
		});
	})), React.createElement("div", {
		style: __assign$5({
			textAlign: "center",
			fontSize: 12,
			fontWeight: 500,
			marginTop: 3
		}, G.rbgcpComparibleLabel),
		id: `rbgcp-comparible-tetrad-colors-label${K}`
	}, "Tetrad"), React.createElement("div", {
		style: {
			borderRadius: 5,
			overflow: "hidden",
			display: "flex",
			justifyContent: "flex-end"
		},
		id: `rbgcp-comparible-tetrad-colors${K}`
	}, $?.map(function(x, w) {
		return React.createElement("div", {
			key: w,
			id: `rbgcp-comparible-tetrad-color-${w}${K}`,
			style: {
				width: "25%",
				height: 28,
				background: x.toHexString()
			},
			onClick: function() {
				return ql(x);
			}
		});
	}))));
}, __assign$4 = function() {
	return __assign$4 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$4.apply(this, arguments);
}, GradientType = function() {
	var x = usePicker(), w = x.gradientType, V = x.onChange, U = x.value, W = x.defaultStyles, G = x.pickerIdSuffix, K = w === "linear-gradient", J = w === "radial-gradient";
	return React.createElement("div", { style: W.rbgcpControlBtnWrapper }, React.createElement("div", {
		onClick: function() {
			var x = U.split(/,(.+)/)[1];
			V(`linear-gradient(90deg, ${x}`);
		},
		id: `rbgcp-linear-btn${G}`,
		style: __assign$4(__assign$4({}, W.rbgcpControlBtn), K && W.rbgcpControlBtnSelected),
		tabIndex: 0,
		role: "button",
		onKeyDown: function() {}
	}, React.createElement(LinearIcon, { color: K ? "#568CF5" : "" })), React.createElement("div", {
		onClick: function() {
			var x = U.split(/,(.+)/)[1];
			V(`radial-gradient(circle, ${x}`);
		},
		id: `rbgcp-radial-btn${G}`,
		style: __assign$4(__assign$4({}, W.rbgcpControlBtn), J && W.rbgcpControlBtnSelected),
		tabIndex: 0,
		role: "button",
		onKeyDown: function() {}
	}, React.createElement(RadialIcon, { color: J ? "#568CF5" : "" })));
}, StopPicker = function() {
	var x = usePicker(), w = x.currentLeft, V = x.currentColor, U = x.defaultStyles, W = x.handleGradient, G = x.pickerIdSuffix, K = function(x) {
		W(V, formatInputValues(parseInt(x), 0, 100));
	};
	return React.createElement("div", {
		style: __assign$4(__assign$4(__assign$4(__assign$4({}, U.rbgcpControlBtnWrapper), U.rbgcpControlInputWrap), U.rbgcpStopInputWrap), { paddingLeft: 8 }),
		id: `rbgcp-stop-input-wrapper${G}`
	}, React.createElement(StopIcon, null), React.createElement("input", {
		value: w,
		id: `rbgcp-stop-input${G}`,
		onChange: function(x) {
			return K(x.target.value);
		},
		style: __assign$4(__assign$4({}, U.rbgcpControlInput), U.rbgcpStopInput)
	}));
}, DegreePicker = function() {
	var x = usePicker(), w = x.degrees, V = x.onChange, U = x.value, W = x.defaultStyles, G = x.pickerIdSuffix, K = function(x) {
		var w = formatInputValues(x.target.value, 0, 360), W = U.split(/,(.+)/)[1];
		V(`linear-gradient(${w ?? 0}deg, ${W}`);
	};
	return React.createElement("div", {
		style: __assign$4(__assign$4(__assign$4({}, W.rbgcpControlBtnWrapper), W.rbgcpControlInputWrap), W.rbgcpDegreeInputWrap),
		id: `rbgcp-degree-input-wrapper${G}`
	}, React.createElement(DegreesIcon, null), React.createElement("input", {
		value: w,
		onChange: function(x) {
			return K(x);
		},
		id: `rbgcp-degree-input${G}`,
		style: __assign$4(__assign$4({}, W.rbgcpControlInput), W.rbgcpDegreeInput)
	}), React.createElement("div", { style: __assign$4(__assign$4({}, W.rbgcpDegreeIcon), {
		position: "absolute",
		right: w > 99 ? 0 : w < 10 ? 7 : 3,
		top: 1,
		fontWeight: 400,
		fontSize: 13
	}) }, "°"));
}, DeleteBtn = function() {
	var x = usePicker(), w = x.colors, V = x.selectedColor, U = x.createGradientStr, W = x.defaultStyles, G = x.pickerIdSuffix;
	return React.createElement("div", {
		onClick: function() {
			if (w?.length > 2) {
				var x = w?.map(function(x, w) {
					return __assign$4(__assign$4({}, x), { value: w === V - 1 ? high(x) : low(x) });
				});
				U(x?.filter(function(x, w) {
					return w !== V;
				}));
			}
		},
		style: __assign$4(__assign$4({}, controlBtnStyles(!1, W)), { width: 28 }),
		id: `rbgcp-point-delete-btn${G}`,
		tabIndex: 0,
		role: "button",
		onKeyDown: function() {}
	}, React.createElement(icon_default, null));
}, GradientControls_default = function(x) {
	var w = x.hideGradientType, V = x.hideGradientAngle, U = x.hideGradientStop, W = usePicker(), G = W.gradientType, K = W.defaultStyles, J = W.pickerIdSuffix;
	return React.createElement("div", {
		style: __assign$4(__assign$4({}, K.rbgcpControlBtnWrapper), {
			marginTop: 12,
			marginBottom: -4,
			justifyContent: "space-between",
			paddingLeft: w ? 4 : 0
		}),
		id: `rbgcp-gradient-controls-wrap${J}`
	}, !w && React.createElement(GradientType, null), React.createElement("div", { style: { width: 53 } }, !V && G === "linear-gradient" && React.createElement(DegreePicker, null)), !U && React.createElement(StopPicker, null), React.createElement(DeleteBtn, null));
}, __assign$3 = function() {
	return __assign$3 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$3.apply(this, arguments);
}, ColorTypeBtns = function(x) {
	var w = x.hideColorTypeBtns, V = x.setGradient, U = x.isGradient, W = x.setSolid, G = x.locales, K = usePicker(), J = K.defaultStyles, Y = K.pickerIdSuffix;
	return w ? React.createElement("div", { style: { width: 1 } }) : React.createElement("div", {
		style: __assign$3({
			display: "flex",
			alignItems: "center"
		}, J.rbgcpControlBtnWrapper),
		id: `rbgcp-color-type-btns${Y}`
	}, React.createElement("div", {
		onClick: W,
		id: `rbgcp-solid-btn${Y}`,
		style: colorTypeBtnStyles(!U, J)
	}, G?.CONTROLS?.SOLID), React.createElement("div", {
		onClick: V,
		id: `rbgcp-gradient-btn${Y}`,
		style: colorTypeBtnStyles(U ?? !1, J)
	}, G?.CONTROLS?.GRADIENT));
}, InputTypeDropdown = function(x) {
	var w = x.openInputType, V = x.setOpenInputType, U = usePicker(), W = U.inputType, G = U.setInputType, K = U.defaultStyles, J = U.pickerIdSuffix, Y = w ? "visibility 0ms linear" : "visibility 100ms linear 150ms", Z = w ? "z-index 0ms linear" : "z-index 100ms linear 150ms", $ = w ? "opacity 120ms linear" : "opacity 150ms linear 50ms", ql = function(x, U) {
		w && (x.stopPropagation(), G(U), V(!1));
	};
	return React.createElement("div", {
		style: __assign$3({
			visibility: w ? "visible" : "hidden",
			zIndex: w ? "" : -100,
			opacity: w ? 1 : 0,
			transition: `${$}, ${Y}, ${Z}`
		}, K.rbgcpColorModelDropdown),
		id: `rbgcp-color-model-dropdown${J}`
	}, React.createElement("div", {
		id: `rbgcp-color-model-rgb-btn${J}`,
		onClick: function(x) {
			return ql(x, "rgb");
		},
		style: modalBtnStyles(W === "rgb", K)
	}, "RGB"), React.createElement("div", {
		id: `rbgcp-color-model-hsl-btn${J}`,
		onClick: function(x) {
			return ql(x, "hsl");
		},
		style: modalBtnStyles(W === "hsl", K)
	}, "HSL"), React.createElement("div", {
		id: `rbgcp-color-model-hsv-btn${J}`,
		onClick: function(x) {
			return ql(x, "hsv");
		},
		style: modalBtnStyles(W === "hsv", K)
	}, "HSV"), React.createElement("div", {
		id: `rbgcp-color-model-cmyk-btn${J}`,
		onClick: function(x) {
			return ql(x, "cmyk");
		},
		style: modalBtnStyles(W === "cmyk", K)
	}, "CMYK"));
}, Controls_default = function(x) {
	var w = x.locales, V = x.hideEyeDrop, U = V === void 0 ? !1 : V, W = x.hideAdvancedSliders, G = W === void 0 ? !1 : W, K = x.hideColorGuide, J = K === void 0 ? !1 : K, Y = x.hideInputType, Z = Y === void 0 ? !1 : Y, $ = x.hideColorTypeBtns, ql = $ === void 0 ? !1 : $, Jl = x.hideGradientControls, Yl = Jl === void 0 ? !1 : Jl, Xl = x.hideGradientType, Zl = Xl === void 0 ? !1 : Xl, $l = x.hideGradientAngle, eu = $l === void 0 ? !1 : $l, tu = x.hideGradientStop, nu = tu === void 0 ? !1 : tu, ru = usePicker(), iu = ru.config, au = ru.onChange, ou = ru.isGradient, su = ru.handleChange, cu = ru.previous, lu = ru.defaultStyles, uu = ru.pickerIdSuffix, du = iu.defaultColor, fu = iu.defaultGradient, pu = useState(!1), mu = pu[0], hu = pu[1], _u = useState(!1), vu = _u[0], yu = _u[1], bu = useState(!1), xu = bu[0], Su = bu[1], Cu = U && G && J && Z, wu = cu?.color ?? du, Tu = cu?.gradient ?? fu, Eu = function() {
		au(wu);
	}, Du = function() {
		au(Tu);
	}, Ou = U && G && J && Z;
	return Ou && ql ? ou && !Yl ? React.createElement(GradientControls_default, {
		hideGradientType: Zl,
		hideGradientAngle: eu,
		hideGradientStop: nu
	}) : null : React.createElement("div", { style: { paddingBottom: 4 } }, React.createElement("div", {
		style: {
			width: "100%",
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between"
		},
		id: `rbgcp-controls-wrapper${uu}`
	}, React.createElement(ColorTypeBtns, {
		hideColorTypeBtns: ql,
		setGradient: Du,
		isGradient: ou,
		setSolid: Eu,
		locales: w
	}), !Ou && React.createElement("div", {
		style: __assign$3({ display: Cu ? "none" : "" }, lu.rbgcpControlBtnWrapper),
		id: `rbgcp-control-rightside-wrapper${uu}`
	}, !U && React.createElement(EyeDropper_default, { onSelect: su }), !G && React.createElement("div", {
		id: `rbgcp-advanced-btn${uu}`,
		onClick: function() {
			return Su(!xu);
		},
		style: controlBtnStyles(xu, lu)
	}, React.createElement(SlidersIcon, { color: xu ? "#568CF5" : "" })), !J && React.createElement("div", {
		style: controlBtnStyles(mu, lu),
		onClick: function() {
			return hu(!mu);
		},
		id: `rbgcp-comparibles-btn${uu}`
	}, React.createElement(PaletteIcon, { color: mu ? "#568CF5" : "" })), !Z && React.createElement("div", {
		id: `rbgcp-color-model-btn${uu}`,
		onClick: function() {
			return yu(!vu);
		},
		style: controlBtnStyles(vu, lu)
	}, React.createElement(InputsIcon, { color: vu ? "#568CF5" : "" }), React.createElement(InputTypeDropdown, {
		openInputType: vu,
		setOpenInputType: yu
	})))), !G && React.createElement(AdvancedControls_default, { openAdvanced: xu }), !J && React.createElement(ComparibleColors_default, { openComparibles: mu }), ou && !Yl && React.createElement(GradientControls_default, {
		hideGradientType: Zl,
		hideGradientAngle: eu,
		hideGradientStop: nu
	}));
}, __assign$2 = function() {
	return __assign$2 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$2.apply(this, arguments);
}, __spreadArray = function(x, w, V) {
	if (V || arguments.length === 2) for (var U = 0, W = w.length, G; U < W; U++) (G || !(U in w)) && (G ||= Array.prototype.slice.call(w, 0, U), G[U] = w[U]);
	return x.concat(G || Array.prototype.slice.call(w));
}, Handle = function(x) {
	var w = x.left, V = x.i, U = x.setDragging, W = usePicker(), G = W.colors, K = W.squareWidth, J = W.selectedColor, Y = W.defaultStyles, Z = W.pickerIdSuffix, $ = W.createGradientStr, ql = J === V, Jl = (K - 18) / 100, Yl = function(x) {
		$(G?.map(function(w, V) {
			return __assign$2(__assign$2({}, w), { value: V === x ? high(w) : low(w) });
		}));
	}, Xl = function(x) {
		x.stopPropagation(), Yl(V), U(!0);
	};
	return React.createElement("div", {
		onMouseDown: function(x) {
			return Xl(x);
		},
		id: `rbgcp-gradient-handle-${V}${Z}`,
		style: __assign$2(__assign$2({}, Y.rbgcpGradientHandleWrap), { left: (w ?? 0) * Jl })
	}, React.createElement("div", {
		style: __assign$2(__assign$2({}, Y.rbgcpGradientHandle), ql ? {
			boxShadow: "0px 0px 5px 1px rgba(86, 140, 245,.95)",
			border: "2px solid white"
		} : {}),
		id: `rbgcp-gradient-handle-${V}-dot${Z}`
	}, ql && React.createElement("div", {
		style: {
			width: 5,
			height: 5,
			borderRadius: "50%",
			background: "white"
		},
		id: `rbgcp-gradient-handle-${V}-selected-dot${Z}`
	})));
}, GradientBar_default = function() {
	var x = usePicker(), w = x.value, V = x.colors, U = x.config, W = x.squareWidth, G = x.currentColor, K = x.handleGradient, J = x.pickerIdSuffix, Y = x.createGradientStr, Z = U.barSize, $ = useState(!1), ql = $[0], Jl = $[1];
	function Yl(x) {
		return x.replace(/(radial|linear)-gradient\([^,]+,/, "linear-gradient(90deg,");
	}
	var Xl = function(x) {
		var w = getHandleValue(x, Z);
		Y(__spreadArray(__spreadArray([], V.map(function(x) {
			return __assign$2(__assign$2({}, x), { value: low(x) });
		}), !0), [{
			value: G,
			left: w
		}], !1)?.sort(function(x, w) {
			return x.left - w.left;
		}));
	}, Zl = function() {
		Jl(!1);
	}, $l = function(x) {
		ql || (Xl(x), Jl(!0));
	}, eu = function(x) {
		ql && K(G, getHandleValue(x, Z));
	}, tu = function() {
		Zl();
	};
	return useEffect(function() {
		return window.addEventListener("mouseup", tu), function() {
			window.removeEventListener("mouseup", tu);
		};
	}), React.createElement("div", {
		style: {
			width: "100%",
			marginTop: 17,
			marginBottom: 4,
			position: "relative"
		},
		id: `rbgcp-gradient-bar${J}`
	}, React.createElement("div", {
		style: {
			height: 14,
			borderRadius: 10,
			width: W,
			backgroundImage: Yl(w)
		},
		onMouseDown: function(x) {
			return $l(x);
		},
		onMouseMove: function(x) {
			return eu(x);
		},
		id: `rbgcp-gradient-bar-canvas${J}`
	}), V?.map(function(x, w) {
		return React.createElement(Handle, {
			i: w,
			left: x.left,
			key: `${w}-${x}`,
			setDragging: Jl
		});
	}));
}, Picker_default = function(x) {
	var w = x.locales, V = x.presets, U = x.hideHue, W = x.hideInputs, G = x.hidePresets, K = x.hideOpacity, J = x.hideEyeDrop, Y = x.hideControls, Z = x.hideInputType, $ = x.hideColorGuide, ql = x.hidePickerSquare, Jl = x.hideGradientType, Yl = x.hideGradientStop, Xl = x.hideGradientAngle, Zl = x.hideColorTypeBtns, $l = x.hideAdvancedSliders, eu = x.hideGradientControls, tu = usePicker(), nu = tu.isGradient, ru = tu.pickerIdSuffix;
	return React.createElement("div", {
		style: { userSelect: "none" },
		id: `rbgcp-color-picker${ru}`
	}, !ql && React.createElement(Square_default, null), !Y && React.createElement(Controls_default, {
		locales: w,
		hideEyeDrop: J,
		hideInputType: Z,
		hideColorGuide: $,
		hideGradientType: Jl,
		hideGradientStop: Yl,
		hideColorTypeBtns: Zl,
		hideGradientAngle: Xl,
		hideAdvancedSliders: $l,
		hideGradientControls: eu
	}), nu && React.createElement(GradientBar_default, null), !U && React.createElement(Hue_default, null), !K && React.createElement(Opacity_default, null), !W && React.createElement(Inputs_default, null), !G && React.createElement(Presets_default, { presets: V }));
}, __assign$1 = function() {
	return __assign$1 = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign$1.apply(this, arguments);
};
function ColorPicker(x) {
	var w = x.idSuffix, V = x.value, U = V === void 0 ? "rgba(175, 51, 242, 1)" : V, W = x.onChange, G = x.hideControls, K = G === void 0 ? !1 : G, J = x.hideInputs, Y = J === void 0 ? !1 : J, Z = x.hideOpacity, $ = Z === void 0 ? !1 : Z, ql = x.hidePresets, Jl = ql === void 0 ? !1 : ql, Yl = x.hideHue, Xl = Yl === void 0 ? !1 : Yl, Zl = x.presets, $l = Zl === void 0 ? [] : Zl, eu = x.hideEyeDrop, tu = eu === void 0 ? !1 : eu, nu = x.hideAdvancedSliders, ru = nu === void 0 ? !1 : nu, iu = x.hideColorGuide, au = iu === void 0 ? !1 : iu, ou = x.hideInputType, su = ou === void 0 ? !1 : ou, cu = x.hideColorTypeBtns, lu = cu === void 0 ? !1 : cu, uu = x.hideGradientType, du = uu === void 0 ? !1 : uu, fu = x.hideGradientAngle, pu = fu === void 0 ? !1 : fu, mu = x.hideGradientStop, hu = mu === void 0 ? !1 : mu, gu = x.hideGradientControls, _u = gu === void 0 ? !1 : gu, vu = x.locales, yu = vu === void 0 ? defaultLocales : vu, bu = x.width, xu = bu === void 0 ? 294 : bu, Su = x.height, Cu = Su === void 0 ? 294 : Su, wu = x.style, Tu = wu === void 0 ? {} : wu, Eu = x.className, Du = x.disableDarkMode, Ou = Du === void 0 ? !1 : Du, ku = x.disableLightMode, Au = ku === void 0 ? !1 : ku, ju = x.hidePickerSquare, Mu = ju === void 0 ? !1 : ju, Nu = x.showHexAlpha, Pu = Nu === void 0 ? !1 : Nu, Fu = x.config, Iu = Fu === void 0 ? {} : Fu, Lu = objectToString(U), Ru = typeof window > "u" || Ou ? !1 : !!(window.matchMedia("(prefers-color-scheme: dark)").matches || Au), zu = getStyles(Ru, Tu), Bu = Ru ? `-dark${w ? `-${w}` : ""}` : w ? `-${w}` : "";
	return React.createElement("div", {
		className: Eu,
		style: __assign$1(__assign$1({}, zu.body), { width: xu })
	}, React.createElement(PickerContextWrapper, {
		value: Lu,
		onChange: W,
		squareWidth: xu,
		passedConfig: Iu,
		squareHeight: Cu,
		isDarkMode: Ru,
		hideOpacity: $,
		showHexAlpha: Pu,
		defaultStyles: zu,
		pickerIdSuffix: Bu
	}, React.createElement(Picker_default, {
		hideControls: K,
		hideInputs: Y,
		hidePresets: Jl,
		hideOpacity: $,
		hideHue: Xl,
		presets: $l,
		hideEyeDrop: tu,
		hideAdvancedSliders: ru,
		hideColorGuide: au,
		hideInputType: su,
		hideColorTypeBtns: lu,
		hideGradientType: du,
		hideGradientAngle: pu,
		hideGradientStop: hu,
		hideGradientControls: _u,
		hidePickerSquare: Mu,
		locales: yu
	})));
}
var esm_default = ColorPicker;
function createSizeClassMap(x) {
	return {
		sm: x.sizeSm,
		md: x.sizeMd,
		lg: x.sizeLg
	};
}
var ColorPickerV2_module_default = {
	container: "_container_1sz0y_1",
	swatch: "_swatch_1sz0y_5",
	sizeSm: "_sizeSm_1sz0y_12",
	sizeMd: "_sizeMd_1sz0y_16",
	sizeLg: "_sizeLg_1sz0y_20",
	gradientInput: "_gradientInput_1sz0y_24",
	popover: "_popover_1sz0y_28",
	input: "_input_1sz0y_32"
}, r$1 = {
	grad: .9,
	turn: 360,
	rad: 360 / (2 * Math.PI)
}, t = function(x) {
	return typeof x == "string" ? x.length > 0 : typeof x == "number";
}, n = function(x, w, V) {
	return w === void 0 && (w = 0), V === void 0 && (V = 10 ** w), Math.round(V * x) / V + 0;
}, e = function(x, w, V) {
	return w === void 0 && (w = 0), V === void 0 && (V = 1), x > V ? V : x > w ? x : w;
}, u$1 = function(x) {
	return (x = isFinite(x) ? x % 360 : 0) > 0 ? x : x + 360;
}, a = function(x) {
	return {
		r: e(x.r, 0, 255),
		g: e(x.g, 0, 255),
		b: e(x.b, 0, 255),
		a: e(x.a)
	};
}, o = function(x) {
	return {
		r: n(x.r),
		g: n(x.g),
		b: n(x.b),
		a: n(x.a, 3)
	};
}, i = /^#([0-9a-f]{3,8})$/i, s = function(x) {
	var w = x.toString(16);
	return w.length < 2 ? "0" + w : w;
}, h$1 = function(x) {
	var w = x.r, V = x.g, U = x.b, W = x.a, G = Math.max(w, V, U), K = G - Math.min(w, V, U), J = K ? G === w ? (V - U) / K : G === V ? 2 + (U - w) / K : 4 + (w - V) / K : 0;
	return {
		h: 60 * (J < 0 ? J + 6 : J),
		s: G ? K / G * 100 : 0,
		v: G / 255 * 100,
		a: W
	};
}, b$1 = function(x) {
	var w = x.h, V = x.s, U = x.v, W = x.a;
	w = w / 360 * 6, V /= 100, U /= 100;
	var G = Math.floor(w), K = U * (1 - V), J = U * (1 - (w - G) * V), Y = U * (1 - (1 - w + G) * V), Z = G % 6;
	return {
		r: 255 * [
			U,
			J,
			K,
			K,
			Y,
			U
		][Z],
		g: 255 * [
			Y,
			U,
			U,
			J,
			K,
			K
		][Z],
		b: 255 * [
			K,
			K,
			Y,
			U,
			U,
			J
		][Z],
		a: W
	};
}, g$1 = function(x) {
	return {
		h: u$1(x.h),
		s: e(x.s, 0, 100),
		l: e(x.l, 0, 100),
		a: e(x.a)
	};
}, d$1 = function(x) {
	return {
		h: n(x.h),
		s: n(x.s),
		l: n(x.l),
		a: n(x.a, 3)
	};
}, f$1 = function(x) {
	return b$1((V = (w = x).s, {
		h: w.h,
		s: (V *= ((U = w.l) < 50 ? U : 100 - U) / 100) > 0 ? 2 * V / (U + V) * 100 : 0,
		v: U + V,
		a: w.a
	}));
	var w, V, U;
}, c = function(x) {
	return {
		h: (w = h$1(x)).h,
		s: (W = (200 - (V = w.s)) * (U = w.v) / 100) > 0 && W < 200 ? V * U / 100 / (W <= 100 ? W : 200 - W) * 100 : 0,
		l: W / 2,
		a: w.a
	};
	var w, V, U, W;
}, l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, p$1 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, v$1 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, m$1 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, y$1 = {
	string: [
		[function(x) {
			var w = i.exec(x);
			return w ? (x = w[1]).length <= 4 ? {
				r: parseInt(x[0] + x[0], 16),
				g: parseInt(x[1] + x[1], 16),
				b: parseInt(x[2] + x[2], 16),
				a: x.length === 4 ? n(parseInt(x[3] + x[3], 16) / 255, 2) : 1
			} : x.length === 6 || x.length === 8 ? {
				r: parseInt(x.substr(0, 2), 16),
				g: parseInt(x.substr(2, 2), 16),
				b: parseInt(x.substr(4, 2), 16),
				a: x.length === 8 ? n(parseInt(x.substr(6, 2), 16) / 255, 2) : 1
			} : null : null;
		}, "hex"],
		[function(x) {
			var w = v$1.exec(x) || m$1.exec(x);
			return w ? w[2] !== w[4] || w[4] !== w[6] ? null : a({
				r: Number(w[1]) / (w[2] ? 100 / 255 : 1),
				g: Number(w[3]) / (w[4] ? 100 / 255 : 1),
				b: Number(w[5]) / (w[6] ? 100 / 255 : 1),
				a: w[7] === void 0 ? 1 : Number(w[7]) / (w[8] ? 100 : 1)
			}) : null;
		}, "rgb"],
		[function(x) {
			var w = l.exec(x) || p$1.exec(x);
			if (!w) return null;
			var V, U;
			return f$1(g$1({
				h: (V = w[1], U = w[2], U === void 0 && (U = "deg"), Number(V) * (r$1[U] || 1)),
				s: Number(w[3]),
				l: Number(w[4]),
				a: w[5] === void 0 ? 1 : Number(w[5]) / (w[6] ? 100 : 1)
			}));
		}, "hsl"]
	],
	object: [
		[function(x) {
			var w = x.r, V = x.g, U = x.b, W = x.a, G = W === void 0 ? 1 : W;
			return t(w) && t(V) && t(U) ? a({
				r: Number(w),
				g: Number(V),
				b: Number(U),
				a: Number(G)
			}) : null;
		}, "rgb"],
		[function(x) {
			var w = x.h, V = x.s, U = x.l, W = x.a, G = W === void 0 ? 1 : W;
			return !t(w) || !t(V) || !t(U) ? null : f$1(g$1({
				h: Number(w),
				s: Number(V),
				l: Number(U),
				a: Number(G)
			}));
		}, "hsl"],
		[function(x) {
			var w = x.h, V = x.s, U = x.v, W = x.a, G = W === void 0 ? 1 : W;
			return !t(w) || !t(V) || !t(U) ? null : b$1(function(x) {
				return {
					h: u$1(x.h),
					s: e(x.s, 0, 100),
					v: e(x.v, 0, 100),
					a: e(x.a)
				};
			}({
				h: Number(w),
				s: Number(V),
				v: Number(U),
				a: Number(G)
			}));
		}, "hsv"]
	]
}, N$1 = function(x, w) {
	for (var V = 0; V < w.length; V++) {
		var U = w[V][0](x);
		if (U) return [U, w[V][1]];
	}
	return [null, void 0];
}, x$1 = function(x) {
	return typeof x == "string" ? N$1(x.trim(), y$1.string) : typeof x == "object" && x ? N$1(x, y$1.object) : [null, void 0];
}, M$1 = function(x, w) {
	var V = c(x);
	return {
		h: V.h,
		s: e(V.s + 100 * w, 0, 100),
		l: V.l,
		a: V.a
	};
}, H$1 = function(x) {
	return (299 * x.r + 587 * x.g + 114 * x.b) / 1e3 / 255;
}, $$1 = function(x, w) {
	var V = c(x);
	return {
		h: V.h,
		s: V.s,
		l: e(V.l + 100 * w, 0, 100),
		a: V.a
	};
}, j = function() {
	function x(x) {
		this.parsed = x$1(x)[0], this.rgba = this.parsed || {
			r: 0,
			g: 0,
			b: 0,
			a: 1
		};
	}
	return x.prototype.isValid = function() {
		return this.parsed !== null;
	}, x.prototype.brightness = function() {
		return n(H$1(this.rgba), 2);
	}, x.prototype.isDark = function() {
		return H$1(this.rgba) < .5;
	}, x.prototype.isLight = function() {
		return H$1(this.rgba) >= .5;
	}, x.prototype.toHex = function() {
		return x = o(this.rgba), w = x.r, V = x.g, U = x.b, G = (W = x.a) < 1 ? s(n(255 * W)) : "", "#" + s(w) + s(V) + s(U) + G;
		var x, w, V, U, W, G;
	}, x.prototype.toRgb = function() {
		return o(this.rgba);
	}, x.prototype.toRgbString = function() {
		return x = o(this.rgba), w = x.r, V = x.g, U = x.b, (W = x.a) < 1 ? "rgba(" + w + ", " + V + ", " + U + ", " + W + ")" : "rgb(" + w + ", " + V + ", " + U + ")";
		var x, w, V, U, W;
	}, x.prototype.toHsl = function() {
		return d$1(c(this.rgba));
	}, x.prototype.toHslString = function() {
		return x = d$1(c(this.rgba)), w = x.h, V = x.s, U = x.l, (W = x.a) < 1 ? "hsla(" + w + ", " + V + "%, " + U + "%, " + W + ")" : "hsl(" + w + ", " + V + "%, " + U + "%)";
		var x, w, V, U, W;
	}, x.prototype.toHsv = function() {
		return x = h$1(this.rgba), {
			h: n(x.h),
			s: n(x.s),
			v: n(x.v),
			a: n(x.a, 3)
		};
		var x;
	}, x.prototype.invert = function() {
		return w$1({
			r: 255 - (x = this.rgba).r,
			g: 255 - x.g,
			b: 255 - x.b,
			a: x.a
		});
		var x;
	}, x.prototype.saturate = function(x) {
		return x === void 0 && (x = .1), w$1(M$1(this.rgba, x));
	}, x.prototype.desaturate = function(x) {
		return x === void 0 && (x = .1), w$1(M$1(this.rgba, -x));
	}, x.prototype.grayscale = function() {
		return w$1(M$1(this.rgba, -1));
	}, x.prototype.lighten = function(x) {
		return x === void 0 && (x = .1), w$1($$1(this.rgba, x));
	}, x.prototype.darken = function(x) {
		return x === void 0 && (x = .1), w$1($$1(this.rgba, -x));
	}, x.prototype.rotate = function(x) {
		return x === void 0 && (x = 15), this.hue(this.hue() + x);
	}, x.prototype.alpha = function(x) {
		return typeof x == "number" ? w$1({
			r: (w = this.rgba).r,
			g: w.g,
			b: w.b,
			a: x
		}) : n(this.rgba.a, 3);
		var w;
	}, x.prototype.hue = function(x) {
		var w = c(this.rgba);
		return typeof x == "number" ? w$1({
			h: x,
			s: w.s,
			l: w.l,
			a: w.a
		}) : n(w.h);
	}, x.prototype.isEqual = function(x) {
		return this.toHex() === w$1(x).toHex();
	}, x;
}(), w$1 = function(x) {
	return x instanceof j ? x : new j(x);
};
const rgbaToHex = (x) => {
	let w = x.match(/\d+(?:\.\d+)?/g);
	if (!w) return x;
	let V = parseInt(w[0]), U = parseInt(w[1]), W = parseInt(w[2]), G = w[3] === void 0 ? void 0 : Math.round(parseFloat(w[3]) * 255), K = `#${((1 << 24) + (V << 16) + (U << 8) + W).toString(16).slice(1)}`;
	return G !== void 0 && !isNaN(G) ? K + G.toString(16).padStart(2, "0") : K;
};
function getLinearGradientAngleFromCSS(x) {
	let w = x.match(/linear-gradient\(([^,]+),/i), V = 180;
	if (w) {
		let x = w[1].trim();
		x.endsWith("deg") && (V = (parseFloat(x) - 90 + 360) % 360);
	}
	return V;
}
function getLinearGradientStopsFromCSS(x) {
	let w = x.substring(x.indexOf(",") + 1, x.lastIndexOf(")")), V = Array.from(w.matchAll(/(rgba?\([^)]*\))(?:\s*(\d+(?:\.\d+)?%))?/g));
	return V.length ? V.map((x) => {
		let w = x[1], V = x[2] ?? "0%", U = w, W = "1", G = w.match(/rgba\((\d+),(\d+),(\d+),(\d*\.?\d+)\)/);
		return G && (U = `rgb(${G[1]},${G[2]},${G[3]})`, W = G[4]), {
			color: U,
			opacity: W,
			offset: V
		};
	}) : [];
}
function parseLinearGradientCSS(x) {
	let w = x.replace(/\s+/g, "").toLowerCase();
	return {
		angle: getLinearGradientAngleFromCSS(w),
		stops: getLinearGradientStopsFromCSS(w)
	};
}
function stringifyLinearGradientCSS(x) {
	let { angle: w, stops: V } = x ?? {};
	return w === void 0 || !V ? "#ffffff" : `linear-gradient(${(w + 90) % 360}deg, ${V.map((x) => {
		let w = x.opacity === void 0 ? 1 : Number(x.opacity);
		return `${w$1(x.color).alpha(w).toRgbString()} ${x.offset}`;
	}).join(", ")})`;
}
var import_classnames$36 = /* @__PURE__ */ __toESM(require_classnames(), 1), COLOR_PICKER_WIDTH = 240, HEX_COLOR_REGEX = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/, COLOR_PICKER_HEIGHT = 175, SIZE_CLASS$4 = createSizeClassMap(ColorPickerV2_module_default), COLOR_PICKER_PRESETS = [
	"rgba(16,16,16,1)",
	"rgba(128,128,128,1)",
	"rgba(192,192,192,1)",
	"rgba(235,235,235,1)",
	"rgba(16,16,128,1)",
	"rgba(16,16,235,1)",
	"rgba(16,235,235,1)",
	"rgba(16,128,16,1)",
	"rgba(128,128,16,1)",
	"rgba(16,128,128,1)",
	"rgba(16,235,16,1)",
	"rgba(128,16,16,1)",
	"rgba(128,16,128,1)",
	"rgba(175,51,235,1)",
	"rgba(235,16,235,1)",
	"rgba(235,16,16,1)",
	"rgba(235,103,46,1)",
	"rgba(235,235,16,1)"
];
function ColorPickerPanel({ defaultValue: x = "", onChange: w, enableGradient: V }) {
	let [U, W] = useState(x === "none" ? "rgba(0,0,0,0)" : x);
	return /* @__PURE__ */ jsx("div", {
		ref: useRef(null),
		children: /* @__PURE__ */ jsx(esm_default, {
			className: "custom-color-picker",
			value: U,
			onChange: (x) => {
				W(x), x.startsWith("linear-gradient") ? w(parseLinearGradientCSS(x)) : w(rgbaToHex(x));
			},
			width: COLOR_PICKER_WIDTH,
			height: COLOR_PICKER_HEIGHT,
			hideColorTypeBtns: !V,
			hideGradientControls: !V,
			hideAdvancedSliders: !0,
			hideColorGuide: !0,
			hideGradientType: !0,
			disableLightMode: !0,
			presets: COLOR_PICKER_PRESETS
		})
	});
}
function ColorPickerV2({ inputSize: x = "md", value: w = preset_default.theme.extend.colors["white-safe"], placeholder: V = "#FFFFFF", onChange: U, disabled: G, readOnly: K, enableGradient: J, title: Y, ...Z }, ql) {
	let Jl = G || K, Yl = typeof w == "object", Xl = Yl ? stringifyLinearGradientCSS(w) : w, Zl = Yl || w == null ? "" : String(w), [Ql, $l] = useState(Zl);
	useEffect(() => {
		$l(Zl);
	}, [Zl]);
	let [eu, nu] = useState(null), [ru, iu] = useState(null), { styles: au, attributes: ou } = usePopper(eu, ru, { placement: "auto-start" }), su = useCallback((x) => {
		let w = x.target.value;
		$l(w), HEX_COLOR_REGEX.test(w) && U?.(w);
	}, [U]);
	return /* @__PURE__ */ jsx(Popover$1, {
		as: "div",
		className: (0, import_classnames$36.default)(ColorPickerV2_module_default.container, SIZE_CLASS$4[x]),
		children: ({ open: w }) => /* @__PURE__ */ jsxs(Fragment, { children: [
			/* @__PURE__ */ jsx(Popover$1.Button, {
				ref: nu,
				disabled: Jl,
				tabIndex: Jl ? -1 : 0,
				title: Y,
				className: ColorPickerV2_module_default.swatch,
				style: { background: Xl || "transparent" }
			}),
			/* @__PURE__ */ jsx(InputV2_default, {
				ref: ql,
				inputSize: x,
				value: Ql,
				placeholder: Yl ? "Gradient" : V,
				onChange: su,
				onClick: Yl && !Jl ? () => eu?.click() : void 0,
				readOnly: K || Yl,
				disabled: G,
				wrapperClassName: (0, import_classnames$36.default)(Yl && !Jl && ColorPickerV2_module_default.gradientInput),
				className: ColorPickerV2_module_default.input,
				title: Y,
				...Z,
				type: "text"
			}),
			w && createPortal(/* @__PURE__ */ jsx(Popover$1.Panel, {
				static: !0,
				ref: iu,
				style: {
					...au.popper,
					zIndex: 1e3
				},
				className: ColorPickerV2_module_default.popover,
				...ou.popper,
				children: /* @__PURE__ */ jsx(ColorPickerPanel, {
					enableGradient: J,
					onChange: U ?? (() => {}),
					defaultValue: Xl || Zl
				})
			}), document.body)
		] })
	});
}
var ColorPickerV2_default = React.forwardRef(ColorPickerV2), InputAffix_module_default = { affixText: "_affixText_1lwv3_1" }, import_classnames$35 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function InputAffix({ children: x, className: w }) {
	return typeof x == "string" ? /* @__PURE__ */ jsx("span", {
		"aria-hidden": "true",
		className: (0, import_classnames$35.default)(typeof x == "string" && InputAffix_module_default.affixText, w),
		children: x
	}) : x;
}
var InputAffix_default = InputAffix, InputWrapper_module_default = {
	wrapper: "_wrapper_1vco4_1",
	sizeSm: "_sizeSm_1vco4_13",
	sizeMd: "_sizeMd_1vco4_17",
	sizeLg: "_sizeLg_1vco4_21",
	hasError: "_hasError_1vco4_25",
	disabled: "_disabled_1vco4_29"
}, import_classnames$34 = /* @__PURE__ */ __toESM(require_classnames(), 1), SIZE_CLASS$3 = createSizeClassMap(InputWrapper_module_default);
function InputWrapper$1({ inputSize: x = "md", hasError: w, disabled: V, wrapperClassName: U, prefix: W, suffix: G, prefixClassName: K, suffixClassName: J, children: Y, ...Z }) {
	return /* @__PURE__ */ jsxs("label", {
		style: { colorScheme: "dark" },
		className: (0, import_classnames$34.default)(InputWrapper_module_default.wrapper, "group", SIZE_CLASS$3[x], w && InputWrapper_module_default.hasError, V && InputWrapper_module_default.disabled, U),
		...Z,
		children: [
			/* @__PURE__ */ jsx(InputAffix_default, {
				className: K,
				children: W
			}),
			Y,
			/* @__PURE__ */ jsx(InputAffix_default, {
				className: J,
				children: G
			})
		]
	});
}
var InputWrapper_default = InputWrapper$1, GenericInputV2_module_default = {
	input: "_input_1etct_1",
	disabled: "_disabled_1etct_6"
}, import_classnames$33 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function GenericInputV2({ inputSize: x, prefix: w, suffix: V, disabled: U, wrapperClassName: W, hasError: G, className: K, ...J }, Y) {
	return /* @__PURE__ */ jsx(InputWrapper_default, {
		inputSize: x,
		hasError: G,
		disabled: U,
		wrapperClassName: W,
		prefix: w,
		suffix: V,
		children: /* @__PURE__ */ jsx("input", {
			ref: Y,
			disabled: U,
			className: (0, import_classnames$33.default)(GenericInputV2_module_default.input, U && GenericInputV2_module_default.disabled, K),
			...J
		})
	});
}
var GenericInputV2_default = React.forwardRef(GenericInputV2), NumberInputV2_module_default = {
	input: "_input_rgtkk_1",
	disabled: "_disabled_rgtkk_11",
	mouseDown: "_mouseDown_rgtkk_15",
	dragging: "_dragging_rgtkk_19"
}, DEFAULT_DRAG_DEAD_ZONE_PX = 3, DEFAULT_DRAG_PIXELS_PER_STEP = 8;
function clamp(x, w, V) {
	let U = x;
	return w != null && (U = Math.max(w, U)), V != null && (U = Math.min(V, U)), U;
}
function parseNumber(x) {
	if (x == null || x === "") return;
	if (typeof x == "number") return Number.isFinite(x) ? x : void 0;
	let w = Number(x);
	return Number.isFinite(w) ? w : void 0;
}
function setNativeValue(x, w) {
	let { set: V } = Object.getOwnPropertyDescriptor(x, "value") ?? {}, U = Object.getPrototypeOf(x), { set: W } = Object.getOwnPropertyDescriptor(U, "value") ?? {};
	if (W) {
		W.call(x, w);
		return;
	}
	V?.call(x, w);
}
function assignRef(x, w) {
	if (typeof x == "function") {
		x(w);
		return;
	}
	x && (x.current = w);
}
function useDragScrub({ disabled: x, value: w, min: V, max: U, step: W, inputRef: G, onValueChange: K }) {
	let [J, Y] = useState(!1), [Z, $] = useState(!1), ql = W === 0 ? 1 : W;
	return {
		isDragging: J,
		isMouseDown: Z,
		handlePointerDown: useCallback((W) => {
			if (x || W.button !== 0 || W.pointerType !== "mouse") return;
			let J = G.current;
			if (!J) return;
			$(!0);
			let Z = parseNumber(J.value) ?? parseNumber(w) ?? 0, Jl = 0, Yl = !1, Xl = !1, Zl = null, Ql = () => {
				let x = J.requestPointerLock();
				x && (Zl = x, x.then(() => {
					Zl = null;
				}).catch(() => {
					Zl = null;
				}));
			}, $l = (x) => x.preventDefault(), eu = (x) => {
				if (Jl -= x.movementY, !Yl) {
					if (Math.abs(Jl) < DEFAULT_DRAG_DEAD_ZONE_PX) return;
					Yl = !0, Y(!0), document.addEventListener("selectstart", $l), Ql();
				}
				let w = Math.sign(Jl) * Math.max(0, Math.abs(Jl) - DEFAULT_DRAG_DEAD_ZONE_PX), W = clamp(Z + Math.trunc(w / DEFAULT_DRAG_PIXELS_PER_STEP) * ql, V, U);
				K?.(String(W));
			}, tu = () => {
				Yl && (document.removeEventListener("pointerlockchange", tu), document.pointerLockElement || nu());
			}, nu = () => {
				Xl || (Xl = !0, Zl ? Zl.then(() => document.exitPointerLock()).catch(() => {}) : document.pointerLockElement === J && document.exitPointerLock(), $(!1), Y(!1), document.removeEventListener("mousemove", eu), document.removeEventListener("mouseup", nu), document.removeEventListener("pointerup", nu), document.removeEventListener("pointerlockchange", tu), document.removeEventListener("selectstart", $l));
			};
			document.addEventListener("mousemove", eu), document.addEventListener("pointerup", nu), document.addEventListener("mouseup", nu), document.addEventListener("pointerlockchange", tu);
		}, [
			x,
			G,
			w,
			ql,
			V,
			U,
			K
		])
	};
}
var import_classnames$32 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function NumberInputV2({ inputSize: x, value: w = "", onChange: V, prefix: U, suffix: W, disabled: G, readOnly: K, wrapperClassName: J, className: Y, hasError: Z, min: $, max: ql, step: Jl = 1, ...Yl }, Xl) {
	let Zl = useRef(null), [Ql, $l] = useState(() => w == null ? "" : String(w)), eu = useCallback((x) => {
		let w = Zl.current;
		$l(x), !(!w || !V) && (setNativeValue(w, x), V({
			target: w,
			currentTarget: w
		}));
	}, [V]), { isDragging: tu, isMouseDown: nu, handlePointerDown: ru } = useDragScrub({
		disabled: G || K,
		value: w,
		min: $,
		max: ql,
		step: Jl,
		inputRef: Zl,
		onValueChange: eu
	}), iu = useCallback((x) => {
		$l(x.target.value), V?.(x);
	}, [V]);
	return useEffect(() => {
		$l(w == null ? "" : String(w));
	}, [w]), /* @__PURE__ */ jsx(InputWrapper_default, {
		inputSize: x,
		hasError: Z,
		disabled: G,
		wrapperClassName: J,
		prefix: U,
		suffix: W,
		children: /* @__PURE__ */ jsx("input", {
			ref: (x) => {
				Zl.current = x, assignRef(Xl, x);
			},
			type: "number",
			value: Ql,
			onChange: iu,
			disabled: G,
			readOnly: K,
			min: $,
			max: ql,
			step: Jl,
			inputMode: "decimal",
			onPointerDown: ru,
			onWheel: (x) => x.currentTarget.blur(),
			className: (0, import_classnames$32.default)(NumberInputV2_module_default.input, G && NumberInputV2_module_default.disabled, nu && NumberInputV2_module_default.mouseDown, tu && NumberInputV2_module_default.dragging, Y),
			...Yl
		})
	});
}
var NumberInputV2_default = React.forwardRef(NumberInputV2), SelectableInputV2_module_default = {
	inputWrapper: "_inputWrapper_eejb2_1",
	sizeSm: "_sizeSm_eejb2_5",
	suffixButton: "_suffixButton_eejb2_5",
	sizeMd: "_sizeMd_eejb2_9",
	sizeLg: "_sizeLg_eejb2_13"
}, import_classnames$31 = /* @__PURE__ */ __toESM(require_classnames(), 1), SIZE_CLASS$2 = createSizeClassMap(SelectableInputV2_module_default), SUFFIX_ICON_SIZE = {
	sm: 8,
	md: 16,
	lg: 20
};
function SelectableInputV2({ value: x = "", onClick: w, onRemoveMedia: V, inputSize: U = "md", ...W }, G) {
	return /* @__PURE__ */ jsx(InputV2_default, {
		ref: G,
		value: x,
		suffix: /* @__PURE__ */ jsxs(Fragment$1, { children: [!!x && /* @__PURE__ */ jsx(Button_default, {
			iconProps: {
				icon: "x",
				weight: "bold",
				size: SUFFIX_ICON_SIZE[U]
			},
			variant: "tertiary",
			color: "gray",
			onClick: V,
			buttonSize: U === "lg" ? "medium" : "small"
		}), /* @__PURE__ */ jsx(Button_default, {
			className: SelectableInputV2_module_default.suffixButton,
			iconProps: {
				icon: "media",
				weight: "bold",
				size: SUFFIX_ICON_SIZE[U]
			},
			color: "primaryLight",
			onClick: w,
			buttonSize: U === "lg" ? "medium" : "small"
		})] }),
		wrapperClassName: (0, import_classnames$31.default)(SelectableInputV2_module_default.inputWrapper, SIZE_CLASS$2[U]),
		inputSize: U,
		...W,
		type: "text"
	});
}
var SelectableInputV2_default = React.forwardRef(SelectableInputV2), SelectV2_module_default = {
	wrapper: "_wrapper_8f4r9_1",
	select: "_select_8f4r9_5",
	affix: "_affix_8f4r9_20",
	placeholder: "_placeholder_8f4r9_24",
	disabled: "_disabled_8f4r9_28",
	caret: "_caret_8f4r9_32",
	sizeSm: "_sizeSm_8f4r9_36",
	selectWithPrefix: "_selectWithPrefix_8f4r9_39",
	prefixAffix: "_prefixAffix_8f4r9_42",
	suffixAffix: "_suffixAffix_8f4r9_45",
	sizeMd: "_sizeMd_8f4r9_52",
	sizeLg: "_sizeLg_8f4r9_68"
}, import_classnames$30 = /* @__PURE__ */ __toESM(require_classnames(), 1), PLACEHOLDER_VALUE = "", SIZE_CLASS$1 = createSizeClassMap(SelectV2_module_default), CARET_ICON_SIZE = {
	sm: 10,
	md: 12,
	lg: 14
};
function SelectV2({ options: x, onChange: w, prefix: V, suffix: U, prefixClassName: W, suffixClassName: G, wrapperClassName: K, className: J, inputSize: Y = "md", disabled: Z, value: $, placeholder: ql, selectablePlaceholder: Jl, hasError: Yl, ...Xl }, Zl) {
	let Ql = ql === void 0 ? x : x.filter((x) => x.value !== PLACEHOLDER_VALUE), $l = $ === PLACEHOLDER_VALUE && !Jl;
	return /* @__PURE__ */ jsxs(InputWrapper_default, {
		inputSize: Y,
		hasError: Yl,
		disabled: Z,
		wrapperClassName: (0, import_classnames$30.default)(SelectV2_module_default.wrapper, SIZE_CLASS$1[Y], K),
		prefix: V,
		suffix: U,
		prefixClassName: (0, import_classnames$30.default)(SelectV2_module_default.affix, V && SelectV2_module_default.prefixAffix, W),
		suffixClassName: (0, import_classnames$30.default)(SelectV2_module_default.affix, U && SelectV2_module_default.suffixAffix, G),
		children: [/* @__PURE__ */ jsxs("select", {
			ref: Zl,
			value: $,
			onChange: w,
			disabled: Z,
			className: (0, import_classnames$30.default)(SelectV2_module_default.select, V && SelectV2_module_default.selectWithPrefix, $l && SelectV2_module_default.placeholder, Z && SelectV2_module_default.disabled, J),
			...Xl,
			children: [ql !== void 0 && /* @__PURE__ */ jsx("option", {
				disabled: !Jl,
				value: PLACEHOLDER_VALUE,
				children: ql
			}), Ql.map(({ value: x, label: w, ...V }) => /* @__PURE__ */ jsx("option", {
				value: x,
				...V,
				children: w ?? x.toString()
			}, x.toString()))]
		}), /* @__PURE__ */ jsx("span", {
			className: SelectV2_module_default.caret,
			"aria-hidden": !0,
			children: /* @__PURE__ */ jsx(Icon_default, {
				icon: "chevron-down",
				size: CARET_ICON_SIZE[Y],
				color: "#777883"
			})
		})]
	});
}
SelectV2.displayName = "SelectV2";
var SelectV2_default = React.forwardRef(SelectV2), TextareaV2_module_default = {
	wrapper: "_wrapper_11tw1_1",
	textarea: "_textarea_11tw1_5",
	disabled: "_disabled_11tw1_11",
	sizeSm: "_sizeSm_11tw1_15",
	sizeMd: "_sizeMd_11tw1_19",
	sizeLg: "_sizeLg_11tw1_23"
}, import_classnames$29 = /* @__PURE__ */ __toESM(require_classnames(), 1), SIZE_CLASS = createSizeClassMap(TextareaV2_module_default);
function TextareaV2({ inputSize: x = "md", prefix: w, suffix: V, disabled: U, wrapperClassName: W, hasError: G, className: K, ...J }, Y) {
	return /* @__PURE__ */ jsx(InputWrapper_default, {
		inputSize: x,
		hasError: G,
		disabled: U,
		wrapperClassName: (0, import_classnames$29.default)(TextareaV2_module_default.wrapper, SIZE_CLASS[x], W),
		prefix: w,
		suffix: V,
		children: /* @__PURE__ */ jsx("textarea", {
			ref: Y,
			disabled: U,
			rows: x === "sm" ? 3 : x === "md" ? 4 : 5,
			className: (0, import_classnames$29.default)(TextareaV2_module_default.textarea, U && TextareaV2_module_default.disabled, K),
			...J
		})
	});
}
var TextareaV2_default = React.forwardRef(TextareaV2), TextInputV2_module_default = {
	input: "_input_1etct_1",
	disabled: "_disabled_1etct_6"
}, import_classnames$28 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function TextInputV2({ inputSize: x, value: w = "", placeholder: V, onChange: U, onClick: W, prefix: G, suffix: K, disabled: J, readOnly: Y, wrapperClassName: Z, className: $, hasError: ql, autoFocus: Jl, onFocus: Yl, onBlur: Xl, onKeyDown: Zl, ...Ql }, $l) {
	return /* @__PURE__ */ jsx(InputWrapper_default, {
		inputSize: x,
		hasError: ql,
		disabled: J,
		wrapperClassName: Z,
		prefix: G,
		suffix: K,
		children: /* @__PURE__ */ jsx("input", {
			ref: $l,
			type: "text",
			value: w,
			placeholder: V,
			onChange: U,
			onClick: W,
			disabled: J,
			readOnly: Y,
			autoFocus: Jl,
			onFocus: Yl,
			onBlur: Xl,
			onKeyDown: Zl,
			className: (0, import_classnames$28.default)(TextInputV2_module_default.input, J && TextInputV2_module_default.disabled, $),
			...Ql
		})
	});
}
var TextInputV2_default = React.forwardRef(TextInputV2), componentMap = {
	select: SelectV2_default,
	colorPicker: ColorPickerV2_default,
	number: NumberInputV2_default,
	textarea: TextareaV2_default,
	text: TextInputV2_default,
	selectableInput: SelectableInputV2_default
}, InputV2 = React.forwardRef(({ type: x, ...w }, V) => /* @__PURE__ */ jsx(componentMap[x] ?? GenericInputV2_default, {
	...w,
	ref: V
}));
InputV2.displayName = "InputV2";
var InputV2_default = InputV2, Button$3 = ({ children: x, as: w = "button", ...V }) => /* @__PURE__ */ jsx(Listbox.Button, {
	as: w,
	...V,
	children: x
}), Label$3 = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Listbox.Label, {
	...w,
	children: x
}), Options$1 = ({ children: x, as: w = "ul", ...V }) => /* @__PURE__ */ jsx(Listbox.Options, {
	as: w,
	...V,
	children: x
}), Option$2 = ({ children: x, as: w = "li", ...V }) => /* @__PURE__ */ jsx(Listbox.Option, {
	as: w,
	...V,
	children: x
}), ListboxRoot = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Listbox, {
	...w,
	children: x
});
ListboxRoot.displayName = "Listbox", ListboxRoot.Button = Button$3, ListboxRoot.Label = Label$3, ListboxRoot.Options = Options$1, ListboxRoot.Option = Option$2;
var Listbox_default = ListboxRoot, Logo_default = () => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 697.2 180",
	width: "165px",
	height: "42.59px",
	children: [/* @__PURE__ */ jsx("path", {
		fill: "#ffffff",
		strokeWidth: "0",
		d: "m435.74 149.48-21.66-30.94-21.67 30.94h-26.57l34.95-49.91-34.95-49.92h26.57l21.67 30.95 21.66-30.95h26.57l-34.95 49.92 34.95 49.91h-26.57zM328.12 149.48V95.56l-33.31 47.57-33.31-47.57v53.92h-21.76V49.65h16.18l38.89 55.54 38.89-55.54h16.18v99.83h-21.76zM566.65 149.48V95.56l-33.31 47.57-33.31-47.57v53.92h-21.76V49.65h16.18l38.89 55.54 38.89-55.54h16.18v99.83h-21.76zM604.37 149.48v-16.44l58-61.78h-58V49.5h92.83v16.45l-57.99 61.77h57.99v21.76h-92.83z"
	}), /* @__PURE__ */ jsx("path", {
		fill: "#3b56ff",
		strokeWidth: "0",
		d: "M35.07 180h-32c-2.21 0-3.52-1.79-2.93-4L30.15 64c.59-2.21 2.86-4 5.07-4h32c2.21 0 3.52 1.79 2.93 4L40.14 176c-.59 2.21-2.86 4-5.07 4ZM98.11 150h-32c-2.21 0-3.52-1.79-2.93-4L93.19 34c.59-2.21 2.86-4 5.07-4h32c2.21 0 3.52 1.79 2.93 4l-30.01 112c-.59 2.21-2.86 4-5.07 4ZM145.07 180h-32c-2.21 0-3.52-1.79-2.93-4L156.23 4c.59-2.21 2.86-4 5.07-4h32c2.21 0 3.52 1.79 2.93 4l-46.09 172c-.59 2.21-2.86 4-5.07 4Z"
	})]
}), Dropzone_module_default = {
	Dropzone: "_Dropzone_dos5t_1",
	DropzoneText: "_DropzoneText_dos5t_5"
}, Dropzone_default = ({ handleDrop: x }) => /* @__PURE__ */ jsx("div", {
	onDragOver: (x) => x.preventDefault(),
	onDrop: x,
	className: Dropzone_module_default.Dropzone,
	children: /* @__PURE__ */ jsx(Text, {
		as: "p",
		className: Dropzone_module_default.DropzoneText,
		children: "Drop it like it's hot"
	})
});
const FILE_EXTENSIONS = {
	image: {
		jpg: ["image/jpg"],
		jpeg: ["image/jpeg"],
		png: ["image/png"],
		svg: ["image/svg+xml"],
		webp: ["image/webp"]
	},
	font: {
		woff: [
			"font/woff",
			"application/font-woff",
			"application/x-font-woff"
		],
		woff2: ["font/woff2"],
		ttf: ["font/ttf", "application/x-font-ttf"],
		otf: [
			"font/otf",
			"application/x-font-otf",
			"application/vnd.ms-opentype"
		]
	},
	video: { webm: ["video/webm"] }
}, ALL_EXTENSIONS = Object.values(FILE_EXTENSIONS).flatMap(Object.keys), ALL_MIME_TYPES = Object.values(FILE_EXTENSIONS).flatMap(Object.values).flat(), FONT_EXTENSIONS = Object.keys(FILE_EXTENSIONS.font), FONT_MIME_TYPES = Object.values(FILE_EXTENSIONS.font).flat();
function getExtFromFilename$1(x) {
	return x.split(".").pop()?.toLowerCase() ?? "";
}
function stripExtFromFilename(x, w) {
	if (!w) return x;
	let V = `.${w.toLowerCase()}`;
	return x.toLowerCase().endsWith(V) ? x.slice(0, x.length - V.length) : x;
}
async function validateSVG(x) {
	try {
		let w = await x.text().catch();
		if (!w) return !1;
		let V = new DOMParser().parseFromString(w, "image/svg+xml");
		return !(V.querySelector("parsererror") || !V.documentElement || V.documentElement.nodeName !== "svg");
	} catch {
		return !1;
	}
}
function isFile(x) {
	return "data" in x;
}
function isInFontsFolder(x) {
	return !x || !x.currentDirectory || !x.activeIds || !x.fontsDirectoryId ? !1 : x.currentDirectory.id === x.fontsDirectoryId && x.activeIds.length === 2 && x.activeIds[0] === "root" && x.activeIds[1] === x.fontsDirectoryId;
}
function getAllowedExtensions(x) {
	return isInFontsFolder(x) ? FONT_EXTENSIONS : ALL_EXTENSIONS.filter((x) => !FONT_EXTENSIONS.includes(x));
}
function getAllowedMimeTypes(x) {
	return isInFontsFolder(x) ? FONT_MIME_TYPES : ALL_MIME_TYPES.filter((x) => !FONT_MIME_TYPES.includes(x));
}
function getAcceptString(x, w, V) {
	let U = getAllowedExtensions(V), W = getAllowedMimeTypes(V);
	return x && x.length > 0 ? x.filter((x) => U.includes(x)).map((x) => `.${x}`).join(",") : w && w.length > 0 ? w.filter((x) => W.includes(x)).join(",") : [U, W].flat().join(",");
}
const isFontFile = (x) => {
	let w = getExtFromFilename$1(x.name);
	return w !== void 0 && FONT_EXTENSIONS.includes(w);
}, filterDirectories = (x, w) => x.filter((x) => x.id !== w).map((x) => ({
	...x,
	directories: x.directories ? filterDirectories(x.directories, w) : void 0
}));
async function normalizeFiles(x) {
	for (let V = 0; V < x.length; V++) {
		let U = x[V], W = U.type || "", G = getExtFromFilename$1(U.name), K = G, J = await fileTypeFromBlob(U);
		await validateSVG(U) ? (W = "image/svg+xml", K = "svg") : J && (W = J.mime || W, K = J.ext?.toLowerCase() || K);
		let Y = stripExtFromFilename(U.name, G), Z = K ? `${Y}.${K}` : Y;
		x[V] = new File([U], Z, {
			type: W,
			lastModified: U.lastModified
		});
	}
}
var fileTypeFromBufferFn = null;
async function getFileType() {
	return fileTypeFromBufferFn ||= (await import("./core-DUb7K8No.js")).fileTypeFromBuffer, fileTypeFromBufferFn;
}
async function getExtFromFilename(x) {
	let w = await x.arrayBuffer(), V = await (await getFileType())(new Uint8Array(w)), U;
	if (V) U = V.ext;
	else {
		let w = x.name.toLowerCase().split(".");
		w.length > 1 && (U = w.pop());
	}
	return U;
}
function isMimeTypeSupported(x, w) {
	return !w || w.length === 0 ? !0 : w.some((w) => w === x);
}
function isExtensionSupported(x, w) {
	return !w || w.length === 0 ? !0 : w.some((w) => w === x);
}
async function validateFileForFolder(x, w) {
	if (!w) return null;
	let V = await getExtFromFilename(x), U = x.type;
	if (isInFontsFolder(w)) {
		if (!(FONT_EXTENSIONS.includes(V) || FONT_MIME_TYPES.includes(U))) return {
			valid: !1,
			error: "Only font files can be uploaded to the fonts folder."
		};
	} else if (FONT_EXTENSIONS.includes(V) || FONT_MIME_TYPES.includes(U)) return {
		valid: !1,
		error: "Font files can only be uploaded to the fonts folder."
	};
	return null;
}
function validateFileMime(x, w) {
	let V = !w || w.length === 0 || isMimeTypeSupported(x.type, w);
	return {
		file: x,
		valid: V,
		error: V ? void 0 : `MIME type not supported: ${x.type}`
	};
}
async function validateFileExtension(x, w) {
	try {
		let V = await x.arrayBuffer(), U = await (await getFileType())(new Uint8Array(V)), W;
		if (U) W = U.ext;
		else {
			let w = x.name.toLowerCase().split(".");
			w.length > 1 && (W = w.pop());
		}
		return W && isExtensionSupported(W, w) ? {
			file: x,
			valid: !0
		} : W ? {
			file: x,
			valid: !1,
			error: `File extension not allowed: .${W}`
		} : {
			file: x,
			valid: !1,
			error: "Unknown file extension"
		};
	} catch {
		return {
			file: x,
			valid: !1,
			error: "Error reading file"
		};
	}
}
async function validateFile(x, w) {
	let { supportedMimeTypes: V, supportedExtensions: U, folderContext: W } = w, G = await validateFileForFolder(x, W);
	return G ? {
		file: x,
		...G
	} : U?.length > 0 ? validateFileExtension(x, U) : V?.length > 0 ? validateFileMime(x, V) : {
		file: x,
		valid: !0
	};
}
async function filterValidFiles(x, w) {
	let { onUploadResult: V, ...U } = w, W = Array.from(x), G = await Promise.all(W.map((x) => validateFile(x, U)));
	V && V(G);
	let K = G.filter((x) => x.valid).map((x) => x.file), J = new DataTransfer();
	return K.forEach((x) => J.items.add(x)), J.files;
}
var useDropzone_default = ({ uploadFiles: x, supportedMimeTypes: w, supportedExtensions: V, folderContext: U, onUploadResult: W }) => {
	let [G, K] = useState(!1);
	return {
		handleDragOver: (x) => {
			Array.from(x.dataTransfer.items).some((x) => x.kind === "file") && (x.preventDefault(), K(!0));
		},
		handleDrop: async (G) => {
			G.preventDefault(), K(!1);
			let J = Array.from(G.dataTransfer.files);
			await normalizeFiles(J);
			let Y = await filterValidFiles(J, {
				supportedMimeTypes: w,
				supportedExtensions: V,
				folderContext: U,
				onUploadResult: W
			});
			Y.length > 0 && x(Y);
		},
		isDraggingOver: G,
		handleDragLeave: (x) => {
			x.preventDefault();
			let { relatedTarget: w } = x;
			(!w || !x.currentTarget.contains(w)) && K(!1);
		}
	};
};
const INVALID_FILENAME_REGEX = /[<>:"/\\|?*\x00-\x1F]/, MAX_FILENAME_LENGTH = 255, getFileExtension = (x) => {
	let w = x.match(/\.[^.]+$/);
	return w ? w[0] : "";
}, sanitizeFileName = (x) => {
	let w = x.replace(INVALID_FILENAME_REGEX, "");
	return w.length > 255 && (w = w.substring(0, 255)), w;
}, normalizeFileName = (x, w) => {
	let V = x.trim().replace(/^\.+|\.+$/g, "");
	return w && V.length > 0 && getFileExtension(V) !== w && (V += w), V;
}, prepareRenamedFileName = (x, w) => {
	let V = getFileExtension(x), U = normalizeFileName(sanitizeFileName(w), V);
	return U && U !== x ? U : null;
};
var extendStatics = function(x, w) {
	return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(x, w) {
		x.__proto__ = w;
	} || function(x, w) {
		for (var V in w) w.hasOwnProperty(V) && (x[V] = w[V]);
	}, extendStatics(x, w);
};
function __extends(x, w) {
	extendStatics(x, w);
	function V() {
		this.constructor = x;
	}
	x.prototype = w === null ? Object.create(w) : (V.prototype = w.prototype, new V());
}
var __assign = function() {
	return __assign = Object.assign || function(x) {
		for (var w, V = 1, U = arguments.length; V < U; V++) for (var W in w = arguments[V], w) Object.prototype.hasOwnProperty.call(w, W) && (x[W] = w[W]);
		return x;
	}, __assign.apply(this, arguments);
};
function throttle(x, w, V, U) {
	var W, G = !1, K = 0;
	function J() {
		W && clearTimeout(W);
	}
	function Y() {
		J(), G = !0;
	}
	typeof w != "boolean" && (U = V, V = w, w = void 0);
	function Z() {
		var Y = this, Z = Date.now() - K, $ = arguments;
		if (G) return;
		function ql() {
			K = Date.now(), V.apply(Y, $);
		}
		function Jl() {
			W = void 0;
		}
		U && !W && ql(), J(), U === void 0 && Z > x ? ql() : w !== !0 && (W = setTimeout(U ? Jl : ql, U === void 0 ? x - Z : x));
	}
	return Z.cancel = Y, Z;
}
var ThresholdUnits = {
	Pixel: "Pixel",
	Percent: "Percent"
}, defaultThreshold = {
	unit: ThresholdUnits.Percent,
	value: .8
};
function parseThreshold(x) {
	return typeof x == "number" ? {
		unit: ThresholdUnits.Percent,
		value: x * 100
	} : typeof x == "string" ? x.match(/^(\d*(\.\d+)?)px$/) ? {
		unit: ThresholdUnits.Pixel,
		value: parseFloat(x)
	} : x.match(/^(\d*(\.\d+)?)%$/) ? {
		unit: ThresholdUnits.Percent,
		value: parseFloat(x)
	} : (console.warn("scrollThreshold format is invalid. Valid formats: \"120px\", \"50%\"..."), defaultThreshold) : (console.warn("scrollThreshold should be string or number"), defaultThreshold);
}
var index_es_default = function(x) {
	__extends(w, x);
	function w(w) {
		var V = x.call(this, w) || this;
		return V.lastScrollTop = 0, V.actionTriggered = !1, V.startY = 0, V.currentY = 0, V.dragging = !1, V.maxPullDownDistance = 0, V.getScrollableTarget = function() {
			return V.props.scrollableTarget instanceof HTMLElement ? V.props.scrollableTarget : typeof V.props.scrollableTarget == "string" ? document.getElementById(V.props.scrollableTarget) : (V.props.scrollableTarget === null && console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      "), null);
		}, V.onStart = function(x) {
			V.lastScrollTop || (V.dragging = !0, x instanceof MouseEvent ? V.startY = x.pageY : x instanceof TouchEvent && (V.startY = x.touches[0].pageY), V.currentY = V.startY, V._infScroll && (V._infScroll.style.willChange = "transform", V._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)"));
		}, V.onMove = function(x) {
			V.dragging && (x instanceof MouseEvent ? V.currentY = x.pageY : x instanceof TouchEvent && (V.currentY = x.touches[0].pageY), !(V.currentY < V.startY) && (V.currentY - V.startY >= Number(V.props.pullDownToRefreshThreshold) && V.setState({ pullToRefreshThresholdBreached: !0 }), !(V.currentY - V.startY > V.maxPullDownDistance * 1.5) && V._infScroll && (V._infScroll.style.overflow = "visible", V._infScroll.style.transform = "translate3d(0px, " + (V.currentY - V.startY) + "px, 0px)")));
		}, V.onEnd = function() {
			V.startY = 0, V.currentY = 0, V.dragging = !1, V.state.pullToRefreshThresholdBreached && (V.props.refreshFunction && V.props.refreshFunction(), V.setState({ pullToRefreshThresholdBreached: !1 })), requestAnimationFrame(function() {
				V._infScroll && (V._infScroll.style.overflow = "auto", V._infScroll.style.transform = "none", V._infScroll.style.willChange = "unset");
			});
		}, V.onScrollListener = function(x) {
			typeof V.props.onScroll == "function" && setTimeout(function() {
				return V.props.onScroll && V.props.onScroll(x);
			}, 0);
			var w = V.props.height || V._scrollableNode ? x.target : document.documentElement.scrollTop ? document.documentElement : document.body;
			V.actionTriggered || ((V.props.inverse ? V.isElementAtTop(w, V.props.scrollThreshold) : V.isElementAtBottom(w, V.props.scrollThreshold)) && V.props.hasMore && (V.actionTriggered = !0, V.setState({ showLoader: !0 }), V.props.next && V.props.next()), V.lastScrollTop = w.scrollTop);
		}, V.state = {
			showLoader: !1,
			pullToRefreshThresholdBreached: !1,
			prevDataLength: w.dataLength
		}, V.throttledOnScrollListener = throttle(150, V.onScrollListener).bind(V), V.onStart = V.onStart.bind(V), V.onMove = V.onMove.bind(V), V.onEnd = V.onEnd.bind(V), V;
	}
	return w.prototype.componentDidMount = function() {
		if (this.props.dataLength === void 0) throw Error("mandatory prop \"dataLength\" is missing. The prop is needed when loading more content. Check README.md for usage");
		if (this._scrollableNode = this.getScrollableTarget(), this.el = this.props.height ? this._infScroll : this._scrollableNode || window, this.el && this.el.addEventListener("scroll", this.throttledOnScrollListener), typeof this.props.initialScrollY == "number" && this.el && this.el instanceof HTMLElement && this.el.scrollHeight > this.props.initialScrollY && this.el.scrollTo(0, this.props.initialScrollY), this.props.pullDownToRefresh && this.el && (this.el.addEventListener("touchstart", this.onStart), this.el.addEventListener("touchmove", this.onMove), this.el.addEventListener("touchend", this.onEnd), this.el.addEventListener("mousedown", this.onStart), this.el.addEventListener("mousemove", this.onMove), this.el.addEventListener("mouseup", this.onEnd), this.maxPullDownDistance = this._pullDown && this._pullDown.firstChild && this._pullDown.firstChild.getBoundingClientRect().height || 0, this.forceUpdate(), typeof this.props.refreshFunction != "function")) throw Error("Mandatory prop \"refreshFunction\" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage'");
	}, w.prototype.componentWillUnmount = function() {
		this.el && (this.el.removeEventListener("scroll", this.throttledOnScrollListener), this.props.pullDownToRefresh && (this.el.removeEventListener("touchstart", this.onStart), this.el.removeEventListener("touchmove", this.onMove), this.el.removeEventListener("touchend", this.onEnd), this.el.removeEventListener("mousedown", this.onStart), this.el.removeEventListener("mousemove", this.onMove), this.el.removeEventListener("mouseup", this.onEnd)));
	}, w.prototype.componentDidUpdate = function(x) {
		this.props.dataLength !== x.dataLength && (this.actionTriggered = !1, this.setState({ showLoader: !1 }));
	}, w.getDerivedStateFromProps = function(x, w) {
		return x.dataLength === w.prevDataLength ? null : __assign(__assign({}, w), { prevDataLength: x.dataLength });
	}, w.prototype.isElementAtTop = function(x, w) {
		w === void 0 && (w = .8);
		var V = x === document.body || x === document.documentElement ? window.screen.availHeight : x.clientHeight, U = parseThreshold(w);
		return U.unit === ThresholdUnits.Pixel ? x.scrollTop <= U.value + V - x.scrollHeight + 1 : x.scrollTop <= U.value / 100 + V - x.scrollHeight + 1;
	}, w.prototype.isElementAtBottom = function(x, w) {
		w === void 0 && (w = .8);
		var V = x === document.body || x === document.documentElement ? window.screen.availHeight : x.clientHeight, U = parseThreshold(w);
		return U.unit === ThresholdUnits.Pixel ? x.scrollTop + V >= x.scrollHeight - U.value : x.scrollTop + V >= U.value / 100 * x.scrollHeight;
	}, w.prototype.render = function() {
		var x = this, w = __assign({
			height: this.props.height || "auto",
			overflow: "auto",
			WebkitOverflowScrolling: "touch"
		}, this.props.style), V = this.props.hasChildren || !!(this.props.children && this.props.children instanceof Array && this.props.children.length), U = this.props.pullDownToRefresh && this.props.height ? { overflow: "auto" } : {};
		return React.createElement("div", {
			style: U,
			className: "infinite-scroll-component__outerdiv"
		}, React.createElement("div", {
			className: "infinite-scroll-component " + (this.props.className || ""),
			ref: function(w) {
				return x._infScroll = w;
			},
			style: w
		}, this.props.pullDownToRefresh && React.createElement("div", {
			style: { position: "relative" },
			ref: function(w) {
				return x._pullDown = w;
			}
		}, React.createElement("div", { style: {
			position: "absolute",
			left: 0,
			right: 0,
			top: -1 * this.maxPullDownDistance
		} }, this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent)), this.props.children, !this.state.showLoader && !V && this.props.hasMore && this.props.loader, this.state.showLoader && this.props.hasMore && this.props.loader, !this.props.hasMore && this.props.endMessage));
	}, w;
}(Component), BulkActionsBar_module_default = {
	BulkActionsBar: "_BulkActionsBar_1ym16_1",
	Content: "_Content_1ym16_9",
	Count: "_Count_1ym16_15",
	Actions: "_Actions_1ym16_22"
};
const BulkActionsBar = ({ selectedCount: x, onCopy: w, onDelete: V, onClear: U, hasLoadingFiles: W = !1 }) => x ? /* @__PURE__ */ jsx("div", {
	className: BulkActionsBar_module_default.BulkActionsBar,
	children: /* @__PURE__ */ jsxs("div", {
		className: BulkActionsBar_module_default.Content,
		children: [/* @__PURE__ */ jsxs(Text, {
			as: "span",
			className: BulkActionsBar_module_default.Count,
			children: [
				x,
				" ",
				x === 1 ? "file" : "files",
				" selected"
			]
		}), /* @__PURE__ */ jsxs("div", {
			className: BulkActionsBar_module_default.Actions,
			children: [
				w && /* @__PURE__ */ jsx(Button_default, {
					onClick: w,
					variant: "primary",
					buttonSize: "small",
					iconProps: {
						icon: "copy",
						size: 14
					},
					disabled: W,
					children: "Copy"
				}),
				V && /* @__PURE__ */ jsx(Button_default, {
					onClick: V,
					variant: "danger",
					buttonSize: "small",
					iconProps: {
						icon: "trash",
						size: 14
					},
					disabled: W,
					children: "Delete"
				}),
				/* @__PURE__ */ jsx(Button_default, {
					onClick: U,
					variant: "secondary",
					buttonSize: "small",
					children: "Clear Selection"
				})
			]
		})]
	})
}) : null;
var CopyFileDialog_module_default = {
	Content: "_Content_yuk6f_1",
	Field: "_Field_yuk6f_5",
	Label: "_Label_yuk6f_9",
	CurrentFileName: "_CurrentFileName_yuk6f_13",
	FilesList: "_FilesList_yuk6f_17",
	FileRow: "_FileRow_yuk6f_22",
	FileNameSection: "_FileNameSection_yuk6f_27",
	NewNameSection: "_NewNameSection_yuk6f_31",
	HelperText: "_HelperText_yuk6f_35",
	DirectoryPickerWrapper: "_DirectoryPickerWrapper_yuk6f_39",
	DirectoryTree: "_DirectoryTree_yuk6f_43",
	DirectoryItem: "_DirectoryItem_yuk6f_47",
	DirectoryRow: "_DirectoryRow_yuk6f_51",
	Selected: "_Selected_yuk6f_56",
	ExpandButton: "_ExpandButton_yuk6f_60",
	Arrow: "_Arrow_yuk6f_71",
	Spacer: "_Spacer_yuk6f_75",
	DirectoryName: "_DirectoryName_yuk6f_79",
	NoDirectories: "_NoDirectories_yuk6f_83",
	DialogFooter: "_DialogFooter_yuk6f_87",
	LeftActions: "_LeftActions_yuk6f_91",
	RightActions: "_RightActions_yuk6f_95"
}, collectDefaultExpandedIds = (x) => x.filter((x) => x.defaultExpanded).map((x) => x.id);
const DirectoryTree = ({ directories: x, selectedId: w, onSelect: V, onExpand: U, level: W = 0 }) => {
	let [G, K] = useState(() => W === 0 ? new Set(collectDefaultExpandedIds(x)) : /* @__PURE__ */ new Set());
	useEffect(() => {
		W === 0 && K((w) => {
			let V = new Set(w);
			return x.forEach((x) => {
				x.defaultExpanded && !V.has(x.id) && V.add(x.id);
			}), V;
		});
	}, [x, W]);
	let J = useRef(!1);
	useEffect(() => {
		W !== 0 || !U || J.current || (J.current = !0, ((x) => {
			for (let w of x) w.defaultExpanded && w.directories === void 0 && U(w.id);
		})(x));
	}, [
		x,
		W,
		U
	]);
	let Y = (x) => {
		let w = G.has(x);
		K((w) => {
			let V = new Set(w);
			return V.has(x) ? V.delete(x) : V.add(x), V;
		}), !w && U && U(x);
	}, Z = (x, w) => {
		(x.key === "Enter" || x.key === " ") && (x.preventDefault(), V(w.id));
	};
	return /* @__PURE__ */ jsx("div", {
		className: CopyFileDialog_module_default.DirectoryTree,
		children: x.map((x) => {
			let K = x.directories === void 0 || x.directories.length > 0, J = x.directories && x.directories.length > 0, $ = G.has(x.id), ql = w === x.id;
			return /* @__PURE__ */ jsxs("div", {
				className: CopyFileDialog_module_default.DirectoryItem,
				children: [/* @__PURE__ */ jsxs("div", {
					className: classNames$10(CopyFileDialog_module_default.DirectoryRow, ql ? CopyFileDialog_module_default.Selected : ""),
					style: { paddingLeft: `${W * 20 + 8}px` },
					onClick: () => V(x.id),
					onKeyDown: (w) => Z(w, x),
					tabIndex: 0,
					role: "button",
					"aria-selected": ql,
					children: [
						K && /* @__PURE__ */ jsx("button", {
							className: CopyFileDialog_module_default.ExpandButton,
							onClick: (w) => {
								w.stopPropagation(), Y(x.id);
							},
							"aria-label": $ ? "Collapse folder" : "Expand folder",
							tabIndex: -1,
							children: /* @__PURE__ */ jsx("span", {
								className: `${CopyFileDialog_module_default.Arrow} ${$ ? CopyFileDialog_module_default.Expanded : ""}`,
								children: /* @__PURE__ */ jsx(Icon_default, { icon: $ ? "chevron-down" : "chevron-right" })
							})
						}),
						!K && /* @__PURE__ */ jsx("span", { className: CopyFileDialog_module_default.Spacer }),
						/* @__PURE__ */ jsx("span", {
							className: CopyFileDialog_module_default.DirectoryName,
							children: x.name
						})
					]
				}), J && $ && /* @__PURE__ */ jsx(DirectoryTree, {
					directories: x.directories,
					selectedId: w,
					onSelect: V,
					onExpand: U,
					level: W + 1
				})]
			}, x.id);
		})
	});
}, CopyFileDialog = ({ files: x, directories: w = [], onCopy: V, onClose: U, open: W, folderContext: G, onDirectoryExpand: K, isLoading: J = !1 }) => {
	let [Y, Z] = useState({}), [$, ql] = useState(null), Jl = useMemo(() => filterDirectories(w, G?.fontsDirectoryId), [w, G?.fontsDirectoryId]);
	useEffect(() => {
		W && (Z({}), ql(null));
	}, [W]);
	let Yl = () => {
		$ && V($, x.map((x) => ({
			id: x.id,
			newName: Y[x.id]?.trim() || void 0
		})));
	}, Xl = (x, w) => {
		let V = sanitizeFileName(w);
		Z((w) => ({
			...w,
			[x]: V
		}));
	}, Zl = (w) => {
		let V = Y[w];
		if (!V) return;
		let U = x.find((x) => x.id === w);
		if (!U) return;
		let W = normalizeFileName(V, getFileExtension(U.name));
		W !== V && Z((x) => ({
			...x,
			[w]: W
		}));
	}, Ql = $ !== null && !J && x.length > 0, $l = x.length > 1;
	return /* @__PURE__ */ jsx(Dialog, {
		backdrop: !0,
		open: W,
		onClose: U,
		children: /* @__PURE__ */ jsxs(Dialog.Panel, { children: [
			/* @__PURE__ */ jsx(Dialog.Title, { children: $l ? `Copy ${x.length} files` : "Copy file" }),
			/* @__PURE__ */ jsxs("div", {
				className: CopyFileDialog_module_default.Content,
				children: [x.length > 0 && /* @__PURE__ */ jsxs("div", {
					className: CopyFileDialog_module_default.Field,
					children: [/* @__PURE__ */ jsx("div", {
						className: CopyFileDialog_module_default.FilesList,
						children: x.map((x) => /* @__PURE__ */ jsxs("div", {
							className: CopyFileDialog_module_default.FileRow,
							children: [/* @__PURE__ */ jsx("div", {
								className: CopyFileDialog_module_default.FileNameSection,
								children: /* @__PURE__ */ jsx(Text, {
									as: "span",
									className: CopyFileDialog_module_default.CurrentFileName,
									children: x.name
								})
							}), /* @__PURE__ */ jsx("div", {
								className: CopyFileDialog_module_default.NewNameSection,
								children: /* @__PURE__ */ jsx(Input, {
									type: "text",
									value: Y[x.id] || "",
									onChange: (w) => Xl(x.id, w.target.value),
									onBlur: () => Zl(x.id),
									placeholder: "Enter new name (optional)",
									disabled: J,
									"aria-label": `New filename for ${x.name}`
								})
							})]
						}, x.id))
					}), /* @__PURE__ */ jsx(Text, {
						as: "span",
						className: CopyFileDialog_module_default.HelperText,
						children: "Leave filenames empty to auto-generate names"
					})]
				}), x.length > 0 && /* @__PURE__ */ jsxs("div", {
					className: CopyFileDialog_module_default.Field,
					children: [/* @__PURE__ */ jsx("label", {
						className: CopyFileDialog_module_default.Label,
						children: /* @__PURE__ */ jsx(Text, {
							as: "span",
							children: "Destination folder"
						})
					}), Jl.length > 0 ? /* @__PURE__ */ jsx("div", {
						className: CopyFileDialog_module_default.DirectoryPickerWrapper,
						children: /* @__PURE__ */ jsx(DirectoryTree, {
							directories: Jl,
							selectedId: $,
							onSelect: ql,
							onExpand: K
						})
					}) : /* @__PURE__ */ jsx(Text, {
						as: "p",
						className: CopyFileDialog_module_default.NoDirectories,
						children: "No directories available"
					})]
				})]
			}),
			/* @__PURE__ */ jsxs(Dialog.Footer, {
				className: CopyFileDialog_module_default.DialogFooter,
				children: [/* @__PURE__ */ jsx("div", {
					className: CopyFileDialog_module_default.LeftActions,
					children: /* @__PURE__ */ jsx(Button_default, {
						onClick: U,
						variant: "secondary",
						disabled: J,
						children: "Cancel"
					})
				}), /* @__PURE__ */ jsx("div", {
					className: CopyFileDialog_module_default.RightActions,
					children: /* @__PURE__ */ jsx(Button_default, {
						onClick: Yl,
						variant: "primary",
						disabled: !Ql,
						children: J ? "Copying..." : "Copy"
					})
				})]
			})
		] })
	});
};
var DeleteConfirmationDialog_module_default = {
	DialogFooter: "_DialogFooter_w972q_1",
	LeftActions: "_LeftActions_w972q_5",
	RightActions: "_RightActions_w972q_9"
};
const DeleteConfirmationDialog = ({ open: x, onClose: w, onConfirm: V, fileCount: U, fileName: W }) => {
	let G = U > 1, K = W || "this file";
	return /* @__PURE__ */ jsx(Dialog, {
		backdrop: !0,
		open: x,
		onClose: w,
		children: /* @__PURE__ */ jsxs(Dialog.Panel, { children: [
			/* @__PURE__ */ jsx(Dialog.Title, { children: `Are you sure you want to delete ${U} file${U === 1 ? "" : "s"} ` }),
			G ? /* @__PURE__ */ jsxs(Text, {
				as: "p",
				children: [
					"This will permanently delete ",
					/* @__PURE__ */ jsxs("strong", { children: [U, " files"] }),
					" from your library."
				]
			}) : /* @__PURE__ */ jsxs(Text, {
				as: "span",
				children: [
					"Are you sure you want to delete ",
					/* @__PURE__ */ jsx("strong", { children: K }),
					"?"
				]
			}),
			/* @__PURE__ */ jsx(Text, { children: "This action cannot be undone." }),
			/* @__PURE__ */ jsxs(Dialog.Footer, {
				className: DeleteConfirmationDialog_module_default.DialogFooter,
				children: [/* @__PURE__ */ jsx("div", {
					className: DeleteConfirmationDialog_module_default.LeftActions,
					children: /* @__PURE__ */ jsx(Button_default, {
						onClick: w,
						variant: "secondary",
						children: "Cancel"
					})
				}), /* @__PURE__ */ jsx("div", {
					className: DeleteConfirmationDialog_module_default.RightActions,
					children: /* @__PURE__ */ jsx(Button_default, {
						onClick: V,
						variant: "danger",
						children: "Delete"
					})
				})]
			})
		] })
	});
}, useBulkActions = ({ selectedFiles: x, onClearSelection: w, onDeleteFiles: V, onCopyFiles: U }) => {
	let [W, G] = useState(!1), [K, J] = useState(!1), Y = () => G(!0), Z = () => G(!1), $ = (x, V) => {
		U && U({
			files: V,
			destinationDirectoryId: x,
			callback: () => {
				Z(), w();
			}
		});
	}, ql = () => J(!0), Jl = () => J(!1);
	return {
		isCopyDialogOpen: W,
		openCopyDialog: Y,
		closeCopyDialog: Z,
		handleCopySubmit: $,
		isDeleteDialogOpen: K,
		openDeleteDialog: ql,
		closeDeleteDialog: Jl,
		handleDeleteConfirm: () => {
			V && (x.forEach((x) => {
				V(x);
			}), Jl(), w());
		}
	};
}, useMultiSelect = ({ libraryData: x, selectedFile: w, selectedFileIds: V, setSelectedFile: U, onSelectionChange: W, onClearSelection: G, onItemClick: K, isLoading: J }) => {
	let Y = useRef(-1), Z = (x) => x.ctrlKey || x.metaKey ? "toggle" : x.shiftKey ? "range" : "single", $ = (x, w, J) => {
		let Z = V.size === 1 && V.has(x.id);
		Z || (G(), W(x.id, !0)), U(x), Y.current = w, Z && K?.(x, J);
	}, ql = (x, G) => {
		let K = V.has(x.id);
		W(x.id, !K), K ? w?.id === x.id && U(null) : U(x), Y.current = G;
	}, Jl = (w, V, K) => {
		if (Y.current === -1) {
			$(w, V, K);
			return;
		}
		let J = Math.min(Y.current, V), Z = Math.max(Y.current, V);
		G(), x.slice(J, Z + 1).filter((x) => isFile(x)).map((x) => x.id).forEach((x) => W(x, !0)), U(w);
	};
	return {
		handleItemClick: (w, V) => {
			if (J) return;
			if (!isFile(w)) {
				K?.(w, V);
				return;
			}
			let U = x.findIndex((x) => x.id === w.id), W = Z(V);
			W !== "single" && V.preventDefault(), W === "range" ? Jl(w, U, V) : W === "toggle" ? ql(w, U) : $(w, U, V);
		},
		selectedFiles: useMemo(() => x.filter((x) => isFile(x)).filter((x) => V.has(x.id)), [x, V])
	};
};
var Gallery_module_default = {
	MediaLibraryEmptyMessageFull: "_MediaLibraryEmptyMessageFull_lcra0_1",
	MediaLibraryEmptyMessageCompact: "_MediaLibraryEmptyMessageCompact_lcra0_8",
	MediaLibraryGalleryFull: "_MediaLibraryGalleryFull_lcra0_14",
	MediaLibraryGalleryCompact: "_MediaLibraryGalleryCompact_lcra0_20",
	MediaLibraryInfiniteScrollFull: "_MediaLibraryInfiniteScrollFull_lcra0_28",
	MediaLibraryInfiniteScrollCompact: "_MediaLibraryInfiniteScrollCompact_lcra0_32",
	MediaLibraryInfiniteScrollLoader: "_MediaLibraryInfiniteScrollLoader_lcra0_38",
	MediaLibraryItemsFull: "_MediaLibraryItemsFull_lcra0_43",
	MediaLibraryItemsCompact: "_MediaLibraryItemsCompact_lcra0_48",
	MediaLibraryLoader: "_MediaLibraryLoader_lcra0_56",
	MediaLibraryLoaderWrapperFull: "_MediaLibraryLoaderWrapperFull_lcra0_60",
	MediaLibraryLoaderWrapperCompact: "_MediaLibraryLoaderWrapperCompact_lcra0_64",
	MediaLibrarySearchBarFull: "_MediaLibrarySearchBarFull_lcra0_69",
	MediaLibrarySearchBarCompact: "_MediaLibrarySearchBarCompact_lcra0_74"
}, import_classnames$27 = /* @__PURE__ */ __toESM(require_classnames(), 1), import_uniqueId = /* @__PURE__ */ __toESM(require_uniqueId(), 1), Gallery_default = (x) => {
	let { deleteFile: w, directories: V, copyFiles: U, renameFile: W, hasMore: G, headerRef: K, itemsLength: J, isLoading: Y, isCopyLoading: Z, onDirectoryExpand: $, libraryData: ql, loadMore: Jl, onItemClick: Yl, searchOption: Xl, searchOptions: Zl, searchQuery: Ql, selectedFile: $l, selectedFileIds: eu, setSearchQuery: tu, setSelectedFile: nu, setSearchOption: ru, supportedMimeTypes: iu, supportedExtensions: au, uploadFiles: ou, variant: su, onUploadResult: cu, folderContext: lu, onSelectionChange: uu, onClearSelection: du } = x, fu = useMemo(() => (0, import_uniqueId.default)("scrollable-"), []), { handleDragOver: mu, handleDrop: hu, isDraggingOver: gu, handleDragLeave: _u } = useDropzone_default({
		uploadFiles: ou,
		supportedMimeTypes: iu,
		supportedExtensions: au,
		folderContext: lu,
		onUploadResult: cu
	}), { handleItemClick: vu, selectedFiles: yu } = useMultiSelect({
		libraryData: ql,
		selectedFile: $l,
		selectedFileIds: eu,
		setSelectedFile: nu,
		onSelectionChange: uu,
		onClearSelection: du,
		onItemClick: Yl,
		isLoading: Y
	}), { isCopyDialogOpen: bu, openCopyDialog: xu, closeCopyDialog: Su, handleCopySubmit: Cu, isDeleteDialogOpen: wu, openDeleteDialog: Tu, closeDeleteDialog: Eu, handleDeleteConfirm: Du } = useBulkActions({
		selectedFiles: yu,
		onClearSelection: du,
		onDeleteFiles: w,
		onCopyFiles: U
	}), Ou = yu.some((x) => x.isLoading), ku = yu.some((x) => isFontFile(x));
	return /* @__PURE__ */ jsxs("div", {
		className: (0, import_classnames$27.default)({
			[Gallery_module_default.MediaLibraryGalleryFull]: su === "full",
			[Gallery_module_default.MediaLibraryGalleryCompact]: su === "compact"
		}),
		style: { "--subtractHeader": `${K.current?.offsetHeight ?? 0}px` },
		onDragOver: mu,
		onDragLeave: _u,
		children: [
			/* @__PURE__ */ jsxs("div", {
				id: fu,
				className: (0, import_classnames$27.default)({
					[Gallery_module_default.MediaLibraryInfiniteScrollFull]: su === "full",
					[Gallery_module_default.MediaLibraryInfiniteScrollCompact]: su === "compact"
				}),
				children: [su === "full" && /* @__PURE__ */ jsx(SearchBar_default, {
					className: Gallery_module_default.MediaLibrarySearchBarFull,
					searchOption: Xl,
					searchOptions: Zl,
					searchQuery: Ql,
					setSearchOption: ru,
					setSearchQuery: tu
				}), ql.length === 0 ? /* @__PURE__ */ jsx(Fragment$1, { children: Y ? /* @__PURE__ */ jsx("div", {
					className: (0, import_classnames$27.default)({
						[Gallery_module_default.MediaLibraryLoaderWrapperFull]: su === "full",
						[Gallery_module_default.MediaLibraryLoaderWrapperCompact]: su === "compact"
					}),
					children: /* @__PURE__ */ jsx(Loader_default, { className: Gallery_module_default.MediaLibraryLoader })
				}) : /* @__PURE__ */ jsx("p", {
					className: (0, import_classnames$27.default)({
						[Gallery_module_default.MediaLibraryEmptyMessageFull]: su === "full",
						[Gallery_module_default.MediaLibraryEmptyMessageCompact]: su === "compact"
					}),
					children: Ql ? "Your search did not return any results" : "This directory is empty"
				}) }) : /* @__PURE__ */ jsxs(index_es_default, {
					dataLength: J + (Y ? 1 : 0),
					next: Jl,
					hasMore: G,
					loader: "",
					scrollableTarget: fu,
					className: (0, import_classnames$27.default)({
						[Gallery_module_default.MediaLibraryItemsFull]: su === "full",
						[Gallery_module_default.MediaLibraryItemsCompact]: su === "compact"
					}),
					inverse: !1,
					children: [ql?.map((x) => /* @__PURE__ */ jsx(Item_default, {
						deleteFile: w,
						directories: V,
						copyFiles: U,
						renameFile: W,
						item: x,
						isActive: $l?.id === x.id,
						isSelected: isFile(x) && eu.has(x.id),
						isLibrary: su === "full",
						onClick: vu,
						searchQuery: Ql,
						showInfo: !0
					}, x.id)), Y && /* @__PURE__ */ jsx("div", {
						className: Gallery_module_default.MediaLibraryInfiniteScrollLoader,
						children: /* @__PURE__ */ jsx(Loader_default, { className: Gallery_module_default.MediaLibraryLoader })
					})]
				})]
			}),
			gu && !Ql && /* @__PURE__ */ jsx(Dropzone_default, {
				handleDrop: hu,
				supportedExtensions: au,
				supportedMimeTypes: iu,
				folderContext: lu
			}),
			/* @__PURE__ */ jsx(BulkActionsBar, {
				selectedCount: eu.size,
				onCopy: U && V && !ku ? xu : void 0,
				onDelete: w ? Tu : void 0,
				onClear: du,
				hasLoadingFiles: Ou
			}),
			U && V && /* @__PURE__ */ jsx(CopyFileDialog, {
				files: yu,
				directories: V,
				onCopy: Cu,
				onClose: Su,
				open: bu,
				folderContext: lu,
				isLoading: Z,
				onDirectoryExpand: $
			}),
			/* @__PURE__ */ jsx(DeleteConfirmationDialog, {
				open: wu,
				onClose: Eu,
				onConfirm: Du,
				fileCount: yu.length
			})
		]
	});
}, SearchBar_module_default = {
	SearchBar: "_SearchBar_kauh8_1",
	SearchInput: "_SearchInput_kauh8_5",
	SearchOptionButton: "_SearchOptionButton_kauh8_11",
	SearchOptions: "_SearchOptions_kauh8_16",
	SearchOptionsWrapper: "_SearchOptionsWrapper_kauh8_21"
}, import_classnames$26 = /* @__PURE__ */ __toESM(require_classnames(), 1), SearchBar_default = ({ className: x, searchOption: w, searchOptions: V, searchQuery: U, setSearchOption: W, setSearchQuery: G }) => (useEffect(() => {
	let x = (x) => {
		x.key === "Escape" && G("");
	};
	return document.addEventListener("keydown", x, !0), function() {
		document.removeEventListener("keydown", x, !0);
	};
}, []), /* @__PURE__ */ jsx("div", {
	className: (0, import_classnames$26.default)(SearchBar_module_default.SearchBar, x),
	children: /* @__PURE__ */ jsx(Input, {
		className: SearchBar_module_default.SearchInput,
		maxLength: 40,
		onChange: (x) => G(x.target.value),
		placeholder: "Start typing to search...",
		value: U,
		suffix: /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(Icon_default, {
			icon: "search",
			weight: "regular",
			size: 18
		}), V.length > 0 && /* @__PURE__ */ jsx("div", {
			className: SearchBar_module_default.SearchOptions,
			children: /* @__PURE__ */ jsx("div", {
				className: SearchBar_module_default.SearchOptionsWrapper,
				children: V.map((x) => /* @__PURE__ */ jsx(Button_default, {
					buttonSize: "xs",
					className: SearchBar_module_default.SearchOptionButton,
					onClick: () => W(x),
					variant: x.id === w.id ? "primary" : "secondary",
					children: x.label
				}, x.id))
			})
		})] })
	})
})), Breadcrumbs_module_default = {
	BreadcrumbsHeader: "_BreadcrumbsHeader_1f1k6_1",
	BreadcrumbsWrapper: "_BreadcrumbsWrapper_1f1k6_11",
	BreadcrumbWrapper: "_BreadcrumbWrapper_1f1k6_16",
	Breadcrumb: "_Breadcrumb_1f1k6_1",
	BreadcrumbText: "_BreadcrumbText_1f1k6_24"
}, Breadcrumbs_default = ({ initialBreadcrumbs: x, isLoading: w, onClick: V }) => {
	let [U, G] = useState(x), K = U.length - 1, J = (x) => {
		let w = U.findIndex((w) => w.id === x.id), { id: V, name: W } = x;
		if (w !== -1) {
			G([...U.slice(0, w), {
				id: V,
				name: W
			}]);
			return;
		}
		G([...U, {
			id: V,
			name: W
		}]);
	}, Y = (x, U) => {
		w || (J(x), V(x, U));
	};
	return /* @__PURE__ */ jsx("div", {
		className: Breadcrumbs_module_default.BreadcrumbsHeader,
		children: U.map((x, w) => /* @__PURE__ */ jsx("div", {
			className: Breadcrumbs_module_default.BreadcrumbWrapper,
			onClick: (w) => {
				Y(x, w);
			},
			children: /* @__PURE__ */ jsxs("div", {
				className: Breadcrumbs_module_default.Breadcrumb,
				children: [
					/* @__PURE__ */ jsx(Icon_default, {
						color: preset_default.theme.extend.colors.secondary,
						icon: "folder",
						size: 18
					}),
					/* @__PURE__ */ jsxs(Text, {
						color: "light",
						className: Breadcrumbs_module_default.BreadcrumbText,
						children: [" ", x.name]
					}),
					K !== w && /* @__PURE__ */ jsx(Icon_default, {
						icon: "chevron-right",
						size: 12,
						color: "white"
					})
				]
			})
		}, x.id))
	});
}, CurrentDirectory_module_default = {
	CurrentDirectoryHeader: "_CurrentDirectoryHeader_5i6f4_1",
	DirectoryName: "_DirectoryName_5i6f4_5",
	DirectoryNameEditable: "_DirectoryNameEditable_5i6f4_13",
	DirectoryIsLockedIcon: "_DirectoryIsLockedIcon_5i6f4_17",
	spin: "_spin_5i6f4_1",
	DirectNameEditIcon: "_DirectNameEditIcon_5i6f4_21",
	UploadButton: "_UploadButton_5i6f4_25",
	UpdateDirectoryNameButton: "_UpdateDirectoryNameButton_5i6f4_29"
}, import_classnames$25 = /* @__PURE__ */ __toESM(require_classnames(), 1), CurrentDirectory_default = (x) => {
	let { directoryName: w, isLoading: V, isRoot: U, isLocked: G, supportedMimeTypes: K, supportedExtensions: J, updateDirectoryName: Y, uploadFiles: Z, onUploadResult: $, folderContext: ql } = x, Jl = useRef(null), [Yl, Xl] = useState(w || ""), [Zl, Ql] = useState(!1), $l = useRef(null), eu = useRef(w), tu = () => {
		Jl.current.click();
	}, nu = async (x) => {
		let w = Array.from(x.target.files) || [];
		await normalizeFiles(w), Z(await filterValidFiles(w, {
			supportedMimeTypes: K,
			supportedExtensions: J,
			folderContext: ql,
			onUploadResult: $
		}));
	}, ru = () => {
		Yl && (Ql(!1), Y({
			updatedDirectoryName: Yl,
			onSuccess: () => {
				eu.current = Yl;
			},
			onFailure: () => {
				Xl(eu.current);
			}
		}));
	};
	return useEffect(() => {
		Zl && $l.current?.focus();
	}, [Zl]), useEffect(() => {
		let x = (x) => {
			x.key === "Escape" && (Ql(!1), Xl(eu.current));
		};
		return document.addEventListener("keydown", x, !0), function() {
			document.removeEventListener("keydown", x, !0);
		};
	}, []), /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("div", {
		className: CurrentDirectory_module_default.CurrentDirectoryHeader,
		children: !Zl || U ? /* @__PURE__ */ jsx(Text, {
			className: (0, import_classnames$25.default)(CurrentDirectory_module_default.DirectoryName, { [CurrentDirectory_module_default.DirectoryNameEditable]: !U }),
			as: "h3",
			children: /* @__PURE__ */ jsxs("span", {
				className: CurrentDirectory_module_default.DirectoryNameText,
				onClick: () => {
					!U && !G && (eu.current = Yl, Ql(!0));
				},
				children: [!U && /* @__PURE__ */ jsx(Icon_default, {
					icon: G ? "circle-notch" : "note-pencil",
					size: 18,
					weight: G ? "regular" : "fill",
					className: (0, import_classnames$25.default)(CurrentDirectory_module_default.DirectNameEditIcon, { [CurrentDirectory_module_default.DirectoryIsLockedIcon]: G })
				}), Yl]
			})
		}) : /* @__PURE__ */ jsx(Input, {
			type: "text",
			inputRef: $l,
			onChange: (x) => {
				Xl(x.currentTarget.value.replace(/\//g, ""));
			},
			onKeyDown: (x) => {
				x.key === "Enter" && ru();
			},
			placeholder: "Fill in a directory name",
			suffix: /* @__PURE__ */ jsx(Button_default, {
				className: CurrentDirectory_module_default.UpdateDirectoryNameButton,
				iconProps: {
					icon: "check",
					color: preset_default.theme.extend.colors.primary,
					weight: "bold"
				},
				onClick: ru,
				variant: "tertiary"
			}),
			value: Yl
		})
	}), /* @__PURE__ */ jsxs("div", {
		className: CurrentDirectory_module_default.UploadButton,
		children: [/* @__PURE__ */ jsx(Button_default, {
			onClick: tu,
			disabled: V,
			variant: "primary",
			buttonSize: "medium",
			children: "Upload"
		}), /* @__PURE__ */ jsx("input", {
			type: "file",
			accept: getAcceptString(J, K, ql),
			multiple: !0,
			style: { display: "none" },
			ref: Jl,
			onChange: nu
		})]
	})] });
}, Header_module_default = {
	MediaLibraryHeaderFull: "_MediaLibraryHeaderFull_wbpyb_1",
	MediaLibraryHeaderCompact: "_MediaLibraryHeaderCompact_wbpyb_7",
	MediaLibrarySearchBarCompact: "_MediaLibrarySearchBarCompact_wbpyb_12"
}, SearchResults_module_default = {
	CloseSearchButton: "_CloseSearchButton_7ei00_1",
	SearchResultsHeaderCompact: "_SearchResultsHeaderCompact_7ei00_6",
	SearchResultsHeaderTextFull: "_SearchResultsHeaderTextFull_7ei00_11",
	SearchResultsHeaderTextCompact: "_SearchResultsHeaderTextCompact_7ei00_15",
	SearchHighlight: "_SearchHighlight_7ei00_19",
	SearchQueryHightlight: "_SearchQueryHightlight_7ei00_23"
}, import_classnames$24 = /* @__PURE__ */ __toESM(require_classnames(), 1), SearchResults_default = ({ directoryName: x, searchQuery: w, setSearchQuery: V, variant: U }) => /* @__PURE__ */ jsxs(U === "compact" ? "div" : React.Fragment, {
	...U === "compact" ? { className: SearchResults_module_default.SearchResultsHeaderCompact } : {},
	children: [/* @__PURE__ */ jsxs(Text, {
		as: "h2",
		className: (0, import_classnames$24.default)({
			[SearchResults_module_default.SearchResultsHeaderTextFull]: U === "full",
			[SearchResults_module_default.SearchResultsHeaderTextCompact]: U === "compact"
		}),
		children: [
			"Searching for ",
			/* @__PURE__ */ jsx("span", {
				className: SearchResults_module_default.SearchHighlight,
				children: w
			}),
			" in",
			" ",
			/* @__PURE__ */ jsx("span", {
				className: SearchResults_module_default.SearchHighlight,
				children: x
			})
		]
	}), /* @__PURE__ */ jsx(Button_default, {
		className: SearchResults_module_default.CloseSearchButton,
		iconProps: {
			icon: "x",
			color: preset_default.theme.extend.colors["gr-gray-dark"],
			weight: "regular"
		},
		onClick: () => V(""),
		variant: "secondary"
	})]
}), import_classnames$23 = /* @__PURE__ */ __toESM(require_classnames(), 1), Header_default = React.forwardRef(({ directoryName: x, initialBreadcrumbs: w, isLoading: V = !1, isRoot: U = !1, isLocked: W = !1, onItemClick: G, searchOption: K, searchOptions: J, searchQuery: Y, setSearchOption: Z, setSearchQuery: $, supportedMimeTypes: ql, supportedExtensions: Jl, updateDirectoryName: Yl, uploadFiles: Xl, variant: Zl = "full", onUploadResult: Ql, folderContext: $l }, eu) => /* @__PURE__ */ jsxs("div", {
	className: (0, import_classnames$23.default)({
		[Header_module_default.MediaLibraryHeaderCompact]: Zl === "compact",
		[Header_module_default.MediaLibraryHeaderFull]: Zl === "full"
	}),
	ref: eu,
	children: [Y ? /* @__PURE__ */ jsx(SearchResults_default, {
		directoryName: x,
		searchQuery: Y,
		setSearchQuery: $,
		variant: Zl
	}) : Zl === "full" ? /* @__PURE__ */ jsx(CurrentDirectory_default, {
		directoryName: x,
		isLoading: V,
		isLocked: W,
		isRoot: U,
		supportedMimeTypes: ql,
		supportedExtensions: Jl,
		updateDirectoryName: Yl,
		uploadFiles: Xl,
		onUploadResult: Ql,
		folderContext: $l
	}) : Zl === "compact" ? /* @__PURE__ */ jsx(Breadcrumbs_default, {
		initialBreadcrumbs: w,
		isLoading: V,
		onClick: G
	}) : null, Zl === "compact" && /* @__PURE__ */ jsx(SearchBar_default, {
		className: Header_module_default.MediaLibrarySearchBarCompact,
		searchOption: K,
		searchOptions: J,
		searchQuery: Y,
		setSearchOption: Z,
		setSearchQuery: $
	})]
})), Directory_module_default = {
	LibraryImageWrapper: "_LibraryImageWrapper_h315z_1",
	MediaLibraryDirectoryWrapper: "_MediaLibraryDirectoryWrapper_h315z_8"
}, import_classnames$22 = /* @__PURE__ */ __toESM(require_classnames(), 1), Directory_default = ({ onClick: x, item: w, searchQuery: V }) => /* @__PURE__ */ jsxs("div", {
	className: (0, import_classnames$22.default)(Directory_module_default.LibraryImageWrapper, Directory_module_default.MediaLibraryDirectoryWrapper),
	onClick: x,
	children: [/* @__PURE__ */ jsx(Icon_default, {
		icon: "folder",
		size: 50,
		color: preset_default.theme.extend.colors.secondary
	}), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Text, {
		color: "light",
		children: /* @__PURE__ */ jsx(SearchQueryHighlight_default, {
			searchQuery: V,
			string: w.name
		})
	}) })]
}), File_module_default = {
	FileMenu: "_FileMenu_175pb_1",
	MenuButtonWrapper: "_MenuButtonWrapper_175pb_5",
	MenuButton: "_MenuButton_175pb_5",
	MenuItems: "_MenuItems_175pb_16",
	MenuItem: "_MenuItem_175pb_16",
	Active: "_Active_175pb_28",
	DeleteMenuItem: "_DeleteMenuItem_175pb_35",
	FileInfoMainWrapper: "_FileInfoMainWrapper_175pb_42",
	FileInfoWrapper: "_FileInfoWrapper_175pb_53",
	FileSkeletonLoader: "_FileSkeletonLoader_175pb_57",
	pulse: "_pulse_175pb_1",
	FileSkeletonLarge: "_FileSkeletonLarge_175pb_61",
	DimensionSpacer: "_DimensionSpacer_175pb_65",
	ImageIsActive: "_ImageIsActive_175pb_69",
	ImageIsInLibrary: "_ImageIsInLibrary_175pb_73",
	LibraryImage: "_LibraryImage_175pb_77",
	LibraryImageLoader: "_LibraryImageLoader_175pb_82",
	LibraryImageLoading: "_LibraryImageLoading_175pb_88",
	LibraryImageLoaded: "_LibraryImageLoaded_175pb_92",
	LibraryImageWrapper: "_LibraryImageWrapper_175pb_97",
	MediaLibraryName: "_MediaLibraryName_175pb_103",
	MediaLibraryNameWrapper: "_MediaLibraryNameWrapper_175pb_108"
};
const MediaLibraryFileInfo = ({ item: x, searchQuery: w, onRename: V, isLibrary: U = !0 }) => /* @__PURE__ */ jsxs("div", {
	className: File_module_default.FileInfoWrapper,
	children: [/* @__PURE__ */ jsx("div", {
		className: File_module_default.MediaLibraryNameWrapper,
		children: V ? /* @__PURE__ */ jsx(InlineEdit, {
			value: x.name,
			onChange: (w) => {
				if (!V) return;
				let U = prepareRenamedFileName(x.name, w);
				U && V(U);
			},
			placeholder: "Enter file name",
			hidePencil: !U,
			characterLimit: 255
		}) : /* @__PURE__ */ jsx(Text, {
			color: "light",
			className: File_module_default.MediaLibraryName,
			title: x.name,
			children: /* @__PURE__ */ jsx(SearchQueryHighlight_default, {
				searchQuery: w,
				string: x.name
			})
		})
	}), x.dimensions ? /* @__PURE__ */ jsxs(Text, {
		color: "elevated",
		as: "span",
		children: [
			x.dimensions.x,
			"x",
			x.dimensions.y,
			"px"
		]
	}) : /* @__PURE__ */ jsx("div", { className: File_module_default.DimensionSpacer })]
});
var import_classnames$21 = /* @__PURE__ */ __toESM(require_classnames(), 1);
const MediaLibraryFileInfoSkeletonLoader = ({ item: x, searchQuery: w }) => /* @__PURE__ */ jsxs("div", {
	className: File_module_default.FileInfoWrapper,
	"data-skeleton": !0,
	children: [/* @__PURE__ */ jsx("div", {
		className: File_module_default.MediaLibraryNameWrapper,
		children: x.name ? /* @__PURE__ */ jsx(Text, {
			color: "light",
			className: File_module_default.MediaLibraryName,
			children: /* @__PURE__ */ jsx(SearchQueryHighlight_default, {
				searchQuery: w,
				string: x.name
			})
		}) : /* @__PURE__ */ jsx("div", { className: File_module_default.FileSkeletonLoader })
	}), x.dimensions ? /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx("div", { className: (0, import_classnames$21.default)(File_module_default.FileSkeletonLoader, File_module_default.FileSkeletonLarge) }) }) : /* @__PURE__ */ jsx("div", { className: File_module_default.DimensionSpacer })]
});
var import_classnames$20 = /* @__PURE__ */ __toESM(require_classnames(), 1);
const MediaLibraryFile = ({ item: x, onClick: w, isActive: V, isSelected: U = !1, searchQuery: W, showInfo: G = !1, isLibrary: K, onRename: J }) => {
	let [Y, Z] = useState(!1), [$, ql] = useState(!1), [Jl, Yl] = useState(1), Xl = x.data.find((x) => x.type === "thumbnail")?.url, Zl = React.useRef(null), $l, eu = () => {
		Yl(1), clearInterval($l);
	};
	return useEffect(() => ($ && $l === void 0 && ($l = setInterval(() => {
		Yl((x) => x + 1), Zl.current && (Zl.current.src = `${Xl}?${(/* @__PURE__ */ new Date()).getTime()}`);
	}, 1e3)), !$ && $l && eu(), function() {
		$l && eu();
	}), [Jl, $]), useEffect(() => {
		$l && Jl === 30 && clearInterval($l);
	}, [Jl]), /* @__PURE__ */ jsxs("div", {
		className: File_module_default.FileInfoMainWrapper,
		children: [/* @__PURE__ */ jsxs("div", {
			className: (0, import_classnames$20.default)(File_module_default.LibraryImageWrapper, {
				[File_module_default.ImageIsActive]: V || U,
				[File_module_default.ImageIsInLibrary]: K,
				[File_module_default.ImageIsInDirectory]: !K
			}),
			onClick: w,
			children: [(x.isLoading || !Y || $) && /* @__PURE__ */ jsx(Loader_default, { className: File_module_default.LibraryImageLoader }), /* @__PURE__ */ jsx("img", {
				loading: "lazy",
				className: (0, import_classnames$20.default)(File_module_default.LibraryImage, {
					[File_module_default.LibraryImageLoading]: !Y || $ || x.isLoading,
					[File_module_default.LibraryImageLoaded]: Y && !$ && !x.isLoading
				}),
				width: "100%",
				src: Xl,
				onError: () => ql(!0),
				onLoad: () => {
					ql(!1), Z(!0);
				},
				ref: Zl
			})]
		}), G ? x.isLoading || $ ? /* @__PURE__ */ jsx(MediaLibraryFileInfoSkeletonLoader, {
			item: x,
			searchQuery: W
		}) : /* @__PURE__ */ jsx(MediaLibraryFileInfo, {
			item: x,
			searchQuery: W,
			onRename: J,
			isLibrary: K
		}) : null]
	});
};
var Item_default = ({ deleteFile: x, directories: w, copyFiles: V, renameFile: U, item: W, isActive: G, isLibrary: K, onClick: J, searchQuery: Y, showInfo: Z, isSelected: $ }) => isFile(W) ? /* @__PURE__ */ jsx(MediaLibraryFile, {
	item: W,
	isActive: G,
	onClick: (x) => J(W, x),
	onDelete: () => x(W),
	onRename: U ? (x) => U(W, x) : void 0,
	directories: w,
	copyFiles: V,
	isLibrary: K,
	searchQuery: Y,
	showInfo: Z,
	isSelected: $
}) : /* @__PURE__ */ jsx(Directory_default, {
	item: W,
	onClick: (x) => J(W, x),
	searchQuery: Y
}), require_escapeRegExp = /* @__PURE__ */ __commonJSMin(((x, w) => {
	var V = require_toString(), U = /[\\^$.*+?()[\]{}|]/g, W = RegExp(U.source);
	function G(x) {
		return x = V(x), x && W.test(x) ? x.replace(U, "\\$&") : x;
	}
	w.exports = G;
})), SearchQueryHighlight_module_default = { SearchQueryHighlight: "_SearchQueryHighlight_xga0c_1" }, import_classnames$19 = /* @__PURE__ */ __toESM(require_classnames(), 1), import_escapeRegExp = /* @__PURE__ */ __toESM(require_escapeRegExp(), 1), SearchQueryHighlight_default = ({ string: x, searchQuery: w = "" }) => {
	let V = (0, import_escapeRegExp.default)(w), U = x.split(RegExp(`(${V})`, "gi")), W = useCallback((x) => x.toLowerCase() === w.toLowerCase(), [w]);
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [U.map((x, w) => /* @__PURE__ */ jsx("span", {
		className: (0, import_classnames$19.default)({ [SearchQueryHighlight_module_default.SearchQueryHighlight]: W(x) }),
		children: x
	}, w)), " "] });
}, MediaLibrary_module_default = {
	MediaLibraryFull: "_MediaLibraryFull_17rop_1",
	MediaLibraryCompact: "_MediaLibraryCompact_17rop_7",
	MediaLibraryContentFull: "_MediaLibraryContentFull_17rop_13",
	MediaLibraryPreview: "_MediaLibraryPreview_17rop_17"
}, import_classnames$18 = /* @__PURE__ */ __toESM(require_classnames(), 1), MediaLibrary_default = ({ deleteFile: x, directories: w, directoryName: V, copyFiles: U, hasMore: W, isCopyLoading: G, onDirectoryExpand: K, initialBreadcrumbs: J, isLoading: Y, isLocked: Z, isRoot: $, itemsLength: ql, libraryData: Jl, loadMore: Yl, onItemClick: Xl, renameFile: Zl, searchOption: $l, searchOptions: eu, searchQuery: tu, setSearchOption: nu, setSearchQuery: ru, supportedMimeTypes: iu, supportedExtensions: au, uploadFiles: ou, updateDirectoryName: su, variant: cu = "full", onUploadResult: lu, folderContext: du }) => {
	let [fu, pu] = useState(null), [mu, hu] = useState(/* @__PURE__ */ new Set()), _u = React.useRef(null), vu = cu === "full" ? "div" : React.Fragment, yu = (x, w) => {
		hu((V) => {
			let U = new Set(V);
			return w ? U.add(x) : U.delete(x), U;
		});
	}, bu = () => {
		hu(/* @__PURE__ */ new Set()), pu(null);
	};
	return useEffect(() => {
		fu && pu(Jl.find((x) => x.id === fu?.id) || null);
	}, [fu, Jl]), useEffect(() => {
		if (mu.size === 0) return;
		let x = new Set(Jl.map((x) => x.id)), w = [];
		mu.forEach((V) => {
			x.has(V) || w.push(V);
		}), w.length > 0 && hu((x) => {
			let V = new Set(x);
			return w.forEach((x) => V.delete(x)), V;
		});
	}, [Jl, mu]), /* @__PURE__ */ jsxs("div", {
		className: (0, import_classnames$18.default)({
			[MediaLibrary_module_default.MediaLibraryFull]: cu === "full",
			[MediaLibrary_module_default.MediaLibraryCompact]: cu === "compact"
		}),
		children: [/* @__PURE__ */ jsxs(vu, {
			...cu === "full" ? { className: MediaLibrary_module_default.MediaLibraryContentFull } : {},
			children: [/* @__PURE__ */ jsx(Header_default, {
				directoryName: V,
				initialBreadcrumbs: J,
				isLoading: Y,
				isLocked: Z,
				isRoot: $,
				onItemClick: Xl,
				ref: _u,
				searchOption: $l,
				searchOptions: eu,
				searchQuery: tu,
				setSearchOption: nu,
				setSearchQuery: ru,
				supportedMimeTypes: iu,
				supportedExtensions: au,
				updateDirectoryName: su,
				uploadFiles: ou,
				variant: cu,
				onUploadResult: lu,
				folderContext: du
			}), /* @__PURE__ */ jsx(Gallery_default, {
				deleteFile: x,
				directories: w,
				copyFiles: U,
				renameFile: Zl,
				libraryData: Jl,
				hasMore: W,
				headerRef: _u,
				loadMore: Yl,
				isLoading: Y,
				isCopyLoading: G,
				onDirectoryExpand: K,
				itemsLength: ql,
				onItemClick: Xl,
				searchOption: $l,
				searchOptions: eu,
				searchQuery: tu,
				selectedFile: fu,
				selectedFileIds: mu,
				setSearchOption: nu,
				setSearchQuery: ru,
				setSelectedFile: pu,
				supportedMimeTypes: iu,
				supportedExtensions: au,
				uploadFiles: ou,
				variant: cu,
				onUploadResult: lu,
				folderContext: du,
				onSelectionChange: yu,
				onClearSelection: bu
			})]
		}), cu === "full" && /* @__PURE__ */ jsx("div", {
			className: MediaLibrary_module_default.MediaLibraryPreview,
			children: /* @__PURE__ */ jsx(Preview_default, {
				selectedFile: fu,
				renameFile: Zl
			})
		})]
	});
}, Preview_module_default = {
	InfoWrapper: "_InfoWrapper_c6al1_1",
	InfoSingleWrapper: "_InfoSingleWrapper_c6al1_5",
	MediaPreviewImage: "_MediaPreviewImage_c6al1_9",
	MediaPreviewImageParagraph: "_MediaPreviewImageParagraph_c6al1_14",
	MediaPreviewImageSticky: "_MediaPreviewImageSticky_c6al1_18",
	MediaPreviewImageWrapper: "_MediaPreviewImageWrapper_c6al1_22",
	MediaPreviewImageLoader: "_MediaPreviewImageLoader_c6al1_33",
	MediaPreviewImageLoading: "_MediaPreviewImageLoading_c6al1_39",
	MediaPreviewImageLoaded: "_MediaPreviewImageLoaded_c6al1_43",
	PreviewInfo: "_PreviewInfo_c6al1_48",
	UrlPreview: "_UrlPreview_c6al1_52"
}, import_classnames$17 = /* @__PURE__ */ __toESM(require_classnames(), 1), Preview_default = ({ selectedFile: x, renameFile: w }) => {
	let [V, U] = useState(!1), [W, G] = useState(!1), [K, J] = useState(1), Y = x?.data.find((x) => x.type === "preview")?.url, Z = x?.data.find((x) => x.type === "full")?.url, $ = React.useRef(null), ql, Jl = () => {
		J(1), clearInterval(ql);
	};
	return useEffect(() => (V && ql === void 0 && (ql = setInterval(() => {
		J((x) => x + 1), $.current && ($.current.src = `${Y}?${(/* @__PURE__ */ new Date()).getTime()}`);
	}, 1e3)), !V && ql && Jl(), function() {
		ql && Jl();
	}), [K, V]), useEffect(() => {
		ql && K === 30 && clearInterval(ql);
	}, [K]), /* @__PURE__ */ jsx("div", {
		className: Preview_module_default.MediaPreviewImage,
		children: x === null ? /* @__PURE__ */ jsx("p", {
			className: Preview_module_default.MediaPreviewImageParagraph,
			children: "No selected image"
		}) : Y ? /* @__PURE__ */ jsxs("div", {
			className: Preview_module_default.MediaPreviewImageSticky,
			children: [/* @__PURE__ */ jsxs("div", {
				className: Preview_module_default.MediaPreviewImageWrapper,
				children: [V && /* @__PURE__ */ jsx(Loader_default, { className: Preview_module_default.MediaPreviewImageLoader }), /* @__PURE__ */ jsx("img", {
					className: (0, import_classnames$17.default)(Preview_module_default.MediaPreviewImage, {
						[Preview_module_default.MediaPreviewImageLoading]: !W || V,
						[Preview_module_default.MediaPreviewImageLoaded]: W && !V
					}),
					src: Y,
					onError: () => U(!0),
					onLoad: () => {
						U(!1), G(!0);
					},
					ref: $
				})]
			}), /* @__PURE__ */ jsxs("div", {
				className: Preview_module_default.InfoWrapper,
				children: [
					w ? /* @__PURE__ */ jsx(InlineEdit, {
						value: x.name,
						onChange: (V) => {
							let U = prepareRenamedFileName(x.name, V);
							U && w(x, U);
						},
						placeholder: "Enter file name",
						characterLimit: 255
					}) : /* @__PURE__ */ jsx(Text, {
						as: "h3",
						className: Preview_module_default.PreviewInfo,
						children: x.name
					}),
					/* @__PURE__ */ jsxs("div", {
						className: Preview_module_default.InfoSingleWrapper,
						style: { marginTop: 16 },
						children: [/* @__PURE__ */ jsx(Text, {
							color: "elevated",
							children: /* @__PURE__ */ jsx("strong", { children: "URL" })
						}), /* @__PURE__ */ jsx("a", {
							href: Z,
							target: "_blank",
							rel: "noopener",
							children: /* @__PURE__ */ jsx(Text, {
								color: "light",
								className: (0, import_classnames$17.default)(Preview_module_default.PreviewInfo, { [Preview_module_default.UrlPreview]: !0 }),
								children: Z
							})
						})]
					}),
					/* @__PURE__ */ jsxs("div", {
						className: Preview_module_default.InfoSingleWrapper,
						children: [/* @__PURE__ */ jsx(Text, {
							color: "elevated",
							children: /* @__PURE__ */ jsx("strong", { children: "File size" })
						}), /* @__PURE__ */ jsx(Text, {
							color: "light",
							children: prettyBytes(x.size)
						})]
					}),
					x.createdAt && /* @__PURE__ */ jsxs("div", {
						className: Preview_module_default.InfoSingleWrapper,
						children: [/* @__PURE__ */ jsx(Text, {
							color: "elevated",
							children: /* @__PURE__ */ jsx("strong", { children: "Created at" })
						}), /* @__PURE__ */ jsx(Text, {
							color: "light",
							children: x.createdAt
						})]
					})
				]
			})]
		}) : /* @__PURE__ */ jsx("p", {
			className: Preview_module_default.MediaPreviewImageParagraph,
			children: "Preview not available"
		})
	});
}, Button$2 = ({ children: x, as: w = "button", ...V }) => /* @__PURE__ */ jsx(Menu.Button, {
	as: w,
	...V,
	children: x
}), Items = ({ children: x, as: w = "ul", ...V }) => /* @__PURE__ */ jsx(Menu.Items, {
	as: w,
	...V,
	children: x
}), Item = ({ children: x, as: w = "li", ...V }) => /* @__PURE__ */ jsx(Menu.Item, {
	as: w,
	...V,
	children: x
}), MenuRoot = ({ children: x, ...w }) => /* @__PURE__ */ jsx(Menu, {
	...w,
	children: x
});
MenuRoot.displayName = "Menu", MenuRoot.Button = Button$2, MenuRoot.Items = Items, MenuRoot.Item = Item;
var Menu_default = Object.assign(MenuRoot, {
	Button: Button$2,
	Items,
	Item
}), Modal_module_default = {
	DialogPanel: "_DialogPanel_1hqlg_1",
	DialogFooter: "_DialogFooter_1hqlg_5",
	DialogTitle: "_DialogTitle_1hqlg_9",
	DialogSubTitle: "_DialogSubTitle_1hqlg_13",
	Icon: "_Icon_1hqlg_17",
	WarningIcon: "_WarningIcon_1hqlg_21",
	CloseButton: "_CloseButton_1hqlg_25"
}, import_classnames$16 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function Modal({ title: x, subtitle: w, cancelButtonText: V = "Cancel", submitButtonText: U = "Submit", icon: W, iconProps: G, className: K, isOpen: J, setIsOpen: Y, onCancel: Z, onSubmit: $, showCloseButtonOnly: ql = !1 }) {
	let Jl = () => {
		Y(!1), Z?.();
	};
	return /* @__PURE__ */ jsx(Dialog, {
		backdrop: !0,
		open: J,
		onClose: () => Y(!1),
		children: /* @__PURE__ */ jsxs(Dialog.Panel, {
			className: twMerge((0, import_classnames$16.default)(Modal_module_default.DialogPanel, K)),
			children: [
				ql && /* @__PURE__ */ jsx("button", {
					onClick: () => {
						Y(!1), Z?.();
					},
					className: Modal_module_default.CloseButton,
					"aria-label": "Close modal",
					children: /* @__PURE__ */ jsx(Icon_default, {
						icon: "x",
						size: 20,
						weight: "bold"
					})
				}),
				!!W && /* @__PURE__ */ jsx("div", {
					className: twMerge((0, import_classnames$16.default)(Modal_module_default.Icon, W === "warning" && Modal_module_default.WarningIcon)),
					children: /* @__PURE__ */ jsx(Icon_default, {
						icon: W,
						size: 42,
						...G
					})
				}),
				!!x && /* @__PURE__ */ jsx(Dialog.Title, { children: /* @__PURE__ */ jsx(Text, {
					className: Modal_module_default.DialogTitle,
					children: x
				}) }),
				!!w && /* @__PURE__ */ jsx(Dialog.Description, { children: /* @__PURE__ */ jsx(Text, {
					color: "surface",
					className: Modal_module_default.DialogSubTitle,
					children: w
				}) }),
				!ql && /* @__PURE__ */ jsxs(Dialog.Footer, {
					className: Modal_module_default.DialogFooter,
					children: [/* @__PURE__ */ jsx(Button_default, {
						variant: "secondary",
						onClick: Jl,
						children: V
					}), /* @__PURE__ */ jsx(Button_default, {
						variant: "primary",
						onClick: $,
						children: U
					})]
				})
			]
		})
	});
}
var Navbar_module_default = {
	Container: "_Container_jfkqr_1",
	LeftContainer: "_LeftContainer_jfkqr_7",
	CenterContainer: "_CenterContainer_jfkqr_11",
	RightContainer: "_RightContainer_jfkqr_15",
	LeftContent: "_LeftContent_jfkqr_19",
	Logo: "_Logo_jfkqr_23",
	LogoText: "_LogoText_jfkqr_26",
	Navbar: "_Navbar_jfkqr_33",
	Links: "_Links_jfkqr_37",
	Link: "_Link_jfkqr_37",
	LinkText: "_LinkText_jfkqr_44",
	ActiveLink: "_ActiveLink_jfkqr_52",
	LogoutButton: "_LogoutButton_jfkqr_59",
	Content: "_Content_jfkqr_63"
};
function Navbar({ isAuthenticated: x = !1, contentRight: w, contentCenter: V, className: U, links: W = [{
	to: "/rundown",
	label: "Operator",
	isActive: !0,
	isHidden: !0
}] }) {
	return /* @__PURE__ */ jsxs("header", {
		className: twMerge(Navbar_module_default.Container, U),
		children: [/* @__PURE__ */ jsxs("div", {
			className: Navbar_module_default.LeftContainer,
			children: [/* @__PURE__ */ jsx("a", {
				href: "/",
				className: Navbar_module_default.Logo,
				children: /* @__PURE__ */ jsx(Logo_default, {})
			}), x ? /* @__PURE__ */ jsx("div", {
				className: Navbar_module_default.LeftContent,
				children: /* @__PURE__ */ jsx("nav", {
					className: Navbar_module_default.Navbar,
					children: /* @__PURE__ */ jsx("ul", {
						className: Navbar_module_default.Links,
						children: (() => W ? W.map((x, w) => x.isHidden ? null : /* @__PURE__ */ jsx("li", {
							className: Navbar_module_default.Link,
							children: /* @__PURE__ */ jsx(Link$1, {
								to: x.to,
								className: twMerge(Navbar_module_default.LinkText, x.isActive ? Navbar_module_default.ActiveLink : ""),
								children: x.label
							})
						}, w)) : null)()
					})
				})
			}) : null]
		}), x ? /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("div", {
			className: Navbar_module_default.CenterContainer,
			children: V
		}), /* @__PURE__ */ jsx("div", {
			className: Navbar_module_default.RightContainer,
			children: w
		})] }) : null]
	});
}
var PanelGroupContext = createContext(null);
PanelGroupContext.displayName = "PanelGroupContext";
var DATA_ATTRIBUTES = {
	group: "data-panel-group",
	groupDirection: "data-panel-group-direction",
	groupId: "data-panel-group-id",
	panel: "data-panel",
	panelCollapsible: "data-panel-collapsible",
	panelId: "data-panel-id",
	panelSize: "data-panel-size",
	resizeHandle: "data-resize-handle",
	resizeHandleActive: "data-resize-handle-active",
	resizeHandleEnabled: "data-panel-resize-handle-enabled",
	resizeHandleId: "data-panel-resize-handle-id",
	resizeHandleState: "data-resize-handle-state"
}, PRECISION = 10, useIsomorphicLayoutEffect = useLayoutEffect, useId = React$1.useId, wrappedUseId = typeof useId == "function" ? useId : () => null, counter = 0;
function useUniqueId(x = null) {
	let w = wrappedUseId(), V = useRef(x || w || null);
	return V.current === null && (V.current = "" + counter++), x ?? V.current;
}
function PanelWithForwardedRef({ children: x, className: w = "", collapsedSize: V, collapsible: U, defaultSize: W, forwardedRef: G, id: K, maxSize: J, minSize: Y, onCollapse: Z, onExpand: $, onResize: ql, order: Jl, style: Yl, tagName: Xl = "div", ...Zl }) {
	let Ql = useContext(PanelGroupContext);
	if (Ql === null) throw Error("Panel components must be rendered within a PanelGroup container");
	let { collapsePanel: $l, expandPanel: eu, getPanelSize: tu, getPanelStyle: nu, groupId: ru, isPanelCollapsed: au, reevaluatePanelConstraints: ou, registerPanel: su, resizePanel: cu, unregisterPanel: uu } = Ql, fu = useUniqueId(K), pu = useRef({
		callbacks: {
			onCollapse: Z,
			onExpand: $,
			onResize: ql
		},
		constraints: {
			collapsedSize: V,
			collapsible: U,
			defaultSize: W,
			maxSize: J,
			minSize: Y
		},
		id: fu,
		idIsFromProps: K !== void 0,
		order: Jl
	});
	useRef({ didLogMissingDefaultSizeWarning: !1 }), useIsomorphicLayoutEffect(() => {
		let { callbacks: x, constraints: w } = pu.current, G = { ...w };
		pu.current.id = fu, pu.current.idIsFromProps = K !== void 0, pu.current.order = Jl, x.onCollapse = Z, x.onExpand = $, x.onResize = ql, w.collapsedSize = V, w.collapsible = U, w.defaultSize = W, w.maxSize = J, w.minSize = Y, (G.collapsedSize !== w.collapsedSize || G.collapsible !== w.collapsible || G.maxSize !== w.maxSize || G.minSize !== w.minSize) && ou(pu.current, G);
	}), useIsomorphicLayoutEffect(() => {
		let x = pu.current;
		return su(x), () => {
			uu(x);
		};
	}, [
		Jl,
		fu,
		su,
		uu
	]), useImperativeHandle(G, () => ({
		collapse: () => {
			$l(pu.current);
		},
		expand: (x) => {
			eu(pu.current, x);
		},
		getId() {
			return fu;
		},
		getSize() {
			return tu(pu.current);
		},
		isCollapsed() {
			return au(pu.current);
		},
		isExpanded() {
			return !au(pu.current);
		},
		resize: (x) => {
			cu(pu.current, x);
		}
	}), [
		$l,
		eu,
		tu,
		au,
		fu,
		cu
	]);
	let mu = nu(pu.current, W);
	return createElement(Xl, {
		...Zl,
		children: x,
		className: w,
		id: fu,
		style: {
			...mu,
			...Yl
		},
		[DATA_ATTRIBUTES.groupId]: ru,
		[DATA_ATTRIBUTES.panel]: "",
		[DATA_ATTRIBUTES.panelCollapsible]: U || void 0,
		[DATA_ATTRIBUTES.panelId]: fu,
		[DATA_ATTRIBUTES.panelSize]: parseFloat("" + mu.flexGrow).toFixed(1)
	});
}
var Panel$2 = forwardRef((x, w) => createElement(PanelWithForwardedRef, {
	...x,
	forwardedRef: w
}));
PanelWithForwardedRef.displayName = "Panel", Panel$2.displayName = "forwardRef(Panel)";
var nonce;
function getNonce() {
	return nonce;
}
var currentCursorStyle = null, enabled = !0, prevRuleIndex = -1, styleElement = null;
function getCursorStyle(x, w) {
	if (w) {
		let x = (w & EXCEEDED_HORIZONTAL_MIN) !== 0, V = (w & EXCEEDED_HORIZONTAL_MAX) !== 0, U = (w & EXCEEDED_VERTICAL_MIN) !== 0, W = (w & EXCEEDED_VERTICAL_MAX) !== 0;
		if (x) return U ? "se-resize" : W ? "ne-resize" : "e-resize";
		if (V) return U ? "sw-resize" : W ? "nw-resize" : "w-resize";
		if (U) return "s-resize";
		if (W) return "n-resize";
	}
	switch (x) {
		case "horizontal": return "ew-resize";
		case "intersection": return "move";
		case "vertical": return "ns-resize";
	}
}
function resetGlobalCursorStyle() {
	styleElement !== null && (document.head.removeChild(styleElement), currentCursorStyle = null, styleElement = null, prevRuleIndex = -1);
}
function setGlobalCursorStyle(x, w) {
	if (!enabled) return;
	let V = getCursorStyle(x, w);
	if (currentCursorStyle !== V) {
		if (currentCursorStyle = V, styleElement === null) {
			styleElement = document.createElement("style");
			let x = getNonce();
			x && styleElement.setAttribute("nonce", x), document.head.appendChild(styleElement);
		}
		if (prevRuleIndex >= 0) {
			var U;
			(U = styleElement.sheet) == null || U.removeRule(prevRuleIndex);
		}
		prevRuleIndex = styleElement.sheet?.insertRule(`*{cursor: ${V} !important;}`) ?? -1;
	}
}
function isKeyDown(x) {
	return x.type === "keydown";
}
function isPointerEvent(x) {
	return x.type.startsWith("pointer");
}
function isMouseEvent(x) {
	return x.type.startsWith("mouse");
}
function getResizeEventCoordinates(x) {
	if (isPointerEvent(x)) {
		if (x.isPrimary) return {
			x: x.clientX,
			y: x.clientY
		};
	} else if (isMouseEvent(x)) return {
		x: x.clientX,
		y: x.clientY
	};
	return {
		x: Infinity,
		y: Infinity
	};
}
function getInputType() {
	if (typeof matchMedia == "function") return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
function intersects(x, w, V) {
	return V ? x.x < w.x + w.width && x.x + x.width > w.x && x.y < w.y + w.height && x.y + x.height > w.y : x.x <= w.x + w.width && x.x + x.width >= w.x && x.y <= w.y + w.height && x.y + x.height >= w.y;
}
function compare(x, w) {
	if (x === w) throw Error("Cannot compare node with itself");
	let V = {
		a: get_ancestors(x),
		b: get_ancestors(w)
	}, U;
	for (; V.a.at(-1) === V.b.at(-1);) x = V.a.pop(), w = V.b.pop(), U = x;
	assert(U, "Stacking order can only be calculated for elements with a common ancestor");
	let W = {
		a: get_z_index(find_stacking_context(V.a)),
		b: get_z_index(find_stacking_context(V.b))
	};
	if (W.a === W.b) {
		let x = U.childNodes, w = {
			a: V.a.at(-1),
			b: V.b.at(-1)
		}, W = x.length;
		for (; W--;) {
			let V = x[W];
			if (V === w.a) return 1;
			if (V === w.b) return -1;
		}
	}
	return Math.sign(W.a - W.b);
}
var props = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function is_flex_item(x) {
	let w = getComputedStyle(get_parent(x) ?? x).display;
	return w === "flex" || w === "inline-flex";
}
function creates_stacking_context(x) {
	let w = getComputedStyle(x);
	return !!(w.position === "fixed" || w.zIndex !== "auto" && (w.position !== "static" || is_flex_item(x)) || +w.opacity < 1 || "transform" in w && w.transform !== "none" || "webkitTransform" in w && w.webkitTransform !== "none" || "mixBlendMode" in w && w.mixBlendMode !== "normal" || "filter" in w && w.filter !== "none" || "webkitFilter" in w && w.webkitFilter !== "none" || "isolation" in w && w.isolation === "isolate" || props.test(w.willChange) || w.webkitOverflowScrolling === "touch");
}
function find_stacking_context(x) {
	let w = x.length;
	for (; w--;) {
		let V = x[w];
		if (assert(V, "Missing node"), creates_stacking_context(V)) return V;
	}
	return null;
}
function get_z_index(x) {
	return x && Number(getComputedStyle(x).zIndex) || 0;
}
function get_ancestors(x) {
	let w = [];
	for (; x;) w.push(x), x = get_parent(x);
	return w;
}
function get_parent(x) {
	let { parentNode: w } = x;
	return w && w instanceof ShadowRoot ? w.host : w;
}
var EXCEEDED_HORIZONTAL_MIN = 1, EXCEEDED_HORIZONTAL_MAX = 2, EXCEEDED_VERTICAL_MIN = 4, EXCEEDED_VERTICAL_MAX = 8, isCoarsePointer = getInputType() === "coarse", intersectingHandles = [], isPointerDown = !1, ownerDocumentCounts = /* @__PURE__ */ new Map(), panelConstraintFlags = /* @__PURE__ */ new Map(), registeredResizeHandlers = /* @__PURE__ */ new Set();
function registerResizeHandle(x, w, V, U, W) {
	let { ownerDocument: G } = w, K = {
		direction: V,
		element: w,
		hitAreaMargins: U,
		setResizeHandlerState: W
	}, J = ownerDocumentCounts.get(G) ?? 0;
	return ownerDocumentCounts.set(G, J + 1), registeredResizeHandlers.add(K), updateListeners(), function() {
		panelConstraintFlags.delete(x), registeredResizeHandlers.delete(K);
		let w = ownerDocumentCounts.get(G) ?? 1;
		if (ownerDocumentCounts.set(G, w - 1), updateListeners(), w === 1 && ownerDocumentCounts.delete(G), intersectingHandles.includes(K)) {
			let x = intersectingHandles.indexOf(K);
			x >= 0 && intersectingHandles.splice(x, 1), updateCursor(), W("up", !0, null);
		}
	};
}
function handlePointerDown(x) {
	let { target: w } = x, { x: V, y: U } = getResizeEventCoordinates(x);
	isPointerDown = !0, recalculateIntersectingHandles({
		target: w,
		x: V,
		y: U
	}), updateListeners(), intersectingHandles.length > 0 && (updateResizeHandlerStates("down", x), x.preventDefault(), isWithinResizeHandle(w) || x.stopImmediatePropagation());
}
function handlePointerMove(x) {
	let { x: w, y: V } = getResizeEventCoordinates(x);
	if (isPointerDown && x.buttons === 0 && (isPointerDown = !1, updateResizeHandlerStates("up", x)), !isPointerDown) {
		let { target: U } = x;
		recalculateIntersectingHandles({
			target: U,
			x: w,
			y: V
		});
	}
	updateResizeHandlerStates("move", x), updateCursor(), intersectingHandles.length > 0 && x.preventDefault();
}
function handlePointerUp(x) {
	let { target: w } = x, { x: V, y: U } = getResizeEventCoordinates(x);
	panelConstraintFlags.clear(), isPointerDown = !1, intersectingHandles.length > 0 && (x.preventDefault(), isWithinResizeHandle(w) || x.stopImmediatePropagation()), updateResizeHandlerStates("up", x), recalculateIntersectingHandles({
		target: w,
		x: V,
		y: U
	}), updateCursor(), updateListeners();
}
function isWithinResizeHandle(x) {
	let w = x;
	for (; w;) {
		if (w.hasAttribute(DATA_ATTRIBUTES.resizeHandle)) return !0;
		w = w.parentElement;
	}
	return !1;
}
function recalculateIntersectingHandles({ target: x, x: w, y: V }) {
	intersectingHandles.splice(0);
	let U = null;
	(x instanceof HTMLElement || x instanceof SVGElement) && (U = x), registeredResizeHandlers.forEach((x) => {
		let { element: W, hitAreaMargins: G } = x, K = W.getBoundingClientRect(), { bottom: J, left: Y, right: Z, top: $ } = K, ql = isCoarsePointer ? G.coarse : G.fine;
		if (w >= Y - ql && w <= Z + ql && V >= $ - ql && V <= J + ql) {
			if (U !== null && document.contains(U) && W !== U && !W.contains(U) && !U.contains(W) && compare(U, W) > 0) {
				let x = U, w = !1;
				for (; x && !x.contains(W);) {
					if (intersects(x.getBoundingClientRect(), K, !0)) {
						w = !0;
						break;
					}
					x = x.parentElement;
				}
				if (w) return;
			}
			intersectingHandles.push(x);
		}
	});
}
function reportConstraintsViolation(x, w) {
	panelConstraintFlags.set(x, w);
}
function updateCursor() {
	let x = !1, w = !1;
	intersectingHandles.forEach((V) => {
		let { direction: U } = V;
		U === "horizontal" ? x = !0 : w = !0;
	});
	let V = 0;
	panelConstraintFlags.forEach((x) => {
		V |= x;
	}), x && w ? setGlobalCursorStyle("intersection", V) : x ? setGlobalCursorStyle("horizontal", V) : w ? setGlobalCursorStyle("vertical", V) : resetGlobalCursorStyle();
}
var listenersAbortController = new AbortController();
function updateListeners() {
	listenersAbortController.abort(), listenersAbortController = new AbortController();
	let x = {
		capture: !0,
		signal: listenersAbortController.signal
	};
	registeredResizeHandlers.size && (isPointerDown ? (intersectingHandles.length > 0 && ownerDocumentCounts.forEach((w, V) => {
		let { body: U } = V;
		w > 0 && (U.addEventListener("contextmenu", handlePointerUp, x), U.addEventListener("pointerleave", handlePointerMove, x), U.addEventListener("pointermove", handlePointerMove, x));
	}), window.addEventListener("pointerup", handlePointerUp, x), window.addEventListener("pointercancel", handlePointerUp, x)) : ownerDocumentCounts.forEach((w, V) => {
		let { body: U } = V;
		w > 0 && (U.addEventListener("pointerdown", handlePointerDown, x), U.addEventListener("pointermove", handlePointerMove, x));
	}));
}
function updateResizeHandlerStates(x, w) {
	registeredResizeHandlers.forEach((V) => {
		let { setResizeHandlerState: U } = V;
		U(x, intersectingHandles.includes(V), w);
	});
}
function useForceUpdate() {
	let [x, w] = useState(0);
	return useCallback(() => w((x) => x + 1), []);
}
function assert(x, w) {
	if (!x) throw console.error(w), Error(w);
}
function fuzzyCompareNumbers(x, w, V = PRECISION) {
	return x.toFixed(V) === w.toFixed(V) ? 0 : x > w ? 1 : -1;
}
function fuzzyNumbersEqual$1(x, w, V = PRECISION) {
	return fuzzyCompareNumbers(x, w, V) === 0;
}
function fuzzyNumbersEqual(x, w, V) {
	return fuzzyCompareNumbers(x, w, V) === 0;
}
function fuzzyLayoutsEqual(x, w, V) {
	if (x.length !== w.length) return !1;
	for (let U = 0; U < x.length; U++) {
		let W = x[U], G = w[U];
		if (!fuzzyNumbersEqual(W, G, V)) return !1;
	}
	return !0;
}
function resizePanel({ panelConstraints: x, panelIndex: w, size: V }) {
	let U = x[w];
	assert(U != null, `Panel constraints not found for index ${w}`);
	let { collapsedSize: W = 0, collapsible: G, maxSize: K = 100, minSize: J = 0 } = U;
	if (fuzzyCompareNumbers(V, J) < 0) if (G) {
		let x = (W + J) / 2;
		V = fuzzyCompareNumbers(V, x) < 0 ? W : J;
	} else V = J;
	return V = Math.min(K, V), V = parseFloat(V.toFixed(PRECISION)), V;
}
function adjustLayoutByDelta({ delta: x, initialLayout: w, panelConstraints: V, pivotIndices: U, prevLayout: W, trigger: G }) {
	if (fuzzyNumbersEqual(x, 0)) return w;
	let K = [...w], [J, Y] = U;
	assert(J != null, "Invalid first pivot index"), assert(Y != null, "Invalid second pivot index");
	let Z = 0;
	if (G === "keyboard") {
		{
			let U = x < 0 ? Y : J, W = V[U];
			assert(W, `Panel constraints not found for index ${U}`);
			let { collapsedSize: G = 0, collapsible: K, minSize: Z = 0 } = W;
			if (K) {
				let V = w[U];
				if (assert(V != null, `Previous layout not found for panel index ${U}`), fuzzyNumbersEqual(V, G)) {
					let w = Z - V;
					fuzzyCompareNumbers(w, Math.abs(x)) > 0 && (x = x < 0 ? 0 - w : w);
				}
			}
		}
		{
			let U = x < 0 ? J : Y, W = V[U];
			assert(W, `No panel constraints found for index ${U}`);
			let { collapsedSize: G = 0, collapsible: K, minSize: Z = 0 } = W;
			if (K) {
				let V = w[U];
				if (assert(V != null, `Previous layout not found for panel index ${U}`), fuzzyNumbersEqual(V, Z)) {
					let w = V - G;
					fuzzyCompareNumbers(w, Math.abs(x)) > 0 && (x = x < 0 ? 0 - w : w);
				}
			}
		}
	}
	{
		let U = x < 0 ? 1 : -1, W = x < 0 ? Y : J, G = 0;
		for (;;) {
			let x = w[W];
			assert(x != null, `Previous layout not found for panel index ${W}`);
			let K = resizePanel({
				panelConstraints: V,
				panelIndex: W,
				size: 100
			}) - x;
			if (G += K, W += U, W < 0 || W >= V.length) break;
		}
		let K = Math.min(Math.abs(x), Math.abs(G));
		x = x < 0 ? 0 - K : K;
	}
	{
		let U = x < 0 ? J : Y;
		for (; U >= 0 && U < V.length;) {
			let W = Math.abs(x) - Math.abs(Z), G = w[U];
			assert(G != null, `Previous layout not found for panel index ${U}`);
			let J = G - W, Y = resizePanel({
				panelConstraints: V,
				panelIndex: U,
				size: J
			});
			if (!fuzzyNumbersEqual(G, Y) && (Z += G - Y, K[U] = Y, Z.toPrecision(3).localeCompare(Math.abs(x).toPrecision(3), void 0, { numeric: !0 }) >= 0)) break;
			x < 0 ? U-- : U++;
		}
	}
	if (fuzzyLayoutsEqual(W, K)) return W;
	{
		let U = x < 0 ? Y : J, W = w[U];
		assert(W != null, `Previous layout not found for panel index ${U}`);
		let G = W + Z, $ = resizePanel({
			panelConstraints: V,
			panelIndex: U,
			size: G
		});
		if (K[U] = $, !fuzzyNumbersEqual($, G)) {
			let w = G - $, U = x < 0 ? Y : J;
			for (; U >= 0 && U < V.length;) {
				let W = K[U];
				assert(W != null, `Previous layout not found for panel index ${U}`);
				let G = W + w, J = resizePanel({
					panelConstraints: V,
					panelIndex: U,
					size: G
				});
				if (fuzzyNumbersEqual(W, J) || (w -= J - W, K[U] = J), fuzzyNumbersEqual(w, 0)) break;
				x > 0 ? U-- : U++;
			}
		}
	}
	return fuzzyNumbersEqual(K.reduce((x, w) => w + x, 0), 100) ? K : W;
}
function calculateAriaValues({ layout: x, panelsArray: w, pivotIndices: V }) {
	let U = 0, W = 100, G = 0, K = 0, J = V[0];
	return assert(J != null, "No pivot index found"), w.forEach((x, w) => {
		let { constraints: V } = x, { maxSize: Y = 100, minSize: Z = 0 } = V;
		w === J ? (U = Z, W = Y) : (G += Z, K += Y);
	}), {
		valueMax: Math.min(W, 100 - G),
		valueMin: Math.max(U, 100 - K),
		valueNow: x[J]
	};
}
function getResizeHandleElementsForGroup(x, w = document) {
	return Array.from(w.querySelectorAll(`[${DATA_ATTRIBUTES.resizeHandleId}][data-panel-group-id="${x}"]`));
}
function getResizeHandleElementIndex(x, w, V = document) {
	return getResizeHandleElementsForGroup(x, V).findIndex((x) => x.getAttribute(DATA_ATTRIBUTES.resizeHandleId) === w) ?? null;
}
function determinePivotIndices(x, w, V) {
	let U = getResizeHandleElementIndex(x, w, V);
	return U == null ? [-1, -1] : [U, U + 1];
}
function getPanelGroupElement(x, w = document) {
	return w instanceof HTMLElement && w?.dataset?.panelGroupId == x ? w : w.querySelector(`[data-panel-group][data-panel-group-id="${x}"]`) || null;
}
function getResizeHandleElement(x, w = document) {
	return w.querySelector(`[${DATA_ATTRIBUTES.resizeHandleId}="${x}"]`) || null;
}
function getResizeHandlePanelIds(x, w, V, U = document) {
	let W = getResizeHandleElement(w, U), G = getResizeHandleElementsForGroup(x, U), K = W ? G.indexOf(W) : -1;
	return [V[K]?.id ?? null, V[K + 1]?.id ?? null];
}
function useWindowSplitterPanelGroupBehavior({ committedValuesRef: x, eagerValuesRef: w, groupId: V, layout: U, panelDataArray: W, panelGroupElement: G, setLayout: K }) {
	useRef({ didWarnAboutMissingResizeHandle: !1 }), useIsomorphicLayoutEffect(() => {
		if (!G) return;
		let x = getResizeHandleElementsForGroup(V, G);
		for (let w = 0; w < W.length - 1; w++) {
			let { valueMax: V, valueMin: G, valueNow: K } = calculateAriaValues({
				layout: U,
				panelsArray: W,
				pivotIndices: [w, w + 1]
			}), J = x[w];
			if (J != null) {
				let x = W[w];
				assert(x, `No panel data found for index "${w}"`), J.setAttribute("aria-controls", x.id), J.setAttribute("aria-valuemax", "" + Math.round(V)), J.setAttribute("aria-valuemin", "" + Math.round(G)), J.setAttribute("aria-valuenow", K == null ? "" : "" + Math.round(K));
			}
		}
		return () => {
			x.forEach((x, w) => {
				x.removeAttribute("aria-controls"), x.removeAttribute("aria-valuemax"), x.removeAttribute("aria-valuemin"), x.removeAttribute("aria-valuenow");
			});
		};
	}, [
		V,
		U,
		W,
		G
	]), useEffect(() => {
		if (!G) return;
		let x = w.current;
		assert(x, "Eager values not found");
		let { panelDataArray: W } = x;
		assert(getPanelGroupElement(V, G) != null, `No group found for id "${V}"`);
		let J = getResizeHandleElementsForGroup(V, G);
		assert(J, `No resize handles found for group id "${V}"`);
		let Y = J.map((x) => {
			let w = x.getAttribute(DATA_ATTRIBUTES.resizeHandleId);
			assert(w, "Resize handle element has no handle id attribute");
			let [J, Y] = getResizeHandlePanelIds(V, w, W, G);
			if (J == null || Y == null) return () => {};
			let Z = (x) => {
				if (!x.defaultPrevented) switch (x.key) {
					case "Enter": {
						x.preventDefault();
						let Y = W.findIndex((x) => x.id === J);
						if (Y >= 0) {
							let x = W[Y];
							assert(x, `No panel data found for index ${Y}`);
							let J = U[Y], { collapsedSize: Z = 0, collapsible: $, minSize: ql = 0 } = x.constraints;
							if (J != null && $) {
								let x = adjustLayoutByDelta({
									delta: fuzzyNumbersEqual(J, Z) ? ql - Z : Z - J,
									initialLayout: U,
									panelConstraints: W.map((x) => x.constraints),
									pivotIndices: determinePivotIndices(V, w, G),
									prevLayout: U,
									trigger: "keyboard"
								});
								U !== x && K(x);
							}
						}
						break;
					}
				}
			};
			return x.addEventListener("keydown", Z), () => {
				x.removeEventListener("keydown", Z);
			};
		});
		return () => {
			Y.forEach((x) => x());
		};
	}, [
		G,
		x,
		w,
		V,
		U,
		W,
		K
	]);
}
function areEqual(x, w) {
	if (x.length !== w.length) return !1;
	for (let V = 0; V < x.length; V++) if (x[V] !== w[V]) return !1;
	return !0;
}
function getResizeEventCursorPosition(x, w) {
	let V = x === "horizontal", { x: U, y: W } = getResizeEventCoordinates(w);
	return V ? U : W;
}
function calculateDragOffsetPercentage(x, w, V, U, W) {
	let G = V === "horizontal", K = getResizeHandleElement(w, W);
	assert(K, `No resize handle element found for id "${w}"`);
	let J = K.getAttribute(DATA_ATTRIBUTES.groupId);
	assert(J, "Resize handle element has no group id attribute");
	let { initialCursorPosition: Y } = U, Z = getResizeEventCursorPosition(V, x), $ = getPanelGroupElement(J, W);
	assert($, `No group element found for id "${J}"`);
	let ql = $.getBoundingClientRect(), Jl = G ? ql.width : ql.height;
	return (Z - Y) / Jl * 100;
}
function calculateDeltaPercentage(x, w, V, U, W, G) {
	if (isKeyDown(x)) {
		let w = V === "horizontal", U = 0;
		U = x.shiftKey ? 100 : W ?? 10;
		let G = 0;
		switch (x.key) {
			case "ArrowDown":
				G = w ? 0 : U;
				break;
			case "ArrowLeft":
				G = w ? -U : 0;
				break;
			case "ArrowRight":
				G = w ? U : 0;
				break;
			case "ArrowUp":
				G = w ? 0 : -U;
				break;
			case "End":
				G = 100;
				break;
			case "Home":
				G = -100;
				break;
		}
		return G;
	} else return U == null ? 0 : calculateDragOffsetPercentage(x, w, V, U, G);
}
function calculateUnsafeDefaultLayout({ panelDataArray: x }) {
	let w = Array(x.length), V = x.map((x) => x.constraints), U = 0, W = 100;
	for (let G = 0; G < x.length; G++) {
		let x = V[G];
		assert(x, `Panel constraints not found for index ${G}`);
		let { defaultSize: K } = x;
		K != null && (U++, w[G] = K, W -= K);
	}
	for (let G = 0; G < x.length; G++) {
		let K = V[G];
		assert(K, `Panel constraints not found for index ${G}`);
		let { defaultSize: J } = K;
		if (J != null) continue;
		let Y = x.length - U, Z = W / Y;
		U++, w[G] = Z, W -= Z;
	}
	return w;
}
function callPanelCallbacks(x, w, V) {
	w.forEach((w, U) => {
		let W = x[U];
		assert(W, `Panel data not found for index ${U}`);
		let { callbacks: G, constraints: K, id: J } = W, { collapsedSize: Y = 0, collapsible: Z } = K, $ = V[J];
		if ($ == null || w !== $) {
			V[J] = w;
			let { onCollapse: x, onExpand: U, onResize: W } = G;
			W && W(w, $), Z && (x || U) && (U && ($ == null || fuzzyNumbersEqual$1($, Y)) && !fuzzyNumbersEqual$1(w, Y) && U(), x && ($ == null || !fuzzyNumbersEqual$1($, Y)) && fuzzyNumbersEqual$1(w, Y) && x());
		}
	});
}
function compareLayouts(x, w) {
	if (x.length !== w.length) return !1;
	for (let V = 0; V < x.length; V++) if (x[V] != w[V]) return !1;
	return !0;
}
function computePanelFlexBoxStyle({ defaultSize: x, dragState: w, layout: V, panelData: U, panelIndex: W, precision: G = 3 }) {
	let K = V[W], J;
	return J = K == null ? x == null ? "1" : x.toPrecision(G) : U.length === 1 ? "1" : K.toPrecision(G), {
		flexBasis: 0,
		flexGrow: J,
		flexShrink: 1,
		overflow: "hidden",
		pointerEvents: w === null ? void 0 : "none"
	};
}
function debounce(x, w = 10) {
	let V = null;
	return (...U) => {
		V !== null && clearTimeout(V), V = setTimeout(() => {
			x(...U);
		}, w);
	};
}
function initializeDefaultStorage(x) {
	try {
		if (typeof localStorage < "u") x.getItem = (x) => localStorage.getItem(x), x.setItem = (x, w) => {
			localStorage.setItem(x, w);
		};
		else throw Error("localStorage not supported in this environment");
	} catch (w) {
		console.error(w), x.getItem = () => null, x.setItem = () => {};
	}
}
function getPanelGroupKey(x) {
	return `react-resizable-panels:${x}`;
}
function getPanelKey(x) {
	return x.map((x) => {
		let { constraints: w, id: V, idIsFromProps: U, order: W } = x;
		return U ? V : W ? `${W}:${JSON.stringify(w)}` : JSON.stringify(w);
	}).sort((x, w) => x.localeCompare(w)).join(",");
}
function loadSerializedPanelGroupState(x, w) {
	try {
		let V = getPanelGroupKey(x), U = w.getItem(V);
		if (U) {
			let x = JSON.parse(U);
			if (typeof x == "object" && x) return x;
		}
	} catch {}
	return null;
}
function loadPanelGroupState(x, w, V) {
	return (loadSerializedPanelGroupState(x, V) ?? {})[getPanelKey(w)] ?? null;
}
function savePanelGroupState(x, w, V, U, W) {
	let G = getPanelGroupKey(x), K = getPanelKey(w), J = loadSerializedPanelGroupState(x, W) ?? {};
	J[K] = {
		expandToSizes: Object.fromEntries(V.entries()),
		layout: U
	};
	try {
		W.setItem(G, JSON.stringify(J));
	} catch (x) {
		console.error(x);
	}
}
function validatePanelGroupLayout({ layout: x, panelConstraints: w }) {
	let V = [...x], U = V.reduce((x, w) => x + w, 0);
	if (V.length !== w.length) throw Error(`Invalid ${w.length} panel layout: ${V.map((x) => `${x}%`).join(", ")}`);
	if (!fuzzyNumbersEqual(U, 100) && V.length > 0) for (let x = 0; x < w.length; x++) {
		let w = V[x];
		assert(w != null, `No layout data found for index ${x}`), V[x] = 100 / U * w;
	}
	let W = 0;
	for (let x = 0; x < w.length; x++) {
		let U = V[x];
		assert(U != null, `No layout data found for index ${x}`);
		let G = resizePanel({
			panelConstraints: w,
			panelIndex: x,
			size: U
		});
		U != G && (W += U - G, V[x] = G);
	}
	if (!fuzzyNumbersEqual(W, 0)) for (let x = 0; x < w.length; x++) {
		let U = V[x];
		assert(U != null, `No layout data found for index ${x}`);
		let G = U + W, K = resizePanel({
			panelConstraints: w,
			panelIndex: x,
			size: G
		});
		if (U !== K && (W -= K - U, V[x] = K, fuzzyNumbersEqual(W, 0))) break;
	}
	return V;
}
var LOCAL_STORAGE_DEBOUNCE_INTERVAL = 100, defaultStorage = {
	getItem: (x) => (initializeDefaultStorage(defaultStorage), defaultStorage.getItem(x)),
	setItem: (x, w) => {
		initializeDefaultStorage(defaultStorage), defaultStorage.setItem(x, w);
	}
}, debounceMap = {};
function PanelGroupWithForwardedRef({ autoSaveId: x = null, children: w, className: V = "", direction: U, forwardedRef: W, id: G = null, onLayout: K = null, keyboardResizeBy: J = null, storage: Y = defaultStorage, style: Z, tagName: $ = "div", ...ql }) {
	let Jl = useUniqueId(G), Yl = useRef(null), [Xl, Zl] = useState(null), [Ql, $l] = useState([]), eu = useForceUpdate(), tu = useRef({}), nu = useRef(/* @__PURE__ */ new Map()), ru = useRef(0), au = useRef({
		autoSaveId: x,
		direction: U,
		dragState: Xl,
		id: Jl,
		keyboardResizeBy: J,
		onLayout: K,
		storage: Y
	}), ou = useRef({
		layout: Ql,
		panelDataArray: [],
		panelDataArrayChanged: !1
	});
	useRef({
		didLogIdAndOrderWarning: !1,
		didLogPanelConstraintsWarning: !1,
		prevPanelIds: []
	}), useImperativeHandle(W, () => ({
		getId: () => au.current.id,
		getLayout: () => {
			let { layout: x } = ou.current;
			return x;
		},
		setLayout: (x) => {
			let { onLayout: w } = au.current, { layout: V, panelDataArray: U } = ou.current, W = validatePanelGroupLayout({
				layout: x,
				panelConstraints: U.map((x) => x.constraints)
			});
			areEqual(V, W) || ($l(W), ou.current.layout = W, w && w(W), callPanelCallbacks(U, W, tu.current));
		}
	}), []), useIsomorphicLayoutEffect(() => {
		au.current.autoSaveId = x, au.current.direction = U, au.current.dragState = Xl, au.current.id = Jl, au.current.onLayout = K, au.current.storage = Y;
	}), useWindowSplitterPanelGroupBehavior({
		committedValuesRef: au,
		eagerValuesRef: ou,
		groupId: Jl,
		layout: Ql,
		panelDataArray: ou.current.panelDataArray,
		setLayout: $l,
		panelGroupElement: Yl.current
	}), useEffect(() => {
		let { panelDataArray: w } = ou.current;
		if (x) {
			if (Ql.length === 0 || Ql.length !== w.length) return;
			let V = debounceMap[x];
			V ?? (V = debounce(savePanelGroupState, LOCAL_STORAGE_DEBOUNCE_INTERVAL), debounceMap[x] = V);
			let U = [...w], W = new Map(nu.current);
			V(x, U, W, Ql, Y);
		}
	}, [
		x,
		Ql,
		Y
	]), useEffect(() => {});
	let su = useCallback((x) => {
		let { onLayout: w } = au.current, { layout: V, panelDataArray: U } = ou.current;
		if (x.constraints.collapsible) {
			let W = U.map((x) => x.constraints), { collapsedSize: G = 0, panelSize: K, pivotIndices: J } = panelDataHelper(U, x, V);
			if (assert(K != null, `Panel size not found for panel "${x.id}"`), !fuzzyNumbersEqual$1(K, G)) {
				nu.current.set(x.id, K);
				let Y = adjustLayoutByDelta({
					delta: findPanelDataIndex(U, x) === U.length - 1 ? K - G : G - K,
					initialLayout: V,
					panelConstraints: W,
					pivotIndices: J,
					prevLayout: V,
					trigger: "imperative-api"
				});
				compareLayouts(V, Y) || ($l(Y), ou.current.layout = Y, w && w(Y), callPanelCallbacks(U, Y, tu.current));
			}
		}
	}, []), lu = useCallback((x, w) => {
		let { onLayout: V } = au.current, { layout: U, panelDataArray: W } = ou.current;
		if (x.constraints.collapsible) {
			let G = W.map((x) => x.constraints), { collapsedSize: K = 0, panelSize: J = 0, minSize: Y = 0, pivotIndices: Z } = panelDataHelper(W, x, U), $ = w ?? Y;
			if (fuzzyNumbersEqual$1(J, K)) {
				let w = nu.current.get(x.id), K = w != null && w >= $ ? w : $, Y = adjustLayoutByDelta({
					delta: findPanelDataIndex(W, x) === W.length - 1 ? J - K : K - J,
					initialLayout: U,
					panelConstraints: G,
					pivotIndices: Z,
					prevLayout: U,
					trigger: "imperative-api"
				});
				compareLayouts(U, Y) || ($l(Y), ou.current.layout = Y, V && V(Y), callPanelCallbacks(W, Y, tu.current));
			}
		}
	}, []), fu = useCallback((x) => {
		let { layout: w, panelDataArray: V } = ou.current, { panelSize: U } = panelDataHelper(V, x, w);
		return assert(U != null, `Panel size not found for panel "${x.id}"`), U;
	}, []), mu = useCallback((x, w) => {
		let { panelDataArray: V } = ou.current;
		return computePanelFlexBoxStyle({
			defaultSize: w,
			dragState: Xl,
			layout: Ql,
			panelData: V,
			panelIndex: findPanelDataIndex(V, x)
		});
	}, [Xl, Ql]), _u = useCallback((x) => {
		let { layout: w, panelDataArray: V } = ou.current, { collapsedSize: U = 0, collapsible: W, panelSize: G } = panelDataHelper(V, x, w);
		return assert(G != null, `Panel size not found for panel "${x.id}"`), W === !0 && fuzzyNumbersEqual$1(G, U);
	}, []), vu = useCallback((x) => {
		let { layout: w, panelDataArray: V } = ou.current, { collapsedSize: U = 0, collapsible: W, panelSize: G } = panelDataHelper(V, x, w);
		return assert(G != null, `Panel size not found for panel "${x.id}"`), !W || fuzzyCompareNumbers(G, U) > 0;
	}, []), yu = useCallback((x) => {
		let { panelDataArray: w } = ou.current;
		w.push(x), w.sort((x, w) => {
			let V = x.order, U = w.order;
			return V == null && U == null ? 0 : V == null ? -1 : U == null ? 1 : V - U;
		}), ou.current.panelDataArrayChanged = !0, eu();
	}, [eu]);
	useIsomorphicLayoutEffect(() => {
		if (ou.current.panelDataArrayChanged) {
			ou.current.panelDataArrayChanged = !1;
			let { autoSaveId: x, onLayout: w, storage: V } = au.current, { layout: U, panelDataArray: W } = ou.current, G = null;
			if (x) {
				let w = loadPanelGroupState(x, W, V);
				w && (nu.current = new Map(Object.entries(w.expandToSizes)), G = w.layout);
			}
			G ??= calculateUnsafeDefaultLayout({ panelDataArray: W });
			let K = validatePanelGroupLayout({
				layout: G,
				panelConstraints: W.map((x) => x.constraints)
			});
			areEqual(U, K) || ($l(K), ou.current.layout = K, w && w(K), callPanelCallbacks(W, K, tu.current));
		}
	}), useIsomorphicLayoutEffect(() => {
		let x = ou.current;
		return () => {
			x.layout = [];
		};
	}, []);
	let bu = useCallback((x) => {
		let w = !1, V = Yl.current;
		return V && window.getComputedStyle(V, null).getPropertyValue("direction") === "rtl" && (w = !0), function(V) {
			V.preventDefault();
			let U = Yl.current;
			if (!U) return () => null;
			let { direction: W, dragState: G, id: K, keyboardResizeBy: J, onLayout: Y } = au.current, { layout: Z, panelDataArray: $ } = ou.current, { initialLayout: ql } = G ?? {}, Jl = determinePivotIndices(K, x, U), Xl = calculateDeltaPercentage(V, x, W, G, J, U), Zl = W === "horizontal";
			Zl && w && (Xl = -Xl);
			let Ql = $.map((x) => x.constraints), eu = adjustLayoutByDelta({
				delta: Xl,
				initialLayout: ql ?? Z,
				panelConstraints: Ql,
				pivotIndices: Jl,
				prevLayout: Z,
				trigger: isKeyDown(V) ? "keyboard" : "mouse-or-touch"
			}), nu = !compareLayouts(Z, eu);
			(isPointerEvent(V) || isMouseEvent(V)) && ru.current != Xl && (ru.current = Xl, !nu && Xl !== 0 ? Zl ? reportConstraintsViolation(x, Xl < 0 ? EXCEEDED_HORIZONTAL_MIN : EXCEEDED_HORIZONTAL_MAX) : reportConstraintsViolation(x, Xl < 0 ? EXCEEDED_VERTICAL_MIN : EXCEEDED_VERTICAL_MAX) : reportConstraintsViolation(x, 0)), nu && ($l(eu), ou.current.layout = eu, Y && Y(eu), callPanelCallbacks($, eu, tu.current));
		};
	}, []), xu = useCallback((x, w) => {
		let { onLayout: V } = au.current, { layout: U, panelDataArray: W } = ou.current, G = W.map((x) => x.constraints), { panelSize: K, pivotIndices: J } = panelDataHelper(W, x, U);
		assert(K != null, `Panel size not found for panel "${x.id}"`);
		let Y = adjustLayoutByDelta({
			delta: findPanelDataIndex(W, x) === W.length - 1 ? K - w : w - K,
			initialLayout: U,
			panelConstraints: G,
			pivotIndices: J,
			prevLayout: U,
			trigger: "imperative-api"
		});
		compareLayouts(U, Y) || ($l(Y), ou.current.layout = Y, V && V(Y), callPanelCallbacks(W, Y, tu.current));
	}, []), Su = useCallback((x, w) => {
		let { layout: V, panelDataArray: U } = ou.current, { collapsedSize: W = 0, collapsible: G } = w, { collapsedSize: K = 0, collapsible: J, maxSize: Y = 100, minSize: Z = 0 } = x.constraints, { panelSize: $ } = panelDataHelper(U, x, V);
		$ != null && (G && J && fuzzyNumbersEqual$1($, W) ? fuzzyNumbersEqual$1(W, K) || xu(x, K) : $ < Z ? xu(x, Z) : $ > Y && xu(x, Y));
	}, [xu]), Cu = useCallback((x, w) => {
		let { direction: V } = au.current, { layout: U } = ou.current;
		if (!Yl.current) return;
		let W = getResizeHandleElement(x, Yl.current);
		assert(W, `Drag handle element not found for id "${x}"`);
		let G = getResizeEventCursorPosition(V, w);
		Zl({
			dragHandleId: x,
			dragHandleRect: W.getBoundingClientRect(),
			initialCursorPosition: G,
			initialLayout: U
		});
	}, []), wu = useCallback(() => {
		Zl(null);
	}, []), Tu = useCallback((x) => {
		let { panelDataArray: w } = ou.current, V = findPanelDataIndex(w, x);
		V >= 0 && (w.splice(V, 1), delete tu.current[x.id], ou.current.panelDataArrayChanged = !0, eu());
	}, [eu]), Eu = useMemo(() => ({
		collapsePanel: su,
		direction: U,
		dragState: Xl,
		expandPanel: lu,
		getPanelSize: fu,
		getPanelStyle: mu,
		groupId: Jl,
		isPanelCollapsed: _u,
		isPanelExpanded: vu,
		reevaluatePanelConstraints: Su,
		registerPanel: yu,
		registerResizeHandle: bu,
		resizePanel: xu,
		startDragging: Cu,
		stopDragging: wu,
		unregisterPanel: Tu,
		panelGroupElement: Yl.current
	}), [
		su,
		Xl,
		U,
		lu,
		fu,
		mu,
		Jl,
		_u,
		vu,
		Su,
		yu,
		bu,
		xu,
		Cu,
		wu,
		Tu
	]), Du = {
		display: "flex",
		flexDirection: U === "horizontal" ? "row" : "column",
		height: "100%",
		overflow: "hidden",
		width: "100%"
	};
	return createElement(PanelGroupContext.Provider, { value: Eu }, createElement($, {
		...ql,
		children: w,
		className: V,
		id: G,
		ref: Yl,
		style: {
			...Du,
			...Z
		},
		[DATA_ATTRIBUTES.group]: "",
		[DATA_ATTRIBUTES.groupDirection]: U,
		[DATA_ATTRIBUTES.groupId]: Jl
	}));
}
var PanelGroup$1 = forwardRef((x, w) => createElement(PanelGroupWithForwardedRef, {
	...x,
	forwardedRef: w
}));
PanelGroupWithForwardedRef.displayName = "PanelGroup", PanelGroup$1.displayName = "forwardRef(PanelGroup)";
function findPanelDataIndex(x, w) {
	return x.findIndex((x) => x === w || x.id === w.id);
}
function panelDataHelper(x, w, V) {
	let U = findPanelDataIndex(x, w), W = U === x.length - 1 ? [U - 1, U] : [U, U + 1], G = V[U];
	return {
		...w.constraints,
		panelSize: G,
		pivotIndices: W
	};
}
function useWindowSplitterResizeHandlerBehavior({ disabled: x, handleId: w, resizeHandler: V, panelGroupElement: U }) {
	useEffect(() => {
		if (x || V == null || U == null) return;
		let W = getResizeHandleElement(w, U);
		if (W == null) return;
		let G = (x) => {
			if (!x.defaultPrevented) switch (x.key) {
				case "ArrowDown":
				case "ArrowLeft":
				case "ArrowRight":
				case "ArrowUp":
				case "End":
				case "Home":
					x.preventDefault(), V(x);
					break;
				case "F6": {
					x.preventDefault();
					let V = W.getAttribute(DATA_ATTRIBUTES.groupId);
					assert(V, `No group element found for id "${V}"`);
					let G = getResizeHandleElementsForGroup(V, U), K = getResizeHandleElementIndex(V, w, U);
					assert(K !== null, `No resize element found for id "${w}"`), G[x.shiftKey ? K > 0 ? K - 1 : G.length - 1 : K + 1 < G.length ? K + 1 : 0].focus();
					break;
				}
			}
		};
		return W.addEventListener("keydown", G), () => {
			W.removeEventListener("keydown", G);
		};
	}, [
		U,
		x,
		w,
		V
	]);
}
function PanelResizeHandle$1({ children: x = null, className: w = "", disabled: V = !1, hitAreaMargins: U, id: W, onBlur: G, onClick: K, onDragging: J, onFocus: Y, onPointerDown: Z, onPointerUp: $, style: ql = {}, tabIndex: Jl = 0, tagName: Yl = "div", ...Xl }) {
	let Zl = useRef(null), Ql = useRef({
		onClick: K,
		onDragging: J,
		onPointerDown: Z,
		onPointerUp: $
	});
	useEffect(() => {
		Ql.current.onClick = K, Ql.current.onDragging = J, Ql.current.onPointerDown = Z, Ql.current.onPointerUp = $;
	});
	let $l = useContext(PanelGroupContext);
	if ($l === null) throw Error("PanelResizeHandle components must be rendered within a PanelGroup container");
	let { direction: eu, groupId: tu, registerResizeHandle: nu, startDragging: ru, stopDragging: au, panelGroupElement: ou } = $l, su = useUniqueId(W), [cu, du] = useState("inactive"), [fu, pu] = useState(!1), [mu, _u] = useState(null), vu = useRef({ state: cu });
	useIsomorphicLayoutEffect(() => {
		vu.current.state = cu;
	}), useEffect(() => {
		if (V) _u(null);
		else {
			let x = nu(su);
			_u(() => x);
		}
	}, [
		V,
		su,
		nu
	]);
	let yu = U?.coarse ?? 15, bu = U?.fine ?? 5;
	useEffect(() => {
		if (V || mu == null) return;
		let x = Zl.current;
		assert(x, "Element ref not attached");
		let w = !1;
		return registerResizeHandle(su, x, eu, {
			coarse: yu,
			fine: bu
		}, (x, V, U) => {
			if (!V) {
				du("inactive");
				return;
			}
			switch (x) {
				case "down": {
					du("drag"), w = !1, assert(U, "Expected event to be defined for \"down\" action"), ru(su, U);
					let { onDragging: x, onPointerDown: V } = Ql.current;
					x?.(!0), V?.();
					break;
				}
				case "move": {
					let { state: x } = vu.current;
					w = !0, x !== "drag" && du("hover"), assert(U, "Expected event to be defined for \"move\" action"), mu(U);
					break;
				}
				case "up": {
					du("hover"), au();
					let { onClick: x, onDragging: V, onPointerUp: U } = Ql.current;
					V?.(!1), U?.(), w || x?.();
					break;
				}
			}
		});
	}, [
		yu,
		eu,
		V,
		bu,
		nu,
		su,
		mu,
		ru,
		au
	]), useWindowSplitterResizeHandlerBehavior({
		disabled: V,
		handleId: su,
		resizeHandler: mu,
		panelGroupElement: ou
	});
	let xu = {
		touchAction: "none",
		userSelect: "none"
	};
	return createElement(Yl, {
		...Xl,
		children: x,
		className: w,
		id: W,
		onBlur: () => {
			pu(!1), G?.();
		},
		onFocus: () => {
			pu(!0), Y?.();
		},
		ref: Zl,
		role: "separator",
		style: {
			...xu,
			...ql
		},
		tabIndex: Jl,
		[DATA_ATTRIBUTES.groupDirection]: eu,
		[DATA_ATTRIBUTES.groupId]: tu,
		[DATA_ATTRIBUTES.resizeHandle]: "",
		[DATA_ATTRIBUTES.resizeHandleActive]: cu === "drag" ? "pointer" : fu ? "keyboard" : void 0,
		[DATA_ATTRIBUTES.resizeHandleEnabled]: !V,
		[DATA_ATTRIBUTES.resizeHandleId]: su,
		[DATA_ATTRIBUTES.resizeHandleState]: cu
	});
}
PanelResizeHandle$1.displayName = "PanelResizeHandle";
var Panel_module_default = {
	Content: "_Content_106b1_1",
	Header: "_Header_106b1_5",
	Collapsible: "_Collapsible_106b1_9",
	Collapsed: "_Collapsed_106b1_13"
}, PanelHeader_module_default = {
	PanelHeader: "_PanelHeader_r0b3g_1",
	PanelHeaderLarge: "_PanelHeaderLarge_r0b3g_9",
	PanelHeaderMedium: "_PanelHeaderMedium_r0b3g_14",
	PanelHeaderSmall: "_PanelHeaderSmall_r0b3g_18",
	PanelHeaderExtraSmall: "_PanelHeaderExtraSmall_r0b3g_22",
	CursorPointer: "_CursorPointer_r0b3g_26",
	Chevron: "_Chevron_r0b3g_30",
	Rotate90: "_Rotate90_r0b3g_34",
	SmallHeaderText: "_SmallHeaderText_r0b3g_38"
}, import_classnames$15 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function PanelHeader({ header: x, headerSize: w = "small", collapsible: V, panelRef: U, isCollapsed: G, setIsCollapsed: K, style: J }) {
	let Y = typeof x == "string", Z = w === "small" || w === "extra-small", $ = useCallback(() => {
		let x = !G;
		K?.(x);
		try {
			x ? U.current.collapse() : U.current.expand();
		} catch {}
	}, [
		G,
		U,
		K
	]);
	return /* @__PURE__ */ jsxs("div", {
		className: (0, import_classnames$15.default)(PanelHeader_module_default.PanelHeader, {
			[PanelHeader_module_default.CursorPointer]: V,
			[PanelHeader_module_default.PanelHeaderLarge]: w === "large",
			[PanelHeader_module_default.PanelHeaderMedium]: w === "medium",
			[PanelHeader_module_default.PanelHeaderSmall]: w === "small",
			[PanelHeader_module_default.PanelHeaderExtraSmall]: w === "extra-small"
		}),
		onClick: V ? $ : void 0,
		style: J,
		children: [V && /* @__PURE__ */ jsx(Icon_default, {
			icon: "chevron-right",
			className: (0, import_classnames$15.default)(PanelHeader_module_default.Chevron, { [PanelHeader_module_default.Rotate90]: !G }),
			color: preset_default.theme.extend.colors.gray[500],
			size: 12
		}), Y ? /* @__PURE__ */ jsx(Text, {
			as: "h4",
			className: (0, import_classnames$15.default)("w-full text-nowrap", { [PanelHeader_module_default.SmallHeaderText]: Z }),
			children: x
		}) : x]
	});
}
var import_classnames$14 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function Panel({ collapsible: x, defaultSize: w, minSize: V, minSizePixels: U, header: W, headerSize: G = "small", headerDirection: K, headerStyle: J, children: Y, defaultCollapsed: Z = !1, onToggle: $, className: ql, ...Jl }) {
	let [Yl, Xl] = React.useState(Z), Zl = useRef(null), $l = useCallback((x) => {
		Xl(x), $?.(x);
	}, [$]);
	return /* @__PURE__ */ jsx(Panel$2, {
		ref: Zl,
		collapsible: x,
		defaultSize: w,
		collapsedSize: 0,
		minSize: V ?? (K === "horizontal" ? 20 : void 0),
		className: (0, import_classnames$14.default)("relative", Yl && Panel_module_default.Collapsed, x && Panel_module_default.Collapsible, ql),
		style: { minWidth: U },
		...Jl,
		children: /* @__PURE__ */ jsxs("div", {
			className: (0, import_classnames$14.default)("h-full w-full text-gray-50 bg-elevated-1 flex flex-col", x && Panel_module_default.Collapsible, Yl && Panel_module_default.Collapsed),
			children: [!!W && /* @__PURE__ */ jsx(PanelHeader, {
				header: W,
				headerSize: G,
				collapsible: x,
				panelRef: Zl,
				isCollapsed: Yl,
				setIsCollapsed: $l,
				style: J
			}), !Yl && /* @__PURE__ */ jsx("div", {
				className: (0, import_classnames$14.default)(x && Panel_module_default.Collapsible, Panel_module_default.Content),
				children: Y
			})]
		})
	});
}
Panel.displayName = "Panel";
var PanelGroup_module_default = { PanelGroup: "_PanelGroup_17bkq_1" }, import_classnames$13 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function PanelGroup({ children: x, className: w, ...V }) {
	let U = Children.map(x, (x) => !isValidElement(x) || x.type?.displayName !== "Panel" ? x : cloneElement(x, { headerDirection: V.direction }));
	return /* @__PURE__ */ jsx(PanelGroup$1, {
		className: (0, import_classnames$13.default)(PanelGroup_module_default.PanelGroup, w),
		...V,
		children: U
	});
}
var PanelItem_module_default = {
	PlaylistContainer: "_PlaylistContainer_1wq4r_1",
	Active: "_Active_1wq4r_6",
	Playlist: "_Playlist_1wq4r_1",
	PlaylistItem: "_PlaylistItem_1wq4r_17",
	PlaylistSpacing: "_PlaylistSpacing_1wq4r_21",
	Content: "_Content_1wq4r_25",
	Options: "_Options_1wq4r_33",
	Icon: "_Icon_1wq4r_38"
}, import_classnames$12 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function PanelItem({ content: x, actionButtonText: w = "", active: V = !1, autoplay: U, icon: W = "sort", onClick: G, onEdit: K, onCopy: J, onDelete: Y, onClickAutoPlay: Z, onUpdatePlaylist: $, onMouseEnter: ql, onMouseLeave: Jl }) {
	let Yl = !!($ || K || J || Y);
	return /* @__PURE__ */ jsx("div", {
		className: (0, import_classnames$12.default)(PanelItem_module_default.PlaylistContainer),
		onMouseEnter: ql,
		onMouseLeave: Jl,
		children: /* @__PURE__ */ jsxs("div", {
			className: (0, import_classnames$12.default)(PanelItem_module_default.PlaylistItem, { [PanelItem_module_default.Active]: V }),
			children: [W && /* @__PURE__ */ jsx("div", {
				className: (0, import_classnames$12.default)(PanelItem_module_default.Icon),
				children: /* @__PURE__ */ jsx(Icon_default, {
					icon: W,
					weight: "bold",
					size: 20
				})
			}), /* @__PURE__ */ jsxs("div", {
				className: (0, import_classnames$12.default)(PanelItem_module_default.Playlist, { [PanelItem_module_default.PlaylistSpacing]: !W }),
				onClick: G,
				children: [/* @__PURE__ */ jsx("div", {
					className: PanelItem_module_default.Content,
					children: typeof x == "string" ? /* @__PURE__ */ jsx(Text, {
						as: "p",
						lineClamp: "clamp-1",
						children: x
					}) : x
				}), Yl && /* @__PURE__ */ jsx("div", {
					className: PanelItem_module_default.Options,
					children: /* @__PURE__ */ jsxs(ActionButtons_default, {
						isActive: V,
						text: w,
						showAuto: U?.isEnabled,
						autoEnabled: U?.isRunning,
						onClickAutoPlay: Z,
						children: [
							$ && U && /* @__PURE__ */ jsx(Button_default, {
								title: "Update",
								iconProps: {
									icon: "arrow-clockwise",
									weight: "bold"
								},
								color: U.isEnabled ? "primary" : "darkGray",
								onClick: (x) => {
									x.stopPropagation(), $({
										...U,
										isEnabled: !U.isEnabled
									});
								}
							}),
							K && /* @__PURE__ */ jsx(Button_default, {
								onClick: (x) => {
									x.stopPropagation(), K?.();
								},
								iconProps: {
									icon: "pencil",
									weight: "bold"
								},
								color: "darkGray",
								title: "Edit"
							}),
							J && /* @__PURE__ */ jsx(Button_default, {
								title: "Copy",
								iconProps: {
									icon: "copy",
									weight: "bold"
								},
								color: "darkGray",
								onClick: (x) => {
									x.stopPropagation(), J?.();
								}
							}),
							Y && /* @__PURE__ */ jsx(Button_default, {
								title: "Delete",
								iconProps: {
									icon: "trash",
									weight: "bold"
								},
								color: "danger",
								onClick: (x) => {
									x.stopPropagation(), Y?.();
								}
							})
						]
					})
				})]
			})]
		})
	});
}
var PanelResizeHandle_module_default = {
	ResizeHandleOuter: "_ResizeHandleOuter_pe6kd_1",
	Subpanel: "_Subpanel_pe6kd_7",
	Disabled: "_Disabled_pe6kd_10"
}, import_classnames$11 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function PanelResizeHandle({ className: x = "", id: w, variant: V = "panel", disabled: U }) {
	return /* @__PURE__ */ jsx(PanelResizeHandle$1, {
		disabled: U,
		className: (0, import_classnames$11.default)(PanelResizeHandle_module_default.ResizeHandleOuter, V === "subpanel" && PanelResizeHandle_module_default.Subpanel, U && PanelResizeHandle_module_default.Disabled, x),
		id: w
	});
}
var PlayButton_module_default = {
	PlayButton: "_PlayButton_1da27_1",
	isRunning: "_isRunning_1da27_9",
	disabled: "_disabled_1da27_13"
}, getIcon = (x, w) => {
	switch (x) {
		case "live": return w ? "stop" : "play";
		case "preview": return "monitor-arrow-up";
		case "cut": return "fast-forward";
		case "fade": return "arrow-lines-right";
		case "tickNext": return "arrow-fat-line-up";
		case "tickPrev": return "arrow-fat-line-down";
		case "fetchData": return "cloud-arrow-down";
		default: return "play";
	}
};
function PlayButton({ hasIcon: x, isRunning: w, variant: V = "live", onClick: U, iconPosition: G = "left", className: K, disabled: J, children: Y, iconProps: Z, title: $ }) {
	let ql = getIcon(V, w), Jl = preset_default.theme.extend.colors.white;
	return /* @__PURE__ */ jsxs(Button_default, {
		className: twMerge(PlayButton_module_default.PlayButton, w && PlayButton_module_default.isRunning, J && PlayButton_module_default.disabled, K),
		disabled: J,
		onClick: U,
		title: $,
		children: [
			x && G === "left" && /* @__PURE__ */ jsx(Icon_default, {
				color: Jl,
				icon: ql,
				...Z
			}),
			Y,
			x && G === "right" && /* @__PURE__ */ jsx(Icon_default, {
				color: Jl,
				icon: ql,
				...Z
			})
		]
	});
}
var useAuth_default = () => ({
	hasAllRoles: (x, w) => w.every((w) => x.includes(w)),
	hasAnyRole: (x, w) => w.some((w) => x.includes(w))
}), PrivateRoute_module_default = { Unauthorized: "_Unauthorized_1wv1w_1" };
function PrivateRoute({ authenticated: x = !1, loginUrl: w = "/login", roles: V = [], userRoles: U = [], ssrEnabled: W = !1, children: G }) {
	let { hasAnyRole: K } = useAuth_default(), J = V.length === 0 || K(U, V), Y = typeof window < "u";
	return !W && !Y ? null : Y && !x ? /* @__PURE__ */ jsx(Navigate, {
		to: w,
		replace: !0
	}) : Y && x && J ? /* @__PURE__ */ jsx(Fragment$1, { children: G }) : /* @__PURE__ */ jsx("h1", {
		className: PrivateRoute_module_default.Unauthorized,
		children: "Insufficient permissions"
	});
}
function PublicRoute({ authenticated: x = !1, redirectUrl: w = "/", children: V }) {
	let U = typeof window < "u";
	return U && x ? /* @__PURE__ */ jsx(Navigate, {
		to: w,
		replace: !0
	}) : U && !x ? /* @__PURE__ */ jsx(Fragment$1, { children: V }) : null;
}
var QuickButton_module_default = {
	QuickButton: "_QuickButton_1yt1d_1",
	Title: "_Title_1yt1d_6",
	Subtitle: "_Subtitle_1yt1d_9",
	isRunning: "_isRunning_1yt1d_13",
	disabled: "_disabled_1yt1d_17",
	placeholder: "_placeholder_1yt1d_21",
	isFullWidth: "_isFullWidth_1yt1d_25"
};
function QuickButton({ isRunning: x, onClick: w, className: V, disabled: U = !1, children: W, title: G, subtitle: K, isFullWidth: J, isPlaceholder: Y = !1, ...Z }) {
	return /* @__PURE__ */ jsx("button", {
		type: "button",
		className: twMerge(classNames$10(QuickButton_module_default.QuickButton, J && QuickButton_module_default.isFullWidth, x && QuickButton_module_default.isRunning, Y && QuickButton_module_default.placeholder), V),
		onClick: w,
		disabled: U || Y,
		...Z,
		children: !Y && /* @__PURE__ */ jsxs(Fragment$1, { children: [
			/* @__PURE__ */ jsx(Text, {
				as: "h4",
				className: QuickButton_module_default.Title,
				lineClamp: "clamp-1",
				children: G
			}),
			/* @__PURE__ */ jsx(Text, {
				as: "p",
				className: QuickButton_module_default.Subtitle,
				lineClamp: "clamp-1",
				color: x ? "light" : "elevated",
				children: K
			}),
			W
		] })
	});
}
var Option$1 = ({ children: x, ...w }) => /* @__PURE__ */ jsx(RadioGroup.Option, {
	...w,
	children: x
}), Label$1 = ({ children: x, ...w }) => /* @__PURE__ */ jsx(RadioGroup.Label, {
	...w,
	children: x
}), RootRadioGroup = ({ children: x, ...w }) => /* @__PURE__ */ jsx(RadioGroup, {
	...w,
	children: x
});
RootRadioGroup.displayName = "RadioGroup", RootRadioGroup.Option = Option$1, RootRadioGroup.Label = Label$1;
var Radiogroup_default = RootRadioGroup, Repeater_module_default = {
	Repeater: "_Repeater_lz85i_1",
	isNestedWithChildren: "_isNestedWithChildren_lz85i_5",
	RepeaterRow: "_RepeaterRow_lz85i_9",
	isNested: "_isNested_lz85i_5",
	RepeaterChildren: "_RepeaterChildren_lz85i_16",
	isSingle: "_isSingle_lz85i_20",
	RepeaterRemoveRowButton: "_RepeaterRemoveRowButton_lz85i_27",
	RepeaterRemoveBlockButton: "_RepeaterRemoveBlockButton_lz85i_31",
	RepeaterAddRow: "_RepeaterAddRow_lz85i_35",
	isNestedSingle: "_isNestedSingle_lz85i_39"
};
function Repeater({ children: x, value: w, onChange: V, className: U }) {
	if (!Array.isArray(w)) throw Error("Repeater value should be an array with objects");
	let W = Array.isArray(x) ? x : [x], G = (x) => React.Children.toArray(x).some((x) => React.isValidElement(x) ? x.type === Repeater : !1), K = G(x) ? Repeater_module_default.isNested : Repeater_module_default.isSingle, J = (V) => React.Children.map(x, (U) => {
		if (!U.key) throw Error("Repeater child needs a key");
		if (w[V][U.key] === void 0) throw Error(`Repeater child key ${U.key} not found in array index ${V}`);
		let W = U.key, K = G(x) ? Repeater_module_default.isNestedWithChildren : Repeater_module_default.isNestedSingle;
		return React.cloneElement(U, {
			onChange: (x) => {
				$(V, W, x.target?.value ?? x.value);
			},
			value: w[V][W],
			key: V + "." + W,
			className: K
		});
	}), Y = (x) => {
		let w = {};
		return React.Children.forEach(x, (x) => {
			x.props.children ? w[x.key] = [Y(x.props.children)] : w[x.key] = x.props.value;
		}), w;
	}, Z = Y(W), $ = (x, U, W) => {
		let G = [...w];
		G[x][U] = W, V({ target: { value: G } });
	}, ql = () => {
		let x = [...w];
		try {
			let w = structuredClone(Z);
			x.push(w);
		} catch {}
		V({ target: { value: x } });
	}, Jl = (x) => {
		let U = [...w];
		U.splice(x, 1), V({ target: { value: U } });
	};
	return /* @__PURE__ */ jsxs("div", {
		className: twMerge(U, Repeater_module_default.Repeater),
		children: [w.map((w, V) => /* @__PURE__ */ jsxs("div", {
			className: Repeater_module_default.RepeaterRow,
			children: [/* @__PURE__ */ jsx("div", {
				className: K,
				children: /* @__PURE__ */ jsx("div", {
					className: Repeater_module_default.RepeaterChildren,
					children: J(V)
				})
			}), /* @__PURE__ */ jsx(Button_default, {
				type: "button",
				variant: "icon",
				iconProps: { icon: "x-circle" },
				color: "white",
				buttonSize: "large",
				className: twMerge(G(x) ? Repeater_module_default.RepeaterRemoveBlockButton : Repeater_module_default.RepeaterRemoveRowButton, "text-[#F5F6FF] hover:opacity-90"),
				onClick: () => {
					Jl(V);
				}
			})]
		}, V)), G(x) ? /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(Button_default, {
			variant: "primary",
			onClick: ql,
			buttonSize: "small",
			className: Repeater_module_default.RepeaterAddRow,
			children: "Add block"
		}) }) : /* @__PURE__ */ jsx(Button_default, {
			type: "button",
			variant: "icon",
			iconProps: { icon: "plus-circle" },
			color: "white",
			buttonSize: "large",
			className: twMerge(Repeater_module_default.RepeaterRemoveRowButton, "text-[#F5F6FF] hover:opacity-90"),
			onClick: ql
		})]
	});
}
var ArrayField_module_default = {
	arrayFieldItemContainer: "_arrayFieldItemContainer_1iwrj_1",
	arrayFieldItemContent: "_arrayFieldItemContent_1iwrj_5",
	arrayFieldItemButtons: "_arrayFieldItemButtons_1iwrj_9",
	directionButtons: "_directionButtons_1iwrj_13"
};
function ArrayFieldItemButtonsTemplate({ disabled: x, hasMoveDown: w, hasMoveUp: V, hasRemove: U, fieldPathId: W, onRemoveItem: G, onMoveDownItem: K, onMoveUpItem: J, readonly: Y, registry: Z, uiSchema: $ }) {
	let { MoveDownButton: ql, MoveUpButton: Jl, RemoveButton: Yl } = Z.templates.ButtonTemplates, Xl = x || Y, Zl = V && !Xl, Ql = w && !Xl, $l = Zl || Ql;
	return /* @__PURE__ */ jsxs("div", {
		className: ArrayField_module_default.arrayFieldItemButtons,
		children: [$l && /* @__PURE__ */ jsxs("div", {
			className: ArrayField_module_default.directionButtons,
			children: [/* @__PURE__ */ jsx(Jl, {
				id: buttonId(W, "moveUp"),
				className: "rjsf-array-item-move-up",
				disabled: !Zl,
				onClick: J,
				uiSchema: $,
				registry: Z
			}), /* @__PURE__ */ jsx(ql, {
				id: buttonId(W, "moveDown"),
				className: "rjsf-array-item-move-down",
				disabled: !Ql,
				onClick: K,
				uiSchema: $,
				registry: Z
			})]
		}), U && /* @__PURE__ */ jsx(Yl, {
			id: buttonId(W, "remove"),
			className: "rjsf-array-item-remove",
			disabled: Xl,
			onClick: G,
			uiSchema: $,
			registry: Z
		})]
	});
}
function ArrayFieldItemTemplate({ children: x, buttonsProps: w, hasToolbar: V, registry: U, uiSchema: W }) {
	let G = getTemplate("ArrayFieldItemButtonsTemplate", U, getUiOptions(W));
	return /* @__PURE__ */ jsxs("div", {
		className: ArrayField_module_default.arrayFieldItemContainer,
		children: [/* @__PURE__ */ jsx("div", {
			className: ArrayField_module_default.arrayFieldItemContent,
			children: x
		}), V && /* @__PURE__ */ jsx("div", {
			className: ArrayField_module_default.arrayFieldItemButtons,
			children: /* @__PURE__ */ jsx(G, { ...w })
		})]
	});
}
var SchemaForm_module_default = {
	container: "_container_ozg4l_1",
	flexColumn: "_flexColumn_ozg4l_5",
	flexColumnSmall: "_flexColumnSmall_ozg4l_9",
	hiddenField: "_hiddenField_ozg4l_13",
	title: "_title_ozg4l_17",
	description: "_description_ozg4l_21",
	required: "_required_ozg4l_25"
}, ButtonTemplates_module_default = {
	button: "_button_x1a3a_1",
	addButton: "_addButton_x1a3a_5",
	submitButton: "_submitButton_x1a3a_9",
	directionButton: "_directionButton_x1a3a_13",
	removeButton: "_removeButton_x1a3a_25"
}, import_classnames$10 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function SubmitButton({ uiSchema: x }) {
	let { submitText: w = "Sumbit", norender: V, props: U } = x?.["ui:options"]?.submitButtonOptions ?? {};
	return V ? null : /* @__PURE__ */ jsx(Button_default, {
		type: "submit",
		variant: "primary",
		className: ButtonTemplates_module_default.submitButton,
		disabled: U?.disabled,
		children: w
	});
}
function AddButton({ onClick: x, disabled: w }) {
	return /* @__PURE__ */ jsx(Button_default, {
		type: "button",
		onClick: x,
		disabled: w,
		variant: "secondary",
		iconProps: {
			icon: "plus",
			weight: "bold"
		},
		className: ButtonTemplates_module_default.addButton,
		children: /* @__PURE__ */ jsx(Text, { children: "Add" })
	});
}
function RemoveButton({ onClick: x, disabled: w, className: V }) {
	return /* @__PURE__ */ jsx(Button_default, {
		type: "button",
		onClick: x,
		disabled: w,
		variant: "icon",
		iconProps: { icon: "trash" },
		className: (0, import_classnames$10.default)(ButtonTemplates_module_default.removeButton, V)
	});
}
function MoveUpButton({ onClick: x, disabled: w, className: V }) {
	return /* @__PURE__ */ jsx(Button_default, {
		type: "button",
		onClick: x,
		disabled: w,
		buttonSize: "small",
		variant: "secondary",
		iconProps: { icon: "chevron-up" },
		className: (0, import_classnames$10.default)(ButtonTemplates_module_default.directionButton, V),
		title: "Move up"
	});
}
function MoveDownButton({ onClick: x, disabled: w, className: V }) {
	return /* @__PURE__ */ jsx(Button_default, {
		type: "button",
		onClick: x,
		disabled: w,
		buttonSize: "small",
		variant: "secondary",
		iconProps: { icon: "chevron-down" },
		className: (0, import_classnames$10.default)(ButtonTemplates_module_default.directionButton, V),
		title: "Move down"
	});
}
function CopyButton({ onClick: x, disabled: w, className: V }) {
	return /* @__PURE__ */ jsx(Button_default, {
		type: "button",
		onClick: x,
		disabled: w,
		buttonSize: "small",
		variant: "secondary",
		iconProps: { icon: "copy" },
		className: (0, import_classnames$10.default)(ButtonTemplates_module_default.button, V)
	});
}
function ClearButton({ onClick: x, disabled: w, className: V }) {
	return /* @__PURE__ */ jsx(Button_default, {
		type: "button",
		onClick: x,
		disabled: w,
		buttonSize: "small",
		variant: "secondary",
		iconProps: { icon: "x" },
		className: (0, import_classnames$10.default)(ButtonTemplates_module_default.button, V)
	});
}
function ArrayFieldTemplate({ items: x, canAdd: w, onAddClick: V, registry: U }) {
	let W = U.formContext?.compact;
	return /* @__PURE__ */ jsxs("div", {
		className: W ? SchemaForm_module_default.flexColumnSmall : SchemaForm_module_default.flexColumn,
		children: [x.map((x, w) => /* @__PURE__ */ jsx("div", { children: x }, w)), w && /* @__PURE__ */ jsx(AddButton, {
			onClick: V,
			disabled: !1,
			registry: void 0
		})]
	});
}
function DescriptionFieldTemplate({ id: x, description: w }) {
	return w ? /* @__PURE__ */ jsx(Text, {
		id: x,
		className: SchemaForm_module_default.description,
		children: w
	}) : null;
}
var ErrorTemplates_module_default = {
	errorBox: "_errorBox_xuqe4_1",
	errorBoxTitle: "_errorBoxTitle_xuqe4_5",
	errorBoxList: "_errorBoxList_xuqe4_9",
	errorBoxItem: "_errorBoxItem_xuqe4_13",
	errorList: "_errorList_xuqe4_17",
	errorText: "_errorText_xuqe4_21"
};
function ErrorListTemplate({ errors: x }) {
	return !x || x.length === 0 ? null : /* @__PURE__ */ jsxs("div", {
		className: ErrorTemplates_module_default.errorBox,
		children: [/* @__PURE__ */ jsx("p", {
			className: ErrorTemplates_module_default.errorBoxTitle,
			children: x.length === 1 ? "1 error in this form" : `${x.length} errors in this form`
		}), /* @__PURE__ */ jsx("ul", {
			className: ErrorTemplates_module_default.errorBoxList,
			children: x.map((x, w) => /* @__PURE__ */ jsx("li", {
				className: ErrorTemplates_module_default.errorBoxItem,
				children: x.stack
			}, w))
		})]
	});
}
function FieldErrorTemplate({ errors: x }) {
	return !x || x.length === 0 ? null : /* @__PURE__ */ jsx("ul", {
		className: ErrorTemplates_module_default.errorList,
		children: x.map((x, w) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx("p", {
			className: ErrorTemplates_module_default.errorText,
			children: x
		}) }, w))
	});
}
function FieldTemplate({ id: x, label: w, description: V, errors: U, children: W, hidden: G, rawErrors: K, required: J, registry: Y }) {
	let Z = Y.formContext?.compact;
	if (G) return /* @__PURE__ */ jsx("div", {
		className: SchemaForm_module_default.hiddenField,
		children: W
	});
	let $ = K !== void 0 && K.length > 0, ql = J ? `${w} *` : w;
	return w ? /* @__PURE__ */ jsxs(FormGroup, {
		label: ql,
		htmlFor: x,
		hasErrors: $,
		children: [
			V,
			W,
			U
		]
	}) : /* @__PURE__ */ jsxs("div", {
		className: Z ? SchemaForm_module_default.flexColumnSmall : SchemaForm_module_default.flexColumn,
		children: [
			V,
			W,
			U
		]
	});
}
function ObjectFieldTemplate({ properties: x, registry: w }) {
	let V = w.formContext?.compact;
	return /* @__PURE__ */ jsx("div", {
		className: V ? SchemaForm_module_default.flexColumnSmall : SchemaForm_module_default.flexColumn,
		children: x.map((x) => /* @__PURE__ */ jsx("div", { children: x.content }, x.name))
	});
}
function TitleFieldTemplate({ id: x, title: w, required: V }) {
	return w ? /* @__PURE__ */ jsxs(Text, {
		id: x,
		className: SchemaForm_module_default.title,
		children: [w, V && /* @__PURE__ */ jsx("span", {
			className: SchemaForm_module_default.required,
			children: "*"
		})]
	}) : null;
}
var Widgets_module_default = {
	selectPadding: "_selectPadding_jvv3t_1",
	checkboxOption: "_checkboxOption_jvv3t_5"
};
function CheckboxesWidget({ id: x, value: w, disabled: V, readonly: U, options: W, onChange: G, onBlur: K, onFocus: J }) {
	let Y = W.enumOptions ?? [], Z = Array.isArray(w) ? w : [], $ = (x) => Z.includes(x), ql = (x, w) => {
		if (w) {
			if (Z.includes(x)) {
				G(Z);
				return;
			}
			G([...Z, x]);
			return;
		}
		G(Z.filter((w) => w !== x));
	};
	return /* @__PURE__ */ jsx("div", {
		role: "group",
		"aria-labelledby": `${x}Label`,
		children: Y.map((w, W) => {
			let G = W === 0 ? x : `${x}-${W}`, Y = $(w.value);
			return /* @__PURE__ */ jsxs("label", {
				htmlFor: G,
				className: Widgets_module_default.checkboxOption,
				children: [/* @__PURE__ */ jsx(Checkbox_default, {
					id: G,
					checked: Y,
					disabled: V || U,
					onChange: (x) => ql(w.value, x.currentTarget.checked),
					onBlur: () => K(x, Z),
					onFocus: () => J(x, Z)
				}), /* @__PURE__ */ jsx("span", { children: w.label })]
			}, G);
		})
	});
}
function hasTimezone(x) {
	return /([+-]\d{2}:\d{2}|Z)$/.test(x);
}
function stripTimezone(x) {
	return x.replace(/(\.\d+)?([+-]\d{2}:\d{2}|Z)$/, "");
}
function toDisplayValue(x) {
	return typeof x == "string" ? hasTimezone(x) ? stripTimezone(x) : x : "";
}
function DateTimeWidget({ id: x, value: w, readonly: V, disabled: U, onChange: W, onBlur: G, onFocus: K }) {
	return /* @__PURE__ */ jsx(Input, {
		type: "datetime-local",
		step: 1,
		value: toDisplayValue(w),
		onChange: (x) => W(x.currentTarget.value),
		onBlur: () => G(x, w),
		onFocus: () => K(x, w),
		readOnly: V,
		disabled: U
	});
}
function FileWidget({ id: x, value: w, readonly: V, disabled: U, onChange: W, onBlur: G, onFocus: K, options: J }) {
	return /* @__PURE__ */ jsx(Input, {
		type: "file",
		accept: typeof J.accept == "string" ? J.accept : "*",
		multiple: !!J.multiple,
		fileAdded: (x) => {
			let w = new FileReader();
			w.onload = () => {
				W(w.result);
			}, w.readAsDataURL(x);
		},
		fileRemoved: () => {
			W(void 0);
		},
		disabled: U || V,
		onBlur: () => G(x, w),
		onFocus: () => K(x, w)
	});
}
function InputTypeWidget({ id: x, value: w, readonly: V, disabled: U, inputType: W, onChange: G, onBlur: K, onFocus: J, step: Y }) {
	return /* @__PURE__ */ jsx(Input, {
		type: W,
		value: w ?? "",
		onChange: (x) => G(x.currentTarget.value),
		onBlur: () => K(x, w),
		onFocus: () => J(x, w),
		readOnly: V,
		disabled: U,
		step: Y
	});
}
function NumberWidget({ id: x, value: w, readonly: V, disabled: U, onChange: W, onBlur: G, onFocus: K }) {
	return /* @__PURE__ */ jsx(Input, {
		type: "number",
		value: w ?? "",
		onChange: (x) => {
			let w = x.currentTarget.value, V = parseFloat(w);
			W(w === "" ? void 0 : isNaN(V) ? w : V);
		},
		onBlur: () => G(x, w),
		onFocus: () => K(x, w),
		readOnly: V,
		disabled: U
	});
}
var Select_module_default = {
	wrapper: "_wrapper_lnrny_1",
	prefixText: "_prefixText_lnrny_5",
	selectContainer: "_selectContainer_lnrny_9",
	select: "_select_lnrny_9",
	caretIcon: "_caretIcon_lnrny_21",
	option: "_option_lnrny_25"
}, import_classnames$9 = /* @__PURE__ */ __toESM(require_classnames(), 1), CaretDownIcon = () => /* @__PURE__ */ jsx("svg", {
	className: Select_module_default.caretIcon,
	viewBox: "0 -256 1792 1792",
	xmlns: "http://www.w3.org/2000/svg",
	children: /* @__PURE__ */ jsx("g", {
		transform: "matrix(1,0,0,-1,402.44068,1239.8644)",
		fill: "currentColor",
		children: /* @__PURE__ */ jsx("path", { d: "m 1024,832 q 0,-26 -19,-45 L 557,339 q -19,-19 -45,-19 -26,0 -45,19 L 19,787 q -19,19 -19,45 0,26 19,45 19,19 45,19 h 896 q 26,0 45,-19 19,-19 19,-45 z" })
	})
}), Option = ({ value: x, label: w, className: V, ...U }) => /* @__PURE__ */ jsx("option", {
	value: x,
	className: (0, import_classnames$9.default)(Select_module_default.option, V),
	...U,
	children: w ?? x
}), Select_default = forwardRef(({ value: x, options: w, onChange: V, prefix: U, suffix: W, className: G, prefixClassName: K, wrapperClassName: J, ...Y }, Z) => /* @__PURE__ */ jsxs("div", {
	className: (0, import_classnames$9.default)(Select_module_default.wrapper, J),
	children: [
		/* @__PURE__ */ jsx(Text, {
			className: (0, import_classnames$9.default)(Select_module_default.prefixText, K),
			children: U
		}),
		/* @__PURE__ */ jsxs("div", {
			className: Select_module_default.selectContainer,
			children: [/* @__PURE__ */ jsx("select", {
				ref: Z,
				className: (0, import_classnames$9.default)(Select_module_default.select, G),
				value: x,
				onChange: V,
				...Y,
				children: w?.map((x) => /* @__PURE__ */ jsx(Option, { ...x }, x.value))
			}), /* @__PURE__ */ jsx(CaretDownIcon, {})]
		}),
		W
	]
}));
function SelectWidget({ id: x, value: w, disabled: V, readonly: U, options: W, onChange: G, onBlur: K, onFocus: J, multiple: Y, ...Z }) {
	if (Y) return /* @__PURE__ */ jsx(CheckboxesWidget, {
		id: x,
		options: W,
		value: w,
		onBlur: K,
		onFocus: J,
		onChange: G,
		disabled: V || U,
		...Z
	});
	let { enumOptions: $ = [] } = W, ql = (x) => {
		let w = x.currentTarget.value;
		G($.find((x) => String(x.value) === w)?.value);
	}, Jl = $.map((x) => ({
		value: x.value,
		label: x.label
	}));
	return /* @__PURE__ */ jsx(Select_default, {
		value: w ?? "",
		onChange: ql,
		onBlur: () => K(x, w),
		onFocus: () => J(x, w),
		options: Jl,
		disabled: V || U,
		className: Widgets_module_default.selectPadding
	});
}
function TimeWidget({ id: x, value: w, readonly: V, disabled: U, onChange: W, onBlur: G, onFocus: K }) {
	return /* @__PURE__ */ jsx(Input, {
		type: "time",
		step: 1,
		value: toDisplayValue(w),
		onChange: (x) => W(x.currentTarget.value),
		onBlur: () => G(x, w),
		onFocus: () => K(x, w),
		readOnly: V,
		disabled: U
	});
}
const schemaFormWidgets = {
	TextWidget: (x) => /* @__PURE__ */ jsx(InputTypeWidget, {
		...x,
		inputType: "text"
	}),
	PasswordWidget: (x) => /* @__PURE__ */ jsx(InputTypeWidget, {
		...x,
		inputType: "password"
	}),
	EmailWidget: (x) => /* @__PURE__ */ jsx(InputTypeWidget, {
		...x,
		inputType: "email"
	}),
	URLWidget: (x) => /* @__PURE__ */ jsx(InputTypeWidget, {
		...x,
		inputType: "url"
	}),
	DateWidget: (x) => /* @__PURE__ */ jsx(InputTypeWidget, {
		...x,
		inputType: "date"
	}),
	TimeWidget: (x) => /* @__PURE__ */ jsx(TimeWidget, { ...x }),
	DateTimeWidget: (x) => /* @__PURE__ */ jsx(DateTimeWidget, { ...x }),
	ColorWidget: (x) => /* @__PURE__ */ jsx(InputTypeWidget, {
		...x,
		inputType: "colorPicker"
	}),
	UpDownWidget: NumberWidget,
	CheckboxWidget: SelectWidget,
	SelectWidget,
	FileWidget
}, schemaFormTemplates = {
	FieldTemplate,
	ObjectFieldTemplate,
	ArrayFieldTemplate,
	ArrayFieldItemTemplate,
	ArrayFieldItemButtonsTemplate,
	TitleFieldTemplate,
	DescriptionFieldTemplate,
	FieldErrorTemplate,
	ErrorListTemplate,
	ButtonTemplates: {
		SubmitButton,
		AddButton,
		CopyButton,
		MoveDownButton,
		MoveUpButton,
		RemoveButton,
		ClearButton
	}
};
var import_classnames$8 = /* @__PURE__ */ __toESM(require_classnames(), 1), ThemedForm = withTheme({}), SchemaForm_default = forwardRef(function({ schema: x, value: w, onChange: V, onSubmit: U, className: W, showSubmitButton: G = !1, submitText: K = "Submit", liveValidate: J = !1, disabled: Y = !1, readonly: Z = !1, loading: $ = !1, compact: ql = !1, children: Jl, uiSchema: Yl, formContext: Xl, ...Zl }, Ql) {
	let $l = useRef(null);
	useImperativeHandle(Ql, () => ({ submit: () => {
		$l.current?.submit();
	} }));
	let eu = (x) => {
		x.formData && V(x.formData);
	}, tu = (x) => {
		x.formData && U && U(x.formData);
	}, nu = {
		"ui:submitButtonOptions": {
			norender: !G,
			submitText: K,
			props: { disabled: $ || Y },
			...Yl?.["ui:submitButtonOptions"]
		},
		...Yl
	};
	return /* @__PURE__ */ jsx("div", {
		className: (0, import_classnames$8.default)(SchemaForm_module_default.container, W),
		children: /* @__PURE__ */ jsx(ThemedForm, {
			ref: $l,
			schema: x,
			uiSchema: nu,
			formData: w,
			onChange: eu,
			onSubmit: tu,
			validator,
			showErrorList: "bottom",
			liveValidate: J,
			disabled: Y,
			readonly: Z,
			widgets: schemaFormWidgets,
			templates: schemaFormTemplates,
			formContext: {
				...Xl,
				compact: ql
			},
			...Zl,
			children: Jl
		})
	});
}), SettingsForm_module_default = {
	SettingsForm: "_SettingsForm_1g80d_1",
	SettingsFormActions: "_SettingsFormActions_1g80d_6",
	SettingsFormAction: "_SettingsFormAction_1g80d_6",
	SettingsFormGrid: "_SettingsFormGrid_1g80d_15",
	SettingsFormInfo: "_SettingsFormInfo_1g80d_19",
	SettingsFormTitle: "_SettingsFormTitle_1g80d_24",
	SettingsFormSection: "_SettingsFormSection_1g80d_31",
	SettingsFormSectionWrapper: "_SettingsFormSectionWrapper_1g80d_36",
	SettingsFormWrapper: "_SettingsFormWrapper_1g80d_41",
	SettingsMenu: "_SettingsMenu_1g80d_45",
	SettingsMenuGroup: "_SettingsMenuGroup_1g80d_50",
	SettingsMenuItems: "_SettingsMenuItems_1g80d_57",
	SettingsMenuItem: "_SettingsMenuItem_1g80d_57",
	SettingsMenuItemActive: "_SettingsMenuItemActive_1g80d_66",
	SettingsOverview: "_SettingsOverview_1g80d_70",
	SettingsOverviewHasCreateButton: "_SettingsOverviewHasCreateButton_1g80d_74",
	SettingsOverviewWrapper: "_SettingsOverviewWrapper_1g80d_78",
	SettingsOverviewOnCreateButton: "_SettingsOverviewOnCreateButton_1g80d_83",
	SettingsOverviewOnCreateIconWrapper: "_SettingsOverviewOnCreateIconWrapper_1g80d_90",
	SettingsOverviewOnCreateLabel: "_SettingsOverviewOnCreateLabel_1g80d_95"
}, import_classnames$7 = /* @__PURE__ */ __toESM(require_classnames(), 1), SettingsForm_default = ({ formSections: x, menuGroups: w, title: V }) => /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("header", {
	className: SettingsForm_module_default.SettingsFormTitle,
	children: /* @__PURE__ */ jsx(Text, {
		as: "h1",
		children: V
	})
}), /* @__PURE__ */ jsxs("div", {
	className: SettingsForm_module_default.SettingsFormGrid,
	children: [/* @__PURE__ */ jsx("aside", {
		className: SettingsForm_module_default.SettingsMenu,
		children: w.map(({ title: x, menuItems: w }, V) => /* @__PURE__ */ jsxs("div", {
			className: SettingsForm_module_default.SettingsMenuGroup,
			children: [/* @__PURE__ */ jsx(Text, {
				as: "h2",
				children: x
			}), /* @__PURE__ */ jsx("ul", {
				className: SettingsForm_module_default.SettingsMenuItems,
				children: w.map(({ end: x = !0, pathname: w, label: V }, U) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(NavLink, {
					className: ({ isActive: x }) => (0, import_classnames$7.default)(SettingsForm_module_default.SettingsMenuItem, { [SettingsForm_module_default.SettingsMenuItemActive]: x }),
					end: x,
					to: `${w}`,
					children: V
				}) }, U))
			})]
		}, V))
	}), /* @__PURE__ */ jsx("div", {
		className: SettingsForm_module_default.SettingsFormSectionWrapper,
		children: x.map((x, w) => /* @__PURE__ */ jsxs("div", {
			className: SettingsForm_module_default.SettingsFormSection,
			children: [
				x.type === "form" && /* @__PURE__ */ jsxs("div", {
					className: SettingsForm_module_default.SettingsFormWrapper,
					children: [/* @__PURE__ */ jsx("div", {
						className: SettingsForm_module_default.SettingsForm,
						children: x.form
					}), x?.actions !== void 0 && /* @__PURE__ */ jsx("div", {
						className: SettingsForm_module_default.SettingsFormActions,
						children: x?.actions?.map(({ className: x, children: w, ...V }, U) => /* @__PURE__ */ jsx(Button_default, {
							className: (0, import_classnames$7.default)(SettingsForm_module_default.SettingsFormAction, x),
							color: "primaryLight",
							...V,
							children: w
						}, U))
					})]
				}),
				x.type === "overview" && /* @__PURE__ */ jsxs("div", {
					className: (0, import_classnames$7.default)(SettingsForm_module_default.SettingsOverviewWrapper, { [SettingsForm_module_default.SettingsOverviewHasCreateButton]: typeof x.onCreate == "function" }),
					children: [typeof x.onCreate == "function" && /* @__PURE__ */ jsxs(Button_default, {
						className: SettingsForm_module_default.SettingsOverviewOnCreateButton,
						onClick: x.onCreate,
						variant: "tertiary",
						children: [x.onCreateLabel !== void 0 && /* @__PURE__ */ jsx("div", {
							className: SettingsForm_module_default.SettingsOverviewOnCreateLabel,
							children: x.onCreateLabel
						}), /* @__PURE__ */ jsx("div", {
							className: SettingsForm_module_default.SettingsOverviewOnCreateIconWrapper,
							children: /* @__PURE__ */ jsx(Icon_default, {
								icon: "plus",
								color: "#151621",
								weight: "bold",
								size: 16
							})
						})]
					}), /* @__PURE__ */ jsx("div", {
						className: SettingsForm_module_default.SettingsOverview,
						children: x.overview
					})]
				}),
				x.info !== void 0 && /* @__PURE__ */ jsx("aside", {
					className: (0, import_classnames$7.default)(SettingsForm_module_default.SettingsFormInfo, { [SettingsForm_module_default.SettingsOverviewHasCreateButton]: x.type === "overview" && typeof x.onCreate == "function" }),
					children: x.info
				})
			]
		}, w))
	})]
})] }), Sidebar_module_default = {
	Sidebar: "_Sidebar_1be4v_1",
	MenuItems: "_MenuItems_1be4v_5",
	MenuItem: "_MenuItem_1be4v_5",
	MenuItemActive: "_MenuItemActive_1be4v_14",
	Bottom: "_Bottom_1be4v_18",
	Button: "_Button_1be4v_21"
}, import_classnames$6 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function Sidebar({ avatarInput: x, className: w, currentWorkspaceId: V, handleDashboard: U = () => {}, handleLogout: W = () => {}, handleAccountSettings: G = () => {}, isAuthenticated: K, menuItems: J, setCurrentWorkspace: Y, showDashboard: Z, workspaces: $, userLabel: ql }) {
	return /* @__PURE__ */ jsxs("aside", {
		className: (0, import_classnames$6.default)(Sidebar_module_default.Sidebar, w || ""),
		children: [/* @__PURE__ */ jsx("ul", {
			className: Sidebar_module_default.MenuItems,
			children: J.map(({ pathname: x, icon: w }, V) => /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(NavLink, {
				className: ({ isActive: x }) => (0, import_classnames$6.default)(Sidebar_module_default.MenuItem, { [Sidebar_module_default.MenuItemActive]: x }),
				to: `${x}`,
				children: /* @__PURE__ */ jsx(Icon_default, {
					icon: w,
					size: 24,
					color: "#F5F6FF",
					weight: "regular"
				})
			}) }, V))
		}), K ? /* @__PURE__ */ jsx(AccountMenu, {
			avatarInput: x,
			currentWorkspaceId: V,
			handleDashboard: U,
			handleLogout: W,
			isLoading: !x,
			setCurrentWorkspace: Y,
			showDashboard: Z,
			workspaces: $,
			userLabel: ql,
			handleAccountSettings: G
		}) : null]
	});
}
var SlideOut_module_default = {
	SlideOutContainer: "_SlideOutContainer_10dx7_1",
	Backdrop: "_Backdrop_10dx7_8"
}, SlideOut_default = ({ children: x, handleClickOutsideDrawer: w, open: V, size: U = 75 }) => /* @__PURE__ */ jsxs(Transition.Root, {
	show: V,
	className: SlideOut_module_default.SlideOutContainer,
	children: [/* @__PURE__ */ jsx(Transition.Child, {
		className: SlideOut_module_default.Backdrop,
		onClick: w,
		as: "div",
		leave: "transition-opacity",
		leaveFrom: "opacity-25",
		leaveTo: "opacity-0"
	}), /* @__PURE__ */ jsx(Transition.Child, {
		as: "div",
		className: `h-full bg-elevated-1 overflow-auto ${V ? "z-10" : "-z-10"}`,
		style: {
			maxWidth: `${U}%`,
			width: `${U}%`
		},
		enter: "transition-all duration-100",
		enterFrom: `transform translate-x-[${U}%]`,
		enterTo: "transform translate-x-0",
		leave: "transition-all duration-100",
		leaveFrom: "transform translate-x-0",
		leaveTo: `transform translate-x-[${U}%]`,
		children: x
	})]
}), SlideOver_module_default = {
	SlideOverContainer: "_SlideOverContainer_urbo5_1",
	Backdrop: "_Backdrop_urbo5_8",
	BackdropEnter: "_BackdropEnter_urbo5_15",
	BackdropEnterFrom: "_BackdropEnterFrom_urbo5_19",
	BackdropEnterTo: "_BackdropEnterTo_urbo5_23",
	BackdropLeave: "_BackdropLeave_urbo5_27",
	BackdropLeaveFrom: "_BackdropLeaveFrom_urbo5_31",
	BackdropLeaveTo: "_BackdropLeaveTo_urbo5_35",
	Content: "_Content_urbo5_39",
	ContentEnter: "_ContentEnter_urbo5_43",
	ContentEnterFrom: "_ContentEnterFrom_urbo5_47",
	ContentEnterTo: "_ContentEnterTo_urbo5_51",
	ContentLeave: "_ContentLeave_urbo5_55",
	ContentLeaveFrom: "_ContentLeaveFrom_urbo5_59",
	ContentLeaveTo: "_ContentLeaveTo_urbo5_63"
}, SlideOver_default = ({ children: x, handleClickOutsideDrawer: w, open: V, size: U = 75, rootClassName: W, backdropClassName: G, contentClassName: K }) => /* @__PURE__ */ jsxs(Transition.Root, {
	show: V,
	className: twMerge(SlideOver_module_default.SlideOverContainer, W),
	children: [/* @__PURE__ */ jsx(Transition.Child, {
		as: "div",
		onClick: w,
		className: twMerge(SlideOver_module_default.Backdrop, G),
		enter: SlideOver_module_default.BackdropEnter,
		enterFrom: SlideOver_module_default.BackdropEnterFrom,
		enterTo: SlideOver_module_default.BackdropEnterTo,
		leave: SlideOver_module_default.BackdropLeave,
		leaveFrom: SlideOver_module_default.BackdropLeaveFrom,
		leaveTo: SlideOver_module_default.BackdropLeaveTo
	}), /* @__PURE__ */ jsx(Transition.Child, {
		as: "div",
		style: {
			width: `${U}%`,
			minWidth: `${U}%`
		},
		className: twMerge(SlideOver_module_default.Content, K),
		enter: SlideOver_module_default.ContentEnter,
		enterFrom: SlideOver_module_default.ContentEnterFrom,
		enterTo: SlideOver_module_default.ContentEnterTo,
		leave: SlideOver_module_default.ContentLeave,
		leaveFrom: SlideOver_module_default.ContentLeaveFrom,
		leaveTo: SlideOver_module_default.ContentLeaveTo,
		children: x
	})]
}), CustomDroppable_default = (x) => {
	let [w, V] = useState(!1);
	return useEffect(() => {
		let x = requestAnimationFrame(() => V(!0));
		return () => {
			cancelAnimationFrame(x), V(!1);
		};
	}, []), w ? /* @__PURE__ */ jsx(Droppable, { ...x }) : null;
}, SortableListItem_module_default = {
	Container: "_Container_15g1q_1",
	Content: "_Content_15g1q_6",
	Active: "_Active_15g1q_11"
};
function SortableItem({ active: x, children: w }) {
	return /* @__PURE__ */ jsx("div", {
		className: `${SortableListItem_module_default.Container} ${x ? SortableListItem_module_default.Active : ""}`,
		children: /* @__PURE__ */ jsx("div", {
			className: SortableListItem_module_default.Content,
			children: w
		})
	});
}
var SortableList_module_default = {
	Container: "_Container_n56r5_1",
	ListItem: "_ListItem_n56r5_6",
	Icon: "_Icon_n56r5_11"
}, import_classnames$5 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function isObjectWithId(x) {
	return typeof x == "object" && !!x && "id" in x && (typeof x.id == "string" || typeof x.id == "number");
}
function SortableList({ items: x, setItems: w, Component: V, activeId: U, className: W }) {
	let G = (w) => x.filter((x) => isObjectWithId(x) && isObjectWithId(w) && x.relatedTo && x.relatedTo === w.id), K = ((x) => {
		let w = [], V = /* @__PURE__ */ new Map();
		for (let U = 0; U < x.length; U++) {
			let W = x[U];
			if (!isObjectWithId(W)) {
				w.push({
					id: W,
					items: [W]
				});
				continue;
			}
			if (V.has(W.id)) continue;
			let K = [W, ...G(W)];
			K.forEach((x) => {
				isObjectWithId(x) && V.set(x.id, !0);
			}), w.push({
				id: W.id,
				items: K
			});
		}
		return w;
	})(x), J = (x) => {
		try {
			if (!x.destination) return;
			let V = x.destination.index, U = x.source.index, W = arrayMove(K, U, V);
			if (!Array.isArray(W)) return;
			let G = [];
			for (let x = 0; x < W.length; x++) {
				let w = W[x];
				G.push(...w.items);
			}
			w(G);
		} catch {}
	}, Y = (x) => {
		if (x?.transform) {
			let w = `translate(0px, ${x.transform.split(",").pop()}`;
			return {
				...x,
				transform: w
			};
		}
		return x;
	};
	return /* @__PURE__ */ jsx(DragDropContext, {
		onDragEnd: J,
		children: /* @__PURE__ */ jsx(CustomDroppable_default, {
			droppableId: "droppable",
			children: (x) => /* @__PURE__ */ jsxs("div", {
				className: (0, import_classnames$5.default)(SortableList_module_default.Container, W),
				ref: x.innerRef,
				...x.droppableProps,
				children: [K.map((x, w) => /* @__PURE__ */ jsx(Draggable, {
					draggableId: x.id.toString(),
					index: w,
					children: (w) => /* @__PURE__ */ jsx("div", {
						ref: w.innerRef,
						...w.dragHandleProps,
						...w.draggableProps,
						style: Y(w.draggableProps.style),
						children: x.items.map((x) => {
							let w = x, W = isObjectWithId(x) ? x.id === U : x === U;
							return isObjectWithId(x) ? V ? /* @__PURE__ */ jsx(SortableItem, {
								active: W,
								id: x.id,
								children: /* @__PURE__ */ jsx(V, { ...w })
							}, x.id.toString()) : null : /* @__PURE__ */ jsx(SortableItem, {
								active: W,
								id: x,
								children: x
							}, x);
						})
					})
				}, x.id)), x.placeholder]
			})
		})
	});
}
var SortableList_default = SortableList, SubNavbar_module_default = { Container: "_Container_1am3z_1" };
function SubNavbar({ children: x, className: w }) {
	return /* @__PURE__ */ jsx("div", {
		className: twMerge(SubNavbar_module_default.Container, w),
		children: x
	});
}
var Group = ({ children: x, as: w = "div", ...V }) => /* @__PURE__ */ jsx(Tab.Group, {
	as: w,
	...V,
	children: x
}), List$1 = ({ children: x, as: w = "ul", ...V }) => /* @__PURE__ */ jsx(Tab.List, {
	as: w,
	...V,
	children: x
}), Panel$1 = ({ children: x, as: w = "div", ...V }) => /* @__PURE__ */ jsx(Tab.Panel, {
	as: w,
	...V,
	children: x
}), Panels = ({ children: x, as: w = "div", ...V }) => /* @__PURE__ */ jsx(Tab.Panels, {
	as: w,
	...V,
	children: x
}), TabsRoot = ({ children: x, as: w = "button", ...V }) => /* @__PURE__ */ jsx(Tab, {
	as: w,
	...V,
	children: x
});
TabsRoot.displayName = "Tab", TabsRoot.Group = Group, TabsRoot.List = List$1, TabsRoot.Panel = Panel$1, TabsRoot.Panels = Panels;
var Tabs_default = TabsRoot, TextInput_module_default = {
	InputField: "_InputField_1khmf_1",
	TextInput: "_TextInput_1khmf_5",
	error: "_error_1khmf_10",
	readOnly: "_readOnly_1khmf_13",
	disabled: "_disabled_1khmf_17",
	elevated: "_elevated_1khmf_21",
	modal: "_modal_1khmf_24",
	Icon: "_Icon_1khmf_28"
}, import_classnames$4 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function TextInput({ type: x = "text", disabled: w, onChange: V, value: U, error: G, className: K, readOnly: J, placeholder: Y, variant: Z = "elevated", icon: $, iconColor: ql }) {
	let Jl = (0, import_classnames$4.default)(TextInput_module_default.TextInput, K || "", {
		[TextInput_module_default.error]: G,
		[TextInput_module_default.disabled]: w,
		[TextInput_module_default.readOnly]: J,
		[TextInput_module_default.elevated]: Z === "elevated",
		[TextInput_module_default.modal]: Z === "modal"
	});
	return /* @__PURE__ */ jsxs("div", {
		className: TextInput_module_default.InputField,
		children: [
			/* @__PURE__ */ jsx("input", {
				type: x,
				disabled: w,
				onChange: V,
				value: U,
				className: Jl,
				readOnly: J,
				placeholder: Y
			}),
			$ && /* @__PURE__ */ jsx(Icon_default, {
				className: TextInput_module_default.Icon,
				icon: $,
				size: 22,
				color: ql || preset_default.theme.extend.colors["gr-gray-light"]
			}),
			G && /* @__PURE__ */ jsx("div", {
				className: TextInput_module_default.Feedback,
				children: /* @__PURE__ */ jsx(Text, {
					as: "p",
					color: "danger",
					children: G
				})
			})
		]
	});
}
function r(x) {
	var w, V, U = "";
	if (typeof x == "string" || typeof x == "number") U += x;
	else if (typeof x == "object") if (Array.isArray(x)) for (w = 0; w < x.length; w++) x[w] && (V = r(x[w])) && (U && (U += " "), U += V);
	else for (w in x) x[w] && (U && (U += " "), U += w);
	return U;
}
function clsx() {
	for (var x, w, V = 0, U = ""; V < arguments.length;) (x = arguments[V++]) && (w = r(x)) && (U && (U += " "), U += w);
	return U;
}
var clsx_m_default = clsx, u = (x) => typeof x == "number" && !isNaN(x), d = (x) => typeof x == "string", p = (x) => typeof x == "function", m = (x) => d(x) || p(x) ? x : null, f = (x) => isValidElement(x) || d(x) || p(x) || u(x);
function g(x, w, V) {
	V === void 0 && (V = 300);
	let { scrollHeight: U, style: W } = x;
	requestAnimationFrame(() => {
		W.minHeight = "initial", W.height = U + "px", W.transition = `all ${V}ms`, requestAnimationFrame(() => {
			W.height = "0", W.padding = "0", W.margin = "0", setTimeout(w, V);
		});
	});
}
function h(x) {
	let { enter: w, exit: V, appendPosition: U = !1, collapse: W = !0, collapseDuration: G = 300 } = x;
	return function(x) {
		let { children: K, position: J, preventExitTransition: Y, done: Z, nodeRef: $, isIn: ql } = x, Jl = U ? `${w}--${J}` : w, Yl = U ? `${V}--${J}` : V, Xl = useRef(0);
		return useLayoutEffect(() => {
			let x = $.current, w = Jl.split(" "), V = (U) => {
				U.target === $.current && (x.dispatchEvent(new Event("d")), x.removeEventListener("animationend", V), x.removeEventListener("animationcancel", V), Xl.current === 0 && U.type !== "animationcancel" && x.classList.remove(...w));
			};
			x.classList.add(...w), x.addEventListener("animationend", V), x.addEventListener("animationcancel", V);
		}, []), useEffect(() => {
			let x = $.current, w = () => {
				x.removeEventListener("animationend", w), W ? g(x, Z, G) : Z();
			};
			ql || (Y ? w() : (Xl.current = 1, x.className += ` ${Yl}`, x.addEventListener("animationend", w)));
		}, [ql]), React.createElement(React.Fragment, null, K);
	};
}
function y(x, w) {
	return x == null ? {} : {
		content: x.content,
		containerId: x.props.containerId,
		id: x.props.toastId,
		theme: x.props.theme,
		type: x.props.type,
		data: x.props.data || {},
		isLoading: x.props.isLoading,
		icon: x.props.icon,
		status: w
	};
}
var v = {
	list: /* @__PURE__ */ new Map(),
	emitQueue: /* @__PURE__ */ new Map(),
	on(x, w) {
		return this.list.has(x) || this.list.set(x, []), this.list.get(x).push(w), this;
	},
	off(x, w) {
		if (w) {
			let V = this.list.get(x).filter((x) => x !== w);
			return this.list.set(x, V), this;
		}
		return this.list.delete(x), this;
	},
	cancelEmit(x) {
		let w = this.emitQueue.get(x);
		return w && (w.forEach(clearTimeout), this.emitQueue.delete(x)), this;
	},
	emit(x) {
		this.list.has(x) && this.list.get(x).forEach((w) => {
			let V = setTimeout(() => {
				w(...[].slice.call(arguments, 1));
			}, 0);
			this.emitQueue.has(x) || this.emitQueue.set(x, []), this.emitQueue.get(x).push(V);
		});
	}
}, T = (x) => {
	let { theme: w, type: V, ...U } = x;
	return React.createElement("svg", {
		viewBox: "0 0 24 24",
		width: "100%",
		height: "100%",
		fill: w === "colored" ? "currentColor" : `var(--toastify-icon-color-${V})`,
		...U
	});
}, E = {
	info: function(x) {
		return React.createElement(T, { ...x }, React.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
	},
	warning: function(x) {
		return React.createElement(T, { ...x }, React.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
	},
	success: function(x) {
		return React.createElement(T, { ...x }, React.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
	},
	error: function(x) {
		return React.createElement(T, { ...x }, React.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
	},
	spinner: function() {
		return React.createElement("div", { className: "Toastify__spinner" });
	}
};
function C(x) {
	let [, w] = useReducer((x) => x + 1, 0), [V, U] = useState([]), W = useRef(null), G = useRef(/* @__PURE__ */ new Map()).current, K = (x) => V.indexOf(x) !== -1, J = useRef({
		toastKey: 1,
		displayedToast: 0,
		count: 0,
		queue: [],
		props: x,
		containerId: null,
		isToastActive: K,
		getToast: (x) => G.get(x)
	}).current;
	function Y(x) {
		let { containerId: w } = x, { limit: V } = J.props;
		!V || w && J.containerId !== w || (J.count -= J.queue.length, J.queue = []);
	}
	function Z(x) {
		U((w) => x == null ? [] : w.filter((w) => w !== x));
	}
	function $() {
		let { toastContent: x, toastProps: w, staleId: V } = J.queue.shift();
		Jl(x, w, V);
	}
	function ql(x, V) {
		let { delay: U, staleId: K, ...Y } = V;
		if (!f(x) || function(x) {
			return !W.current || J.props.enableMultiContainer && x.containerId !== J.props.containerId || G.has(x.toastId) && x.updateId == null;
		}(Y)) return;
		let { toastId: ql, updateId: Yl, data: Xl } = Y, { props: Zl } = J, Ql = () => Z(ql), $l = Yl == null;
		$l && J.count++;
		let eu = {
			...Zl,
			style: Zl.toastStyle,
			key: J.toastKey++,
			...Object.fromEntries(Object.entries(Y).filter((x) => {
				let [w, V] = x;
				return V != null;
			})),
			toastId: ql,
			updateId: Yl,
			data: Xl,
			closeToast: Ql,
			isIn: !1,
			className: m(Y.className || Zl.toastClassName),
			bodyClassName: m(Y.bodyClassName || Zl.bodyClassName),
			progressClassName: m(Y.progressClassName || Zl.progressClassName),
			autoClose: !Y.isLoading && (tu = Y.autoClose, ru = Zl.autoClose, !1 === tu || u(tu) && tu > 0 ? tu : ru),
			deleteToast() {
				let x = y(G.get(ql), "removed");
				G.delete(ql), v.emit(4, x);
				let V = J.queue.length;
				if (J.count = ql == null ? J.count - J.displayedToast : J.count - 1, J.count < 0 && (J.count = 0), V > 0) {
					let x = ql == null ? J.props.limit : 1;
					if (V === 1 || x === 1) J.displayedToast++, $();
					else {
						let w = x > V ? V : x;
						J.displayedToast = w;
						for (let x = 0; x < w; x++) $();
					}
				} else w();
			}
		};
		var tu, ru;
		eu.iconOut = function(x) {
			let { theme: w, type: V, isLoading: U, icon: W } = x, G = null, K = {
				theme: w,
				type: V
			};
			return !1 === W || (p(W) ? G = W(K) : isValidElement(W) ? G = cloneElement(W, K) : d(W) || u(W) ? G = W : U ? G = E.spinner() : ((x) => x in E)(V) && (G = E[V](K))), G;
		}(eu), p(Y.onOpen) && (eu.onOpen = Y.onOpen), p(Y.onClose) && (eu.onClose = Y.onClose), eu.closeButton = Zl.closeButton, !1 === Y.closeButton || f(Y.closeButton) ? eu.closeButton = Y.closeButton : !0 === Y.closeButton && (eu.closeButton = !f(Zl.closeButton) || Zl.closeButton);
		let iu = x;
		isValidElement(x) && !d(x.type) ? iu = cloneElement(x, {
			closeToast: Ql,
			toastProps: eu,
			data: Xl
		}) : p(x) && (iu = x({
			closeToast: Ql,
			toastProps: eu,
			data: Xl
		})), Zl.limit && Zl.limit > 0 && J.count > Zl.limit && $l ? J.queue.push({
			toastContent: iu,
			toastProps: eu,
			staleId: K
		}) : u(U) ? setTimeout(() => {
			Jl(iu, eu, K);
		}, U) : Jl(iu, eu, K);
	}
	function Jl(x, w, V) {
		let { toastId: W } = w;
		V && G.delete(V);
		let K = {
			content: x,
			props: w
		};
		G.set(W, K), U((x) => [...x, W].filter((x) => x !== V)), v.emit(4, y(K, K.props.updateId == null ? "added" : "updated"));
	}
	return useEffect(() => (J.containerId = x.containerId, v.cancelEmit(3).on(0, ql).on(1, (x) => W.current && Z(x)).on(5, Y).emit(2, J), () => {
		G.clear(), v.emit(3, J);
	}), []), useEffect(() => {
		J.props = x, J.isToastActive = K, J.displayedToast = V.length;
	}), {
		getToastToRender: function(w) {
			let V = /* @__PURE__ */ new Map(), U = Array.from(G.values());
			return x.newestOnTop && U.reverse(), U.forEach((x) => {
				let { position: w } = x.props;
				V.has(w) || V.set(w, []), V.get(w).push(x);
			}), Array.from(V, (x) => w(x[0], x[1]));
		},
		containerRef: W,
		isToastActive: K
	};
}
function b(x) {
	return x.targetTouches && x.targetTouches.length >= 1 ? x.targetTouches[0].clientX : x.clientX;
}
function I(x) {
	return x.targetTouches && x.targetTouches.length >= 1 ? x.targetTouches[0].clientY : x.clientY;
}
function _(x) {
	let [w, V] = useState(!1), [U, W] = useState(!1), G = useRef(null), K = useRef({
		start: 0,
		x: 0,
		y: 0,
		delta: 0,
		removalDistance: 0,
		canCloseOnClick: !0,
		canDrag: !1,
		boundingRect: null,
		didMove: !1
	}).current, J = useRef(x), { autoClose: Y, pauseOnHover: Z, closeToast: $, onClick: ql, closeOnClick: Jl } = x;
	function Yl(w) {
		if (x.draggable) {
			w.nativeEvent.type === "touchstart" && w.nativeEvent.preventDefault(), K.didMove = !1, document.addEventListener("mousemove", $l), document.addEventListener("mouseup", eu), document.addEventListener("touchmove", $l), document.addEventListener("touchend", eu);
			let V = G.current;
			K.canCloseOnClick = !0, K.canDrag = !0, K.boundingRect = V.getBoundingClientRect(), V.style.transition = "", K.x = b(w.nativeEvent), K.y = I(w.nativeEvent), x.draggableDirection === "x" ? (K.start = K.x, K.removalDistance = V.offsetWidth * (x.draggablePercent / 100)) : (K.start = K.y, K.removalDistance = V.offsetHeight * (x.draggablePercent === 80 ? 1.5 * x.draggablePercent : x.draggablePercent / 100));
		}
	}
	function Xl(w) {
		if (K.boundingRect) {
			let { top: V, bottom: U, left: W, right: G } = K.boundingRect;
			w.nativeEvent.type !== "touchend" && x.pauseOnHover && K.x >= W && K.x <= G && K.y >= V && K.y <= U ? Ql() : Zl();
		}
	}
	function Zl() {
		V(!0);
	}
	function Ql() {
		V(!1);
	}
	function $l(V) {
		let U = G.current;
		K.canDrag && U && (K.didMove = !0, w && Ql(), K.x = b(V), K.y = I(V), K.delta = x.draggableDirection === "x" ? K.x - K.start : K.y - K.start, K.start !== K.x && (K.canCloseOnClick = !1), U.style.transform = `translate${x.draggableDirection}(${K.delta}px)`, U.style.opacity = "" + (1 - Math.abs(K.delta / K.removalDistance)));
	}
	function eu() {
		document.removeEventListener("mousemove", $l), document.removeEventListener("mouseup", eu), document.removeEventListener("touchmove", $l), document.removeEventListener("touchend", eu);
		let w = G.current;
		if (K.canDrag && K.didMove && w) {
			if (K.canDrag = !1, Math.abs(K.delta) > K.removalDistance) return W(!0), void x.closeToast();
			w.style.transition = "transform 0.2s, opacity 0.2s", w.style.transform = `translate${x.draggableDirection}(0)`, w.style.opacity = "1";
		}
	}
	useEffect(() => {
		J.current = x;
	}), useEffect(() => (G.current && G.current.addEventListener("d", Zl, { once: !0 }), p(x.onOpen) && x.onOpen(isValidElement(x.children) && x.children.props), () => {
		let x = J.current;
		p(x.onClose) && x.onClose(isValidElement(x.children) && x.children.props);
	}), []), useEffect(() => (x.pauseOnFocusLoss && (document.hasFocus() || Ql(), window.addEventListener("focus", Zl), window.addEventListener("blur", Ql)), () => {
		x.pauseOnFocusLoss && (window.removeEventListener("focus", Zl), window.removeEventListener("blur", Ql));
	}), [x.pauseOnFocusLoss]);
	let tu = {
		onMouseDown: Yl,
		onTouchStart: Yl,
		onMouseUp: Xl,
		onTouchEnd: Xl
	};
	return Y && Z && (tu.onMouseEnter = Ql, tu.onMouseLeave = Zl), Jl && (tu.onClick = (x) => {
		ql && ql(x), K.canCloseOnClick && $();
	}), {
		playToast: Zl,
		pauseToast: Ql,
		isRunning: w,
		preventExitTransition: U,
		toastRef: G,
		eventHandlers: tu
	};
}
function L(x) {
	let { closeToast: w, theme: V, ariaLabel: U = "close" } = x;
	return React.createElement("button", {
		className: `Toastify__close-button Toastify__close-button--${V}`,
		type: "button",
		onClick: (x) => {
			x.stopPropagation(), w(x);
		},
		"aria-label": U
	}, React.createElement("svg", {
		"aria-hidden": "true",
		viewBox: "0 0 14 16"
	}, React.createElement("path", {
		fillRule: "evenodd",
		d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
	})));
}
function O(x) {
	let { delay: w, isRunning: V, closeToast: U, type: W = "default", hide: G, className: K, style: J, controlledProgress: Y, progress: Z, rtl: $, isIn: ql, theme: Jl } = x, Yl = G || Y && Z === 0, Xl = {
		...J,
		animationDuration: `${w}ms`,
		animationPlayState: V ? "running" : "paused",
		opacity: Yl ? 0 : 1
	};
	Y && (Xl.transform = `scaleX(${Z})`);
	let Zl = clsx_m_default("Toastify__progress-bar", Y ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${Jl}`, `Toastify__progress-bar--${W}`, { "Toastify__progress-bar--rtl": $ }), $l = p(K) ? K({
		rtl: $,
		type: W,
		defaultClassName: Zl
	}) : clsx_m_default(Zl, K);
	return React.createElement("div", {
		role: "progressbar",
		"aria-hidden": Yl ? "true" : "false",
		"aria-label": "notification timer",
		className: $l,
		style: Xl,
		[Y && Z >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: Y && Z < 1 ? null : () => {
			ql && U();
		}
	});
}
var N = (x) => {
	let { isRunning: w, preventExitTransition: V, toastRef: U, eventHandlers: W } = _(x), { closeButton: G, children: K, autoClose: J, onClick: Y, type: Z, hideProgressBar: $, closeToast: ql, transition: Jl, position: Yl, className: Xl, style: Zl, bodyClassName: $l, bodyStyle: eu, progressClassName: tu, progressStyle: ru, updateId: iu, role: au, progress: su, rtl: cu, toastId: lu, deleteToast: uu, isIn: du, isLoading: fu, iconOut: pu, closeOnClick: mu, theme: hu } = x, gu = clsx_m_default("Toastify__toast", `Toastify__toast-theme--${hu}`, `Toastify__toast--${Z}`, { "Toastify__toast--rtl": cu }, { "Toastify__toast--close-on-click": mu }), _u = p(Xl) ? Xl({
		rtl: cu,
		position: Yl,
		type: Z,
		defaultClassName: gu
	}) : clsx_m_default(gu, Xl), vu = !!su || !J, yu = {
		closeToast: ql,
		type: Z,
		theme: hu
	}, bu = null;
	return !1 === G || (bu = p(G) ? G(yu) : isValidElement(G) ? cloneElement(G, yu) : L(yu)), React.createElement(Jl, {
		isIn: du,
		done: uu,
		position: Yl,
		preventExitTransition: V,
		nodeRef: U
	}, React.createElement("div", {
		id: lu,
		onClick: Y,
		className: _u,
		...W,
		style: Zl,
		ref: U
	}, React.createElement("div", {
		...du && { role: au },
		className: p($l) ? $l({ type: Z }) : clsx_m_default("Toastify__toast-body", $l),
		style: eu
	}, pu != null && React.createElement("div", { className: clsx_m_default("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !fu }) }, pu), React.createElement("div", null, K)), bu, React.createElement(O, {
		...iu && !vu ? { key: `pb-${iu}` } : {},
		rtl: cu,
		theme: hu,
		delay: J,
		isRunning: w,
		isIn: du,
		closeToast: ql,
		hide: $,
		type: Z,
		style: ru,
		className: tu,
		controlledProgress: vu,
		progress: su || 0
	})));
}, M = function(x, w) {
	return w === void 0 && (w = !1), {
		enter: `Toastify--animate Toastify__${x}-enter`,
		exit: `Toastify--animate Toastify__${x}-exit`,
		appendPosition: w
	};
}, R = h(M("bounce", !0));
h(M("slide", !0)), h(M("zoom")), h(M("flip"));
var k = forwardRef((x, w) => {
	let { getToastToRender: V, containerRef: U, isToastActive: W } = C(x), { className: G, style: K, rtl: J, containerId: Y } = x;
	function Z(x) {
		let w = clsx_m_default("Toastify__toast-container", `Toastify__toast-container--${x}`, { "Toastify__toast-container--rtl": J });
		return p(G) ? G({
			position: x,
			rtl: J,
			defaultClassName: w
		}) : clsx_m_default(w, m(G));
	}
	return useEffect(() => {
		w && (w.current = U.current);
	}, []), React.createElement("div", {
		ref: U,
		className: "Toastify",
		id: Y
	}, V((x, w) => {
		let V = w.length ? { ...K } : {
			...K,
			pointerEvents: "none"
		};
		return React.createElement("div", {
			className: Z(x),
			style: V,
			key: `container-${x}`
		}, w.map((x, V) => {
			let { content: U, props: G } = x;
			return React.createElement(N, {
				...G,
				isIn: W(G.toastId),
				style: {
					...G.style,
					"--nth": V + 1,
					"--len": w.length
				},
				key: `toast-${G.key}`
			}, U);
		}));
	}));
});
k.displayName = "ToastContainer", k.defaultProps = {
	position: "top-right",
	transition: R,
	autoClose: 5e3,
	closeButton: L,
	pauseOnHover: !0,
	pauseOnFocusLoss: !0,
	closeOnClick: !0,
	draggable: !0,
	draggablePercent: 80,
	draggableDirection: "x",
	role: "alert",
	theme: "light"
};
var P, B = /* @__PURE__ */ new Map(), D = [], A = 1;
function z() {
	return "" + A++;
}
function F(x) {
	return x && (d(x.toastId) || u(x.toastId)) ? x.toastId : z();
}
function H(x, w) {
	return B.size > 0 ? v.emit(0, x, w) : D.push({
		content: x,
		options: w
	}), w.toastId;
}
function S(x, w) {
	return {
		...w,
		type: w && w.type || x,
		toastId: F(w)
	};
}
function q(x) {
	return (w, V) => H(w, S(x, V));
}
function Q(x, w) {
	return H(x, S("default", w));
}
Q.loading = (x, w) => H(x, S("default", {
	isLoading: !0,
	autoClose: !1,
	closeOnClick: !1,
	closeButton: !1,
	draggable: !1,
	...w
})), Q.promise = function(x, w, V) {
	let U, { pending: W, error: G, success: K } = w;
	W && (U = d(W) ? Q.loading(W, V) : Q.loading(W.render, {
		...V,
		...W
	}));
	let J = {
		isLoading: null,
		autoClose: null,
		closeOnClick: null,
		closeButton: null,
		draggable: null
	}, Y = (x, w, W) => {
		if (w == null) return void Q.dismiss(U);
		let G = {
			type: x,
			...J,
			...V,
			data: W
		}, K = d(w) ? { render: w } : w;
		return U ? Q.update(U, {
			...G,
			...K
		}) : Q(K.render, {
			...G,
			...K
		}), W;
	}, Z = p(x) ? x() : x;
	return Z.then((x) => Y("success", K, x)).catch((x) => Y("error", G, x)), Z;
}, Q.success = q("success"), Q.info = q("info"), Q.error = q("error"), Q.warning = q("warning"), Q.warn = Q.warning, Q.dark = (x, w) => H(x, S("default", {
	theme: "dark",
	...w
})), Q.dismiss = (x) => {
	B.size > 0 ? v.emit(1, x) : D = D.filter((w) => x != null && w.options.toastId !== x);
}, Q.clearWaitingQueue = function(x) {
	return x === void 0 && (x = {}), v.emit(5, x);
}, Q.isActive = (x) => {
	let w = !1;
	return B.forEach((V) => {
		V.isToastActive && V.isToastActive(x) && (w = !0);
	}), w;
}, Q.update = function(x, w) {
	w === void 0 && (w = {}), setTimeout(() => {
		let V = function(x, w) {
			let { containerId: V } = w, U = B.get(V || P);
			return U && U.getToast(x);
		}(x, w);
		if (V) {
			let { props: U, content: W } = V, G = {
				delay: 100,
				...U,
				...w,
				toastId: w.toastId || x,
				updateId: z()
			};
			G.toastId !== x && (G.staleId = x);
			let K = G.render || W;
			delete G.render, H(K, G);
		}
	}, 0);
}, Q.done = (x) => {
	Q.update(x, { progress: 1 });
}, Q.onChange = (x) => (v.on(4, x), () => {
	v.off(4, x);
}), Q.POSITION = {
	TOP_LEFT: "top-left",
	TOP_RIGHT: "top-right",
	TOP_CENTER: "top-center",
	BOTTOM_LEFT: "bottom-left",
	BOTTOM_RIGHT: "bottom-right",
	BOTTOM_CENTER: "bottom-center"
}, Q.TYPE = {
	INFO: "info",
	SUCCESS: "success",
	WARNING: "warning",
	ERROR: "error",
	DEFAULT: "default"
}, v.on(2, (x) => {
	P = x.containerId || x, B.set(P, x), D.forEach((x) => {
		v.emit(0, x.content, x.options);
	}), D = [];
}).on(3, (x) => {
	B.delete(x.containerId || x), B.size === 0 && v.off(0).off(1).off(5);
});
var VARIANTS = [
	"info",
	"success",
	"warning",
	"error"
];
function injectStyle() {
	var x = ":root{--toastify-color-light:#fff;--toastify-color-dark:#121212;--toastify-color-info:#3498db;--toastify-color-success:#07bc0c;--toastify-color-warning:#f1c40f;--toastify-color-error:#e74c3c;--toastify-color-transparent:hsla(0,0%,100%,.7);--toastify-icon-color-info:var(--toastify-color-info);--toastify-icon-color-success:var(--toastify-color-success);--toastify-icon-color-warning:var(--toastify-color-warning);--toastify-icon-color-error:var(--toastify-color-error);--toastify-toast-width:320px;--toastify-toast-background:#fff;--toastify-toast-min-height:64px;--toastify-toast-max-height:800px;--toastify-font-family:sans-serif;--toastify-z-index:9999;--toastify-text-color-light:#757575;--toastify-text-color-dark:#fff;--toastify-text-color-info:#fff;--toastify-text-color-success:#fff;--toastify-text-color-warning:#fff;--toastify-text-color-error:#fff;--toastify-spinner-color:#616161;--toastify-spinner-color-empty-area:#e0e0e0;--toastify-color-progress-light:linear-gradient(90deg,#4cd964,#5ac8fa,#007aff,#34aadc,#5856d6,#ff2d55);--toastify-color-progress-dark:#bb86fc;--toastify-color-progress-info:var(--toastify-color-info);--toastify-color-progress-success:var(--toastify-color-success);--toastify-color-progress-warning:var(--toastify-color-warning);--toastify-color-progress-error:var(--toastify-color-error)}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translateZ(var(--toastify-z-index));position:fixed;padding:4px;width:var(--toastify-toast-width);box-sizing:border-box;color:#fff}.Toastify__toast-container--top-left{top:1em;left:1em}.Toastify__toast-container--top-center{top:1em;left:50%;transform:translateX(-50%)}.Toastify__toast-container--top-right{top:1em;right:1em}.Toastify__toast-container--bottom-left{bottom:1em;left:1em}.Toastify__toast-container--bottom-center{bottom:1em;left:50%;transform:translateX(-50%)}.Toastify__toast-container--bottom-right{bottom:1em;right:1em}@media only screen and (max-width:480px){.Toastify__toast-container{width:100vw;padding:0;left:0;margin:0}.Toastify__toast-container--top-center,.Toastify__toast-container--top-left,.Toastify__toast-container--top-right{top:0;transform:translateX(0)}.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-right{bottom:0;transform:translateX(0)}.Toastify__toast-container--rtl{right:0;left:auto}}.Toastify__toast{position:relative;min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:8px;border-radius:4px;box-shadow:0 1px 10px 0 rgba(0,0,0,.1),0 2px 15px 0 rgba(0,0,0,.05);display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;max-height:var(--toastify-toast-max-height);overflow:hidden;font-family:var(--toastify-font-family);cursor:default;direction:ltr;z-index:0}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-body{margin:auto 0;-ms-flex:1 1 auto;flex:1 1 auto;padding:6px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.Toastify__toast-body>div:last-child{word-break:break-word;-ms-flex:1;flex:1}.Toastify__toast-icon{-webkit-margin-end:10px;margin-inline-end:10px;width:20px;-ms-flex-negative:0;flex-shrink:0;display:-ms-flexbox;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.7s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}@media only screen and (max-width:480px){.Toastify__toast{margin-bottom:0;border-radius:0}}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--colored.Toastify__toast--default,.Toastify__toast-theme--light{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;-ms-flex-item-align:start;align-self:flex-start}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:focus,.Toastify__close-button:hover{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:5px;z-index:var(--toastify-z-index);opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:auto;transform-origin:right}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--bottom-left,.Toastify__bounce-enter--top-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--bottom-right,.Toastify__bounce-enter--top-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--bottom-left,.Toastify__bounce-exit--top-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--bottom-right,.Toastify__bounce-exit--top-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateX(-20deg);opacity:1}to{transform:perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translateZ(0)}}@keyframes Toastify__slideOutRight{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(110%,0,0)}}@keyframes Toastify__slideOutLeft{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(-110%,0,0)}}@keyframes Toastify__slideOutDown{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--bottom-left,.Toastify__slide-enter--top-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--bottom-right,.Toastify__slide-enter--top-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--bottom-left,.Toastify__slide-exit--top-left{animation-name:Toastify__slideOutLeft}.Toastify__slide-exit--bottom-right,.Toastify__slide-exit--top-right{animation-name:Toastify__slideOutRight}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown}@keyframes Toastify__spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", w = document.createElement("style");
	w.innerText = x, document.head.appendChild(w);
}
var Toast_module_default$1 = { ToastContainer: "_ToastContainer_5xiwl_1" }, import_classnames$3 = /* @__PURE__ */ __toESM(require_classnames(), 1);
function ToastContainer({ className: x, closeButton: w, ...V }) {
	return injectStyle(), /* @__PURE__ */ jsx(k, {
		className: twMerge((0, import_classnames$3.default)(Toast_module_default$1.ToastContainer, x)),
		closeButton: !1,
		closeOnClick: !1,
		autoClose: !1,
		...V
	});
}
var CloseButton_module_default = {
	CloseButton: "_CloseButton_14ky3_1",
	Condense: "_Condense_14ky3_8"
}, import_classnames$2 = /* @__PURE__ */ __toESM(require_classnames(), 1);
const CloseButton = ({ onClick: x, condense: w = !1, className: V, children: U }) => /* @__PURE__ */ jsx("div", {
	className: (0, import_classnames$2.default)(CloseButton_module_default.CloseButton, w && CloseButton_module_default.Condense, V),
	children: /* @__PURE__ */ jsx(Button_default, {
		iconProps: {
			icon: "x-circle",
			color: "white"
		},
		variant: "tertiary",
		onClick: x,
		children: U
	})
});
var Toast_module_default = {
	Toast: "_Toast_dz30y_1",
	Condense: "_Condense_dz30y_5",
	OnClick: "_OnClick_dz30y_10",
	error: "_error_dz30y_14",
	info: "_info_dz30y_18",
	success: "_success_dz30y_22",
	warning: "_warning_dz30y_26",
	LeftSide: "_LeftSide_dz30y_30",
	IconContainer: "_IconContainer_dz30y_34",
	Title: "_Title_dz30y_38",
	Description: "_Description_dz30y_42",
	Undo: "_Undo_dz30y_46",
	ProgressBar: "_ProgressBar_dz30y_50",
	Progress: "_Progress_dz30y_50"
}, import_classnames$1 = /* @__PURE__ */ __toESM(require_classnames(), 1), NotificationIconName = {
	info: "info",
	success: "check-circle",
	warning: "warning",
	error: "x-circle"
};
function ToastContent({ variant: x, title: w, description: V, closeButton: U = !1, condense: W = !1, className: G, toastProps: K, progress: J }) {
	return /* @__PURE__ */ jsxs("div", {
		className: (0, import_classnames$1.default)(Toast_module_default.Toast, Toast_module_default[x], !U && Toast_module_default.OnClick, W && Toast_module_default.Condense, G),
		onClick: (x) => {
			x.stopPropagation(), U || Q.dismiss(K.toastId);
		},
		children: [
			!!J && /* @__PURE__ */ jsx("div", {
				className: Toast_module_default.ProgressBar,
				children: /* @__PURE__ */ jsx("div", {
					className: Toast_module_default.Progress,
					style: { width: `${J}%` }
				})
			}),
			/* @__PURE__ */ jsxs("div", {
				className: (0, import_classnames$1.default)(Toast_module_default.LeftSide, W && Toast_module_default.Condense),
				children: [!W && /* @__PURE__ */ jsx("div", {
					className: Toast_module_default.IconContainer,
					children: /* @__PURE__ */ jsx(Icon_default, {
						icon: NotificationIconName[x],
						color: "white",
						size: 32
					})
				}), /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("span", {
					className: (0, import_classnames$1.default)(Toast_module_default.Title),
					children: w
				}), V && /* @__PURE__ */ jsx("span", {
					className: (0, import_classnames$1.default)(Toast_module_default.Description),
					children: V
				})] })]
			}),
			U && /* @__PURE__ */ jsx(CloseButton, {
				className: (0, import_classnames$1.default)(Toast_module_default.CloseButton),
				onClick: (x) => {
					x.stopPropagation(), Q.dismiss(K.toastId);
				},
				condense: W
			})
		]
	});
}
var ToggleButtons_module_default = {
	"scrollbar-hide": "_scrollbar-hide_12vyk_1",
	Toggle: "_Toggle_12vyk_5",
	Button: "_Button_12vyk_8",
	Selected: "_Selected_12vyk_16",
	NotSelected: "_NotSelected_12vyk_19"
}, import_classnames = /* @__PURE__ */ __toESM(require_classnames(), 1), ToggleButtons_default = ({ items: x, selectedItem: w, onClickItem: V }) => /* @__PURE__ */ jsx("div", {
	className: ToggleButtons_module_default.Toggle,
	children: x.map((x) => x.visible === !1 ? null : /* @__PURE__ */ jsx(Button_default, {
		variant: "tertiary",
		onClick: () => V(x),
		className: (0, import_classnames.default)(ToggleButtons_module_default.Button, w?.id === x.id ? ToggleButtons_module_default.Selected : ToggleButtons_module_default.NotSelected),
		children: x.name
	}, x.id))
}), Tooltip_module_default = { Overlay: "_Overlay_lbt29_1" }, Tooltip = ({ children: x, overlay: w, ...V }) => /* @__PURE__ */ jsx(Tippy, {
	content: w,
	className: Tooltip_module_default.Overlay,
	...V,
	children: /* @__PURE__ */ jsx("div", { children: x })
}), colors_default = { "some-brand-color": {
	50: "#ffffff",
	100: "#ffffff",
	200: "#ffffff",
	300: "#ffffff",
	400: "#ffffff",
	500: "#ffffff",
	600: "#ffffff",
	700: "#ffffff",
	800: "#ffffff",
	900: "#ffffff"
} };
const ComponentContext = createContext(null), supportedLanguages = {
	en: "English",
	nl: "Nederlands"
}, namespaces = ["Heartbeat", "Input"];
var provider_default = ({ children: x, i18n: w, theme: V }) => {
	let U = useMemo(() => (namespaces.forEach((x) => {
		Object.keys(supportedLanguages).forEach((V) => {
			w.options.supportedLngs.includes(V) && import(`components/${x}/locales/${V}/translation.json`).then((U) => {
				w.addResourceBundle(V, x, U.default);
			});
		});
	}), {
		i18n: w,
		theme: V
	}), [w, V]);
	return /* @__PURE__ */ jsx(ComponentContext.Provider, {
		value: U,
		children: /* @__PURE__ */ jsx(I18nextProvider, {
			i18n: U?.i18n,
			children: x
		})
	});
};
export { ALL_EXTENSIONS, ALL_MIME_TYPES, AccordionForm_default as AccordionForm, AccountMenu, ActionButtons_default as ActionButtons, ActionsPopover, Avatar, Button_default as Button, Card, Checkbox_default as Checkbox, ColorPicker_default as ColorPicker, ColorPickerV2_default as ColorPickerV2, Combobox_default as Combobox, provider_default as ComponentProvider, DarkModeSwitch_default as DarkModeSwitch, Date$1 as Date, Dialog, DirectoryBrowser_default as DirectoryBrowser, Disclosure_default as Disclosure, Drawer_default as Drawer, DropdownMenu_default as DropdownMenu, FILE_EXTENSIONS, FONT_EXTENSIONS, FONT_MIME_TYPES, Form, FormGroup, GenericInputV2_default as GenericInputV2, Heartbeat_default as Heartbeat, INVALID_FILENAME_REGEX, Icon_default as Icon, InlineEdit, Input, InputAffix_default as InputAffix, InputElement, InputV2_default as InputV2, InputWrapper, Label, Listbox_default as ListBox, Loader_default as Loader, Logo_default as Logo, MAX_FILENAME_LENGTH, MediaLibrary_default as MediaLibrary, Directory_default as MediaLibraryDirectory, Dropzone_default as MediaLibraryDropzone, MediaLibraryFile, MediaLibraryFileInfo, MediaLibraryFileInfoSkeletonLoader, Gallery_default as MediaLibraryGallery, Header_default as MediaLibraryHeader, Item_default as MediaLibraryItem, Preview_default as MediaLibraryPreview, SearchBar_default as MediaLibrarySearchBar, Menu_default as Menu, Modal, Navbar, NumberInputV2_default as NumberInputV2, Panel, PanelGroup, PanelHeader, PanelItem, PanelResizeHandle, PlayButton, Popover, PrivateRoute, PublicRoute, QuickButton, Radio_default as Radio, Radiogroup_default as Radiogroup, Repeater, STATUS_COMPLETED, STATUS_INITIAL, STATUS_PROCESSING, SchemaForm_default as SchemaForm, SearchQueryHighlight_default as SearchQueryHighlight, Select_default as Select, SelectV2_default as SelectV2, SelectableInput_default as SelectableInput, SelectableInputV2_default as SelectableInputV2, SettingsForm_default as SettingsForm, Sidebar, SlideOut_default as SlideOut, SlideOver_default as SlideOver, SortableList_default as SortableList, SubNavbar, Tabs_default as Tabs, Text, TextInput, TextInputV2_default as TextInputV2, Textarea_default as Textarea, TextareaV2_default as TextareaV2, ToastContainer, ToastContent, Toggle_default as Toggle, ToggleButtons_default as ToggleButtons, Tooltip, VARIANTS, colors_default as colors, filterDirectories, filterValidFiles, getAcceptString, getAllowedExtensions, getAllowedMimeTypes, getFileExtension, isFile, isFontFile, isInFontsFolder, normalizeFileName, normalizeFiles, prepareRenamedFileName, sanitizeFileName, preset_default as tailwindPreset, Q as toast, useDropzone_default as useDropzone, utility_exports as utility };

//# sourceMappingURL=index.js.map